(function () {
  "use strict";

  Array.prototype.clean = function (deleteValue) {
    for (var i = 0; i < this.length; i++) {
      if (this[i] == deleteValue) {
        this.splice(i, 1);
        i--;
      }
    }
    return this;
  };

  angular
    .module("steve2", [
      // eslint-disable-line
      //'ngAnimate', breaks the Send Modal
      "ngCookies",
      "ngTouch",
      "ngSanitize",
      "ngMessages",
      "ngAria",
      "ngResource",
      "ui.router",
      "ui.bootstrap",
      "ui.mask",
      "smart-table",
      "ui.select",
      "ngFileUpload",
      "toaster",
      "toggle-switch",
      "blockUI",
      "login-frontend",
      "angular.filter",
      "truncate",
      "bc.TelephoneFilter",
      "ngMask",
      "ui.slimscroll",
      "aims-notifications",
      "base64",
      "chart.js",
      "angularjs-gauge",
      "pascalprecht.translate",
      "daterangepicker",
    ])

    .config(function (
      $httpProvider,
      authInterceptorProvider,
      blockUIConfig,
      NotificationProvider,
      NotificationConfigProvider,
      $translateProvider
    ) {
      $httpProvider.interceptors.push(authInterceptorProvider.$get);

      blockUIConfig.autoBlock = false; //Blocking manually
      blockUIConfig.blockBrowserNavigation = true; //Not use back in browser while blockUI is active
      blockUIConfig.autoInjectBodyBlock = false;
      blockUIConfig.delay = 10;

      NotificationProvider.notificationBaseUrl = window.config.aims.api; // eslint-disable-line
      NotificationConfigProvider.notificationBaseUrl = window.config.aims.api; // eslint-disable-line

      $translateProvider.useStaticFilesLoader({
        prefix: "assets/locales/",
        suffix: "/translation.json?v=20260805b",
      });
      $translateProvider.preferredLanguage("en");
      $translateProvider.useSanitizeValueStrategy("escapeParameters");
    })

    .controller(
      "AppController",
      function (
        Auth,
        MailServiceCache,
        $rootScope,
        $scope,
        $timeout,
        $log,
        DataWidget,
        ConfigService,
        $uibModal,
        Intervals,
        $state,
        $translate,
        $http,
        $window,
        Notification,
        AddressBookService
      ) {
        var vm = this;

        /* TOKEN Expiring with Interval */
        if (Auth.user.authenticated()) {
          //Launch the interval
          if (typeof vm.tokenInterval === "undefined") {
            //create the timer
            vm.tokenInterval = Intervals.setInterval(function () {
              try {
                if (Auth.get().isTokenExpired()) {
                  Auth.user.logout();
                }
              } catch (e) {
                Auth.user.logout();
              }
            }, 2 * 1000); //Check every two seconds if the token is expired
          }
        } else {
          // clear any interval
          Intervals.clearAll();
        }

        vm.mailStatus = {
          unread: 0,
        };

        vm.environment = ConfigService.environment;

        vm.skipToContent = function ($event) {
          if ($event.keyCode === 13 || $event.type === "click") {
            var element = window.document.getElementById("maincontent"); // eslint-disable-line
            element.focus();
          }
        };

        vm.launchSupport = function () {
          $uibModal.open({
            animation: false,
            templateUrl: "app/support/support.tpl.html",
            controller: "ModalSupportController as support",
            size: "lg",
            backdrop: "static",
          });
        };

        vm.updateStatus = function () {
          MailServiceCache.getStatus().then(function (response) {
            vm.mailStatus.unread = response.status.unread;
            $rootScope.$broadcast("mail-status-updated", response.status);
          });
        };

        vm.displayVersions = function () {
          $window.steveVersion = {
            aimsapi: "",
            steveapi: "",
            steve: "",
          };
          //fetch APIs AIMS
          $http({
            method: "get",
            url: ConfigService.aims.api,
          }).then(function (response) {
            $window.steveVersion.aimsapi = response.data;
          });
          //fetch APIs STEVE
          $http({
            method: "get",
            url: ConfigService.api.baseUrl,
          }).then(function (response) {
            $window.steveVersion.steveapi = response.data;
          });
          //create a string with versions, include npm version of steve frontend
          $http({
            method: "get",
            url: "assets/version.js",
          }).then(function (response) {
            $window.steveVersion.steve = response.data;
          });
        };
        vm.displayVersions();

        vm.notifications = [];

        // generateId :: Integer -> String
        function generateId(len) {
          return Math.random().toString(36).substr(2, len);
        }

        vm.loadNotifications = function () {
          Notification.notifications({
            app: "steve2",
            cache: generateId(8),
          }).then(
            function (response) {
              var count = vm.notifications.length;
              vm.notifications = _.filter(response.data, { read: 0 }); // eslint-disable-line
              if (count !== vm.notifications.length) {
                $rootScope.$broadcast("update-notifications");
              }
            },
            function (error) {
              $log.error("ERROR", error);
            }
          );
        };

        vm.loadProfile = function () {
          AddressBookService.getContactByEmail(Auth.user.get().email).then(
            function (response) {
              if (response.contact === null) {
                vm.noProfileAvailable = false;
                vm.profile = {
                  name: Auth.user.get().name,
                  email: Auth.user.get().email,
                };
              } else {
                vm.profile = response.contact;
              }
            },
            function (error) {
              $log.error("Error fetching contact by email", error);
            }
          );
        };

        $scope.$on("profile-saved", function () {
          vm.loadNotifications();
          vm.loadProfile();
        });

        $scope.$on("notification-read", function () {
          vm.loadNotifications();
        });

        vm.compactWidgets = {};
        vm.loadCompactWidgets = function () {
          DataWidget.get("steve2").then(function (response) {
            response.forEach(function (element) {
              if (response.length < Object.keys(vm.compactWidgets).length) {
                vm.compactWidgets = {};
              }
              var wg = DataWidget.getWidget(element, true);
              if (typeof wg !== "undefined") {
                if (!angular.equals(vm.compactWidgets[element.id], wg)) {
                  vm.compactWidgets[element.id] = wg;
                }
              }
            });
          });
        };

        if (Auth.user.authenticated()) {
          vm.userInfo = Auth.user.get();
          vm.realmName = Auth.realm.getName();

          vm.userInfo.isAdmin =
            Auth.user.realmRoles().indexOf("steve2-admin") > -1;
          vm.accountUrl = vm.userInfo.iss + "/account";
          vm.updateStatus();

          vm.loadNotifications();
          Intervals.setInterval(function () {
            vm.loadNotifications();
            vm.loadCompactWidgets();
          }, 60 * 1000);
          vm.loadProfile();

          vm.loadCompactWidgets();
        }

        $scope.$on("mail-status-updated", function (event, data) {
          vm.mailStatus.unread = data.unread;
        });

        vm.selectItem = function (row) {
          vm.selectedRow = row;

          $uibModal.open({
            animation: false,
            templateUrl: "app/notifications/notifications.detail.tpl.html",
            controller: "NotificationsDetailController as modal",
            resolve: {
              selectedRow: function () {
                return vm.selectedRow;
              },
            },
          });
        };
      }
    );
})();

'use strict';

angular.module('steve2')

// Show the alert when declining the TAC
// Set and retrieve status of steve2tac in localStorage and sessionStorage


.factory('TACService', function(ConfigService, Auth, $timeout, $translate) {

  var key = ConfigService.tac.key;
  var version = ConfigService.tac.version;
  var win = window;

  function getTitle() {
    return $translate.instant('tac.title');
  }

  function getText() {
    return $translate.instant('tac.text') + $translate.instant('tac.text2');
  }

  // localStorage

  function accept() {
    // Set the version of the TAC in the steve2tac on the localStorage
    win.localStorage.setItem(key, version);
  }

  function hasBeenAccepted() {
    var tacVersion = win.localStorage.getItem(key);
    return ((tacVersion !== null) && (tacVersion === version));
  }

  function decline() {
    // Show a sweetAlert with info and a logout button
    swal({ // eslint-disable-line
      title: $translate.instant('tac.disagreetitle'),
      text: $translate.instant('tac.disagreetext'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: $translate.instant('tac.disagreeconfirmbutton'),
      cancelButtonText: 'Cancel'
    }, function(isConfirm) {
      if (isConfirm) {
        win.localStorage.removeItem(key);
        win.sessionStorage.removeItem(key);
        $timeout(function() {
          Auth.user.logout();
        },
        500);
      }
    });
  }

  // sessionStorage

  function dismiss() {
    win.sessionStorage.setItem(key, version);
  }

  function hasBeenDismissed() {
    var tacVersion = win.sessionStorage.getItem(key);
    return ((tacVersion !== null) && (tacVersion === version));
  }

  function clear() {
    win.sessionStorage.removeItem(key);
  }


  return {
    getTitle: getTitle,
    getText: getText,

    accept: accept,
    hasBeenAccepted: hasBeenAccepted,
    decline: decline,

    dismiss: dismiss,
    hasBeenDismissed: hasBeenDismissed,
    clear: clear
  };

})
;

'use strict';

angular.module('steve2')

.controller('TacController', function(TACService, $state, $timeout, Auth) {
  var vm = this;

  if (!Auth.user.authenticated()) {
    $state.go('landing');
  }

  vm.title = TACService.getTitle();
  vm.text = TACService.getText();

  vm.accept = function() {
    TACService.accept();
    TACService.dismiss(); // not to show the red alert on the dashboard
    $state.go('index.dashboard');
  };

  vm.decline = function() {
    TACService.decline();
  };
})

'use strict';

angular.module('steve2')

.controller('SupportAreaController', function(Auth, $state, Support, $uibModal, filterByFilter, orderByFilter, $scope) {

  if (!Auth.user.authenticated()) {
    $state.go('landing');
  }

  var vm = this;

  vm.loadTickets = function(searchSupport) {
    if (typeof searchSupport === 'undefined') {
      searchSupport = '';
    }

    if (typeof vm.safeCollection === 'undefined') {
      vm.loading = true;
    }

    vm.loadingError = false;

    Support.getSupportTickets()
      .then(function(response) {
        vm.safeCollection = orderByFilter(filterByFilter(response.data, ['key', 'fields.description', 'fields.status.name'], vm.searchSupport), '-fields.created');
        vm.loading = false;
        vm.loadingError = false;

      }, function() {
        // console.error('Error loading Jira Tickets', error);
        vm.loading = false;
        vm.loadingError = true;
      });
  };

  $scope.$watch('sup.searchSupport', function(newValue) {
    vm.loadTickets(newValue);
  });

  vm.launchSupport = function() {
    $uibModal.open({
      animation: false,
      templateUrl: 'app/support/support.tpl.html',
      controller: 'ModalSupportController as support',
      size: 'lg',
      backdrop: 'static'
    });
  };

  $scope.$on('new-support-ticket', function() {
    vm.loadTickets(vm.searchSupport);
  });

})

;

'use strict';

angular.module('steve2')

.controller('SupportDetailController', function($state, $stateParams, Auth, Support, toaster, $translate) {
  if (!Auth.user.authenticated()) {
    $state.go('landing');
  }

  var vm = this;

  if (typeof $stateParams.supportId === 'undefined') {
    $state.go('index.support');
  }

  var ticketId = $stateParams.supportId;

  vm.loadTicketInfo = function(ticketId) {
    vm.loading = (typeof vm.ticketInfo === 'undefined');

    Support.getSupportTicket(ticketId)
      .then(function(response) {
        vm.ticketInfo = response.data;
        vm.loading = false;
      }, function(/*error*/) {
        toaster.pop('error', 'Error', $translate.instant('supa.detail.errorloading'));
        $state.go('index.support');
      })
  };
  vm.loadTicketInfo(ticketId);

  vm.postComment = function() {
    if (!vm.newComment) {
      return;
    }

    Support.createComment(ticketId, vm.newComment)
    .then(function(/*response*/) {
      vm.loadTicketInfo(ticketId);
    }, function(/*error*/) {
      toaster.pop('error', $translate.instant('supa.detail.errorposting'));
    });
  };

})

;

angular.module('steve2')

.factory('Support', function ($http, ConfigService, $q) {

  function requestSupport(data) {
    return $http({
      method: 'post',
      url: ConfigService.api.baseUrl + '/support',
      data: data
    });
  }
  // generateId :: Integer -> String
  function generateId (len) {
    return Math.random().toString(36).substr(2, len);
  }

  /*
  * Get all the tickets for an email (extracted from the user token)
  * Route only available for authenticated users
  */
  function getSupportTickets() {
    var deferred = $q.defer();
    params = {};
    params.cache = generateId(8);

    $http({
      method: 'GET',
      url: ConfigService.api.baseUrl + '/support',
      params: params,
    })
    .then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  }

  function getSupportTicket(ticketId) {
    var deferred = $q.defer();
    params = {};
    params.cache = generateId(8);

    $http({
      method: 'GET',
      url: ConfigService.api.baseUrl + '/support/' + ticketId,
      params: params
    })
    .then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  }

  function createComment(ticketId, comment) {
    var deferred = $q.defer();

    $http({
      method: 'POST',
      url: ConfigService.api.baseUrl + '/support/' + ticketId + '/comment',
      data: {
        comment: comment
      }
    })
    .then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  }

  return {
    requestSupport: requestSupport,
    getSupportTickets: getSupportTickets,
    getSupportTicket: getSupportTicket,
    createComment: createComment
  }
})

angular.module('steve2')

.controller('ModalSupportController', function (Support, $uibModalInstance, Auth, toaster, $rootScope, $translate) {
  var vm = this;
  vm.isAuthenticated = Auth.user.authenticated();
  vm.submitButtonText = 'Submit';

  if (vm.isAuthenticated) {
    var userInfo = Auth.user.get();
    vm.name = userInfo.name;
    vm.email = userInfo.email;
  }

  vm.submit = function () {
    submitting();
    Support.requestSupport({
      name: vm.name,
      email: vm.email,
      request: vm.request
    }).then(function () {
      $uibModalInstance.close()
      toaster.pop('success', 'Thank you!', $translate.instant('sup.reqsuccess'));
      doneSubmitting();
    }, function () {
      toaster.pop('error', 'Oops!', $translate.instant('sup.reqerror'));
      doneSubmitting();
    })
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss()
  }

  function submitting() {
    vm.submitting = true;
    vm.submitButtonText = $translate.instant('sup.submitting')
  }

  function doneSubmitting() {
    vm.submitting = true;
    vm.submitButtonText = $translate.instant('sup.submit');
    $rootScope.$broadcast('new-support-ticket');
  }
})

'use strict';

angular.module('steve2')

.controller('SettingsController', function($state, Auth, NotificationConfig, Notification, AddressBookService, toaster, $translate, ConfigService, $filter) {

  var vm = this;

  vm.notifSettings = [];

  vm.loadNotificationSettings = function() {
    AddressBookService.getContactByEmail(Auth.user.get().email)
    .then(function(response) {
      vm.user = response.contact;
      if (vm.user === null) {
        vm.noProfile = true;
        return;
      }

      // Load types
      NotificationConfig.getNotificationTypes()
      .then(function(respT) {
        //vm.nTypes = respT.data;
        vm.nTypes = $filter('pick')(respT, 'app === null || app === \'steve2\'');
        vm.nTypes.forEach(function(element) {
          vm.notifSettings[element.name] = {
            type: element,
            config: {
              app: 'steve2',
              user: vm.user.id,
              notificationType: element.name,
              sendToWeb: false,
              sendToEmail: false,
              sendToSMS: false
            }
          };
        });

        // Load configs
        NotificationConfig.getNotificationConfigs2(vm.user.id, 'steve2')
        .then(function(respC) {
          respC.forEach(function(element) {
            vm.notifSettings[element.notificationType].config = element;
            vm.notifSettings[element.notificationType].config.sendToWeb = element.sendToWeb === 1 ? true : false;
            vm.notifSettings[element.notificationType].config.sendToEmail = element.sendToEmail === 1 ? true : false;
            vm.notifSettings[element.notificationType].config.sendToSMS = element.sendToSMS === 1 ? true : false;
          });
        }, function(error) {
          vm.notifSettings = [];
          console.error('ERROR loading the notification configs', error);
        });

      }, function(error) {
        vm.notifSettings = [];
        console.error('ERROR loading the notification types', error);
      });

    }, function(error) {
      console.error('ERROR loading the user profile', error);
      vm.noProfile = true;
    });
  };

  if (!Auth.user.authenticated()) {
    $state.go('landing');
  } else {
    vm.loadNotificationSettings();
    vm.env = ConfigService.environment.name;
  }


  vm.saveConfig = function(nType) {
    NotificationConfig.saveNotificationConfigs(vm.notifSettings[nType].config)
    .then(function(response) {
      toaster.pop('success', 'Success', $translate.instant('settings.n.configsuccess', {nType: nType.toUpperCase()}));
    }, function(error) {
      console.error('Error configuring the notification', error);
      toaster.pop('error', 'Error', $translate.instant('settings.n.configerror'));
    });
  };

});

'use strict';

angular.module('steve2')

.factory('ListsService', function($q, $http, ConfigService, Auth) {

  // generateId :: Integer -> String
  function generateId (len) {
    return Math.random().toString(36).substr(2, len);
  }

  //Get all the lists in this realm
  function getLists() {
    var deferred = $q.defer();

    var realm = Auth.realm.getName();

    var params = {
      cache: generateId(8)
    };

    $http({
      method: 'get',
      url: ConfigService.api.baseUrl + '/lists/' + realm,
      params: params
    }).then(function(response) {
      deferred.resolve({
        lists: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(ex) {
      deferred.reject({
        ex: ex
      });
    });

    return deferred.promise;
  }

  function getListsBy(fullList, filters) {
    var returnList = [];
    angular.copy(fullList, returnList);
    if (typeof filters === 'undefined') {
      return returnList;
    }

    Object.keys(filters).forEach(function(elem) {
      returnList.forEach(function(element, index) {
        if (typeof element[elem] !== 'undefined') {
          if (element[elem] !== filters[elem]) {
            returnList[index] = null;
          }
        }
      });
      returnList = returnList.filter(function(n) {
        return n !== null;
      });
    });

    return returnList;
  };

  function getListFileTypes(fullList) {
    var helper = {};
    fullList.forEach(function(element, index, array) {
      helper[element.fileType] = true;
    });
    return Object.keys(helper);
  }

  //Get list info using listId
  function getListInfo(listId) {
    var deferred = $q.defer();

    function generateId (len) {
      return Math.random().toString(36).substr(2, len);
    }

    var params = {}
    params.cache = generateId(8);

    $http({
      method: 'get',
      url: ConfigService.api.baseUrl + '/list/' + listId,
      params: params
    }).then(function(response) {
      deferred.resolve({
        info: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  }

  function addUser(listId, userId) {
    var deferred = $q.defer();

    $http({
      method: 'post',
      url: ConfigService.api.baseUrl + '/listUser/' + listId,
      data: {
        userId: userId
      }
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  };

  function removeUser(listId, userId) {
    var deferred = $q.defer();

    $http({
      method: 'delete',
      url: ConfigService.api.baseUrl + '/listUser/' + listId,
      data: {
        userId: userId
      },
      headers: {'Content-Type': 'application/json;charset=utf-8'}
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  };

  function getLists4User() {
    var deferred = $q.defer();
    var params = {
      cache: generateId(8)
    };
    $http({
      method: 'get',
      url: ConfigService.api.baseUrl + '/list',
      params: params
    }).then(function(response) {
      deferred.resolve({
        lists: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  };

  function toggleListStatus(listInfo) {
    var deferred = $q.defer();

    $http({
      method: 'post',
      url: ConfigService.api.baseUrl + '/listStatus/' + listInfo.id,
      data: {
        enabled: listInfo.enabled === 'true'
      }
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  };

  function toggleIncludeInAll(listInfo) {
    var deferred = $q.defer();
    var includeInAll = listInfo.includeInAll === 1 || listInfo.includeInAll === 'true';

    $http({
      method: 'post',
      url: ConfigService.api.baseUrl + '/listIncludeInAll/' + listInfo.id,
      data: {
        includeInAll: includeInAll
      }
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  }

  function checkListName(listName, fileType, listType) {
    var deferred = $q.defer();

    if (listName.match(/nchs/i)) {
      deferred.reject({
        error: 'The word NCHS cannot be part of the name of any user-created list.'
      });

      return deferred.promise;
    }

    $http({
      method: 'get',
      url: ConfigService.api.baseUrl + '/checkListName',
      params: {
        listName: listName,
        fileType: fileType,
        listType: listType
      }
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(ex) {
      deferred.reject({
        ex: ex
      });
    });

    return deferred.promise;
  };

  return {
    getLists: getLists,
    getListInfo: getListInfo,
    addUser: addUser,
    removeUser: removeUser,
    getLists4User: getLists4User,
    getListsBy: getListsBy,
    getListFileTypes: getListFileTypes,
    toggleListStatus: toggleListStatus,
    toggleIncludeInAll: toggleIncludeInAll,
    checkListName: checkListName
  };

});

angular.module('steve2')

.factory('Intervals', function($interval) {

  var intIDs = [];

  function setInterval(fn, interval) {
    var intervalId = $interval(fn, interval);
    intIDs.push(intervalId);
    return intervalId;
  }

  function cancelInterval(intervalId) {
    $interval.cancel(intervalId);
  }

  function clearAll() {
    intIDs.forEach(function(element, index, array) {
      $interval.cancel(array[index]);
    });
    intIds = [];
  }

  return {
    setInterval: setInterval,
    cancelInterval: cancelInterval,
    clearAll: clearAll
  };

});

'use strict';

angular.module('steve2')

.factory('FilterService', function($q, $http) {

  function getFiltersDef(fileType) {
    var deferred = $q.defer();

    $http({
      method: 'get',
      url: 'assets/filters/' + fileType + '.json'
    }).then(function(response) {
      deferred.resolve({
        filters: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(ex) {
      deferred.reject({
        ex: ex
      });
    });

    return deferred.promise;
  }

  return {
    getFiltersDef: getFiltersDef
  };

});

'use strict';

angular.module('steve2')

.controller('ResourcesController', function(Auth, $state) {

  if (!Auth.user.authenticated()) {
    $state.go('landing');
  }

  var vm = this;


})

;

'use strict';

angular.module('steve2')

.factory('RoutesService', function($q, $http, ConfigService) {

  function getDestinations(listInfo) {
    var deferred = $q.defer();

    $http({
      method: 'get',
      url: ConfigService.api.baseUrl + '/outboundListRecipient/' + listInfo.id
    }).then(function(response) {
      deferred.resolve({
        lists: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(ex) {
      deferred.reject({
        ex: ex
      });
    });

    return deferred.promise;
  };

  function getAvailabeDestinations(queryObj) {
    var deferred = $q.defer();

    $http({
      method: 'get',
      url: ConfigService.api.baseUrl + '/lists/',
      params: queryObj
    }).then(function(response) {
      deferred.resolve({
        lists: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(ex) {
      deferred.reject({
        ex: ex
      });
    });

    return deferred.promise;
  };

  function removedAssociatedLists(allLists, associatedLists) {
    var localAL = [];
    angular.copy(allLists, localAL);
    associatedLists.forEach(function(element, index, array) {
      localAL.forEach(function(ele, ind, arr) {
        if (element.id === ele.id) {
          delete localAL[ind];
        }
      });
    });

    localAL.clean(undefined);
    return localAL;
  };

  function addInbound(listId, inboundId) {
    var deferred = $q.defer();

    $http({
      method: 'post',
      url: ConfigService.api.baseUrl + '/outboundListRecipient/' + listId,
      data: {
        recipients: inboundId
      }
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  };

  function removeInbound(listId, inboundId) {
    var deferred = $q.defer();

    $http({
      method: 'delete',
      url: ConfigService.api.baseUrl + '/outboundListRecipient/' + listId,
      data: {
        inboundListId: inboundId
      },
      headers: {'Content-Type': 'application/json;charset=utf-8'}
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  };

  return {
    getDestinations: getDestinations,
    getAvailabeDestinations: getAvailabeDestinations,
    addInbound: addInbound,
    removeInbound: removeInbound,
    removedAssociatedLists: removedAssociatedLists
  };

});

'use strict';

angular.module('steve2')

.factory('OutboundService', function($q, $http, ConfigService, Auth) {

  function createList(listInfo) {
    var deferred = $q.defer();

    $http({
      method: 'post',
      url: ConfigService.api.baseUrl + '/list',
      data: listInfo
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(ex) {
      deferred.reject({
        ex: ex
      });
    });

    return deferred.promise;
  }

  // To update NCHS filters, chech for the Auth.user.hasClientRole:steve-client:NCHS...
  // and call the appropriate API endpoint
  function updateList(listInfo) {
    var deferred = $q.defer();
    var url = ConfigService.api.baseUrl + '/list/' + listInfo.id;

    if ((listInfo.listName === 'NCHS') && (Auth.user.hasClientRole(ConfigService.environment.clientName, ConfigService.environment.nchsEditorRole))) {
      url = ConfigService.api.baseUrl + '/listNCHS/';
    }

    $http({
      method: 'put',
      url: url,
      data: listInfo
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(ex) {
      deferred.reject({
        ex: ex
      });
    });

    return deferred.promise;
  }

  function deleteList(listId) {
    var deferred = $q.defer();

    $http({
      method: 'delete',
      url: ConfigService.api.baseUrl + '/list/' + listId
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(ex) {
      deferred.reject({
        ex: ex
      });
    });

    return deferred.promise;
  }

  function getRoutesFilters() {
    var deferred = $q.defer();

    $http({
      method: 'get',
      url: ConfigService.api.baseUrl + '/list/routingCodes'
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(ex) {
      deferred.reject({
        ex: ex
      });
    });

    return deferred.promise;
  }

  return {
    createList: createList,
    updateList: updateList,
    deleteList: deleteList,
    getRoutesFilters: getRoutesFilters
  };

});

'use strict';

angular.module('steve2')

.controller('OutboundController', function (Auth, $state, ConfigService, ListsService,
    $uibModal, OutboundService, toaster, $translate, $log) {

  //Check for authenticated AND role admin
  if (!Auth.user.authenticated()) {
    $state.go('landing');
  } else {
    if (Auth.user.roles().indexOf('steve2-admin') === -1) {
      $state.go('index.dashboard');
    }
  }

  var vm = this;

  vm.filetypes = ConfigService.api.fileTypes;

  function isAllowedFileType (ft) {
    return ft != null && ft !== '' && vm.filetypes.indexOf(ft) !== -1;
  }

  vm.selectedFileType = isAllowedFileType($state.params.fileType) ? $state.params.fileType : null;

  vm.onSelectedFileTypeChange = function () {
    $state.go('admin.outbound', { fileType: vm.selectedFileType || null }, {
      location: 'replace',
      notify: false
    });
  };

  vm.canEdit = function(item) {
    var hasEditRole = Auth.user.hasClientRole(ConfigService.environment.clientName, ConfigService.environment.nchsEditorRole);
    return item.listName.indexOf('NCHS') === -1 || hasEditRole;
  };

  vm.canDelete = function(item) {
    return (item.listName.indexOf('NCHS') === -1) && (item.protected === 'false');
  }

  vm.loadLists = function() {
    vm.errors = null;
    vm.isLoading = true;

    ListsService.getLists()
      .then(function(response) {
        vm.lists = ListsService.getListsBy(response.lists, {listType: 'outbound'});
        vm.isLoading = false;
      }, function() {
        vm.errors = $translate.instant('out.errorloading');
        vm.isLoading = false;
      });
  };
  vm.loadLists();

  vm.createNewOut = function() {

    var modalInstance = $uibModal.open({
      animation: false,
      templateUrl: 'app/outbound/createOutbound.tpl.html',
      controller: 'CreateOutController as cob',
      size: 'lg',
      backdrop: 'static'
    });

    modalInstance.result.then(function () {
      toaster.pop('success', 'Success', $translate.instant('out.createsuccess'));
    }, function () {
      $log.debug('Modal dismissed at: ' + new Date());
    });
  };

  vm.deleteList = function(listId) {
    swal({ // eslint-disable-line
      title: $translate.instant('out.deletemsgtitle'),
      text: $translate.instant('out.deletemsg'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: $translate.instant('yes'),
      cancelButtonText: $translate.instant('cancel')
    }, function(isConfirm) {
      if (isConfirm) {
        OutboundService.deleteList(listId)
          .then(function() {
            toaster.pop('success', 'Success', $translate.instant('out.deletesuccess'));
            vm.loadLists(vm.selectedFileType);
          }, function(err) {
            $log.error('Error deleting the list', err);
            toaster.pop('error', 'Error', $translate.instant('out.deleteerror'));
          });
      }
    });
  };

})

.controller('CreateOutController', function($uibModalInstance, ConfigService, OutboundService, ListsService, $state, $log) {
  var vm = this;

  vm.activeStep = 0;
  vm.fileTypes = ConfigService.api.fileTypes;

  vm.errors = [];
  vm.validateStep1 = function(callback) {
    vm.errors = [];
    if (typeof vm.fileType === 'undefined') {
      vm.errors.push('File Type is required');
    }

    if (typeof vm.listName === 'undefined') {
      vm.errors.push('Rule Name is required');
    }

    if (typeof vm.fileType !== 'undefined') {
      ListsService.checkListName(vm.listName, vm.fileType, 'outbound')
        .then(function(response) {
          if (response.data === true) {
            vm.errors.push('This name is being used in other rule.');
          }
          callback();
        }, function(error) {
          vm.errors.push('Error validating rule name: ' + error.error);
        })
    } else {
      callback();
    }
  };

  vm.next = function() {
    if (vm.activeStep === 0) {
      vm.validateStep1(function() {
        if (vm.errors.length === 0) {
          vm.activeStep = vm.activeStep + 1;
        }
      });
    } else {
      if (vm.errors.length === 0) {
        vm.activeStep = vm.activeStep + 1;
      }
    }
  };

  vm.previuos = function() {
    vm.activeStep = vm.activeStep - 1;
  };

  vm.createList = function() {
    // TODO: The id of the newly created list must be returned by the API in order to navigate to Edit the list
    var listInfo = {
      listType: 'outbound',
      fileType: vm.fileType,
      listName: vm.listName,
      protected: vm.protected,
      autoRouting: vm.autoRouting
    };

    OutboundService.createList(listInfo)
      .then(function(response) {
        $state.go('admin.editlistout', { id: response.data.id, fileType: vm.fileType });
      }, function(err) {
        $log.error('Error creating the rule', err);
      });

    $uibModalInstance.dismiss('done');
  }

  vm.close = function() {
    $uibModalInstance.dismiss('cancel');
  };
})




;

'use strict';

angular.module('steve2')

.controller('EditOutController', function (Auth, $state, toaster, ListsService, $log, ConfigService, $base64,
    $stateParams, MailServiceCache, FilterService, blockUI, $timeout, OutboundService, RoutesService, $scope, $translate) {

  var vm = this;
  var RESTRICTED_SSN_CODES = ['SSN', 'MOM_SSN', 'DAD_SSN'];

  vm.eid = $stateParams.id;
  vm.returnFileType = $stateParams.fileType;
  vm.hasEditRole = Auth.user.hasClientRole(ConfigService.environment.clientName, ConfigService.environment.nchsEditorRole);

  vm.outboundListSrefParams = function () {
    var ft = vm.returnFileType || (vm.listInfo && vm.listInfo.fileType);
    return ft ? { fileType: ft } : {};
  };

  vm.goBackToOutboundList = function ($event) {
    if ($event) {
      $event.preventDefault();
    }
    $state.go('admin.outbound', vm.outboundListSrefParams());
  };

  if (vm.eid === null) {
    $state.go('admin.outbound', vm.returnFileType ? { fileType: vm.returnFileType } : {});
    return;
  }

  vm.isSsnRestrictedList = function () {
    var name = vm.listInfo && vm.listInfo.listName;
    if (!name) {
      return false;
    }
    return name.indexOf('CPSC') > -1 || name.indexOf('DRH') > -1;
  };

  vm.isSsnFilterField = function (item) {
    return RESTRICTED_SSN_CODES.indexOf(item['@code']) > -1;
  };

  vm.isFilterCheckboxDisabled = function (item) {
    return !vm.filtersEnabled ||
      (vm.isSsnRestrictedList() && vm.isSsnFilterField(item));
  };

  vm.sanitizeRestrictedSsnFilters = function () {
    if (!vm.isSsnRestrictedList() || !vm.filters) {
      return;
    }
    vm.filters.forEach(function (section) {
      section.fields.forEach(function (field) {
        if (vm.isSsnFilterField(field)) {
          field['@enabled'] = false;
        }
      });
    });
  };

  vm.loadFilters = function(listInfo, callback) {

    if (!angular.isFunction(callback)) {
      callback = function(status) {
        $log.log('Callback not provided', status);
      }
    }

    vm.loadingFilters = angular.isUndefined(vm.filters); //First time load, show the spinning icon
    vm.loadingFiltersError = false;
    FilterService.getFiltersDef(listInfo.fileType)
      .then(function(response) {
        vm.STEVE_VR_File = response.filters;
        vm.filters = [].concat(vm.STEVE_VR_File.record);

        //Load enabled filters
        vm.enabledFilters = angular.fromJson(listInfo.filter);
        vm.mergeFilters(vm.filters, vm.enabledFilters);
        vm.filtersMaster = angular.copy(vm.filters);
        vm.sanitizeRestrictedSsnFilters();
        vm.filtersModified = !angular.equals(vm.filters, vm.filtersMaster);

        vm.loadingFilters = false;
        vm.loadingFiltersError = false;

        callback('success');

      }, function() {
        vm.loadingFilters = false;
        vm.loadingFiltersError = true;
        vm.filters = null;
        callback('error');
      });
  };

  vm.exportFilters = function() {
    var fileName = 'filters_exported_' + moment().format('YYYYMMDD') + '_' + vm.listInfo.fileType + '.stv'; // eslint-disable-line
    var blobObj = {
      fileType: vm.listInfo.fileType,
      date: new Date(),
      filters: vm.extractEnabledFilters(vm.filters)
    };
    var blobContent = $base64.encode(angular.toJson(blobObj));
    var blob = new Blob([blobContent], {type: 'text/plain;charset=utf-8'});
    saveAs(blob, fileName); // eslint-disable-line
  }

  vm.onFileChange = function(fileEl) {
    var files = fileEl.files;
    var file = files[0];
    var reader = new FileReader();

    reader.onloadend = function(evt) {
      if (evt.target.readyState === FileReader.DONE) {
        $scope.$apply(function () {
          vm.loadFiltersFromFile(evt.target.result);
          angular.element('#file2Upload').val(null); // reset the file to empty after success upload
        });
      }
    };

    reader.readAsText(file);
  }

  vm.loadFiltersFromFile = function(fileContent) {
    try {
      var decodedObj = angular.fromJson($base64.decode(fileContent));

      if ((angular.isUndefined(decodedObj.fileType)) || (angular.isUndefined(decodedObj.date)) || (angular.isUndefined(decodedObj.filters))) {
        new Error('Object format corrupted');
      }

      if (decodedObj.fileType !== vm.listInfo.fileType) {
        swal({ // eslint-disable-line
          title: $translate.instant('out.edit.filetypeerrortitle'),
          text: $translate.instant('out.edit.filetypeerror', {importft: decodedObj.fileType, hostft: vm.listInfo.fileType}),
          type: 'error',
          showCancelButton: false,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: $translate.instant('ok')
        }, function() {
          angular.noop();
        });
      } else {
        vm.enabledFilters = decodedObj.filters;
        vm.mergeFilters(vm.filters, vm.enabledFilters);
        vm.sanitizeRestrictedSsnFilters();
        toaster.pop('success', 'Success', $translate.instant('out.edit.importsuccess'));
      }
    } catch(ex) {
      swal({ // eslint-disable-line
        title: $translate.instant('out.edit.parseimporterrortitle'),
        text: $translate.instant('out.edit.parseimporterror'),
        type: 'error',
        showCancelButton: false,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: $translate.instant('ok')
      }, function() {
        angular.noop();
      });
    }
  }

  vm.loadRoutesFilters = function() {
    OutboundService.getRoutesFilters()
      .then(function(response) {
        vm.routingCodes = response.data;
      });
  };
  vm.loadRoutesFilters();

  vm.loadRoutes = function(listInfo, callback) {
    if (!angular.isFunction(callback)) {
      callback = function(status) {
        $log.log('Callback not provided', status);
      }
    }

    vm.loadingRoutes = angular.isUndefined(vm.alist); //First time load, show the spinning icon
    vm.loadingRoutesError = false;
    RoutesService.getDestinations(vm.listInfo)
      .then(function(response) {
        //Filter out the routes already associated to the list
        vm.alist = response.lists;
        if ((listInfo.listName !== 'NCHS') || (vm.hasEditRole)) {
          if (vm.alist.length === 0) {
            vm.listInfo.enabled = 'false';
            vm.switchList();
          }
        }

        if (listInfo.protected === 'true') {
          vm.loadingRoutes = false;
          callback('success');
          return;
        }

        vm.loadingRoutes = false;
        callback('success');

      }, function(error) {
        vm.loadingRoutes = false;
        vm.loadingRoutesError = true;
        $log.error('Error fetching the outbound list routes', error);
        callback('error');
      });
  };

  vm.loadAvailableDestinations = function() {
    if (typeof vm.selectedRoutingCode === 'undefined') {
      return;
    }
    RoutesService.getAvailabeDestinations({
      fileType: vm.listInfo.fileType,
      enabled: 'true',
      listType: 'inbound',
      routingCode: vm.selectedRoutingCode
    })
      .then(function(res) {
        //Remove the already associated lists
        vm.availableLists = RoutesService.removedAssociatedLists(res.lists.lists, vm.alist);
      }, function(err) {
        vm.loadingRoutesError = true;
        $log.error('Error fetching the available routes', err);
      });
  };

  vm.mergeFilters = function(filters, values) {
    filters.forEach(function(element, index) {
      element.fields.forEach(function(ele, ind) {
        filters[index].fields[ind]['@enabled'] = values.indexOf(ele['@code']) > -1;
      });
    });
  };

  // Accepts a full definition file with -enabled fields
  // Extract to the desired format all the enabled field by -code by section (i.e."NCHS Standard")
  // This function is called on the save action
  vm.extractEnabledFilters = function(filters) {
    var values = [];

    filters.forEach(function(element, index) {
      element.fields.forEach(function(ele, ind) {
        if (typeof filters[index].fields[ind]['@enabled'] !== 'undefined') {
          if (filters[index].fields[ind]['@enabled'] === true) {
            if (!(vm.isSsnRestrictedList() && vm.isSsnFilterField(ele))) {
              values.push(ele['@code']);
            }
          }
        }
      });
    });

    return values;

  }

  vm.loadInfo = function(callback) {
    if (typeof vm.listInfo === 'undefined') {
      vm.loading = true; //First time load, show the spinning icon
    }
    vm.loadingError = false;
    ListsService.getListInfo(vm.eid)
      .then(function(response) {
        vm.listInfo = response.info;

        if (vm.listInfo.filter === null) {
          vm.listInfo.filter = [];
        } else {
          vm.listInfo.filter = angular.fromJson(vm.listInfo.filter);
        }

        vm.listInfo.enabler = function(value) {
          if (arguments.length) {
            vm.listInfo.enabled = value === true ? 'true' : 'false';
          } else {
            return vm.listInfo.enabled === 'true';
          }
        }

        vm.listInfo.includeInAller = function(value) {
          if (arguments.length) {
            vm.listInfo.includeInAll = value === true ? 1 : 0;
          } else {
            return vm.listInfo.includeInAll === 1;
          }
        }

        //Check type, and according load members/filters and set visibility
        if ((vm.listInfo.listType === 'outbound') && (vm.listInfo.fileType !== 'Other')) {
          //Load filters
          vm.loadFilters(vm.listInfo);

          if ((vm.listInfo.listName !== 'NCHS') || (vm.hasEditRole)) {
            if (vm.listInfo.filter.length === 0) {
              vm.listInfo.enabled = 'false';
              vm.switchList();
            }
          }

          vm.viewMembers = false;
          vm.viewFilters = true;
        }

        vm.filtersEnabled = ((vm.listInfo.listName !== 'NCHS') || (vm.hasEditRole));

        vm.loadRoutes(vm.listInfo, callback);

        vm.loading = false;
      }, function() {
        vm.loading = false;
        vm.loadingError = true;
        callback('error');
      });
  };
  vm.loadInfo();

  vm.makeEdit = function() {
    vm.editName = true;
  };

  vm.editDone = function() {
    vm.editName = false;
    //And save the changes right away
  };

  vm.addUsers = function() {
    if (vm.selectedUsers.length === 0) {
      return;
    }

    var promises = [];
    vm.selectedUsers.forEach(function(element) {
      promises.push(
        ListsService.addUser(vm.eid, element)
        .then(function() {
          //Successful action is manage in the Promise.all resolution
        })
      );

    });

    Promise.all(promises).then(function(/*res*/) {
      vm.loadInfo();
      vm.selectedUsers = [];
    }, function(error) {
      $timeout(function() { //To trigger a $digest cycle
        toaster.pop('error', 'Error', $translate.instant('out.edit.adderror'));
      }, 0);
      $log.error('Error adding a user to the list', error);
    });

  };

  vm.addInbound = function() {
    if (vm.selectedInbounds.length === 0) {
      return;
    }

    blockUI.start($translate.instant('out.edit.wait'));

    RoutesService.addInbound(vm.listInfo.id, vm.selectedInbounds)
      .then(function() {
        vm.selectedInbounds = [];
        vm.loadInfo(function(/*status*/) {
          blockUI.stop();
          vm.loadAvailableDestinations();
        });

      }, function(error) {
        toaster.pop('error', 'Error', $translate.instant('out.edit.addmberror'));
        $log.error('Error adding a mailbox to the list', error);
      });
  }

  vm.removeUser = function(userId) {
    ListsService.removeUser(vm.eid, userId)
      .then(function() {
        vm.loadInfo();
      }, function(error) {
        $log.error('Error removing a user to the list', error);
        toaster.pop('error', 'Error', $translate.instant('out.edit.rmerror'));
      });
  };

  vm.removeInbound = function(inboundId) {
    blockUI.start('Please, wait...');

    RoutesService.removeInbound(vm.listInfo.id, inboundId)
      .then(function() {
        vm.loadInfo(function(/*status*/) {
          vm.loadAvailableDestinations();
          blockUI.stop();
        });

      }, function(error) {
        $log.error('Error removing a mailbox from the routing list', error);
        toaster.pop('error', 'Error', $translate.instant('out.edit.rmmberror'));
      });
  }

  vm.switchList = function() {
    ListsService.toggleListStatus(vm.listInfo)
      .then(function() {
      }, function(error) {
        $log.error(error, vm.listInfo.enabled);
        vm.loadInfo();
      });
  };

  vm.switchIncludeInAll = function() {
    ListsService.toggleIncludeInAll(vm.listInfo)
      .then(function() {
        vm.loadInfo();
      }, function(error) {
        $log.error('Error toggling Include in ALL', error);
        $timeout(function() {
          toaster.pop('error', 'Error', $translate.instant('out.edit.includeInAllError'));
        }, 0);
        vm.loadInfo();
      });
  };

  /* Filters */

  $scope.$watch('eol.filters', function(newValue) {
    vm.filtersModified = !angular.equals(newValue, vm.filtersMaster);
  }, true);

  vm.selectAll = function(filter) {
    filter.fields.forEach(function(ele, ind) {
      if (!(vm.isSsnRestrictedList() && vm.isSsnFilterField(ele))) {
        filter.fields[ind]['@enabled'] = vm.checkAllToggle;
      }
    });
  };

  vm.saveFilters = function() {
    if (!vm.filtersEnabled) {
      //do nothing
      return;
    }

    if (!vm.filtersModified) {
      return;
    }

    swal({ // eslint-disable-line
      title: $translate.instant('out.edit.confirmtitle'),
      text: $translate.instant('out.edit.confirmmsg'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: $translate.instant('yes'),
      cancelButtonText: $translate.instant('cancel')
    }, function(isConfirm) {
      if (isConfirm) {
        //block the UI
        blockUI.start($translate.instant('out.edit.saving'));
        vm.listInfo.filter = vm.extractEnabledFilters(vm.filters);

        OutboundService.updateList(vm.listInfo)
          .then(function() {
            blockUI.stop();
            toaster.pop('success', 'Completed', $translate.instant('out.edit.filtersavedsuccess'));
            vm.loadInfo();
          }, function() {
            blockUI.stop();
            toaster.pop('error', 'Error', $translate.instant('out.edit.filtersavederror'));
            vm.loadFilters(vm.listInfo); //Reload to rollback the ui to the previous state
          });
      }
    });
  };

});

'use strict';

angular.module('steve2')

.controller('NotificationsController', function($state, Auth, Notification, $uibModal, $scope) {

  var vm = this;

  // generateId :: Integer -> String
  function generateId (len) {
    return Math.random().toString(36).substr(2, len);
  }

  vm.loadNotifications = function() {
    vm.loading = true;
    if (typeof vm.notifications === 'undefined') {
      vm.refreshView = true;
    } else {
      vm.refreshView = false;
    }
    Notification.notifications({
      app: 'steve2',
      cache: generateId(8)
    })
    .then(function(response) {
      vm.notifications = response.data;
      vm.loading = false;
    }, function() {
      vm.loading = false;
    });
  };

  vm.selectItem = function(row) {
    vm.selectedRow = row;

    var modalInstance = $uibModal.open({
      animation: false,
      templateUrl: 'app/notifications/notifications.detail.tpl.html',
      controller: 'NotificationsDetailController as modal',
      resolve: {
        selectedRow: function() {
          return vm.selectedRow;
        }
      }
    });

    modalInstance.result.then(function () {
      //console.log(result);

    }, function () {
      //console.log('Modal dismissed at: ' + new Date());

    });
  };

  $scope.$on('update-notifications', function() {
    vm.loadNotifications();
  })

  if (!Auth.user.authenticated()) {
    $state.go('landing');
  } else {
    // TODO: Load all Notifications
    vm.loadNotifications();
    // Order by creation from recent to older
    // Set some filters: unread, read, search, sort by
  }

})

.controller('NotificationsDetailController', function($uibModalInstance, selectedRow, Notification, $rootScope) {
  var vm = this;

  vm.row = selectedRow;

  // Once opened, mark as read locally and remote
  vm.row.read = 1;
  Notification.update({
    id: vm.row.id,
    read: 1
  })
  .then(function() {
    $rootScope.$broadcast('notification-read');
  }, function() {
  });

  vm.close = function() {
    $uibModalInstance.dismiss();
  };

})

;

'use strict';

angular.module('steve2') // eslint-disable-line

.controller('MetricsController', function (Auth, $state, DataWidget, Intervals) {

  var vm = this;
  vm.widgets = {};

  vm.loadDataWidgets = function() {
    vm.widgetsRefresh = true;

    DataWidget.get('steve2').then(function(response) {
      response.forEach(function(element) {
        if (response.length < Object.keys(vm.widgets).length) { vm.widgets = {}; }
        var wg = DataWidget.getWidget(element);
        if (typeof wg !== 'undefined') {
          if (!angular.equals(vm.widgets[element.id], wg)) {
            vm.widgets[element.id] = wg;
          }
        }
      });

      vm.widgetsRefresh = false;

    });
  };

  if (!Auth.user.authenticated()) {
    $state.go('landing');
  } else {
    vm.loadDataWidgets();
    Intervals.setInterval(function() {
      vm.loadDataWidgets();
    }, 60 * 1000);
  }

});

'use strict';

angular.module('steve2') // eslint-disable-line

.directive('svgMap', ['$compile', function($compile) {
  return {
    restrict: 'A',
    templateUrl: '../../assets/images/us-all-territories.svg',
    link: function (scope, element) {

      var regions = element[0].querySelectorAll('.state');
      angular.forEach(regions, function (path) {
        var regionElement = angular.element(path);
        regionElement.attr("region", "");
        regionElement.attr("callback", "main.selectRegion");
        regionElement.attr("jurisdictions", "main.jurisdictions");
        $compile(regionElement)(scope);
      });

      var texts = element[0].querySelectorAll('.statename');
      angular.forEach(texts, function (path) {
        var txElement = angular.element(path);
        txElement.attr("statename", "");
        txElement.attr("callback", "main.selectRegion");
        txElement.attr("jurisdictions", "main.jurisdictions");
        $compile(txElement)(scope);
      });
    }
  }
}])

.directive('region', ['$compile', function ($compile) {
  return {
    restrict: 'A',
    scope: {
      jurisdictions: "=",
      callback: "="
    },
    link: function (scope, element) {
      scope.elementId = element.attr("data-id");
      scope.regionClick = function () {
        scope.callback(scope.elementId);
      };
      element.attr("ng-click", "regionClick()");
      element.attr("ng-attr-fill", "{{jurisdictions[elementId].status | state_status}}");
      element.removeAttr("region");
      $compile(element)(scope);
    }
  };
}])

.directive('statename', ['$compile', function ($compile) {
  return {
    restrict: 'A',
    scope: {
      jurisdictions: "=",
      callback: "="
    },
    link: function (scope, element) {
      scope.elementId = element.attr("data-id");
      scope.regionClick = function () {
        scope.callback(scope.elementId);
      };
      element.attr("ng-click", "regionClick()");
      element.removeAttr("statename");
      $compile(element)(scope);
    }
  };
}])

.controller('MainController', function (Auth, $state, JurisdictionStatus,
  ConfigService, AddressBookService, $translate, TACService) {

  var vm = this;

  vm.loginUrl = ConfigService.aims.urlSSO;

  vm.loadJurisdistionStatus = function() {
    vm.loadingMap = true;
    vm.loadingMapError = false;
    JurisdictionStatus.get().then(function(data) {
      vm.lastUpdated = data.lastUpdated;
      Object.keys(data.jurisdictions).forEach(function (key) {
        if (key !== 'steve-test') {
          vm.jurisdictions[data.jurisdictions[key].state] = data.jurisdictions[key];
          vm[data.jurisdictions[key].status || 'nostatus'].push(data.jurisdictions[key]);
        }
      });

      vm.loadingMap = false;

      AddressBookService.getAllPrimaryContacts()
      .then(function(response) {
        response.contacts.forEach(function(element) {
          var initials = element.realm.split('-')[0].toUpperCase();
          if (typeof vm.jurisdictions[initials] !== 'undefined') {
            vm.jurisdictions[initials]['primaryContact'] = element;
          }
        });
      });
    }, function() {
      vm.loadingMapError = true;
    }).catch(function() {
      vm.loadingMapError = true;
    }).finally(function() {
      vm.loadingMap = false;
      vm.userRealmCode = Auth.getRealmName().split('-')[0].toUpperCase();
      // vm.userRealmCode = 'co-steve2'.split('-')[0].toUpperCase();
      vm.selectRegion(vm.userRealmCode);
    });
  };

  vm.good = [];
  vm.warn = [];
  vm.severe = [];
  vm.nostatus = [];
  vm.jurisdictions = {};

  vm.statusNames = {
    good: 'Good',
    warn: 'Warning',
    severe: 'Inactive'
  };

  vm.selectedRegionId = '';
  vm.noInfoAvailable = {
    infoType: 'info',
    name: '',
    status: ''
  };

  vm.selectRegion = function(region) {
    vm.selectedRegionId = region;
    if (typeof vm.jurisdictions !== 'undefined') {
      if (typeof vm.jurisdictions[region] !== 'undefined') {
        vm.selectedRInfo = vm.jurisdictions[region];
        vm.selectedRInfo.infoType = 'info';
        vm.selectedRInfo.regionImage = region + '.png';
      } else {
        vm.noInfoAvailable.name = region;
        vm.selectedRInfo = vm.noInfoAvailable;
      }
    } else {
      //No data, do nothing
    }
  };

  vm.showList = function(listType) {

    vm.selectedRInfo = {
      infoType: 'statusList',
      name: vm.statusNames[listType],
      status: vm[listType].length,
      fullList: vm[listType]
    };
  };

  vm.tacTitle = TACService.getTitle();
  vm.tacText = TACService.getText();
  vm.dismissed = TACService.hasBeenDismissed();
  vm.dismiss = function() {
    TACService.dismiss();
    vm.dismissed = TACService.hasBeenDismissed();
  }
  vm.disagree = function() {
    TACService.decline();
  }


  /* Profile message */
  // Check if the user have a profile, if not, ask for create fill a new one.
  vm.loadProfile = function() {
    AddressBookService.getContactByEmail(Auth.user.get().email)
    .then(function(response) {
      vm.noProfileAvailable = (response.contact === null);
    }, function(error) {
      console.error('Error fetching contact by email', error); // eslint-disable-line
    });
  };

  if (!Auth.user.authenticated()) {
    $state.go('landing');
  } else {
    vm.loadJurisdistionStatus();
    vm.loadProfile();
  }


});

angular.module('steve2')

.factory('JurisdictionStatus', function ($http, ConfigService) {

  var getPromise;

  function fetch() {
    return $http({
      method: 'GET',
      url: ConfigService.api.baseUrl + '/status/jurisdiction'
    }).then(function (response) {
      return response && response.data;
    });
  }

  function filterFor(jurisdiction) {
    return function (data) {
      if (!jurisdiction) {
        return data;
      }
      return data.jurisdictions[jurisdiction];
    }
  }

  function get(jurisdiction) {
    getPromise = getPromise || fetch();
    return getPromise.then(filterFor(jurisdiction));
  }

  return {
    get: get
  }
})

angular.module('steve2')

.factory('DataWidget', function($filter, ConfigService, $http) {
  function get(appName) {
    return $http({
      method: 'GET',
      url: ConfigService.api.baseUrl + '/widgets/' + appName
    }).then(function(response) {
      return response && response.data;
    }, function(error) {
      console.log(error); // eslint-disable-line
    })
  }

  function getGraph(dataWidget, compact) {
    if (compact) {
      return {
        type: dataWidget.type,
        title: dataWidget.compact_title || dataWidget.title,
        message: dataWidget.message,
        options:  {
          fill: true,
          elements: { point: { radius: 0 } },
          scales: {
            xAxes: [{ display: false }],
            yAxes: [{ display: false }]
          }
        },
        data: Object.values(dataWidget.jsondata.data),
        series: Object.keys(dataWidget.jsondata.data),
        labels: dataWidget.jsondata.labels,
        color: 'default',
        weight: dataWidget.weight
      };
    }

    return {
      type: dataWidget.type,
      title: dataWidget.title,
      message: dataWidget.message,
      options:  {
        fill: true,
        scales: {
          xAxes: [{ display: true }],
          yAxes: [{ display: true }]
        }
      },
      data: Object.values(dataWidget.jsondata.data),
      series: Object.keys(dataWidget.jsondata.data),
      labels: dataWidget.jsondata.labels,
      weight: dataWidget.weight
    };
  }

  function getStatus(dataWidget, compact) {
    if (compact) {
      return {
        type: dataWidget.type,
        title: dataWidget.compact_title || dataWidget.title || null,
        value: dataWidget.jsondata.value || null,
        message: dataWidget.message || null,
        color: dataWidget.color || 'default',
        weight: dataWidget.weight
      };
    }

    return {
      type: dataWidget.type,
      title: dataWidget.title || null,
      value: dataWidget.jsondata.value || null,
      message: dataWidget.message || null,
      color: dataWidget.color || 'default',
      weight: dataWidget.weight
    };
  }

  function getGauge(dataWidget, compact) {
    if (compact) {
      return {
        type: dataWidget.type,
        title: dataWidget.compact_title || dataWidget.title || '',
        message: dataWidget.message || '',
        min: dataWidget.jsondata.min || 0,
        max: dataWidget.jsondata.max,
        value: dataWidget.jsondata.value,
        color: $filter('injectColors')(dataWidget.color),
        weight: dataWidget.weight
      };
    }

    return {
      type: dataWidget.type,
      title: dataWidget.title || '',
      message: dataWidget.message || '',
      min: dataWidget.jsondata.min || 0,
      max: dataWidget.jsondata.max,
      value: dataWidget.jsondata.value,
      color: $filter('injectColors')(dataWidget.color),
      weight: dataWidget.weight
    };
  }

  function getTable(dataWidget, compact) {
    if (compact) {
      return {
        type: dataWidget.type,
        title: dataWidget.compact_title || dataWidget.title || '',
        rows: dataWidget.jsondata.rows.length,
        color: 'default',
        weight: dataWidget.weight
      };
    }

    return {
      type: dataWidget.type,
      title: dataWidget.title || '',
      message: dataWidget.message || '',
      headers: dataWidget.jsondata.headers,
      rows: dataWidget.jsondata.rows,
      weight: dataWidget.weight
    };
  }

  function getWidget(widgetData, compact) {
    var widget;
    var _widgetData = angular.copy(widgetData);
    _widgetData.jsondata = angular.fromJson(_widgetData.jsondata);

    switch (_widgetData.type) {
      case 'status':
        widget = getStatus(_widgetData, compact);
        break;
      case 'gauge':
        widget = getGauge(_widgetData, compact);
        break;
      case 'graph':
        widget = getGraph(_widgetData, compact);
        break;
      case 'table':
        widget = getTable(_widgetData, compact);
        break;
    }

    return widget;
  }

  return {
    get: get,
    getWidget: getWidget
  }
});

'use strict';

angular.module('steve2')

  .controller('Send2Controller', function ($scope, $state,
    $timeout, $http, $rootScope, MailServiceCache, ConfigService,
    Intervals, Auth, ListsService, toaster, filterFilter, $translate, $uibModal) {

    var vm = this;
    vm.showProgress = false;
    vm.message = {};
    vm.message.selectedRecipients = '';

    // Setting success prompt properties for adding and removing recipients when sending files (for questions: dbrothers@ruvos.com) {

    vm.recipientAdded = false;
    vm.recipientRemoved = false;

    vm.totalFileSize = 0;
    vm.mbFileSizeLimit = 999
    vm.fileSizeLimitReached = false;
    vm.fileSizeInBytes = false;
    vm.fileSizeInKB = false;
    vm.fileSizeInMB = false;
    vm.fileSizeString = ''
    vm.listFileExists = false
    vm.existingFile = ''

    // This function adds 'Add recipient...' string to end of recipient list in selectedRecipients as well as setting recipientAdded
    // to true then back to false after 1s. This is for the Added recipient prompt for frontend (for questions: dbrothers@ruvos.com)
    vm.recipientAdd = function () {
      var filteredItems = []
      for (i = 0; i < vm.message.selectedRecipients.length; i++) {
        if (vm.message.selectedRecipients[i].listName !== 'Add recipient...') {
          filteredItems.push(vm.message.selectedRecipients[i])
        }
      }

      vm.message.selectedRecipients = filteredItems
      vm.message.selectedRecipients.push({ listName: 'Add recipient...' })
      vm.recipientAdded = true;
      vm.mbFileSizeLimit = resetMaxFileSize();

      $timeout(function () {
        vm.recipientAdded = false;
      }, 1000)
    }

    // This function sets selectedRecipients to an empty string if there are only 2 items in the array
    // which would be the last recipient and the string 'Add recipient...' it also sets recipientAdded to true
    // then back to false after 1s. This is for the Removed recipient prompt for frontend (for questions: dbrothers@ruvos.com)
    vm.recipientRemove = function () {
      if (vm.message.selectedRecipients.length === 2) {
        vm.message.selectedRecipients = '';
      }
      vm.mbFileSizeLimit = resetMaxFileSize();
      vm.recipientRemoved = true;

      $timeout(function () {
        vm.recipientRemoved = false;
      }, 1000)
    }
    // }

    // This function filters through the list when the remove button is clicked and removes the selected item 
    // from selectedRecipients. The element that is clicked is .remove-recipient-x which is created to cover the x 
    // that is used to remove the recipients as creating this element was cleaner than accessing the current button selector.
    // The dimensions of this element can be found in mailbox.less (for questions: dbrothers@ruvos.com) {
    vm.removeFromSelectedRecipients = function (removedItem) {
      var filteredItems = [];
      for (i = 0; i < vm.message.selectedRecipients.length; i++) {
        if (vm.message.selectedRecipients[i].listName !== removedItem) {
          filteredItems.push(vm.message.selectedRecipients[i])
        }
      }
      vm.message.selectedRecipients = filteredItems;
      vm.mbFileSizeLimit = resetMaxFileSize();
    }
    // }

    var toRecipients = [];
    ListsService.getLists()
      .then(function (response) {
        toRecipients = ListsService.getListsBy(response.lists, {
          listType: 'outbound',
          enabled: 'true'
        });
        vm.fileTypes = ListsService.getListFileTypes(toRecipients);
      });

    $scope.$watch('send2.message.filetype', function (newValue, oldValue) {
      vm.message.selectedRecipients = '';
      if (typeof newValue !== 'undefined') {
        vm.to = ListsService.getListsBy(toRecipients, {
          fileType: newValue
        });
        vm.all = filterFilter(vm.to, function (element) {
          return element.includeInAll === 1
        });
        vm.nchsOnly = filterFilter(vm.to, function (element) {
          return element.listName.indexOf('NCHS') > -1
        });
        vm.jurOnlyTemp = filterFilter(vm.to, function (element) {
          if ((element.protected === 'true') &&
            (element.listName.indexOf('NCHS') === -1) &&
            (element.listName.indexOf('CPSC') === -1)) {
            return true
          }
          return false
        });
        vm.jurOnly = filterFilter(vm.jurOnlyTemp, function (element) {
          if ((element.nonJurisdiction === 'false')) {
            console.log('JurOnly:', element.listName);
            return true
          }
          return false
        });
        if (vm.destType === 'All' && vm.all.length === 0) {
          vm.destType = undefined;
        }
      }
    });

    vm.showAllDestinationsModal = function () {
      $uibModal.open({
        animation: false,
        templateUrl: 'app/mailbox/sendfile2-all-details.tpl.html',
        controller: 'Send2AllDetailsModalController',
        controllerAs: 'allModal',
        size: 'md',
        resolve: {
          allDestinations: function () {
            return angular.copy(vm.all || []);
          },
          fileTypeLabel: function () {
            return vm.message.filetype;
          }
        }
      });
    };

    vm.doSelectRecipient = function (destType) {
      if (vm.message.filetype === 'Other') {
        vm.destType = 'Custom';
      }

      vm.modRecip = [];
      if (destType === 'All') {
        vm.modRecip = vm.all;
      } else {
        if (destType === 'NCHS') {
          vm.modRecip = vm.nchsOnly;
        } else {
          if (destType === 'Jurisdictions') {
            vm.modRecip = vm.jurOnly;
          } else {
            if (vm.message.selectedRecipients !== '') {
              vm.modRecip = vm.message.selectedRecipients;
            }
          }
        }
      }
      //vm.refreshFileDisplay();
    }

    $scope.$watch('send2.message.filetype', function (newValue, oldValue) {
      vm.doSelectRecipient(vm.destType);
    });

    $scope.$watch('send2.destType', function (newValue, oldValue) {
      vm.doSelectRecipient(newValue);
    });

    $scope.$watch('send2.message.selectedRecipients', function (newValue, oldValue) {
      vm.doSelectRecipient(vm.destType);
    });

    vm.disableNoFile = true;

    vm.removeFile = function (currentFile) {
      var byteSize = 0;
      var filteredFiles = []
      vm.files.forEach(function (file) {
        if (currentFile.name !== file.name) {
          filteredFiles.push(file)
        }
      })
      vm.files = filteredFiles;

      vm.files.forEach(function (file) {
        byteSize += file.size;
      })

      vm.totalFileSize = friendlyFileSize(byteSize, vm.mbFileSizeLimit)
      if (vm.fileSizeInBytes) {
        vm.fileSizeString = vm.totalFileSize.toFixed(2) + ' Bytes / ' + vm.mbFileSizeLimit + ' MB Max'
      } else if (vm.fileSizeInKB) {
        vm.fileSizeString = vm.totalFileSize.toFixed(1) + ' KB / ' + vm.mbFileSizeLimit + ' MB Max'
      } else if (vm.fileSizeInMB) {
        vm.fileSizeString = vm.totalFileSize.toFixed(1) + ' MB / ' + vm.mbFileSizeLimit + ' MB Max'
      }

      vm.errors = false;
      vm.showProgress = false;
    };

    vm.refreshFileDisplay = function () {
      console.log('Current selected recipients:', vm.message.selectedRecipients)
    }

    var resetMaxFileSize = function () {
      var mbFileSizeLimit = 999;
      var restictSizeLimit = false
      for (i = 0; i < vm.message.selectedRecipients.length; i++) {
        if (vm.message.selectedRecipients[i].listName.indexOf('DRH') > -1 || vm.message.selectedRecipients[i].listName.indexOf('CPSC') > -1) {
          restictSizeLimit = true
        }
      }
      if (restictSizeLimit) {
        mbFileSizeLimit = 500;
      }
      return mbFileSizeLimit;
    }

    var friendlyFileSize = function (byteSize, mbFileSizeLimit) {
      // console.log('total byte size:',byteSize)
      var kb = 0;
      var mb = 0;
      if (byteSize > 1000) {
        kb = byteSize / 1000;
        if (kb > 1000) {
          mb = kb / 1000;
        }
        if (mb > 0) {
          vm.fileSizeInMB = true;
          if (mb > mbFileSizeLimit) {
            vm.disableNoFile = true; // using this for file limit threshold as well
            vm.fileSizeLimitReached = true;
            return mb
          } else {
            vm.fileSizeLimitReached = false;
            vm.totalFileSize = mb;
            return mb
          }
        } else {
          vm.fileSizeLimitReached = false;
          vm.fileSizeInKB = true;
          return kb;
        }
      } else {
        vm.fileSizeLimitReached = false;
        vm.fileSizeInBytes = true;
        return byteSize;
      }
    }

    vm.addFiles = function (currentFiles) {
      var fileExists = false
      var existingFileName = ''
      var byteSize = 0;
      // var mbFileSizeLimit = 50;
      currentFiles.forEach(function (file1) {
        vm.files.forEach(function (file2) {
          if (file1.name === file2.name) {
            fileExists = true
            existingFileName = file1.name
          }
          if (fileExists) return
        })
        if (fileExists) return
      })
      if (fileExists) {
        vm.existingFile = existingFileName;
        vm.listFileExists = true;
        return console.log(existingFileName, 'already exists in files to be sent.');
      }

      currentFiles.forEach(function (file) {
        vm.files.push(file)
      })
      vm.files.forEach(function (file) {
        byteSize += file.size;
      })
      vm.totalFileSize = friendlyFileSize(byteSize, vm.mbFileSizeLimit)
      if (vm.fileSizeInBytes) {
        vm.fileSizeString = vm.totalFileSize.toFixed(2) + ' Bytes / ' + vm.mbFileSizeLimit + ' MB Max'
      } else if (vm.fileSizeInKB) {
        vm.fileSizeString = vm.totalFileSize.toFixed(1) + ' KB / ' + vm.mbFileSizeLimit + ' MB Max'
      } else if (vm.fileSizeInMB) {
        vm.fileSizeString = vm.totalFileSize.toFixed(1) + ' MB / ' + vm.mbFileSizeLimit + ' MB Max'
      }
    }

    $scope.$watch('send2.files', function (newValue, oldValue) {
      // vm.filesInfo = []; // Array to hold information about each file
      if (newValue && newValue.length > 0) {
        vm.disableNoFile = false;
        var totalFileByteSize = 0
        newValue.forEach(function (val) {
          totalFileByteSize += val.size
        })

        vm.totalFileSize = friendlyFileSize(totalFileByteSize, vm.mbFileSizeLimit)


        if (vm.fileSizeInBytes) {
          vm.fileSizeString = vm.totalFileSize.toFixed(2) + ' Bytes / ' + vm.mbFileSizeLimit + ' MB Max'
        } else if (vm.fileSizeInKB) {
          vm.fileSizeString = vm.totalFileSize.toFixed(1) + ' KB / ' + vm.mbFileSizeLimit + ' MB Max'
        } else if (vm.fileSizeInMB) {
          vm.fileSizeString = vm.totalFileSize.toFixed(1) + ' MB / ' + vm.mbFileSizeLimit + ' MB Max'
        }
        // Values are not currently used for anything
        // Iterate over each file in newValue
        // newValue.forEach(function(file) {
        //   // Create an object to hold file information
        //   var fileInfo = {
        //     name: file.name,
        //     size: file.size,
        //     progressPercentage: 0
        //   };

        // Push fileInfo object to vm.filesInfo array
        //   vm.filesInfo.push(fileInfo);
        // });
        // if files were selected then enable send button
      } else {
        // Handle the case where no files are selected
        vm.disableNoFile = true;
      }
    });

    vm.uploadToSignedUrl = function (file, signedUrl, progressCallback, doneCallback, onErrorCallback) {
      var xhr = new window.XMLHttpRequest();
      xhr.upload.addEventListener("progress", function (event) {
        if (event.lengthComputable) {
          var percentComplete = (event.loaded / event.total);
          var num = percentComplete * 100;
          progressCallback(num);
        } else {
          // Unable to compute progress information since the total size is unknown
        }
      });

      xhr.onload = function () {
        //console.log(xhr);
        if (xhr.status === 200) {
          doneCallback();
        } else {
          onErrorCallback(xhr.status);
        }
      }

      xhr.upload.addEventListener("error", function (evt) {
        //console.error('ERROR IN XHR', evt);
      });
      xhr.open('PUT', signedUrl);
      xhr.send(file);
    };

    vm.refreshTknItval;
    vm.doSendFile = function () {
      var byteLimit = vm.mbFileSizeLimit * 1000000;
      var byteSize = 0;
      vm.files.forEach(function (file) {
        byteSize += file.size;
      })
      
      console.log('File size limit in bytes:', byteLimit);
      console.log('Total file size in bytes:', byteSize);

      if (byteSize > byteLimit) {
        console.log('FILE SIZE EXCEEDED');
        vm.disableWhileSending = false;
        $rootScope.sendingFile = false;
        vm.errors = 'Error. Total file size exceeded.  Please remove large file(s) and try again.';
        vm.showProgress = false;
        Intervals.cancelInterval(vm.refreshTknItval);
        return;
      }
      if (typeof vm.message.selectedRecipients === 'undefined') {
        return;
      }
      // Remove 'Add recipient....' string from end of selectedRecipients array {
      if (vm.destType === 'Custom') { vm.message.selectedRecipients.pop() }
      // }
      //console.log('Current selected recipients:', vm.message.selectedRecipients)

      vm.progressPercentage = 0;
      vm.errors = false;
      vm.doSelectRecipient(vm.destType);

      if (vm.files) {
        console.log('Files to send:', vm.files)
        vm.disableWhileSending = true;
        $rootScope.sendingFile = true;

        Auth.token.update(5);
        vm.refreshTknItval = Intervals.setInterval(function () {
          Auth.token.update(5).success(function () {
            //console.log('TOKEN UPDATED');
          }).error(function () {
            //console.error('TOKEN NOT UPDATED');
          });
        }, 30 * 1000);

        var recip = [];
        vm.modRecip.forEach(function (element, index, array) {
          recip.push({
            id: element.id,
            type: 'list',
            displayName: element.listName
          });
        });
        vm.modRecip = recip;
        vm.files.forEach(function (file) {
          $http({
            method: 'post',
            url: ConfigService.api.mailApi + '/uploadURL',
            headers: {
              'Content-Type': 'application/json'
            },
            data: {
              "AIMSPlatformFileName": file.name,
              'AIMSPlatformRecipient': vm.modRecip,
              "ContentType": file.type,
              "STEVE2FileType": vm.message.filetype
            }
          }).then(function (res) {
            vm.showProgress = true;
            vm.uploadToSignedUrl(file, res.data.url,
              function (percentComplete) {
                vm.progressPercentage = parseInt(percentComplete.toFixed(0));
                vm.progressMessage = vm.progressPercentage + '%';
                $scope.$apply();
              },
              function () {
                $timeout(function () {
                  vm.progressMessage = $translate.instant('send.done');
                  vm.showProgress = true;
                  $scope.$apply();

                  $timeout(function () {
                    toaster.pop('success', 'Completed', $translate.instant('send.filesent'));
                    $rootScope.$broadcast('file-sent');
                    Intervals.cancelInterval(vm.refreshTknItval);
                    vm.disableWhileSending = false;
                    $rootScope.sendingFile = false;
                    $state.go('index.mailbox');
                    $scope.$apply();

                    MailServiceCache.notifyCompletion({
                      "messageId": res.data.messageId
                    });

                  }, 500);

                }, 0);
              },
              function (err) {
                //console.error(err);
                vm.disableWhileSending = false;
                $rootScope.sendingFile = false;
                vm.errors = 'Error. Upload failed';
                vm.showProgress = false;
                Intervals.cancelInterval(vm.refreshTknItval);

                MailServiceCache.notifyCompletion({
                  "messageId": res.data.messageId,
                  "error": err
                });
              }
            );

          }, function (err) {
            //console.error(err);
            vm.disableWhileSending = false;
            $rootScope.sendingFile = false;
            vm.errors = 'Error. Upload failed';
            vm.showProgress = false;
            Intervals.cancelInterval(vm.refreshTknItval);
          }).catch(function (excep) {
            vm.disableWhileSending = false;
            $rootScope.sendingFile = false;
            vm.errors = 'Error. Upload failed';
            vm.showProgress = false;
            Intervals.cancelInterval(vm.refreshTknItval);
            //console.error(excep);
          });
        })


      }

    };

    vm.discardMessage = function () {

      // if (vm.message.filetype || vm.file2send) {
      if (vm.message.filetype || vm.files) {
        swal({
          title: $translate.instant('send.discardmsgtitle'),
          text: $translate.instant('send.discardmsg'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: $translate.instant('yes'),
          cancelButtonText: $translate.instant('cancel')
        }, function (isConfirm) {
          if (isConfirm) {
            $state.go('index.mailbox');
          }
        });
      } else {
        $state.go('index.mailbox');
      }

    };
    //console.log('dest type:', vm.destType)

  })

  .controller('Send2AllDetailsModalController', function ($uibModalInstance, allDestinations, fileTypeLabel) {
    var vm = this;
    vm.destinations = allDestinations;
    vm.fileType = fileTypeLabel;
    vm.close = function () {
      $uibModalInstance.close();
    };
  })

  ;

'use strict';

angular.module('steve2')

.factory('MailServiceCache', function($q, $http, ConfigService, $timeout) {

  if (!CacheFactory.get('mailCache')) { // eslint-disable-line
    CacheFactory.createCache('mailCache', { //eslint-disable-line
      deleteOnExpire: 'aggressive',
      storageMode: 'sessionStorage'
    });
  }

  var mailCache = CacheFactory.get('mailCache'); // eslint-disable-line

  // generateId :: Integer -> String
  function generateId (len) {
    return Math.random().toString(36).substr(2, len);
  }

  function getMail(place, params) {
    var url = ConfigService.api.mailApi + '/files/';
    var _params = params;

    if (angular.isDefined(_params.status)) {
      if (_params.status) {
        _params.status = 'unread';
      } else {
        delete _params.status;
      }
    }

    if (angular.isString(place)) {
      // Folder
      url += place;
    } else {
      // List
      url += 'list';
      _params.listId = place.id;
    }
    _params.cache = generateId(8);

    var deferred = $q.defer();

    $http({
      method: 'GET',
      url: url,
      params: _params,
      cache: mailCache
    })
    .then(function(response) {
      var items = response.data.Items;
      $timeout(function() {
        deferred.resolve({
          data: items,
          count: response.data.Count,
          unread: response.data.unreadCount
        });
      }, 0);

    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  }

  function getStatus() {
    var deferred = $q.defer();

    $http({
      method: 'GET',
      url: ConfigService.api.mailApi + '/status'
    }).then(function(response) {
      deferred.resolve({
        status: response.data
      });
    }, function(error) {
      //console.log('ERROR loading from external', error);
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  }

  function downloadFile(messageId) {
    var deferred = $q.defer();
    params = {};
    params.cache = generateId(8);
    $http({
      method: 'GET',
      url: ConfigService.api.mailApi + '/message/' + messageId,
      params: params
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(exception) {
      deferred.reject({
        error: exception
      });
    });

    return deferred.promise;
  }

  function getRecipients() {
    var deferred = $q.defer();

    $http({
      method: 'GET',
      url: ConfigService.api.mailApi + '/recipients',
      cache: mailCache
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  }

  function getRecipientsByType(recType) {
    var deferred = $q.defer();

    $http({
      method: 'GET',
      url: ConfigService.api.mailApi + '/recipients',
      cache: mailCache
    }).then(function(response) {
      var recList = response.data;
      if (typeof recList.errorno !== 'undefined') {
        deferred.reject({
          error: recList
        });
        return deferred.promise;
      }

      var typedList = [];
      recList.forEach(function(element)  {
        if (element.type === recType) {
          typedList.push(element);
        }
      });

      deferred.resolve({
        data: typedList
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  }

  function clearCache() {
    mailCache.removeAll();
  }

  function notifyCompletion(data) {
    $http({
      method: 'post',
      url: ConfigService.api.mailApi + '/completedUpload',
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    }).then(function() {
      //console.log(response);
    });
  }

  function deleteMessages(messageIds) {
    var deferred = $q.defer();

    var url = ConfigService.api.baseUrl + '/inbox';
    var payload = { ids: messageIds };

    $http({
      method: 'DELETE',
      url: url,
      data: payload,
      headers: {'Content-Type': 'application/json;charset=utf-8'}
    })
      .then(function(response) {
        deferred.resolve({
          data: response.data
        });
      }, function(error) {
        deferred.reject({
          error: error
        });
      });
    return deferred.promise;
  }

  function downloadMultiple(listId, messageIds) {
    var deferred = $q.defer();

    var url = ConfigService.api.baseUrl + '/inbox/export/' + listId;
    var payload = { messageIds: messageIds };

    $http({
      method: 'POST',
      url: url,
      data: payload,
      headers: {'Content-Type': 'application/json;charset=utf-8'}
    })
      .then(function(response) {
        deferred.resolve({
          data: response.data
        });
      }, function(error) {
        deferred.reject({
          error: error
        });
      });
    return deferred.promise;
  }

  function getDeliveryStatus(messageId) {
    var deferred = $q.defer();

    $http({
      method: 'GET',
      url: ConfigService.api.mailApi + '/delivery/' + messageId
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  }

  function downloadUnread(listId) {
    var deferred = $q.defer();

    $http({
      method: 'POST',
      url: ConfigService.api.mailApi + '/inbox/unread/export/' + listId
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  }

  function deleteRead(listId) {
    return $http({
      method: 'DELETE',
      url: ConfigService.api.mailApi + '/inbox/read/' + listId
    }).then(function(res) {
      return res.data;
    }, function(error) {
      return error;
    });
  }

  return {
    getMail: getMail,
    getStatus: getStatus,
    downloadFile: downloadFile,
    downloadUnread: downloadUnread,
    getRecipients: getRecipients,
    getRecipientsByType: getRecipientsByType,
    notifyCompletion: notifyCompletion,
    clearCache: clearCache,
    deleteMessages: deleteMessages,
    downloadMultiple: downloadMultiple,
    getDeliveryStatus: getDeliveryStatus,
    deleteRead: deleteRead
  };

});

'use strict';

angular.module('steve2')

  .controller('MailboxController', function (Auth, $state, ListsService, $translate,
    MailServiceCache, $stateParams, $timeout, $scope, toaster, $uibModal, $cookies, Intervals) {
    var vm = this;

    vm.folder = $stateParams.place;
    vm.currentPage = 1;
    vm.pageSize = $cookies.get('mail.pageSize') || '20';
    vm.read = false;
    vm.selectedBulkRows = [];
    vm.mailCollection = [];

    vm.loadLists = function () {
      ListsService.getLists4User()
        .then(function (response) {
          vm.lists = response.lists;
        });
    };

    var folderNames = {
      inbox: $translate.instant('mail.tome'),
      sent: $translate.instant('mail.sent')
    };

    vm.load = function () {
      vm.loading = true;
      vm.errors = false;
      vm.refreshView = vm.mailCollection.length === 0;
      var place = vm.folder === null ? vm.list : vm.folder;

      var params = {
        page: vm.currentPage - 1,
        pageSize: vm.pageSize
      };

      if (vm.read) {
        params.status = 'unread';
      }

      if (vm.searchFilename) {
        params.search = vm.searchFilename;
      }

      MailServiceCache.getMail(place, params)
        .then(function (response) {
          vm.mailCollection = [];
          response.data.forEach(function (element) {
            var id = typeof element.id !== 'undefined' ? element.id : element.messageId;
            if (vm.selectedBulkRows.indexOf(id) > -1) {
              element.checked = true;
            }

            vm.mailCollection.push(element);
          });

          vm.totalCount = response.count;
          vm.unreadCount = response.unread || 0;
        }, function () {
          vm.errors = $translate.instant('mail.errorloading');
        }).finally(function () {
          vm.loading = false;
        });
    };

    vm.setFolder = function (vFolder) {
      vm.folder = vFolder;
      vm.list = null;
      vm.placeName = folderNames[vFolder];
      vm.placeFileType = null;
      vm.currentPage = 1;
      vm.selectedBulkRows = [];
      vm.mailCollection = [];

      vm.checkForNew();
    };

    vm.setList = function (vList) {
      vm.folder = null;
      vm.list = vList;
      vm.placeName = vList.listName;
      vm.placeFileType = vList.fileType;
      vm.currentPage = 1;
      vm.selectedBulkRows = [];
      vm.mailCollection = [];

      vm.checkForNew();
    };

    $scope.$watch('mail.currentPage', function () {
      vm.load();
    });

    $scope.$watch('mail.pageSize', function (newValue) {
      $cookies.put('mail.pageSize', newValue);
      if (vm.currentPage === 1) {
        vm.load();
      } else {
        vm.currentPage = 1;
      }
    });

    vm.searchByFilename = function () {
      vm.currentPage = 1;
      vm.load();
    };

    vm.clearSearch = function () {
      vm.searchFilename = null;
      vm.currentPage = 1;
      vm.load();
    };

    vm.entrySelected = function (row) {
      var id = angular.isDefined(row.id) ? row.id : row.messageId;
      if (row.checked) {
        vm.selectedBulkRows.push(id);
      } else {
        vm.selectedBulkRows = _.pull(vm.selectedBulkRows, id); // eslint-disable-line
      }
    };

    vm.clearSelection = function () {
      vm.selectedBulkRows = [];
      vm.mailCollection.forEach(function (element) {
        element.checked = false;
      });
    };

    vm.getStatusLabelClass = function (row) {
      if (!row) { return 'label-info'; }
      var s = (row.status != null) ? String(row.status).toLowerCase() : '';
      if (s === 'invalid' || s === 'error' || s === 'upload incomplete' ||
          s === 'no routes enabled' || s === 'no recipients enabled' || s.indexOf('fail') !== -1) { return 'label-danger'; }
      if (s === 'cancelled') { return 'label-warning'; }
      var hasWarnings = row.warnings &&
        (typeof row.warnings !== 'string' || row.warnings.trim() !== '');
      if (hasWarnings) { return 'label-warning'; }
      return 'label-info';
    };

    vm.filterUnread = function () {
      vm.currentPage = 1;
      vm.load();
    }

    vm.checkForNew = function (noReset) {
      MailServiceCache.clearCache();
      $timeout(function () {
        if (!noReset) {
          vm.currentPage = 1;
        }

        vm.load();
      }, 500); // wait a bit until the cache is cleared
      vm.loadLists();
      vm.lastUpdate = new Date();
    }

    vm.deleteSelected = function () {
      if (vm.selectedBulkRows.length > 0) {
        swal({ // eslint-disable-line
          title: $translate.instant('mail.deletemsgtitle'),
          text: $translate.instant('mail.deletemsg'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: $translate.instant('yes'),
          cancelButtonText: $translate.instant('cancel')
        }, function (isConfirm) {
          if (isConfirm) {
            MailServiceCache.deleteMessages(vm.selectedBulkRows)
              .then(function () {
                vm.checkForNew();
                vm.clearSelection();
              }, function (error) {
                console.error('Error deleting', error); // eslint-disable-line
              });
          }
        });
      }
    }; //  DELETE FILES

    $scope.$on('file-sent', function () {
      vm.checkForNew();
    });

    vm.downloadFile = function (item) {
      MailServiceCache.downloadFile(item.messageId)
        .then(function (response) {
          var url = response.data.url;
          var a = document.createElement('a'); // eslint-disable-line
          a.href = url;
          a.style.display = 'none';
          document.body.appendChild(a); // eslint-disable-line
          a.click();
          a.parentNode.removeChild(a);
          if (vm.folder !== 'sent') {
            item.status = 'read';
          }

          vm.checkForNew(true);
        }, function () {
          toaster.pop('error', 'Error', $translate.instant('mail.filenotavail'));
        });
    };

    vm.selectItem = function (row) {
      vm.selectedRow = row;

      var modalInstance = $uibModal.open({
        animation: false,
        templateUrl: 'app/mailbox/details.tpl.html',
        controller: 'ModalController as modal',
        size: 'lg',
        resolve: {
          selectedRow: function () {
            return vm.selectedRow;
          },
          messageFolder: function () {
            return vm.folder;
          }
        }
      });

      modalInstance.result.then(function (result) {
        if (result) { vm.checkForNew(true); }
      });
    };

    vm.downloadMultiple = function () {
      if ((vm.list === null) || (vm.selectedBulkRows.length === 0)) {
        return;
      }

      swal({ // eslint-disable-line
        title: $translate.instant('mail.downloadmultiple.alerttitle'),
        text: $translate.instant('mail.downloadmultiple.alerttext'),
        type: "info",
        closeOnConfirm: false,
        showLoaderOnConfirm: true,
        showCancelButton: true,
        confirmButtonColor: '#747a3f',
        cancelButtonColor: '#c2c2c2',
        confirmButtonText: $translate.instant('yes'),
        cancelButtonText: $translate.instant('cancel')
      },
        function () {
          MailServiceCache.downloadMultiple(vm.list.id, vm.selectedBulkRows)
            .then(function () {
              $timeout(function () {
                swal($translate.instant('mail.downloadmultiple.success'), $translate.instant('mail.downloadmultiple.successmsg'), 'success'); // eslint-disable-line
              });
            }, function () {
              $timeout(function () {
                swal($translate.instant('mail.downloadmultiple.error'), $translate.instant('mail.downloadmultiple.errormsg'), 'error'); // eslint-disable-line
              });
            });

        });
    }

    vm.downloadUnread = function () {
      // TODO: Download all unread messages

      if (vm.list === null) {
        return;
      }

      swal({ // eslint-disable-line
        title: $translate.instant('mail.downloadunread.alerttitle'),
        text: $translate.instant('mail.downloadunread.alerttext'),
        type: "info",
        closeOnConfirm: false,
        showLoaderOnConfirm: true,
        showCancelButton: true,
        confirmButtonColor: '#747a3f',
        cancelButtonColor: '#c2c2c2',
        confirmButtonText: $translate.instant('yes'),
        cancelButtonText: $translate.instant('cancel')
      },
        function () {
          MailServiceCache.downloadUnread(vm.list.id)
            .then(function () {
              $timeout(function () {
                swal($translate.instant('mail.downloadunread.success'), $translate.instant('mail.downloadunread.successmsg'), 'success'); // eslint-disable-line
              });
            }, function () {
              $timeout(function () {
                swal($translate.instant('mail.downloadunread.error'), $translate.instant('mail.downloadunread.errormsg'), 'error'); // eslint-disable-line
              });
            });

        });

    }

    vm.deleteRead = function () {
      if (vm.list !== null) {
        // Call the service method
        swal({ // eslint-disable-line
          title: $translate.instant('mail.deleteread.alerttitle'),
          text: $translate.instant('mail.deleteread.alerttext'),
          type: 'warning',
          showLoaderOnConfirm: true,
          closeOnConfirm: false,
          showCancelButton: true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: $translate.instant('yes'),
          cancelButtonText: $translate.instant('cancel')
        }, function (isConfirm) {
          if (isConfirm) {
            MailServiceCache.deleteRead(vm.list.id)
              .then(function (data) {
                vm.checkForNew();
                $timeout(function () {
                  var message = '';
                  if (data.trashedCount <= 1) {
                    message = $translate.instant('mail.deleteread.successmsg_' + data.trashedCount);
                  } else {
                    message = $translate.instant('mail.deleteread.successmsg', { readCount: data.trashedCount });
                  }
                  swal($translate.instant('mail.deleteread.success'), message, 'success'); // eslint-disable-line
                });
              }, function () {
                swal($translate.instant('mail.deleteread.error'), $translate.instant('mail.deleteread.errormsg'), 'error'); // eslint-disable-line
              });
          }
        });
      }
    }

    if (!Auth.user.authenticated()) {
      $state.go('landing');
    } else {
      vm.loadLists();
      vm.setFolder(vm.folder);

      Intervals.setInterval(function () {
        vm.checkForNew();
      }, 5 * 60 * 1000); // Check for new mail every 5 minutes
    }

  })

  .controller('ModalController', function (selectedRow, messageFolder, $uibModalInstance,
    $rootScope, MailServiceCache, toaster, $translate) {
    var vm = this;

    vm.row = selectedRow;
    vm.folder = messageFolder;
    vm.fileDownloaded = false;

    vm.getStatusLabelClass = function (row) {
      if (!row) { return 'label-info'; }
      var s = (row.status != null) ? String(row.status).toLowerCase() : '';
      if (s === 'invalid' || s === 'error' || s === 'upload incomplete' ||
          s === 'no routes enabled' || s === 'no recipients enabled' || s.indexOf('fail') !== -1) { return 'label-danger'; }
      if (s === 'cancelled') { return 'label-warning'; }
      var hasWarnings = row.warnings &&
        (typeof row.warnings !== 'string' || row.warnings.trim() !== '');
      if (hasWarnings) { return 'label-warning'; }
      return 'label-info';
    };

    if (vm.folder === 'sent') {
      //As for the message delivery status
      MailServiceCache.getDeliveryStatus(vm.row.messageId)
        .then(function (response) {
          vm.deliveryStatus = response.data;
        }, function () {
          vm.deliveryStatus = [];
        });
    }

    vm.close = function () {
      $uibModalInstance.close(vm.fileDownloaded);
    };

    vm.updateStatus = function () {
      MailServiceCache.getStatus()
        .then(function (response) {
          $rootScope.$broadcast('mail-status-updated', response.status);
        });
    }

    vm.downloadFile = function (item) {
      MailServiceCache.downloadFile(item.messageId)
        .then(function (response) {
          var url = response.data.url;
          var a = document.createElement('a'); // eslint-disable-line
          a.href = url;
          a.style.display = 'none';
          document.body.appendChild(a); // eslint-disable-line
          a.click();
          a.parentNode.removeChild(a);
          if (vm.folder !== 'sent') {
            item.status = 'read';
          }

          vm.fileDownloaded = true;
        }, function () {
          toaster.pop('error', 'Error', $translate.instant('mail.filenotavail'));
        });
    };

  })

  ;

(function (window, angular) {
  angular
    .module("login-frontend", [])
    .service("Auth", AuthService)
    .service("authInterceptor", authInterceptor)
    .component("loginFrontend", {
      templateUrl: "/templates/login-frontend.tpl.html",
      controller: LoginController,
      bindings: {
        loginUrl: "<",
        lookupUrl: "<",
        /** Public app base URL for Keycloak redirect_uri (e.g. `AIMS_APP_URL`); falls back to current location if unset. */
        appBaseUrl: "<",
        backState: "@",
        application: "@",
        authenticatedState: "@",
      },
    })
    .component("loginButton", {
      templateUrl: "/templates/login-button.tpl.html",
      bindings: {
        loginState: "@",
      },
    })
    .component("logoutButton", {
      templateUrl: "/templates/logout-button.tpl.html",
      controller: LogoutController,
    });

  authInterceptor.$inject = ["$q", "Auth"];

  // Service for authorization information and functions
  function AuthService() {
    // `window.auth` is assigned in `setupKeycloak`, which is called from
    // `setupRealm` during the application setup/bootstrapping process
    var keycloak = window.auth;
    var get = function get() {
      return keycloak;
    };
    // Set logout function to use by default; Auth.user.logout(fn) will try to use
    // the passed function first, then this `_logoutFn`, then `keycloak.logout()`
    var _logoutFn = void 0;
    var setLogout = function setLogout(fn) {
      _logoutFn = fn;
    };
    // The whitelist (if present) determines which urls activate the interceptor
    var whitelist = window.authWhitelist;
    // // TOKEN // //
    var token = {
      get: function get() {
        return keycloak.token;
      },
      refreshParsed: function refreshParsed() {
        return keycloak.refreshTokenParsed;
      },
      idParsed: function idParsed() {
        return keycloak.idTokenParsed;
      },
      issuer: function issuer() {
        return keycloak.idTokenParsed.iss;
      },
      update: function update(minValidity) {
        return keycloak.updateToken(minValidity);
      },
    };
    // // USER // //
    var user = {
      authenticated: function authenticated() {
        return keycloak.authenticated;
      },
      get: function get() {
        return token.idParsed();
      },
      roles: roles,
      realmRoles: realmRoles,
      clientRoles: clientRoles,
      hasRealmRole: hasRealmRole,
      hasClientRole: hasClientRole,
      logout: logout,
    };
    // Get roles (e.g., realm roles, client roles); defaults to realm roles
    function roles(accessLevel, clientName) {
      if (accessLevel === "resource" || accessLevel === "client")
        return clientRoles(clientName);
      return realmRoles();
    }
    // Get the roles assigned to the user for the current Keycloak realm
    function realmRoles() {
      if (keycloak.realmAccess) return keycloak.realmAccess.roles;
    }
    // Check whether user has given realm role
    function hasRealmRole(role) {
      var userRoles = realmRoles();
      return userRoles && userRoles.indexOf(role) > -1;
    }
    // Get the roles assigned to the user for a given Keycloak client
    function clientRoles(clientName) {
      if (keycloak.resourceAccess && keycloak.resourceAccess[clientName]) {
        return keycloak.resourceAccess[clientName].roles;
      }
    }
    // Check whether user has given role for given client
    function hasClientRole(client, role) {
      var userRoles = clientRoles(client);
      return userRoles && userRoles.indexOf(role) > -1;
    }
    // Called from interceptor, if it needs to log user out
    function logout(logoutFn) {
      if (typeof logoutFn !== "undefined") logoutFn();
      else if (typeof _logoutFn !== "undefined") _logoutFn();
      else keycloak.logout();
    }
    // // REALM // //
    var realm = {
      getName: function getName() {
        return token.issuer().split("/").pop();
      },
      access: function access() {
        return keycloak.realmAccess;
      },
    };
    return {
      get: get,
      setLogout: setLogout,
      whitelist: whitelist,
      token: token,
      user: user,
      realm: realm,
      // Shimmed old functions, backwards compatible
      isAuthenticated: user.authenticated,
      getUser: user.get,
      getRealmName: realm.getName,
      getRoles: user.realmRoles,
    };
  }

  // Auth interceptor, provides the bearer token when requests are made
  function authInterceptor($q, Auth) {
    var interceptor = {
      request: request,
    };
    return interceptor;

    function request(config) {
      // This prevents templates from activating the auth interceptor
      if (config.url.match(/.html$/)) {
        return config;
      }

      // Auth interceptor to only be activated by whitelist
      // This ensures auth interceptor only activated by whitelisted pattern (if present)
      if (Auth.whitelist) {
        var matched = false;
        // Support single whitelisted URL or array of URLs
        if (typeof Auth.whitelist === "string") {
          matched = config.url.match(Auth.whitelist);
        } else {
          Auth.whitelist.forEach(function (whitelistUrl) {
            if (config.url.match(whitelistUrl)) matched = true;
          });
        }

        if (!matched) {
          // console.log('WHITELIST ROUTE NOT MATCHED');
          return config;
        }
        // console.log('WHITELIST ROUTE MATCHED');
      }

      // If the auth object is not present
      if (typeof Auth.get() === "undefined") {
        return config;
      }

      // Activate the auth interceptor if not otherwise skipped
      var deferred = $q.defer();
      if (Auth.token.get()) {
        Auth.get()
          .updateToken(5)
          .success(function () {
            config.headers = config.headers || {};
            config.headers.Authorization = "Bearer " + Auth.token.get();
            deferred.resolve(config);
          })
          .error(function () {
            deferred.reject("Failed to refresh token");
            // Kick the user out
            Auth.user.logout();
          });
      } else {
        deferred.resolve(config);
      }
      return deferred.promise;
    }
  }

  // LoginController for the login window
  function LoginController($scope, $http, $state, $log, Auth, $window) {
    var vm = this;
    $scope.$log = $log;

    if (Auth.user.authenticated()) {
      if (typeof vm.authenticatedState !== "undefined") {
        $state.go(vm.authenticatedState);
      } else {
        $state.go("/");
      }
    }

    $scope.slide1 = true;
    $scope.slide2 = false;
    $scope.slide3 = false;

    $scope.realms = [];
    $scope.realmURLs = {};

    $scope.lookup = function lookup() {
      var email = $scope.email;

      $http
        .get("/app/login-frontend/realmNames.json")
        .then(function (data) {
          $scope.realms = data.data;
          const savedRealmName = $window.localStorage.getItem("savedRealmName");
          $scope.savedRealmName = savedRealmName;
          const savedRealmId = $window.localStorage.getItem("savedRealmId");
          $scope.savedRealmId = savedRealmId;
        })
        .catch(function (data) {
          $log.log(data);
        });

      $scope.slide1 = false;
      $scope.slide2 = true;
    };

    $scope.lookup();

    $scope.goMailSlide = function goMailSlide() {
      $scope.slide1 = true;
      $scope.slide2 = false;
    };

    $scope.login = function login(realm) {
      $log.log("login with realm arg: ", realm);
      const realms = $scope.realms;
      const realmId = Object.keys(realms).find(function (key) {
        return realms[key] === realm;
      });

      $window.localStorage.setItem("savedRealmName", realm);
      $window.localStorage.setItem("savedRealmId", realmId);

      deleteAimsLoginData();
      var email = $scope.email;
      var data = {
        realm: realmId,
        "auth-server-url": vm.loginUrl,
        "ssl-required": "external",
        resource: vm.application,
        "public-client": true,
      };
      setAimsLoginData(data);
      window.setupLogin(data, function (keycloak) {
        // eslint-disable-line
        var configured = vm.appBaseUrl && String(vm.appBaseUrl).trim();
        if (configured === "AIMS_APP_URL") {
          configured = "";
        }
        var redirectUri;
        if (configured) {
          redirectUri = configured.replace(/\/+$/, "");
          if (redirectUri.indexOf("?") === -1) {
            redirectUri += "/";
          }
        } else {
          redirectUri = window.location.href.substring(
            0,
            window.location.href.indexOf("#")
          );
        }
        var part = redirectUri.indexOf("?") === -1 ? "?" : "&";
        var aState = vm.authenticatedState;
        redirectUri += part + "redirect_fragment=" + aState;
        window.auth.login({
          loginHint: email,
          redirectUri: redirectUri,
        });
      });
    };

    $scope.loginWithSavedRealm = function loginWithSavedRealm() {
      this.login($scope.savedRealmName);
    };

    $scope.goHome = function goHome() {
      $state.go(vm.backState);
    };
  }

  function LogoutController($scope, Auth) {
    $scope.logout = function logout() {
      deleteAimsLoginData();
      Auth.user.logout();
    };
  }
})(window, window.angular);

// EXTRA-ANGULAR Functions that are outside of angular
var setAimsLoginData = function setAimsLoginData(data) {
  try {
    return window.createCookie("aimsLogin", JSON.stringify(data));
  } catch (e) {
    deleteAimsLoginData();
    return null;
  }
};

var getAimsLoginData = function getAimsLoginData() {
  try {
    return JSON.parse(window.readCookie("aimsLogin"));
  } catch (e) {
    deleteAimsLoginData();
    return null;
  }
};

var deleteAimsLoginData = function deleteAimsLoginData() {
  return eraseCookie("aimsLogin");
};

// The function to call to auth initialized in the app
var setupLogin = function setupLogin(keycloakData, callback) {
  var aimsData = getAimsLoginData();
  if (aimsData !== null) {
    keycloakData = aimsData;
  }
  if (keycloakData === null) {
    window.createCookie("signal", "on");
    callback();
    return;
  }
  var keycloak = Keycloak(keycloakData); // eslint-disable-line
  keycloak
    .init({ onLoad: "check-sso" })
    .success(function () {
      window.auth = keycloak;
      window.eraseCookie("signal");
      if (typeof callback !== "undefined") callback(keycloak);
    })
    .error(function () {
      deleteAimsLoginData();
      window.location.reload();
    });
};

var createCookie = function createCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var s = date.toUTCString();
    expires = "; expires=" + s;
  }
  document.cookie = name + "=" + value + expires + "; path=/"; // eslint-disable-line
};

var readCookie = function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i += 1) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

var eraseCookie = function eraseCookie(name) {
  window.createCookie(name, "", -1);
};

window.auth = {};
window.setupLogin = setupLogin;
window.setAimsLoginData = setAimsLoginData;
window.getAimsLoginData = getAimsLoginData;
window.deleteAimsLoginData = deleteAimsLoginData;
window.createCookie = createCookie;
window.readCookie = readCookie;
window.eraseCookie = eraseCookie;
angular.module("login-frontend").run([
  "$templateCache",
  function ($templateCache) {
    $templateCache.put(
      "/templates/login-button.tpl.html",
      '<div class="signin-aims-btn" ui-sref="{{$ctrl.loginState}}" aria-label="Sign in with AIMS"></div>\n'
    );
    $templateCache.put(
      "/templates/login-frontend.tpl.html",
      '<div class="login-frontend">\n\n<div class="wrapper text-center center-block">\n\n  <form class="form-signin">\n\n    <div class="image-container">\n      <!--img src="/assets/aims_logo.png" height="120px"-->\n      <img src="https://aimsplatform.com/assets/apps/aims.png" height="120px">\n    </div>\n\n    <div style="margin-bottom: 15px;" class="text-muted" ng-show="loginMessages">\n      {{loginMessages}}</span>\n    </div>\n\n    <div class="slide-container">\n      <div class="slide1" ng-show="slide1" ng-cloak>\n\n        <div class="form-group">\n          <div class="input-group">\n            <span class="input-group-addon" id="basic-addon1">\n              <i class="glyphicon glyphicon-envelope text-primary"></i>\n            </span>\n            <input type="text" class="form-control text-primary" placeholder="Email" aria-describedby="basic-addon1"\n              ng-model-options="{ debounce: 0 }"\n              id="email" name="email" ng-model="email" autofocus autocomplete="off">\n          </div>\n        </div>\n\n        <div class="center-block login-btn">\n          <button class="btn btn-primary btn-block" type="submit"\n            ng-click="lookup()">\n            Submit\n          </button>\n        </div>\n\n\n\n      </div> <!-- SLIDE 1 -->\n\n      <div class="slide2" ng-show="slide2" ng-cloak>\n\n        <!--div class="form-group">\n          <div ng-repeat="realm in realms" class="realms">\n            <a ng-bind="realm" ng-click="login(realm)"></a>\n          </div>\n        </div-->\n        <p>{{email}}</p>\n\n   <button ng-show="savedRealmId" class="btn btn-primary btn-block" type="submit"\n            ng-click="loginWithSavedRealm()">\n            {{savedRealmName}}\n          </button>\n     <div ng-show="realms.length === 0">\n          <p>User credentials not found.</p>\n        </div>\n\n        <div class="form-group text-left">\n          <ul class="list-group">\n            <a href class="list-group-item" ng-repeat="realm in realms" ng-click="login(realm)" ng-cloak>\n              {{realm | uppercase}}\n              <span class="glyphicon glyphicon-chevron-right pull-right"></span>\n            </a>\n          </ul>\n        </div>\n\n      </div> <!-- SLIDE 2 -->\n    </div>\n\n    <div class="center-block text-muted" ng-show="slide1">\n      <button type="button" ng-click="goHome()"\n        class="btn btn-link btn-sm rounded-corners text-primary">\n        Cancel\n      </button>\n    </div>\n\n      </form>\n\n  <div class="tealstrip">\n  </div>\n\n\n</div>\n</div>\n'
    );
    $templateCache.put(
      "/templates/logout-button.tpl.html",
      '<span ng-click="logout()"><i class="fa fa-sign-out"></i> Sign out</span>\n'
    );
  },
]);

 /*
 * Copyright 2016 Red Hat, Inc. and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

 (function( window, undefined ) {

    var Keycloak = function (config) {
        if (!(this instanceof Keycloak)) {
            return new Keycloak(config);
        }
  
        var kc = this;
        var adapter;
        var refreshQueue = [];
        var callbackStorage;
  
        var loginIframe = {
            enable: true,
            callbackList: [],
            interval: 5
        };
  
        var scripts = document.getElementsByTagName('script');
        for (var i = 0; i < scripts.length; i++) {
            if ((scripts[i].src.indexOf('keycloak.js') !== -1 || scripts[i].src.indexOf('keycloak.min.js') !== -1) && scripts[i].src.indexOf('version=') !== -1) {
                kc.iframeVersion = scripts[i].src.substring(scripts[i].src.indexOf('version=') + 8).split('&')[0];
            }
        }
  
        var useNonce = true;
        
        kc.init = function (initOptions) {
            kc.authenticated = false;
  
            callbackStorage = createCallbackStorage();
            var adapters = ['default', 'cordova', 'cordova-native'];
  
            if (initOptions && adapters.indexOf(initOptions.adapter) > -1) {
                adapter = loadAdapter(initOptions.adapter);
            } else if (initOptions && typeof initOptions.adapter === "object") {
                adapter = initOptions.adapter;
            } else {
                if (window.Cordova || window.cordova) {
                    adapter = loadAdapter('cordova');
                } else {
                    adapter = loadAdapter();
                }
            }
  
            if (initOptions) {
                if (typeof initOptions.useNonce !== 'undefined') {
                    useNonce = initOptions.useNonce;
                }
  
                if (typeof initOptions.checkLoginIframe !== 'undefined') {
                    loginIframe.enable = initOptions.checkLoginIframe;
                }
  
                if (initOptions.checkLoginIframeInterval) {
                    loginIframe.interval = initOptions.checkLoginIframeInterval;
                }
  
                if (initOptions.promiseType === 'native') {
                    kc.useNativePromise = typeof Promise === "function";
                } else {
                    kc.useNativePromise = false;
                }
  
                if (initOptions.onLoad === 'login-required') {
                    kc.loginRequired = true;
                }
  
                if (initOptions.responseMode) {
                    if (initOptions.responseMode === 'query' || initOptions.responseMode === 'fragment') {
                        kc.responseMode = initOptions.responseMode;
                    } else {
                        throw 'Invalid value for responseMode';
                    }
                }
  
                if (initOptions.flow) {
                    switch (initOptions.flow) {
                        case 'standard':
                            kc.responseType = 'code';
                            break;
                        case 'implicit':
                            kc.responseType = 'id_token token';
                            break;
                        case 'hybrid':
                            kc.responseType = 'code id_token token';
                            break;
                        default:
                            throw 'Invalid value for flow';
                    }
                    kc.flow = initOptions.flow;
                }
  
                if (initOptions.timeSkew != null) {
                    kc.timeSkew = initOptions.timeSkew;
                }
  
                if(initOptions.redirectUri) {
                    kc.redirectUri = initOptions.redirectUri;
                }
  
                if (initOptions.pkceMethod) {
                    if (initOptions.pkceMethod !== "S256") {
                        throw 'Invalid value for pkceMethod';
                    }
                    kc.pkceMethod = initOptions.pkceMethod;
                }
  
            }
  
            if (!kc.responseMode) {
                kc.responseMode = 'fragment';
            }
            if (!kc.responseType) {
                kc.responseType = 'code';
                kc.flow = 'standard';
            }
  
            var promise = createPromise(false);
  
            var initPromise = createPromise(true);
            initPromise.promise.success(function() {
                kc.onReady && kc.onReady(kc.authenticated);
                promise.setSuccess(kc.authenticated);
            }).error(function(errorData) {
                promise.setError(errorData);
            });
  
            var configPromise = loadConfig(config);
  
            function onLoad() {
                var doLogin = function(prompt) {
                    if (!prompt) {
                        options.prompt = 'none';
                    }
                    kc.login(options).success(function () {
                        initPromise.setSuccess();
                    }).error(function () {
                        initPromise.setError();
                    });
                }
  
                var options = {};
                switch (initOptions.onLoad) {
                    case 'check-sso':
                        if (loginIframe.enable) {
                            setupCheckLoginIframe().success(function() {
                                checkLoginIframe().success(function (unchanged) {
                                    if (!unchanged) {
                                        doLogin(false);
                                    } else {
                                        initPromise.setSuccess();
                                    }
                                }).error(function () {
                                    initPromise.setError();
                                });
                            });
                        } else {
                            doLogin(false);
                        }
                        break;
                    case 'login-required':
                        doLogin(true);
                        break;
                    default:
                        throw 'Invalid value for onLoad';
                }
            }
  
            function processInit() {
                var callback = parseCallback(window.location.href);
  
                if (callback) {
                    window.history.replaceState(window.history.state, null, callback.newUrl);
                }
  
                if (callback && callback.valid) {
                    return setupCheckLoginIframe().success(function() {
                        processCallback(callback, initPromise);
                    }).error(function (e) {
                        initPromise.setError();
                    });
                } else if (initOptions) {
                    if (initOptions.token && initOptions.refreshToken) {
                        setToken(initOptions.token, initOptions.refreshToken, initOptions.idToken);
  
                        if (loginIframe.enable) {
                            setupCheckLoginIframe().success(function() {
                                checkLoginIframe().success(function (unchanged) {
                                    if (unchanged) {
                                        kc.onAuthSuccess && kc.onAuthSuccess();
                                        initPromise.setSuccess();
                                        scheduleCheckIframe();
                                    } else {
                                        initPromise.setSuccess();
                                    }
                                }).error(function () {
                                    initPromise.setError();
                                });
                            });
                        } else {
                            kc.updateToken(-1).success(function() {
                                kc.onAuthSuccess && kc.onAuthSuccess();
                                initPromise.setSuccess();
                            }).error(function() {
                                kc.onAuthError && kc.onAuthError();
                                if (initOptions.onLoad) {
                                    onLoad();
                                } else {
                                    initPromise.setError();
                                }
                            });
                        }
                    } else if (initOptions.onLoad) {
                        onLoad();
                    } else {
                        initPromise.setSuccess();
                    }
                } else {
                    initPromise.setSuccess();
                }
            }
  
            configPromise.success(processInit);
            configPromise.error(function() {
                promise.setError();
            });
  
            return promise.promise;
        }
  
        kc.login = function (options) {
            return adapter.login(options);
        }
  
        function generateRandomData(len) {
            // use web crypto APIs if possible
            var array = null;
            var crypto = window.crypto || window.msCrypto;
            if (crypto && crypto.getRandomValues && window.Uint8Array) {
                array = new Uint8Array(len);
                crypto.getRandomValues(array);
                return array;
            }
  
            // fallback to Math random
            array = new Array(len);
            for (var j = 0; j < array.length; j++) {
                array[j] = Math.floor(256 * Math.random());
            }
            return array;
        }
  
        function generateCodeVerifier(len) {
            return generateRandomString(len, 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789');
        }
  
        function generateRandomString(len, alphabet){
            var randomData = generateRandomData(len);
            var chars = new Array(len);
            for (var i = 0; i < len; i++) {
                chars[i] = alphabet.charCodeAt(randomData[i] % alphabet.length);
            }
            return String.fromCharCode.apply(null, chars);
        }
  
        function generatePkceChallenge(pkceMethod, codeVerifier) {
            switch (pkceMethod) {
                // The use of the "plain" method is considered insecure and therefore not supported.
                case "S256":
                    // hash codeVerifier, then encode as url-safe base64 without padding
                    var hashBytes = new Uint8Array(sha256.arrayBuffer(codeVerifier));
                    var encodedHash = base64js.fromByteArray(hashBytes)
                        .replace(/\+/g, '-')
                        .replace(/\//g, '_')
                        .replace(/\=/g, '');
                    return encodedHash;
                default:
                    throw 'Invalid value for pkceMethod';
            }
        }
  
        kc.createLoginUrl = function(options) {
            var state = createUUID();
            var nonce = createUUID();
  
            var redirectUri = adapter.redirectUri(options);
  
            var callbackState = {
                state: state,
                nonce: nonce,
                redirectUri: encodeURIComponent(redirectUri)
            };
  
            if (options && options.prompt) {
                callbackState.prompt = options.prompt;
            }
  
            var baseUrl;
            if (options && options.action == 'register') {
                baseUrl = kc.endpoints.register();
            } else {
                baseUrl = kc.endpoints.authorize();
            }
  
            var scope;
            if (options && options.scope) {
                if (options.scope.indexOf("openid") != -1) {
                    scope = options.scope;
                } else {
                    scope = "openid " + options.scope;
                }
            } else {
                scope = "openid";
            }
  
            var url = baseUrl
                + '?client_id=' + encodeURIComponent(kc.clientId)
                + '&redirect_uri=' + encodeURIComponent(redirectUri)
                + '&state=' + encodeURIComponent(state)
                + '&response_mode=' + encodeURIComponent(kc.responseMode)
                + '&response_type=' + encodeURIComponent(kc.responseType)
                + '&scope=' + encodeURIComponent(scope);
            if (useNonce) {
                url = url + '&nonce=' + encodeURIComponent(nonce);
            }
  
            if (options && options.prompt) {
                url += '&prompt=' + encodeURIComponent(options.prompt);
            }
  
            if (options && options.maxAge) {
                url += '&max_age=' + encodeURIComponent(options.maxAge);
            }
  
            if (options && options.loginHint) {
                url += '&login_hint=' + encodeURIComponent(options.loginHint);
            }
  
            if (options && options.idpHint) {
                url += '&kc_idp_hint=' + encodeURIComponent(options.idpHint);
            }
  
            if (options && options.locale) {
                url += '&ui_locales=' + encodeURIComponent(options.locale);
            }
            
            if (options && options.kcLocale) {
                url += '&kc_locale=' + encodeURIComponent(options.kcLocale);
            }
  
            if (kc.pkceMethod) {
                var codeVerifier = generateCodeVerifier(96);
                callbackState.pkceCodeVerifier = codeVerifier;
                var pkceChallenge = generatePkceChallenge(kc.pkceMethod, codeVerifier);
                url += '&code_challenge=' + pkceChallenge;
                url += '&code_challenge_method=' + kc.pkceMethod;
            }
  
            callbackStorage.add(callbackState);
  
            return url;
        }
  
        kc.logout = function(options) {
            return adapter.logout(options);
        }
        
        // Old Keycloak logout
        // kc.createLogoutUrl = function(options) {
        //     var url = kc.endpoints.logout()
        //         + '?redirect_uri=' + encodeURIComponent(adapter.redirectUri(options, false));
  
        //     return url;
        // }
  
        // Keycloak 21.1.2 logout
        kc.createLogoutUrl = function(options) {
            var url = kc.endpoints.logout()
                + '?client_id=' + encodeURIComponent(kc.clientId)
                + '&post_logout_redirect_uri=' + encodeURIComponent(adapter.redirectUri(options, false));
    
            if (kc.idToken) {
                url += '&id_token_hint=' + encodeURIComponent(kc.idToken);
            }
    
            return url;
        }
  
        kc.register = function (options) {
            return adapter.register(options);
        }
  
        kc.createRegisterUrl = function(options) {
            if (!options) {
                options = {};
            }
            options.action = 'register';
            return kc.createLoginUrl(options);
        }
  
        kc.createAccountUrl = function(options) {
            var realm = getRealmUrl();
            var url = undefined;
            if (typeof realm !== 'undefined') {
                url = realm
                + '/account'
                + '?referrer=' + encodeURIComponent(kc.clientId)
                + '&referrer_uri=' + encodeURIComponent(adapter.redirectUri(options));
            }
            return url;
        }
  
        kc.accountManagement = function() {
            return adapter.accountManagement();
        }
  
        kc.hasRealmRole = function (role) {
            var access = kc.realmAccess;
            return !!access && access.roles.indexOf(role) >= 0;
        }
  
        kc.hasResourceRole = function(role, resource) {
            if (!kc.resourceAccess) {
                return false;
            }
  
            var access = kc.resourceAccess[resource || kc.clientId];
            return !!access && access.roles.indexOf(role) >= 0;
        }
  
        kc.loadUserProfile = function() {
            var url = getRealmUrl() + '/account';
            var req = new XMLHttpRequest();
            req.open('GET', url, true);
            req.setRequestHeader('Accept', 'application/json');
            req.setRequestHeader('Authorization', 'bearer ' + kc.token);
  
            var promise = createPromise(false);
  
            req.onreadystatechange = function () {
                if (req.readyState == 4) {
                    if (req.status == 200) {
                        kc.profile = JSON.parse(req.responseText);
                        promise.setSuccess(kc.profile);
                    } else {
                        promise.setError();
                    }
                }
            }
  
            req.send();
  
            return promise.promise;
        }
  
        kc.loadUserInfo = function() {
            var url = kc.endpoints.userinfo();
            var req = new XMLHttpRequest();
            req.open('GET', url, true);
            req.setRequestHeader('Accept', 'application/json');
            req.setRequestHeader('Authorization', 'bearer ' + kc.token);
  
            var promise = createPromise(false);
  
            req.onreadystatechange = function () {
                if (req.readyState == 4) {
                    if (req.status == 200) {
                        kc.userInfo = JSON.parse(req.responseText);
                        promise.setSuccess(kc.userInfo);
                    } else {
                        promise.setError();
                    }
                }
            }
  
            req.send();
  
            return promise.promise;
        }
  
        kc.isTokenExpired = function(minValidity) {
            if (!kc.tokenParsed || (!kc.refreshToken && kc.flow != 'implicit' )) {
                throw 'Not authenticated';
            }
  
            if (kc.timeSkew == null) {
                console.info('[KEYCLOAK] Unable to determine if token is expired as timeskew is not set');
                return true;
            }
  
            var expiresIn = kc.tokenParsed['exp'] - Math.ceil(new Date().getTime() / 1000) + kc.timeSkew;
            if (minValidity) {
                if (isNaN(minValidity)) {
                    throw 'Invalid minValidity';
                }
                expiresIn -= minValidity;
            }
            return expiresIn < 0;
        }
  
        kc.updateToken = function(minValidity) {
            var promise = createPromise(false);
  
            if (!kc.refreshToken) {
                promise.setError();
                return promise.promise;
            }
  
            minValidity = minValidity || 5;
  
            var exec = function() {
                var refreshToken = false;
                if (minValidity == -1) {
                    refreshToken = true;
                    console.info('[KEYCLOAK] Refreshing token: forced refresh');
                } else if (!kc.tokenParsed || kc.isTokenExpired(minValidity)) {
                    refreshToken = true;
                    console.info('[KEYCLOAK] Refreshing token: token expired');
                }
  
                if (!refreshToken) {
                    promise.setSuccess(false);
                } else {                 
                    var params = 'grant_type=refresh_token&' + 'refresh_token=' + kc.refreshToken;
                    var url = kc.endpoints.token();
  
                    refreshQueue.push(promise);
  
                    if (refreshQueue.length == 1) {
                        var req = new XMLHttpRequest();
                        req.open('POST', url, true);
                        req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                        req.withCredentials = true;
  
                        if (kc.clientId && kc.clientSecret) {
                            req.setRequestHeader('Authorization', 'Basic ' + btoa(kc.clientId + ':' + kc.clientSecret));
                        } else {
                            params += '&client_id=' + encodeURIComponent(kc.clientId);
                        }
  
                        var timeLocal = new Date().getTime();
  
                        req.onreadystatechange = function () {
                            if (req.readyState == 4) {
                                if (req.status == 200) {
                                    console.info('[KEYCLOAK] Token refreshed');
  
                                    timeLocal = (timeLocal + new Date().getTime()) / 2;
  
                                    var tokenResponse = JSON.parse(req.responseText);
  
                                    setToken(tokenResponse['access_token'], tokenResponse['refresh_token'], tokenResponse['id_token'], timeLocal);
  
                                    kc.onAuthRefreshSuccess && kc.onAuthRefreshSuccess();
                                    for (var p = refreshQueue.pop(); p != null; p = refreshQueue.pop()) {
                                        p.setSuccess(true);
                                    }
                                } else {
                                    console.warn('[KEYCLOAK] Failed to refresh token');
  
                                    if (req.status == 400) {
                                        kc.clearToken();
                                    }
  
                                    kc.onAuthRefreshError && kc.onAuthRefreshError();
                                    for (var p = refreshQueue.pop(); p != null; p = refreshQueue.pop()) {
                                        p.setError(true);
                                    }
                                }
                            }
                        };
  
                        req.send(params);
                    }
                }
            }
  
            if (loginIframe.enable) {
                var iframePromise = checkLoginIframe();
                iframePromise.success(function() {
                    exec();
                }).error(function() {
                    promise.setError();
                });
            } else {
                exec();
            }
  
            return promise.promise;
        }
  
        kc.clearToken = function() {
            if (kc.token) {
                setToken(null, null, null);
                kc.onAuthLogout && kc.onAuthLogout();
                if (kc.loginRequired) {
                    kc.login();
                }
            }
        }
  
        function getRealmUrl() {
            if (typeof kc.authServerUrl !== 'undefined') {
                if (kc.authServerUrl.charAt(kc.authServerUrl.length - 1) == '/') {
                    return kc.authServerUrl + 'realms/' + encodeURIComponent(kc.realm);
                } else {
                    return kc.authServerUrl + '/realms/' + encodeURIComponent(kc.realm);
                }
            } else {
              return undefined;
            }
        }
  
        function getOrigin() {
            if (!window.location.origin) {
                return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
            } else {
                return window.location.origin;
            }
        }
  
        function processCallback(oauth, promise) {
            var code = oauth.code;
            var error = oauth.error;
            var prompt = oauth.prompt;
  
            var timeLocal = new Date().getTime();
  
            if (error) {
                if (prompt != 'none') {
                    var errorData = { error: error, error_description: oauth.error_description };
                    kc.onAuthError && kc.onAuthError(errorData);
                    promise && promise.setError(errorData);
                } else {
                    promise && promise.setSuccess();
                }
                return;
            } else if ((kc.flow != 'standard') && (oauth.access_token || oauth.id_token)) {
                authSuccess(oauth.access_token, null, oauth.id_token, true);
            }
  
            if ((kc.flow != 'implicit') && code) {
                var params = 'code=' + code + '&grant_type=authorization_code';
                var url = kc.endpoints.token();
  
                var req = new XMLHttpRequest();
                req.open('POST', url, true);
                req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  
                if (kc.clientId && kc.clientSecret) {
                    req.setRequestHeader('Authorization', 'Basic ' + btoa(kc.clientId + ':' + kc.clientSecret));
                } else {
                    params += '&client_id=' + encodeURIComponent(kc.clientId);
                    console.log('processCallback() params = ', params)
                }
  
                params += '&redirect_uri=' + oauth.redirectUri;
  
                if (oauth.pkceCodeVerifier) {
                    params += '&code_verifier=' + oauth.pkceCodeVerifier;
                }
  
                req.withCredentials = true;
  
                req.onreadystatechange = function() {
                    if (req.readyState == 4) {
                        if (req.status == 200) {
  
                            var tokenResponse = JSON.parse(req.responseText);
                            authSuccess(tokenResponse['access_token'], tokenResponse['refresh_token'], tokenResponse['id_token'], kc.flow === 'standard');
                            scheduleCheckIframe();
                        } else {
                            kc.onAuthError && kc.onAuthError();
                            promise && promise.setError();
                        }
                    }
                };
  
                req.send(params);
            }
  
            function authSuccess(accessToken, refreshToken, idToken, fulfillPromise) {
                timeLocal = (timeLocal + new Date().getTime()) / 2;
  
                setToken(accessToken, refreshToken, idToken, timeLocal);
  
                if (useNonce && ((kc.tokenParsed && kc.tokenParsed.nonce != oauth.storedNonce) ||
                    (kc.refreshTokenParsed && kc.refreshTokenParsed.nonce != oauth.storedNonce) ||
                    (kc.idTokenParsed && kc.idTokenParsed.nonce != oauth.storedNonce))) {
  
                    console.info('[KEYCLOAK] Invalid nonce, clearing token');
                    kc.clearToken();
                    promise && promise.setError();
                } else {
                    if (fulfillPromise) {
                        kc.onAuthSuccess && kc.onAuthSuccess();
                        promise && promise.setSuccess();
                    }
                }
            }
  
        }
  
        function loadConfig(url) {
            var promise = createPromise(true);
            var configUrl;
  
            kc.authServerUrl = config['auth-server-url'];
            kc.realm = config['realm'];
            kc.clientId = config['resource'];
            kc.clientSecret = (config['credentials'] || {})['secret'];
            setupOidcEndoints(null);
  
            config.clientId = kc.clientId;
            config.url = kc.authServerUrl;
            config.realm = kc.realm;
  
            if (!config) {
                configUrl = 'keycloak.json';
            } else if (typeof config === 'string') {
                configUrl = config;
            }
  
            function setupOidcEndoints(oidcConfiguration) {
                if (! oidcConfiguration) {
                    kc.endpoints = {
                        authorize: function() {
                            return getRealmUrl() + '/protocol/openid-connect/auth';
                        },
                        token: function() {
                            return getRealmUrl() + '/protocol/openid-connect/token';
                        },
                        logout: function() {
                            return getRealmUrl() + '/protocol/openid-connect/logout';
                        },
                        checkSessionIframe: function() {
                            var src = getRealmUrl() + '/protocol/openid-connect/login-status-iframe.html';
                            if (kc.iframeVersion) {
                              src = src + '?version=' + kc.iframeVersion;
                            }
                            return src;
                        },
                        register: function() {
                            return getRealmUrl() + '/protocol/openid-connect/registrations';
                        },
                        userinfo: function() {
                            return getRealmUrl() + '/protocol/openid-connect/userinfo';
                        }
                    };
                } else {
                    kc.endpoints = {
                        authorize: function() {
                            return oidcConfiguration.authorization_endpoint;
                        },
                        token: function() {
                            return oidcConfiguration.token_endpoint;
                        },
                        logout: function() {
                            if (!oidcConfiguration.end_session_endpoint) {
                                throw "Not supported by the OIDC server";
                            }
                            return oidcConfiguration.end_session_endpoint;
                        },
                        checkSessionIframe: function() {
                            if (!oidcConfiguration.check_session_iframe) {
                                throw "Not supported by the OIDC server";
                            }
                            return oidcConfiguration.check_session_iframe;
                        },
                        register: function() {
                            throw 'Redirection to "Register user" page not supported in standard OIDC mode';
                        },
                        userinfo: function() {
                            if (!oidcConfiguration.userinfo_endpoint) {
                                throw "Not supported by the OIDC server";
                            }
                            return oidcConfiguration.userinfo_endpoint;
                        }
                    }
                }
            }
  
            if (configUrl) {
                var req = new XMLHttpRequest();
                req.open('GET', configUrl, true);
                req.setRequestHeader('Accept', 'application/json');
  
                req.onreadystatechange = function () {
                    if (req.readyState == 4) {
                        if (req.status == 200 || fileLoaded(req)) {
                            var config = JSON.parse(req.responseText);
  
                            kc.authServerUrl = config['auth-server-url'];
                            kc.realm = config['realm'];
                            kc.clientId = config['resource'];
                            kc.clientSecret = (config['credentials'] || {})['secret'];
                            setupOidcEndoints(null);
                            promise.setSuccess();
                        } else {
                            promise.setError();
                        }
                    }
                };
  
                req.send();
            } else {
                if (!config.clientId) {
                    throw 'clientId missing';
                }
  
                kc.clientId = config.clientId;
                kc.clientSecret = (config.credentials || {}).secret;
  
                var oidcProvider = config['oidcProvider'];
                if (!oidcProvider) {
                    if (!config['url']) {
                        var scripts = document.getElementsByTagName('script');
                        for (var i = 0; i < scripts.length; i++) {
                            if (scripts[i].src.match(/.*keycloak\.js/)) {
                                config.url = scripts[i].src.substr(0, scripts[i].src.indexOf('/js/keycloak.js'));
                                break;
                            }
                        }
                    }
                    if (!config.realm) {
                        throw 'realm missing';
                    }
  
                    kc.authServerUrl = config.url;
                    kc.realm = config.realm;
                    setupOidcEndoints(null);
                    promise.setSuccess();
                } else {
                    if (typeof oidcProvider === 'string') {
                        var oidcProviderConfigUrl;
                        if (oidcProvider.charAt(oidcProvider.length - 1) == '/') {
                            oidcProviderConfigUrl = oidcProvider + '.well-known/openid-configuration';
                        } else {
                            oidcProviderConfigUrl = oidcProvider + '/.well-known/openid-configuration';
                        }
                        var req = new XMLHttpRequest();
                        req.open('GET', oidcProviderConfigUrl, true);
                        req.setRequestHeader('Accept', 'application/json');
  
                        req.onreadystatechange = function () {
                            if (req.readyState == 4) {
                                if (req.status == 200 || fileLoaded(req)) {
                                    var oidcProviderConfig = JSON.parse(req.responseText);
                                    setupOidcEndoints(oidcProviderConfig);
                                    promise.setSuccess();
                                } else {
                                    promise.setError();
                                }
                            }
                        };
  
                        req.send();
                    } else {
                        setupOidcEndoints(oidcProvider);
                        promise.setSuccess();
                    }
                }
            }
  
            return promise.promise;
        }
  
        function fileLoaded(xhr) {
            return xhr.status == 0 && xhr.responseText && xhr.responseURL.startsWith('file:');
        }
  
        function setToken(token, refreshToken, idToken, timeLocal) {
            if (kc.tokenTimeoutHandle) {
                clearTimeout(kc.tokenTimeoutHandle);
                kc.tokenTimeoutHandle = null;
            }
  
            if (refreshToken) {
                kc.refreshToken = refreshToken;
                kc.refreshTokenParsed = decodeToken(refreshToken);
            } else {
                delete kc.refreshToken;
                delete kc.refreshTokenParsed;
            }
  
            if (idToken) {
                kc.idToken = idToken;
                kc.idTokenParsed = decodeToken(idToken);
            } else {
                delete kc.idToken;
                delete kc.idTokenParsed;
            }
  
            if (token) {
                kc.token = token;
                kc.tokenParsed = decodeToken(token);
                kc.sessionId = kc.tokenParsed.session_state;
                kc.authenticated = true;
                kc.subject = kc.tokenParsed.sub;
                kc.realmAccess = kc.tokenParsed.realm_access;
                kc.resourceAccess = kc.tokenParsed.resource_access;
  
                if (timeLocal) {
                    kc.timeSkew = Math.floor(timeLocal / 1000) - kc.tokenParsed.iat;
                }
  
                if (kc.timeSkew != null) {
                    console.info('[KEYCLOAK] Estimated time difference between browser and server is ' + kc.timeSkew + ' seconds');
  
                    if (kc.onTokenExpired) {
                        var expiresIn = (kc.tokenParsed['exp'] - (new Date().getTime() / 1000) + kc.timeSkew) * 1000;
                        console.info('[KEYCLOAK] Token expires in ' + Math.round(expiresIn / 1000) + ' s');
                        if (expiresIn <= 0) {
                            kc.onTokenExpired();
                        } else {
                            kc.tokenTimeoutHandle = setTimeout(kc.onTokenExpired, expiresIn);
                        }
                    }
                }
                console
            } else {
                delete kc.token;
                delete kc.tokenParsed;
                delete kc.subject;
                delete kc.realmAccess;
                delete kc.resourceAccess;
  
                kc.authenticated = false;
            }
        }
  
        function decodeToken(str) {
            str = str.split('.')[1];
  
            str = str.replace('/-/g', '+');
            str = str.replace('/_/g', '/');
            switch (str.length % 4)
            {
                case 0:
                    break;
                case 2:
                    str += '==';
                    break;
                case 3:
                    str += '=';
                    break;
                default:
                    throw 'Invalid token';
            }
  
            str = (str + '===').slice(0, str.length + (str.length % 4));
            str = str.replace(/-/g, '+').replace(/_/g, '/');
  
            str = decodeURIComponent(escape(atob(str)));
  
            str = JSON.parse(str);
            return str;
        }
  
        function createUUID() {
            var hexDigits = '0123456789abcdef';
            var s = generateRandomString(36, hexDigits).split("");
            s[14] = '4';
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
            s[8] = s[13] = s[18] = s[23] = '-';
            var uuid = s.join('');
            return uuid;
        }
  
        kc.callback_id = 0;
  
        function createCallbackId() {
            var id = '<id: ' + (kc.callback_id++) + (Math.random()) + '>';
            return id;
  
        }
  
        function parseCallback(url) {
            var oauth = parseCallbackUrl(url);
            if (!oauth) {
                return;
            }
  
            var oauthState = callbackStorage.get(oauth.state);
  
            if (oauthState) {
                oauth.valid = true;
                oauth.redirectUri = oauthState.redirectUri;
                oauth.storedNonce = oauthState.nonce;
                oauth.prompt = oauthState.prompt;
                oauth.pkceCodeVerifier = oauthState.pkceCodeVerifier;
            }
  
            return oauth;
        }
  
        function parseCallbackUrl(url) {
            var supportedParams;
            switch (kc.flow) {
                case 'standard':
                    supportedParams = ['code', 'state', 'session_state'];
                    break;
                case 'implicit':
                    supportedParams = ['access_token', 'token_type', 'id_token', 'state', 'session_state', 'expires_in'];
                    break;
                case 'hybrid':
                    supportedParams = ['access_token', 'id_token', 'code', 'state', 'session_state'];
                    break;
            }
  
            supportedParams.push('error');
            supportedParams.push('error_description');
            supportedParams.push('error_uri');
  
            var queryIndex = url.indexOf('?');
            var fragmentIndex = url.indexOf('#');
  
            var newUrl;
            var parsed;
  
            if (kc.responseMode === 'query' && queryIndex !== -1) {
                newUrl = url.substring(0, queryIndex);
                parsed = parseCallbackParams(url.substring(queryIndex + 1, fragmentIndex !== -1 ? fragmentIndex : url.length), supportedParams);
                if (parsed.paramsString !== '') {
                    newUrl += '?' + parsed.paramsString;
                }
                if (fragmentIndex !== -1) {
                    newUrl += url.substring(fragmentIndex);
                }
            } else if (kc.responseMode === 'fragment' && fragmentIndex !== -1) {
                newUrl = url.substring(0, fragmentIndex);
                parsed = parseCallbackParams(url.substring(fragmentIndex + 1), supportedParams);
                if (parsed.paramsString !== '') {
                    newUrl += '#' + parsed.paramsString;
                }
            }
  
            if (parsed && parsed.oauthParams) {
                if (kc.flow === 'standard' || kc.flow === 'hybrid') {
                    if ((parsed.oauthParams.code || parsed.oauthParams.error) && parsed.oauthParams.state) {
                        parsed.oauthParams.newUrl = newUrl;
                        return parsed.oauthParams;
                    }
                } else if (kc.flow === 'implicit') {
                    if ((parsed.oauthParams.access_token || parsed.oauthParams.error) && parsed.oauthParams.state) {
                        parsed.oauthParams.newUrl = newUrl;
                        return parsed.oauthParams;
                    }
                }
            }
        }
  
        function parseCallbackParams(paramsString, supportedParams) {
            var p = paramsString.split('&');
            var result = {
                paramsString: '',
                oauthParams: {}
            }
            for (var i = 0; i < p.length; i++) {
                var t = p[i].split('=');
                if (supportedParams.indexOf(t[0]) !== -1) {
                    result.oauthParams[t[0]] = t[1];
                } else {
                    if (result.paramsString !== '') {
                        result.paramsString += '&';
                    }
                    result.paramsString += p[i];
                }
            }
            return result;
        }
  
        function createPromise(internal) {
            if (!internal && kc.useNativePromise) {
                return createNativePromise();
            } else {
                return createLegacyPromise();
            }
        }
  
        function createNativePromise() {
            // Need to create a native Promise which also preserves the
            // interface of the custom promise type previously used by the API
            var p = {
                setSuccess: function(result) {
                    p.resolve(result);
                },
  
                setError: function(result) {
                    p.reject(result);
                }
            };
            p.promise = new Promise(function(resolve, reject) {
                p.resolve = resolve;
                p.reject = reject;
            });
            return p;
        }
  
        function createLegacyPromise() {
            var p = {
                setSuccess: function(result) {
                    p.success = true;
                    p.result = result;
                    if (p.successCallback) {
                        p.successCallback(result);
                    }
                },
  
                setError: function(result) {
                    p.error = true;
                    p.result = result;
                    if (p.errorCallback) {
                        p.errorCallback(result);
                    }
                },
  
                promise: {
                    success: function(callback) {
                        if (p.success) {
                            callback(p.result);
                        } else if (!p.error) {
                            p.successCallback = callback;
                        }
                        return p.promise;
                    },
                    error: function(callback) {
                        if (p.error) {
                            callback(p.result);
                        } else if (!p.success) {
                            p.errorCallback = callback;
                        }
                        return p.promise;
                    }
                }
            }
            return p;
        }
  
        function setupCheckLoginIframe() {
            var promise = createPromise(true);
  
            if (!loginIframe.enable) {
                promise.setSuccess();
                return promise.promise;
            }
  
            if (loginIframe.iframe) {
                promise.setSuccess();
                return promise.promise;
            }
  
            var iframe = document.createElement('iframe');
            loginIframe.iframe = iframe;
  
            iframe.onload = function() {
                var authUrl = kc.endpoints.authorize();
                if (authUrl.charAt(0) === '/') {
                    loginIframe.iframeOrigin = getOrigin();
                } else {
                    loginIframe.iframeOrigin = authUrl.substring(0, authUrl.indexOf('/', 8));
                }
                promise.setSuccess();
            }
  
            var src = kc.endpoints.checkSessionIframe();
            iframe.setAttribute('src', src );
            iframe.setAttribute('title', 'keycloak-session-iframe' );
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
  
            var messageCallback = function(event) {
                if ((event.origin !== loginIframe.iframeOrigin) || (loginIframe.iframe.contentWindow !== event.source)) {
                    return;
                }
  
                if (!(event.data == 'unchanged' || event.data == 'changed' || event.data == 'error')) {
                    return;
                }
  
                
                if('' !== "dev") {
                    if (event.data != 'unchanged') {                    
                        kc.clearToken();
                    }
                }
                
                var callbacks = loginIframe.callbackList.splice(0, loginIframe.callbackList.length);
  
                for (var i = callbacks.length - 1; i >= 0; --i) {
                    var promise = callbacks[i];
                    if (event.data == 'error') {
                        promise.setError();
                    } else {
                        promise.setSuccess(event.data == 'unchanged');
                    }
                }
            };
  
            window.addEventListener('message', messageCallback, false);
  
            return promise.promise;
        }
  
        function scheduleCheckIframe() {
            if (loginIframe.enable) {
                if (kc.token) {
                    setTimeout(function() {
                        checkLoginIframe().success(function(unchanged) {
                            if (unchanged) {
                                scheduleCheckIframe();
                            }
                        });
                    }, loginIframe.interval * 1000);
                }
            }
        }
  
        function checkLoginIframe() {
            var promise = createPromise(true);
  
            if (loginIframe.iframe && loginIframe.iframeOrigin ) {
                var msg = kc.clientId + ' ' + (kc.sessionId ? kc.sessionId : '');
                loginIframe.callbackList.push(promise);
                var origin = loginIframe.iframeOrigin;
                if (loginIframe.callbackList.length == 1) {
                    loginIframe.iframe.contentWindow.postMessage(msg, origin);
                }
            } else {
                promise.setSuccess();
            }
  
            return promise.promise;
        }
  
        function loadAdapter(type) {
            if (!type || type == 'default') {
                return {
                    login: function(options) {
                        window.location.replace(kc.createLoginUrl(options));
                        return createPromise().promise;
                    },
  
                    logout: function(options) {
                        window.location.replace(kc.createLogoutUrl(options));
                        return createPromise().promise;
                    },
  
                    register: function(options) {
                        window.location.replace(kc.createRegisterUrl(options));
                        return createPromise().promise;
                    },
  
                    accountManagement : function() {
                        var accountUrl = kc.createAccountUrl();
                        if (typeof accountUrl !== 'undefined') {
                            window.location.href = accountUrl;
                        } else {
                            throw "Not supported by the OIDC server";
                        }
                        return createPromise(false).promise;
                    },
  
                    redirectUri: function(options, encodeHash) {
                        if (arguments.length == 1) {
                            encodeHash = true;
                        }
  
                        if (options && options.redirectUri) {
                            return options.redirectUri;
                        } else if (kc.redirectUri) {
                            return kc.redirectUri;
                        } else {
                            return location.href;
                        }
                    }
                };
            }
  
            if (type == 'cordova') {
                loginIframe.enable = false;
                var cordovaOpenWindowWrapper = function(loginUrl, target, options) {
                    if (window.cordova && window.cordova.InAppBrowser) {
                        // Use inappbrowser for IOS and Android if available
                        return window.cordova.InAppBrowser.open(loginUrl, target, options);
                    } else {
                        return window.open(loginUrl, target, options);
                    }
                };
  
                var shallowCloneCordovaOptions = function (userOptions) {
                    if (userOptions && userOptions.cordovaOptions) {
                        return Object.keys(userOptions.cordovaOptions).reduce(function (options, optionName) {
                            options[optionName] = userOptions.cordovaOptions[optionName];
                            return options;
                        }, {});
                    } else {
                        return {};
                    }
                };
  
                var formatCordovaOptions = function (cordovaOptions) {
                    return Object.keys(cordovaOptions).reduce(function (options, optionName) {
                        options.push(optionName+"="+cordovaOptions[optionName]);
                        return options;
                    }, []).join(",");
                };
  
                var createCordovaOptions = function (userOptions) {
                    var cordovaOptions = shallowCloneCordovaOptions(userOptions);
                    cordovaOptions.location = 'no';
                    if (userOptions && userOptions.prompt == 'none') {
                        cordovaOptions.hidden = 'yes';
                    }                    
                    return formatCordovaOptions(cordovaOptions);
                };
  
                return {
                    login: function(options) {
                        var promise = createPromise(false);
  
                        var cordovaOptions = createCordovaOptions(options);
                        var loginUrl = kc.createLoginUrl(options);
                        var ref = cordovaOpenWindowWrapper(loginUrl, '_blank', cordovaOptions);
                        var completed = false;
                        
                        var closed = false;
                        var closeBrowser = function() {
                            closed = true;
                            ref.close();
                        };
  
                        ref.addEventListener('loadstart', function(event) {
                            if (event.url.indexOf('http://localhost') == 0) {
                                var callback = parseCallback(event.url);
                                processCallback(callback, promise);
                                closeBrowser();
                                completed = true;
                            }
                        });
  
                        ref.addEventListener('loaderror', function(event) {
                            if (!completed) {
                                if (event.url.indexOf('http://localhost') == 0) {
                                    var callback = parseCallback(event.url);
                                    processCallback(callback, promise);
                                    closeBrowser();
                                    completed = true;
                                } else {
                                    promise.setError();
                                    closeBrowser();
                                }
                            }
                        });
  
                        ref.addEventListener('exit', function(event) {
                            if (!closed) {
                                promise.setError({
                                    reason: "closed_by_user"
                                });
                            }
                        });
  
                        return promise.promise;
                    },
  
                    logout: function(options) {
                        var promise = createPromise(false);
                        
                        var logoutUrl = kc.createLogoutUrl(options);
                        var ref = cordovaOpenWindowWrapper(logoutUrl, '_blank', 'location=no,hidden=yes');
  
                        var error;
  
                        ref.addEventListener('loadstart', function(event) {
                            if (event.url.indexOf('http://localhost') == 0) {
                                ref.close();
                            }
                        });
  
                        ref.addEventListener('loaderror', function(event) {
                            if (event.url.indexOf('http://localhost') == 0) {
                                ref.close();
                            } else {
                                error = true;
                                ref.close();
                            }
                        });
  
                        ref.addEventListener('exit', function(event) {
                            if (error) {
                                promise.setError();
                            } else {
                                kc.clearToken();
                                promise.setSuccess();
                            }
                        });
  
                        return promise.promise;
                    },
  
                    register : function(options) {
                        var promise = createPromise(false);
                        var registerUrl = kc.createRegisterUrl();
                        var cordovaOptions = createCordovaOptions(options);
                        var ref = cordovaOpenWindowWrapper(registerUrl, '_blank', cordovaOptions);
                        ref.addEventListener('loadstart', function(event) {
                            if (event.url.indexOf('http://localhost') == 0) {
                                ref.close();
                                var oauth = parseCallback(event.url);
                                processCallback(oauth, promise);
                            }
                        });
                        return promise.promise;
                    },
  
                    accountManagement : function() {
                        var accountUrl = kc.createAccountUrl();
                        if (typeof accountUrl !== 'undefined') {
                            var ref = cordovaOpenWindowWrapper(accountUrl, '_blank', 'location=no');
                            ref.addEventListener('loadstart', function(event) {
                                if (event.url.indexOf('http://localhost') == 0) {
                                    ref.close();
                                }
                            });
                        } else {
                            throw "Not supported by the OIDC server";
                        }
                    },
  
                    redirectUri: function(options) {
                        return 'http://localhost';
                    }
                }
            }
  
            if (type == 'cordova-native') {
                loginIframe.enable = false;
  
                return {
                    login: function(options) {
                        var promise = createPromise(false);
                        var loginUrl = kc.createLoginUrl(options);
  
                        universalLinks.subscribe('keycloak', function(event) {
                            universalLinks.unsubscribe('keycloak');
                            window.cordova.plugins.browsertab.close();
                            var oauth = parseCallback(event.url);
                            processCallback(oauth, promise);
                        });
  
                        window.cordova.plugins.browsertab.openUrl(loginUrl);
                        return promise.promise;
                    },
  
                    logout: function(options) {
                        var promise = createPromise(false);
                        var logoutUrl = kc.createLogoutUrl(options);
  
                        universalLinks.subscribe('keycloak', function(event) {
                            universalLinks.unsubscribe('keycloak');
                            window.cordova.plugins.browsertab.close();
                            kc.clearToken();
                            promise.setSuccess();
                        });
  
                        window.cordova.plugins.browsertab.openUrl(logoutUrl);
                        return promise.promise;
                    },
  
                    register : function(options) {
                        var promise = createPromise(false);
                        var registerUrl = kc.createRegisterUrl(options);
                        universalLinks.subscribe('keycloak' , function(event) {
                            universalLinks.unsubscribe('keycloak');
                            window.cordova.plugins.browsertab.close();
                            var oauth = parseCallback(event.url);
                            processCallback(oauth, promise);
                        });
                        window.cordova.plugins.browsertab.openUrl(registerUrl);
                        return promise.promise;
  
                    },
  
                    accountManagement : function() {
                        var accountUrl = kc.createAccountUrl();
                        if (typeof accountUrl !== 'undefined') {
                            window.cordova.plugins.browsertab.openUrl(accountUrl);
                        } else {
                            throw "Not supported by the OIDC server";
                        }
                    },
  
                    redirectUri: function(options) {
                        if (options && options.redirectUri) {
                            return options.redirectUri;
                        } else if (kc.redirectUri) {
                            return kc.redirectUri;
                        } else {
                            return "http://localhost";
                        }
                    }
                }
            }
  
            throw 'invalid adapter type: ' + type;
        }
  
        var LocalStorage = function() {
            if (!(this instanceof LocalStorage)) {
                return new LocalStorage();
            }
  
            localStorage.setItem('kc-test', 'test');
            localStorage.removeItem('kc-test');
  
            var cs = this;
  
            function clearExpired() {
                var time = new Date().getTime();
                for (var i = 0; i < localStorage.length; i++)  {
                    var key = localStorage.key(i);
                    if (key && key.indexOf('kc-callback-') == 0) {
                        var value = localStorage.getItem(key);
                        if (value) {
                            try {
                                var expires = JSON.parse(value).expires;
                                if (!expires || expires < time) {
                                    localStorage.removeItem(key);
                                }
                            } catch (err) {
                                localStorage.removeItem(key);
                            }
                        }
                    }
                }
            }
  
            cs.get = function(state) {
                if (!state) {
                    return;
                }
  
                var key = 'kc-callback-' + state;
                var value = localStorage.getItem(key);
                if (value) {
                    localStorage.removeItem(key);
                    value = JSON.parse(value);
                }
  
                clearExpired();
                return value;
            };
  
            cs.add = function(state) {
                clearExpired();
  
                var key = 'kc-callback-' + state.state;
                state.expires = new Date().getTime() + (60 * 60 * 1000);
                localStorage.setItem(key, JSON.stringify(state));
            };
        };
  
        var CookieStorage = function() {
            if (!(this instanceof CookieStorage)) {
                return new CookieStorage();
            }
  
            var cs = this;
  
            cs.get = function(state) {
                if (!state) {
                    return;
                }
  
                var value = getCookie('kc-callback-' + state);
                setCookie('kc-callback-' + state, '', cookieExpiration(-100));
                if (value) {
                    return JSON.parse(value);
                }
            };
  
            cs.add = function(state) {
                setCookie('kc-callback-' + state.state, JSON.stringify(state), cookieExpiration(60));
            };
  
            cs.removeItem = function(key) {
                setCookie(key, '', cookieExpiration(-100));
            };
  
            var cookieExpiration = function (minutes) {
                var exp = new Date();
                exp.setTime(exp.getTime() + (minutes*60*1000));
                return exp;
            };
  
            var getCookie = function (key) {
                var name = key + '=';
                var ca = document.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return '';
            };
  
            var setCookie = function (key, value, expirationDate) {
                var cookie = key + '=' + value + '; '
                    + 'expires=' + expirationDate.toUTCString() + '; ';
                document.cookie = cookie;
            }
        };
  
        function createCallbackStorage() {
            try {
                return new LocalStorage();
            } catch (err) {
            }
  
            return new CookieStorage();
        }
    }
  
    if ( typeof module === "object" && module && typeof module.exports === "object" ) {
        module.exports = Keycloak;
    } else {
        window.Keycloak = Keycloak;
  
        if ( typeof define === "function" && define.amd ) {
            define( "keycloak", [], function () { return Keycloak; } );
        }
    }
  })( window );
  
  /** Additional support libraries */
  
  /**
  * [js-sha256]{@link https://github.com/emn178/js-sha256}
  *
  * @version 0.9.0
  * @author Chen, Yi-Cyuan [emn178@gmail.com]
  * @copyright Chen, Yi-Cyuan 2014-2017
  * @license MIT
  */
  !function(){"use strict";function t(t,i){i?(d[0]=d[16]=d[1]=d[2]=d[3]=d[4]=d[5]=d[6]=d[7]=d[8]=d[9]=d[10]=d[11]=d[12]=d[13]=d[14]=d[15]=0,this.blocks=d):this.blocks=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],t?(this.h0=3238371032,this.h1=914150663,this.h2=812702999,this.h3=4144912697,this.h4=4290775857,this.h5=1750603025,this.h6=1694076839,this.h7=3204075428):(this.h0=1779033703,this.h1=3144134277,this.h2=1013904242,this.h3=2773480762,this.h4=1359893119,this.h5=2600822924,this.h6=528734635,this.h7=1541459225),this.block=this.start=this.bytes=this.hBytes=0,this.finalized=this.hashed=!1,this.first=!0,this.is224=t}function i(i,r,s){var e,n=typeof i;if("string"===n){var o,a=[],u=i.length,c=0;for(e=0;e<u;++e)(o=i.charCodeAt(e))<128?a[c++]=o:o<2048?(a[c++]=192|o>>6,a[c++]=128|63&o):o<55296||o>=57344?(a[c++]=224|o>>12,a[c++]=128|o>>6&63,a[c++]=128|63&o):(o=65536+((1023&o)<<10|1023&i.charCodeAt(++e)),a[c++]=240|o>>18,a[c++]=128|o>>12&63,a[c++]=128|o>>6&63,a[c++]=128|63&o);i=a}else{if("object"!==n)throw new Error(h);if(null===i)throw new Error(h);if(f&&i.constructor===ArrayBuffer)i=new Uint8Array(i);else if(!(Array.isArray(i)||f&&ArrayBuffer.isView(i)))throw new Error(h)}i.length>64&&(i=new t(r,!0).update(i).array());var y=[],p=[];for(e=0;e<64;++e){var l=i[e]||0;y[e]=92^l,p[e]=54^l}t.call(this,r,s),this.update(p),this.oKeyPad=y,this.inner=!0,this.sharedMemory=s}var h="input is invalid type",r="object"==typeof window,s=r?window:{};s.JS_SHA256_NO_WINDOW&&(r=!1);var e=!r&&"object"==typeof self,n=!s.JS_SHA256_NO_NODE_JS&&"object"==typeof process&&process.versions&&process.versions.node;n?s=global:e&&(s=self);var o=!s.JS_SHA256_NO_COMMON_JS&&"object"==typeof module&&module.exports,a="function"==typeof define&&define.amd,f=!s.JS_SHA256_NO_ARRAY_BUFFER&&"undefined"!=typeof ArrayBuffer,u="0123456789abcdef".split(""),c=[-2147483648,8388608,32768,128],y=[24,16,8,0],p=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298],l=["hex","array","digest","arrayBuffer"],d=[];!s.JS_SHA256_NO_NODE_JS&&Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),!f||!s.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW&&ArrayBuffer.isView||(ArrayBuffer.isView=function(t){return"object"==typeof t&&t.buffer&&t.buffer.constructor===ArrayBuffer});var A=function(i,h){return function(r){return new t(h,!0).update(r)[i]()}},w=function(i){var h=A("hex",i);n&&(h=b(h,i)),h.create=function(){return new t(i)},h.update=function(t){return h.create().update(t)};for(var r=0;r<l.length;++r){var s=l[r];h[s]=A(s,i)}return h},b=function(t,i){var r=eval("require('crypto')"),s=eval("require('buffer').Buffer"),e=i?"sha224":"sha256",n=function(i){if("string"==typeof i)return r.createHash(e).update(i,"utf8").digest("hex");if(null===i||void 0===i)throw new Error(h);return i.constructor===ArrayBuffer&&(i=new Uint8Array(i)),Array.isArray(i)||ArrayBuffer.isView(i)||i.constructor===s?r.createHash(e).update(new s(i)).digest("hex"):t(i)};return n},v=function(t,h){return function(r,s){return new i(r,h,!0).update(s)[t]()}},_=function(t){var h=v("hex",t);h.create=function(h){return new i(h,t)},h.update=function(t,i){return h.create(t).update(i)};for(var r=0;r<l.length;++r){var s=l[r];h[s]=v(s,t)}return h};t.prototype.update=function(t){if(!this.finalized){var i,r=typeof t;if("string"!==r){if("object"!==r)throw new Error(h);if(null===t)throw new Error(h);if(f&&t.constructor===ArrayBuffer)t=new Uint8Array(t);else if(!(Array.isArray(t)||f&&ArrayBuffer.isView(t)))throw new Error(h);i=!0}for(var s,e,n=0,o=t.length,a=this.blocks;n<o;){if(this.hashed&&(this.hashed=!1,a[0]=this.block,a[16]=a[1]=a[2]=a[3]=a[4]=a[5]=a[6]=a[7]=a[8]=a[9]=a[10]=a[11]=a[12]=a[13]=a[14]=a[15]=0),i)for(e=this.start;n<o&&e<64;++n)a[e>>2]|=t[n]<<y[3&e++];else for(e=this.start;n<o&&e<64;++n)(s=t.charCodeAt(n))<128?a[e>>2]|=s<<y[3&e++]:s<2048?(a[e>>2]|=(192|s>>6)<<y[3&e++],a[e>>2]|=(128|63&s)<<y[3&e++]):s<55296||s>=57344?(a[e>>2]|=(224|s>>12)<<y[3&e++],a[e>>2]|=(128|s>>6&63)<<y[3&e++],a[e>>2]|=(128|63&s)<<y[3&e++]):(s=65536+((1023&s)<<10|1023&t.charCodeAt(++n)),a[e>>2]|=(240|s>>18)<<y[3&e++],a[e>>2]|=(128|s>>12&63)<<y[3&e++],a[e>>2]|=(128|s>>6&63)<<y[3&e++],a[e>>2]|=(128|63&s)<<y[3&e++]);this.lastByteIndex=e,this.bytes+=e-this.start,e>=64?(this.block=a[16],this.start=e-64,this.hash(),this.hashed=!0):this.start=e}return this.bytes>4294967295&&(this.hBytes+=this.bytes/4294967296<<0,this.bytes=this.bytes%4294967296),this}},t.prototype.finalize=function(){if(!this.finalized){this.finalized=!0;var t=this.blocks,i=this.lastByteIndex;t[16]=this.block,t[i>>2]|=c[3&i],this.block=t[16],i>=56&&(this.hashed||this.hash(),t[0]=this.block,t[16]=t[1]=t[2]=t[3]=t[4]=t[5]=t[6]=t[7]=t[8]=t[9]=t[10]=t[11]=t[12]=t[13]=t[14]=t[15]=0),t[14]=this.hBytes<<3|this.bytes>>>29,t[15]=this.bytes<<3,this.hash()}},t.prototype.hash=function(){var t,i,h,r,s,e,n,o,a,f=this.h0,u=this.h1,c=this.h2,y=this.h3,l=this.h4,d=this.h5,A=this.h6,w=this.h7,b=this.blocks;for(t=16;t<64;++t)i=((s=b[t-15])>>>7|s<<25)^(s>>>18|s<<14)^s>>>3,h=((s=b[t-2])>>>17|s<<15)^(s>>>19|s<<13)^s>>>10,b[t]=b[t-16]+i+b[t-7]+h<<0;for(a=u&c,t=0;t<64;t+=4)this.first?(this.is224?(e=300032,w=(s=b[0]-1413257819)-150054599<<0,y=s+24177077<<0):(e=704751109,w=(s=b[0]-210244248)-1521486534<<0,y=s+143694565<<0),this.first=!1):(i=(f>>>2|f<<30)^(f>>>13|f<<19)^(f>>>22|f<<10),r=(e=f&u)^f&c^a,w=y+(s=w+(h=(l>>>6|l<<26)^(l>>>11|l<<21)^(l>>>25|l<<7))+(l&d^~l&A)+p[t]+b[t])<<0,y=s+(i+r)<<0),i=(y>>>2|y<<30)^(y>>>13|y<<19)^(y>>>22|y<<10),r=(n=y&f)^y&u^e,A=c+(s=A+(h=(w>>>6|w<<26)^(w>>>11|w<<21)^(w>>>25|w<<7))+(w&l^~w&d)+p[t+1]+b[t+1])<<0,i=((c=s+(i+r)<<0)>>>2|c<<30)^(c>>>13|c<<19)^(c>>>22|c<<10),r=(o=c&y)^c&f^n,d=u+(s=d+(h=(A>>>6|A<<26)^(A>>>11|A<<21)^(A>>>25|A<<7))+(A&w^~A&l)+p[t+2]+b[t+2])<<0,i=((u=s+(i+r)<<0)>>>2|u<<30)^(u>>>13|u<<19)^(u>>>22|u<<10),r=(a=u&c)^u&y^o,l=f+(s=l+(h=(d>>>6|d<<26)^(d>>>11|d<<21)^(d>>>25|d<<7))+(d&A^~d&w)+p[t+3]+b[t+3])<<0,f=s+(i+r)<<0;this.h0=this.h0+f<<0,this.h1=this.h1+u<<0,this.h2=this.h2+c<<0,this.h3=this.h3+y<<0,this.h4=this.h4+l<<0,this.h5=this.h5+d<<0,this.h6=this.h6+A<<0,this.h7=this.h7+w<<0},t.prototype.hex=function(){this.finalize();var t=this.h0,i=this.h1,h=this.h2,r=this.h3,s=this.h4,e=this.h5,n=this.h6,o=this.h7,a=u[t>>28&15]+u[t>>24&15]+u[t>>20&15]+u[t>>16&15]+u[t>>12&15]+u[t>>8&15]+u[t>>4&15]+u[15&t]+u[i>>28&15]+u[i>>24&15]+u[i>>20&15]+u[i>>16&15]+u[i>>12&15]+u[i>>8&15]+u[i>>4&15]+u[15&i]+u[h>>28&15]+u[h>>24&15]+u[h>>20&15]+u[h>>16&15]+u[h>>12&15]+u[h>>8&15]+u[h>>4&15]+u[15&h]+u[r>>28&15]+u[r>>24&15]+u[r>>20&15]+u[r>>16&15]+u[r>>12&15]+u[r>>8&15]+u[r>>4&15]+u[15&r]+u[s>>28&15]+u[s>>24&15]+u[s>>20&15]+u[s>>16&15]+u[s>>12&15]+u[s>>8&15]+u[s>>4&15]+u[15&s]+u[e>>28&15]+u[e>>24&15]+u[e>>20&15]+u[e>>16&15]+u[e>>12&15]+u[e>>8&15]+u[e>>4&15]+u[15&e]+u[n>>28&15]+u[n>>24&15]+u[n>>20&15]+u[n>>16&15]+u[n>>12&15]+u[n>>8&15]+u[n>>4&15]+u[15&n];return this.is224||(a+=u[o>>28&15]+u[o>>24&15]+u[o>>20&15]+u[o>>16&15]+u[o>>12&15]+u[o>>8&15]+u[o>>4&15]+u[15&o]),a},t.prototype.toString=t.prototype.hex,t.prototype.digest=function(){this.finalize();var t=this.h0,i=this.h1,h=this.h2,r=this.h3,s=this.h4,e=this.h5,n=this.h6,o=this.h7,a=[t>>24&255,t>>16&255,t>>8&255,255&t,i>>24&255,i>>16&255,i>>8&255,255&i,h>>24&255,h>>16&255,h>>8&255,255&h,r>>24&255,r>>16&255,r>>8&255,255&r,s>>24&255,s>>16&255,s>>8&255,255&s,e>>24&255,e>>16&255,e>>8&255,255&e,n>>24&255,n>>16&255,n>>8&255,255&n];return this.is224||a.push(o>>24&255,o>>16&255,o>>8&255,255&o),a},t.prototype.array=t.prototype.digest,t.prototype.arrayBuffer=function(){this.finalize();var t=new ArrayBuffer(this.is224?28:32),i=new DataView(t);return i.setUint32(0,this.h0),i.setUint32(4,this.h1),i.setUint32(8,this.h2),i.setUint32(12,this.h3),i.setUint32(16,this.h4),i.setUint32(20,this.h5),i.setUint32(24,this.h6),this.is224||i.setUint32(28,this.h7),t},i.prototype=new t,i.prototype.finalize=function(){if(t.prototype.finalize.call(this),this.inner){this.inner=!1;var i=this.array();t.call(this,this.is224,this.sharedMemory),this.update(this.oKeyPad),this.update(i),t.prototype.finalize.call(this)}};var B=w();B.sha256=B,B.sha224=w(!0),B.sha256.hmac=_(),B.sha224.hmac=_(!0),o?module.exports=B:(s.sha256=B.sha256,s.sha224=B.sha224,a&&define(function(){return B}))}();
  
  /**
  * [base64-js]{@link https://github.com/beatgammit/base64-js}
  *
  * @version v1.3.0
  * @author Kirill, Fomichev
  * @copyright Kirill, Fomichev 2014
  * @license MIT
  */
  (function(r){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=r()}else if(typeof define==="function"&&define.amd){define([],r)}else{var e;if(typeof window!=="undefined"){e=window}else if(typeof global!=="undefined"){e=global}else if(typeof self!=="undefined"){e=self}else{e=this}e.base64js=r()}})(function(){var r,e,n;return function(){function r(e,n,t){function o(f,i){if(!n[f]){if(!e[f]){var u="function"==typeof require&&require;if(!i&&u)return u(f,!0);if(a)return a(f,!0);var v=new Error("Cannot find module '"+f+"'");throw v.code="MODULE_NOT_FOUND",v}var d=n[f]={exports:{}};e[f][0].call(d.exports,function(r){var n=e[f][1][r];return o(n||r)},d,d.exports,r,e,n,t)}return n[f].exports}for(var a="function"==typeof require&&require,f=0;f<t.length;f++)o(t[f]);return o}return r}()({"/":[function(r,e,n){"use strict";n.byteLength=d;n.toByteArray=h;n.fromByteArray=p;var t=[];var o=[];var a=typeof Uint8Array!=="undefined"?Uint8Array:Array;var f="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";for(var i=0,u=f.length;i<u;++i){t[i]=f[i];o[f.charCodeAt(i)]=i}o["-".charCodeAt(0)]=62;o["_".charCodeAt(0)]=63;function v(r){var e=r.length;if(e%4>0){throw new Error("Invalid string. Length must be a multiple of 4")}var n=r.indexOf("=");if(n===-1)n=e;var t=n===e?0:4-n%4;return[n,t]}function d(r){var e=v(r);var n=e[0];var t=e[1];return(n+t)*3/4-t}function c(r,e,n){return(e+n)*3/4-n}function h(r){var e;var n=v(r);var t=n[0];var f=n[1];var i=new a(c(r,t,f));var u=0;var d=f>0?t-4:t;for(var h=0;h<d;h+=4){e=o[r.charCodeAt(h)]<<18|o[r.charCodeAt(h+1)]<<12|o[r.charCodeAt(h+2)]<<6|o[r.charCodeAt(h+3)];i[u++]=e>>16&255;i[u++]=e>>8&255;i[u++]=e&255}if(f===2){e=o[r.charCodeAt(h)]<<2|o[r.charCodeAt(h+1)]>>4;i[u++]=e&255}if(f===1){e=o[r.charCodeAt(h)]<<10|o[r.charCodeAt(h+1)]<<4|o[r.charCodeAt(h+2)]>>2;i[u++]=e>>8&255;i[u++]=e&255}return i}function s(r){return t[r>>18&63]+t[r>>12&63]+t[r>>6&63]+t[r&63]}function l(r,e,n){var t;var o=[];for(var a=e;a<n;a+=3){t=(r[a]<<16&16711680)+(r[a+1]<<8&65280)+(r[a+2]&255);o.push(s(t))}return o.join("")}function p(r){var e;var n=r.length;var o=n%3;var a=[];var f=16383;for(var i=0,u=n-o;i<u;i+=f){a.push(l(r,i,i+f>u?u:i+f))}if(o===1){e=r[n-1];a.push(t[e>>2]+t[e<<4&63]+"==")}else if(o===2){e=(r[n-2]<<8)+r[n-1];a.push(t[e>>10]+t[e>>4&63]+t[e<<2&63]+"=")}return a.join("")}},{}]},{},[])("/")});
'use strict';

angular.module('steve2')

.controller('LoginController', function (ConfigService) {
  var vm = this;
  vm.loginUrl = ConfigService.keycloak.root;
  vm.lookupUrl = ConfigService.aims.urlSSO;
  /** Canonical public app URL for OIDC redirect_uri (build-time `AIMS_APP_URL`); avoids wrong host from window.location. */
  vm.appBaseUrl = ConfigService.aims.appUrl;
});

'use strict';

angular.module('steve2')
  .controller('LandingController', function (Auth, $state, ConfigService, $http, $uibModal, Intervals, TACService, $translate) {

    var vm = this;

    vm.loginErrorInfo = function() {
      swal({ // eslint-disable-line
        title: $translate.instant('landing.loginerrortitle'),
        text: vm.loginError,
        type: "error",
        showLoaderOnConfirm: true,
        showCancelButton: false,
        confirmButtonColor: '#747a3f',
        confirmButtonText: $translate.instant('ok')
      });
    }

    if (Auth.user.authenticated()) {
      $state.go('index.dashboard');
    } else {
      Intervals.clearAll();
      TACService.clear();
    }

    vm.submitted = false;
    vm.formData = {};
    vm.formData.name = "";
    vm.formData.email = "";
    vm.formData.message = "";



    vm.processForm = function() {
      vm.submitted = true;
      var url = ConfigService.aims.contactUrl;
      var data = {
        name: vm.formData.name,
        email: vm.formData.email,
        message: vm.formData.message
      }
      $http({
        method: "post",
        url: url,
        data: data,
        skip: true
      })
      .then(function(data,status){
        //console.log("yay",data,status)
      },function (data,status) {
        //console.log('no',data,status)
      });
    }

    vm.launchSupport = function() {
      var supportModal = $uibModal.open({
        animation: false,
        templateUrl: 'app/support/support.tpl.html',
        controller: 'ModalSupportController as support',
        size: 'lg',
        backdrop: 'static'
      });
    };

    vm.goToResources = function() {
      $state.go('resources');
    };

  });

'use strict';

angular.module('steve2')

.factory('InboundService', function($q, $http, ConfigService) {

  function createList(listInfo) {
    var deferred = $q.defer();

    $http({
      method: 'post',
      url: ConfigService.api.baseUrl + '/list',
      data: listInfo
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(ex) {
      deferred.reject({
        ex: ex
      });
    });

    return deferred.promise;
  };

  function deleteList(listId) {
    var deferred = $q.defer();

    $http({
      method: 'delete',
      url: ConfigService.api.baseUrl + '/list/' + listId
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(ex) {
      deferred.reject({
        ex: ex
      });
    });

    return deferred.promise;
  };



  return {
    createList: createList,
    deleteList: deleteList
  };

});

'use strict';

angular.module('steve2')

.directive('ngSize', function(){
	return {
		restrict: 'A',
		link: function(scope,element,attrs){
			if(!element.nodeName === 'SELECT'){
				return;
			}
			attrs.$observe('ngSize', function setSize(){
        if (attrs.ngSize <= 5) {
          attrs.$set('size', 5);
        } else {
          if ((attrs.ngSize > 5) && (attrs.ngSize <= 20)) {
            attrs.$set('size', (attrs.ngSize * 1) + 4);
          } else {
            attrs.$set('size', 20);
          }
        }
			});
		}
	}
})

.controller('InboundController', function (Auth, $state, ConfigService, ListsService,
		$uibModal, InboundService, toaster, $translate) {

  //Check for authenticated AND role admin
  if (!Auth.user.authenticated()) {
    $state.go('landing');
  } else {
    if (Auth.user.roles().indexOf('steve2-admin') === -1) {
      $state.go('index.dashboard');
    }
  }

  var vm = this;

  vm.filetypes = ConfigService.api.fileTypes;

  function isAllowedFileType (ft) {
    return ft != null && ft !== '' && vm.filetypes.indexOf(ft) !== -1;
  }

  vm.selectedFileType = isAllowedFileType($state.params.fileType) ? $state.params.fileType : null;

  vm.onSelectedFileTypeChange = function () {
    $state.go('admin.inbound', { fileType: vm.selectedFileType || null }, {
      location: 'replace',
      notify: false
    });
  };

  vm.loadLists = function(selectedFileType) {
    vm.errors = null;
    vm.isLoading = true;

    var sObj = {listType: 'inbound'};
    if (typeof selectedFileType !== 'undefined') sObj.fileType = selectedFileType;

    ListsService.getLists()
      .then(function(response) {
        vm.lists = ListsService.getListsBy(response.lists, sObj);
        vm.isLoading = false;

        //vm.filetypes = ListsService.getListFileTypes(vm.lists);
      }, function() {
        vm.errors = $translate.instant('in.errorloading');
        vm.isLoading = false;
      });
  };
  vm.loadLists();

  vm.createNewIn = function() {

    var modalInstance = $uibModal.open({
      animation: false,
      templateUrl: 'app/inbound/createInbound.tpl.html',
      controller: 'CreateInController as cib',
      size: 'lg',
      backdrop: 'static'
    });

    modalInstance.result.then(function () {
      toaster.pop('success', 'Success', $translate.instant('in.createsuccess'));
    }, function () {
      angular.noop();
    });
  };

  vm.deleteList = function(listId) {
    swal({ // eslint-disable-line
      title: $translate.instant('in.deletemsgtitle'),
      text: $translate.instant('in.deletemsg'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: $translate.instant('yes'),
      cancelButtonText: $translate.instant('cancel')
    }, function(isConfirm) {
      if (isConfirm) {
        InboundService.deleteList(listId)
          .then(function() {
            toaster.pop('success', 'Success', $translate.instant('in.deletesuccess'));
            vm.loadLists(vm.selectedFileType);
          }, function() {
            toaster.pop('error', 'Error', $translate.instant('in.deleteerror'));
          });
      }
    });
  };

})

.controller('CreateInController', function($uibModalInstance, ConfigService, ListsService, InboundService, $state, $translate) {
  var vm = this;

  vm.activeStep = 0;
  vm.fileTypes = ConfigService.api.fileTypes;
  vm.enabled = true;

  vm.errors = [];
  vm.validateStep1 = function(callback) {
    vm.errors = [];
    if (typeof vm.fileType === 'undefined') {
      vm.errors.push($translate.instant('in.create.ftreq'));
    }

    if (typeof vm.listName === 'undefined') {
      vm.errors.push($translate.instant('in.create.namereq'));
    }

    if (typeof vm.fileType !== 'undefined') {
      ListsService.checkListName(vm.listName, vm.fileType, 'inbound')
        .then(function(response) {
          if (response.data === true) {
            vm.errors.push($translate.instant('in.create.nameused'));
          }
          callback();
        }, function(error) {
          vm.errors.push($translate.instant('in.create.ruleerror') + error.error);
        })
    } else {
      callback();
    }

  };

  vm.next = function() {
    if (vm.activeStep === 0) {
      vm.validateStep1(function() {
        if (vm.errors.length === 0) {
          vm.activeStep = vm.activeStep + 1;
        }
      });
    } else {
      if (vm.errors.length === 0) {
        vm.activeStep = vm.activeStep + 1;
      }
    }
  };

  vm.previuos = function() {
    vm.activeStep = vm.activeStep - 1;
  };

  vm.createList = function() {
    // TODO: The id of the newly created list must be returned by the API in order to navigate to Edit the list
    var listInfo = {
      listType: 'inbound',
      fileType: vm.fileType,
      listName: vm.listName,
      enabled: vm.enabled
    };

    InboundService.createList(listInfo)
      .then(function(response) {
        $state.go('admin.editlistin', { id: response.data.id, fileType: vm.fileType });
      }, function(err) {
        console.error('Error creating the mailbox', err); // eslint-disable-line
      });

    $uibModalInstance.dismiss('done');
  };

  vm.close = function() {
    $uibModalInstance.dismiss('cancel');
  };
})

;

'use strict';

angular.module('steve2')

.controller('EditInController', function (Auth, $state, $stateParams, MailServiceCache, ListsService, $timeout, toaster, $translate) {

  var vm = this;

  vm.eid = $stateParams.id;
  vm.returnFileType = $stateParams.fileType;

  vm.inboundListSrefParams = function () {
    var ft = vm.returnFileType || (vm.listInfo && vm.listInfo.fileType);
    return ft ? { fileType: ft } : {};
  };

  vm.goBackToInboundList = function ($event) {
    if ($event) {
      $event.preventDefault();
    }
    $state.go('admin.inbound', vm.inboundListSrefParams());
  };

  if (vm.eid === null) {
    $state.go('admin.inbound', vm.returnFileType ? { fileType: vm.returnFileType } : {});
    return;
  }

  vm.loadMembers = function() {
    //Now, load the recipients filtering out the ones already assigned
    if (typeof vm.recipients === 'undefined') {
      vm.loadingUsers = true; //First time load, show the spinning icon
    }
    vm.loadingUsersError = false;
    MailServiceCache.getRecipientsByType('user')
      .then(function(response) {
        vm.recipients = [];
        angular.copy(response.data, vm.recipients);

        response.data.forEach(function(element, index, array) {
          vm.listInfo.users.forEach(function(el, ix, ar) {
            if (element.id === el.userId) {
              delete vm.recipients[index];
            }
          });
        });

        vm.recipients.clean(undefined);
        vm.loadingUsers = false;
      }, function(error) {
        console.error('Error loading list members', error);
        vm.loadingUsers = false;
        vm.loadingUsersError = true;
      });
  };

  vm.loadInfo = function() {
    if (typeof vm.listInfo === 'undefined') {
      vm.loading = true; //First time load, show the spinning icon
    }
    vm.loadingError = false;
    ListsService.getListInfo(vm.eid)
      .then(function(response) {
        vm.listInfo = response.info;

        vm.listInfo.enabler = function(value) {
          if (arguments.length) {
            vm.listInfo.enabled = value === true ? 'true' : 'false';
          } else {
            return vm.listInfo.enabled === 'true';
          }
        }

        vm.loading = false;
        vm.loadMembers();
      }, function(error) {
        console.error('Error loading list info', error);
        vm.loading = false;
        vm.loadingError = true;
      });
  };
  vm.loadInfo();

  vm.makeEdit = function() {
    vm.editName = true;
  };

  vm.editDone = function() {
    vm.editName = false;
    //And save the changes right away
  };

  vm.addUsers = function() {
    if (vm.selectedUsers.length === 0) {
      return;
    }

    var promises = [];
    vm.selectedUsers.forEach(function(element, index, arr) {
      promises.push(
        ListsService.addUser(vm.eid, element)
        .then(function(response) {
          //Successful action is manage in the Promise.all resolution
        })
      );

    });

    Promise.all(promises).then(function(res) {
      vm.loadInfo();
      vm.selectedUsers = [];
    }, function(error) {
      $timeout(function() { //To trigger a $digest cycle
        toaster.pop('error', 'Error', $translate.instant('in.edit.erroradding'));
      }, 0);
      console.error('Error adding a user to the list', error);
    });

  };

  vm.removeUser = function(userId) {
    ListsService.removeUser(vm.eid, userId)
      .then(function(response) {
        vm.loadInfo();
      }, function(error) {
        console.error('Error removing a user to the list', error);
        toaster.pop('error', 'Error', $translate.instant('in.edit.errorremoving'));
      });
  };

  vm.switchList = function() {
    ListsService.toggleListStatus(vm.listInfo)
      .then(function(response) {
        //console.log(response.data);
      }, function(error) {
        console.error(error);
      });
  };

});

'use strict'

var config = {
  // TODO: The version should be changed everytime the TAC gets changed
  tac: {
    key: '',
    version: '',
  },

  env: {
    name: 'development',
    displayName: 'PRR',
    clientName: '',
    nchsEditorRole: '',
  },

  aims: {
    api: 'https://api.steve-development.eks.sandbox.aimsplatform.com',
    urlSSO: 'https://api-prr.eks.sandbox.aimsplatform.com/sso',
    appUrl: 'https://steve-development.eks.sandbox.aimsplatform.com',
    contactUrl: 'https://fkoq94vtsb.execute-api.us-east-1.amazonaws.com/prod/steve2-contact',
  },

  keycloak: {
    root: 'https://keycloak.steve-development.eks.sandbox.aimsplatform.com/auth',
    realmLookup: '',
  },

  api: {
    baseUrl: 'https://api.steve-development.eks.sandbox.aimsplatform.com',
    mailApi: 'https://api.steve-development.eks.sandbox.aimsplatform.com',
    fileTypes: [
      'Mortality',
      'Other',
      'ITOP',
      'Natality',
      'Roster',
      'FetalDeath',
      'BirthInfantDeath',
    ],
    clientTypes: ['STEVE2 client', 'Web', 'PHIN MS', 'SFTP', 'Direct'],
    clientInstaller: {
      url: 'https://client.steve-development.eks.sandbox.aimsplatform.com/downloads',
      win32: {
        name: 'Windows 32bit',
        filename: 'steveclient_windows.exe',
      },
      win64: {
        name: 'Windows 64bit',
        filename: 'steveclient_windows-x64.exe',
      },
      linux: {
        name: 'Linux/Unix',
        filename: 'steveclient_unix.sh',
      }
    },
  },
}

angular
  .module('steve2')

  .factory('ConfigService', function () {
    return {
      tac: config.tac,
      environment: config.env,
      keycloak: config.keycloak,
      api: config.api,
      aims: config.aims,
    }
  })

"use strict";

angular
  .module("steve2")

  .filter("state_status", function () {
    var colors = {
      good: "#1b9e77",
      warn: "#F2AE43",
      severe: "#db524b",
    };
    return function (input) {
      if (typeof input === "undefined") {
        return "#999999";
      } else {
        return colors[input];
      }
    };
  })

  .filter("emailify", function () {
    return function (input) {
      return input.split("/").pop();
    };
  })

  .filter("yesNo", function ($translate) {
    return function (b) {
      return b ? $translate.instant("yes") : $translate.instant("no");
    };
  })

  .filter("routingCode", function () {
    return function (input) {
      if (input.length > 0) {
        return "(" + input + ") ";
      } else {
        return "";
      }
    };
  })

  .filter("phoneUS", function () {
    return function (input) {
      if (input === null) {
        return "";
      }
      var partOf4 = input.slice(-4);
      var partOf3 = input.slice(-7, -4);
      var partOf2 = input.slice(-10, -7);
      var first = input.replace(partOf2 + partOf3 + partOf4, "");

      return first + " (" + partOf2 + ") " + partOf3 + " " + partOf4;
    };
  })

  .filter("momentify", function () {
    return function (input) {
      input = input || Date.now();
      return moment(input).calendar(); // eslint-disable-line
    };
  })

  .filter("relatify", function () {
    return function (input) {
      input = input || Date.now();
      return moment(input).fromNow(); // eslint-disable-line
    };
  })

  .filter("capitalize", function () {
    return function (input) {
      if (input !== null) {
        return input.toString().replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
      }
    };
  })

  .filter("senderUser", function () {
    return function (input) {
      if (input !== null) {
        var parts = input.split("/");
        return parts[parts.length - 1];
      }
    };
  })

  .filter("recipientList", function () {
    return function (input) {
      if (input !== null) {
        var parsed = angular.fromJson(input);
        var list = [].concat(parsed);
        var dnArray = [];
        list.forEach(function (element) {
          dnArray.push(element.displayName);
        });
        return dnArray.join(", ");
      }
    };
  })

  .filter("bytes", function () {
    return function (bytes, precision) {
      if (bytes === 0) {
        return "0 bytes";
      }
      if (isNaN(parseFloat(bytes)) || !isFinite(bytes))
        return "unknown filesize";
      if (typeof precision === "undefined") precision = 1;

      var units = ["bytes", "kB", "MB", "GB", "TB", "PB"],
        number = Math.floor(Math.log(bytes) / Math.log(1024)),
        val = (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision);

      return (
        (val.match(/\.0*$/) ? val.substr(0, val.indexOf(".")) : val) +
        " " +
        units[number]
      );
    };
  })

  .filter("typeClass", function () {
    return function (input, base) {
      var suffix = {
        success: "success",
        info: "info",
        warning: "warning",
        error: "danger",
      }[input];

      var prefix = base ? base + "-" : "";

      return prefix + suffix;
    };
  })

  .filter("iconClass", function () {
    return function (input, base) {
      var suffix = {
        success: "check-circle",
        info: "info-circle",
        warning: "exclamation-triangle",
        error: "times-circle",
        win32: "windows",
        win64: "windows",
        mac: "apple",
        linux: "linux",
      }[input];

      var prefix = base ? base + "-" : "";

      return prefix + suffix;
    };
  })

  .filter("injectColors", function () {
    return function (intention) {
      var intentions = {
        // primary: '#747a3f',
        primary: "#2E527A",
        default: "#c2c2c2",
        success: "#007680",
        info: "#864731",
        warning: "#f2ae43",
        danger: "#d63a32",
      };

      // return intentions[intention] || '#747a3f';
      return intentions[intention] || "#2E527A";
    };
  });

'use strict';

angular.module('steve2')

.controller('ClientDownloadController', function() {
  var vm = this;

  vm.platform = platform; // eslint-disable-line

  if (vm.platform.os.toString().toUpperCase().indexOf('WINDOWS') !== -1) {
    if (vm.platform.os.toString().toUpperCase().indexOf('X64') !== -1) {
      vm.type = 'win64';
    } else {
      vm.type = 'win32';
    }
  } else {
    if (vm.platform.os.toString().toUpperCase().indexOf('OS X') !== -1) {
      vm.type = 'mac';
    } else {
      vm.type = 'linux';
    }
  }

  if (angular.isUndefined(vm.installer[vm.type])) {
    vm.type = 'win64';
  }

  vm.changePlatform = function(type) {
    vm.type = type;
  }
})

;

'use strict';

angular.module('steve2')

.component('searchBox', {
  bindings: {
    search: '=model',
    placeholder: '@',
    aria: '@',
    size: '@'
  },
  templateUrl: 'app/components/common/searchBox.tpl.html'
})

.component('noProfile', {
  templateUrl: 'app/components/common/noprofile.tpl.html'
})

.component('contactCard', {
  bindings: {
    contact: '='
  },
  templateUrl: 'app/components/common/contactCard.tpl.html'
})

.component('contactBox', {
  bindings: {
    contact: '=',
    parent: '=',
    onContactSelected: '='
  },
  templateUrl: 'app/components/common/contactBox.tpl.html'
})

.component('contactRow', {
  bindings: {
    contact: '=',
    parent: '=',
    onContactSelected: '='
  },
  templateUrl: 'app/components/common/contactRow.tpl.html'
})

.component('clientDownload', {
  bindings: {
    installer: '<'
  },
  controller: 'ClientDownloadController',
  templateUrl: 'app/components/common/clientDownload.tpl.html'
})

.component('dashWidget', {
  bindings: {
    status: '='
  },
  templateUrl: 'app/components/common/dashWidget.tpl.html'
})

.component('compactWidget', {
  bindings: {
    status: '=',
    link: '='
  },
  templateUrl: 'app/components/common/compactWidget.tpl.html'
})

.component('resourceItem', {
  bindings: {
    icon: '@',
    titleText: '@',
    text: '@',
    link: '@',
    button: '@',
    down: '@'
  },
  templateUrl: 'app/components/common/resourceItem.tpl.html'
})

;

'use strict';

angular.module('steve2')

.factory('ClientsService', function($q, $http, ConfigService) {

  function getClients() {
    var deferred = $q.defer();

    $http({
      method: 'GET',
      url: ConfigService.api.baseUrl + '/client'
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      //console.log('ERROR loading from external', error);
      deferred.reject({
        error: error
      });
    }).catch(function(except) {
      //console.log('EXCEPTION loading from external', error);
      deferred.reject({
        error: except
      });
    });

    return deferred.promise;
  };

  function updateClient(clientId) {
    var deferred = $q.defer();

    $http({
      method: 'GET',
      url: ConfigService.api.baseUrl + '/client/' + clientId
    }).then(function(result) {
      deferred.resolve({
        data: result.data
      });
    }, function(error) {
      //console.log('ERROR loading data', error);
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  }

  function getClientConfig(clientId) {
    var deferred = $q.defer();

    $http({
      method: 'GET',
      url: ConfigService.api.baseUrl + '/client/' + clientId + '/config'
    }).then(function(result) {
      deferred.resolve({
        data: result.data
      });
    }, function(error) {
      //console.log('ERROR loading data', error);
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  };

  function saveClientConfig(clientId, rules) {
    var deferred = $q.defer();

    $http({
      method: 'POST',
      url: ConfigService.api.baseUrl + '/client/' + clientId + '/config',
      data: rules,
      json: true
    }).then(function(result) {
      deferred.resolve({
        data: result.data
      });
    }, function(error) {
      //console.log('ERROR loading data', error);
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  };

  function deleteRule(clientId, routeId) {
    var deferred = $q.defer();

    $http({
      method: 'DELETE',
      url: ConfigService.api.baseUrl + '/client/' + clientId + '/config/' + routeId,
    }).then(function(result) {
      deferred.resolve({
        data: result.data
      });
    }, function(error) {
      //console.log('ERROR loading data', error);
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  };

  return {
    getClients: getClients,
    updateClient: updateClient,
    getClientConfig: getClientConfig,
    saveClientConfig: saveClientConfig,
    deleteRule: deleteRule
  };

});

'use strict';

angular.module('steve2')

.directive('clientStatus', function() {
  return {
    restrict: 'E',
    scope: {
      clientInfo: '=info',
      callback: '=callback',
      installer: '='
    },
    templateUrl: 'app/clients/clients.directive.tpl.html',
    link: function(scope) {
      scope.checkStatus = function() {
        scope.callback(scope.clientInfo);
      };
    }
  };
})

.controller('ClientsController', function (Auth, $state, ClientsService, $timeout, $translate, $uibModal, ConfigService) {

  var vm = this;

  if (!Auth.user.authenticated()) {
    $state.go('landing');
  }

  vm.installer = ConfigService.api.clientInstaller;

  vm.loadClients = function() {
    vm.loading = true;
    vm.errors = null;
    $timeout(function() {
      ClientsService.getClients()
        .then(function(response) {
          vm.clients = response.data;
          vm.loading = false;
        }, function(error) {
          vm.loading = false;
          vm.errors = $translate.instant('clients.loaderror');
          if ((error.error.status >= 400) && (error.error.status < 500)) {
            //Auth.user.logout();
            //Logout because of lack of permissions
          }
        }).catch(function(/* exception */) {
          //console.log('Exception caught', exception);
        });
    }, 500);
  };

  vm.loadClients();

  vm.checkStatus = function(client) {
    var lastStatus = client.status;
    client.status = 'CHECKING';
    $timeout(function() {
      ClientsService.updateClient(client.clientId)
        .then(function(response) {
          //console.log(response);
          client.clientName = response.data.clientName;
          client.status = response.data.status;
          client.statusMsg = response.data.statusMsg;
          client.download = response.data.download;
          client.available = response.data.available;
          client.installed = response.data.installed;
        }, function(error) {
          //console.log('CATCH ERROR');
          client.status = lastStatus;
          if ((error.error.status >= 400) && (error.error.status < 500)) {
            //Auth.user.logout();
            //Logout because of lack of permissions
          }
        }).catch(function(/* exception */) {
          //console.log('CATCH EXCEPTION');
          client.status = lastStatus;
        });
    }, 500); //Give a little timeout to not flick too fast

  };

  vm.createRequest = function() {
    $uibModal.open({
      animation: false,
      templateUrl: 'createRequest.html',
      controller: 'RequestModalController as req'
    });
    // swal({ // eslint-disable-line
    //   title: $translate.instant('clients.req.createsuccess'),
    //   text: $translate.instant('clients.req.checksupport'),
    //   type: 'success',
    //   showCancelButton: true,
    //   cancelButtonText: $translate.instant('ok'),
    //   confirmButtonText: $translate.instant('supa.title')
    // }, function(isConfirm) {
    //   if (isConfirm) {
    //     $state.go('index.support');
    //   }
    // });
  };

})

.controller('RequestModalController', function($uibModalInstance, $translate, Auth, Support, toaster, ConfigService, $state) {
  var vm = this;

  vm.clientTypes = ConfigService.api.clientTypes;

  vm.cancel = function() {
    $uibModalInstance.close('cancel');
  };

  vm.request = function() {
    vm.submitting = true;
    var email = Auth.user.get().email;
    var name = Auth.user.get().name || email;
    var request = 'Request a Client. Client Name: ' + vm.clientRequest.clientName + '. Client Type: ' + vm.clientRequest.clientType;

    Support.requestSupport({
      name: name,
      email: email,
      request: request
    }).then(function () {
      $uibModalInstance.close();
      swal({ // eslint-disable-line
        title: $translate.instant('clients.req.createsuccess'),
        text: $translate.instant('clients.req.checksupport'),
        type: 'success',
        showCancelButton: true,
        cancelButtonText: $translate.instant('ok'),
        confirmButtonText: $translate.instant('supa.title')
      }, function(isConfirm) {
        if (isConfirm) {
          $state.go('index.support');
        }
      });
    }, function () {
      toaster.pop('error', 'Oops!', $translate.instant('sup.reqerror'));
    }).finally(function() {
      vm.submitting = false;
    });
  }
})

;

'use strict';

angular.module('steve2')

.directive('recList', function() {
  return {
    restrict: 'E',
    scope: {
      addressList: '=info'
    },
    templateUrl: 'app/clients/reclist.directive.tpl.html'
  };
})

.directive('allowPattern', function allowPatternDirective() {
  return {
    restrict: "A",
    compile: function(/* tElement, tAttrs */) {
      return function(scope, element, attrs) {
        // I handle key events
        element.bind("keypress", function(event) {
          var keyCode = event.which || event.keyCode; // I safely get the keyCode pressed from the event.
          var keyCodeChar = String.fromCharCode(keyCode); // I determine the char from the keyCode.

          // If the keyCode char does not match the allowed Regex Pattern, then don't allow the input into the field.
          if (!keyCodeChar.match(new RegExp(attrs.allowPattern, "i"))) {
            event.preventDefault();
            return false;
          }

        });
      };
    }
  };
})

.controller('ClientDetailController', function (Auth, $state, ClientsService, $stateParams, $uibModal,
    toaster, ConfigService, ListsService, $translate) {

  if (!Auth.user.authenticated()) {
    $state.go('landing');
  }

  var vm = this;
  vm.clientId = $stateParams.clientId;
  vm.canEdit = false;

  function syncCanEdit() {
    if (!vm.clientInfo || !vm.clientInfo.userId) {
      vm.canEdit = false;
      return;
    }
    var parsed = Auth.user.get();
    var email = parsed.email || parsed.preferred_username;
    vm.canEdit = vm.clientInfo.userId === (Auth.realm.getName() + '/' + email);
  }

  vm.installer = ConfigService.api.clientInstaller;

  if (platform.os.toString().toUpperCase().indexOf('WINDOWS') !== -1) { // eslint-disable-line
    vm.platform = 'windows';
  } else {
    vm.platform = 'mac';
  }

  vm.loadClientConfig = function() {
    ClientsService.getClientConfig(vm.clientId)
      .then(function(response) {
        vm.clientConfig = response.data;
        // console.log('CLIENT CONFIG', vm.clientConfig);
      }, function(error) {
        vm.errors = error;
      });
  };

  if (typeof vm.clientId !== 'undefined') {
    vm.loading = true;
    ClientsService.updateClient(vm.clientId)
      .then(function(response) {
        vm.clientInfo = response.data;
        syncCanEdit();
        vm.loading = false;
      }, function(error) {
        vm.errors = error;
        vm.loading = false;
      });

      vm.loadClientConfig();

  } else {
    $state.go('index.clients');
  }

  vm.changePlatform = function(platf) {
    vm.platform = platf;
  };

  // NEW INBOUND RULE **********************************************************
  vm.newInboundRule = function() {
    if (!vm.canEdit) {
      return;
    }
    vm.createNewIn = true;
    vm.editRule = -1;
    //Load lists
    vm.selectedFileType = null;
    vm.filetypes = ConfigService.api.fileTypes;
    vm.associatedMailboxes = [];
    vm.loadLists();
    vm.newFolderName = '';
  };

  vm.editInboundRule = function(ruleIndex) {
    if (!vm.canEdit) {
      return;
    }
    vm.createNewIn = true;
    vm.editRule = ruleIndex;
    //Load lists
    vm.selectedFileType = null;
    vm.filetypes = ConfigService.api.fileTypes;
    vm.associatedMailboxes = angular.copy(vm.clientConfig.inrules[ruleIndex].address);
    vm.loadLists();
    vm.newFolderName = angular.copy(vm.clientConfig.inrules[ruleIndex].folder);
  };

  vm.loadLists = function() {
    vm.errors = null;
    vm.isLoading = true;

    var sObj = {listType: 'inbound'};

    ListsService.getLists()
      .then(function(response) {
        vm.availableMailboxes = ListsService.getListsBy(response.lists, sObj);
        vm.removeFromList(vm.associatedMailboxes, vm.availableMailboxes);
        vm.isLoading = false;
      }, function() {
        vm.errors = $translate.instant('clients.detail.errorloading');
        vm.isLoading = false;
      });
  };

  vm.addMailboxes = function() {
    vm.selectedMailboxes.forEach(function(element) {
      vm.associatedMailboxes.push({
        'id': element.id,
        'displayName': element.listName,
        'type': 'list',
        'fileType': element.fileType
      });
    });
    vm.removeFromList(vm.associatedMailboxes, vm.availableMailboxes);
  };

  vm.removeMailboxes = function() {
    vm.selectedAssMailboxes.forEach(function(element) {
      vm.availableMailboxes.push({
        'id': element.id,
        'listName': element.displayName,
        'fileType': element.fileType
      });
    });
    vm.removeFromList(vm.selectedAssMailboxes, vm.associatedMailboxes);
  };

  vm.saveInRule = function() {
    if (!vm.canEdit) {
      return;
    }
    if (vm.editRule !== -1) {
      //Editig
      vm.clientConfig.inrules[vm.editRule].folder = vm.newFolderName;
      vm.clientConfig.inrules[vm.editRule].address = vm.associatedMailboxes;
    } else {
      //Creating
      vm.clientConfig.inrules.push({
        'folder': vm.newFolderName,
        'address': vm.associatedMailboxes
      });
    }
    vm.createNewIn = false;
    vm.saveChanges();
  };

  // OUTBOUND ********************************************************************

  vm.loadOutboundLists = function() {
    vm.errors = null;
    vm.isLoading = true;

    var sObj = {listType: 'outbound'};

    ListsService.getLists()
      .then(function(response) {
        vm.availableOutbound = ListsService.getListsBy(response.lists, sObj);
        vm.removeFromList(vm.associatedOutbound, vm.availableOutbound);
        vm.isLoading = false;
      }, function() {
        vm.errors = $translate.instant('clients.detail.errorloading');
        vm.isLoading = false;
      });
  };

  vm.newOutboundRule = function() {
    if (!vm.canEdit) {
      return;
    }
    vm.createNewOut = true;
    vm.editRule = -1;
    //Load lists
    vm.selectedOutFileType = null;
    vm.filetypes = ConfigService.api.fileTypes;
    vm.associatedOutbound = [];
    vm.loadOutboundLists();
    vm.newOutFolderName = '';
  };

  vm.editOutboundRule = function(ruleIndex) {
    if (!vm.canEdit) {
      return;
    }
    vm.createNewOut = true;
    vm.editRule = ruleIndex;
    //Load lists
    vm.selectedOutFileType = null;
    vm.filetypes = ConfigService.api.fileTypes;
    vm.associatedOutbound = angular.copy(vm.clientConfig.outrules[ruleIndex].address);
    vm.loadOutboundLists();
    vm.newOutFolderName = angular.copy(vm.clientConfig.outrules[ruleIndex].folder);
  };

  vm.addOutbound = function() {
    vm.selectedOutbound.forEach(function(element) {
      vm.associatedOutbound.push({
        'id': element.id,
        'displayName': element.listName,
        'type': 'list',
        'fileType': element.fileType
      });
    });
    vm.removeFromList(vm.associatedOutbound, vm.availableOutbound);
  };

  vm.removeOutbound = function() {
    vm.selectedAssOutbound.forEach(function(element) {
      vm.availableOutbound.push({
        'id': element.id,
        'listName': element.displayName,
        'fileType': element.fileType
      });
    });
    vm.removeFromList(vm.selectedAssOutbound, vm.associatedOutbound);
  };

  vm.saveOutRule = function() {
    if (!vm.canEdit) {
      return;
    }
    if (vm.editRule !== -1) {
      //Editig
      vm.clientConfig.outrules[vm.editRule].folder = vm.newOutFolderName;
      vm.clientConfig.outrules[vm.editRule].address = vm.associatedOutbound;
    } else {
      //Creating
      vm.clientConfig.outrules.push({
        'folder': vm.newOutFolderName,
        'address': vm.associatedOutbound
      });
    }
    vm.createNewOut = false;
    vm.saveChanges();
  };



  // COMMON ********************************************************************
  vm.removeFromList = function(toRemove, removeFrom) {
    removeFrom.forEach(function(element, index) {
      toRemove.forEach(function(ele) {
        if (ele.id === element.id) {
          removeFrom[index] = undefined;
        }
      });
    });
    removeFrom.clean(undefined);
  };

  vm.saveChanges = function saveChanges() {
    if (!vm.canEdit) {
      return;
    }
    //console.log('CONFIG', $scope.clientConfig);
    ClientsService.saveClientConfig(vm.clientId, vm.clientConfig)
      .then(function() {
        toaster.pop('success', 'Completed', $translate.instant('clients.detail.configsuccess'));
        vm.loadClientConfig();
      }, function() {
        toaster.pop('error', 'Error', $translate.instant('clients.detail.configerror'));
      });
  };

  vm.deleteRule = function deleteRule(type, ruleIndex) {
    if (!vm.canEdit) {
      return;
    }
    if (type === 'inbound') {
      ClientsService.deleteRule(vm.clientId, vm.clientConfig.inrules[ruleIndex].id)
        .then(function() {
          vm.clientConfig.inrules.splice(ruleIndex, 1);
          vm.loadClientConfig();
        }, function() {
          //console.error(error);
        });
    } else {
      ClientsService.deleteRule(vm.clientId, vm.clientConfig.outrules[ruleIndex].id)
        .then(function() {
          vm.clientConfig.outrules.splice(ruleIndex, 1);
          vm.loadClientConfig();
        }, function() {
          //console.error(error);
        });
    }
  };

})


;

'use strict';

angular.module('steve2')

.controller('BulletinController', function() {
  
})

;

(function (window, angular) {

  angular.module('aims-notifications', [])
  .provider('Notification', function() {

    var notificationBaseUrl = '';

    this.notificationBaseUrl = function(value) {
      notificationBaseUrl = !!value;
    }

    this.$get = function($http, $q) {
      return {
        notificationBaseUrl: this.notificationBaseUrl,

        notifications: function(params) {
          var deferred = $q.defer();
          var url = this.notificationBaseUrl + '/notifications';

          $http({
            method: 'get',
            url: url,
            params: params
          })
          .then(function(response) {
            deferred.resolve({
              data: response.data
            });
          }, function(error) {
            deferred.reject({
              error: error
            });
          });
          return deferred.promise;
        },

        update: function(notification) {
          var deferred = $q.defer();
          var url = this.notificationBaseUrl + '/notifications/' + notification.id;

          $http({
            method: 'put',
            url: url,
            data: notification,
          })
          .then(function(response) {
            deferred.resolve({
              data: response.data
            });
          }, function(error) {
            deferred.reject({
              error: error
            });
          });
          return deferred.promise;
        },

      };
    };


  })

  .provider('NotificationConfig', function() {

    var notificationBaseUrl = '';

    this.notificationBaseUrl = function(value) {
      notificationBaseUrl = !!value;
    }

    this.$get = function($http, $q) {

      return {

        notificationBaseUrl: this.notificationBaseUrl,

        getNotificationTypes: function() {
          return $http.get(this.notificationBaseUrl + '/notificationTypes').then(function(res) {
            return res.data;
          }, function(error) {
            return error;
          }).catch(function(excep) {
            return excep;
          });
        },

        getNotificationConfigs: function(userId) {
          var params = {
            user: userId
          };
          return $http.get(this.notificationBaseUrl + '/notificationConfigs',  params ).then(function(res) {
            return res.data;
          }, function(error) {
            return error;
          }).catch(function(excep) {
            return excep;
          });
        },

        getNotificationConfigs2: function(userId, app) {
          var params = {
            user: userId,
            app: app
          };
          return $http.get(this.notificationBaseUrl + '/notificationConfigs', params ).then(function(res) {
            return res.data;
          }, function(error) {
            return error;
          }).catch(function(excep) {
            return excep;
          });
        },

        getNotificationConfig: function(id) {
          var deferred = $q.defer();

          $http({
            method: 'get',
            url: this.notificationBaseUrl + '/notificationConfigs/' + id
          }).then(function(response) {
            deferred.resolve({
              data: response.data
            });
          }, function(error) {
            deferred.reject({
              error: error
            });
          }).catch(function(ex) {
            deferred.reject({
              ex: ex
            });
          });

          return deferred.promise;
        },

        saveNotificationConfigs: function(config) {
          var deferred = $q.defer();

          if (typeof config.id !== 'undefined') {
            $http({
              method: 'put',
              url: this.notificationBaseUrl + '/notificationConfigs/' + config.id,
              data: config
            }).then(function(response) {
              deferred.resolve({
                data: response.data
              });
            }, function(error) {
              deferred.reject({
                error: error
              });
            }).catch(function(ex) {
              deferred.reject({
                ex: ex
              });
            });
          } else {
            $http({
              method: 'post',
              url: this.notificationBaseUrl + '/notificationConfigs',
              data: config
            }).then(function(response) {
              deferred.resolve({
                data: response.data
              });
            }, function(error) {
              deferred.reject({
                error: error
              });
            }).catch(function(ex) {
              deferred.reject({
                ex: ex
              });
            });
          }

          return deferred.promise;
        },

      };
    };


  });

})(window, window.angular);

'use strict';

angular.module('steve2')

.factory('RolesService', function($q, $http, ConfigService) {

  function getRealmRoles(realm) {
    var deferred = $q.defer();
    var url = ConfigService.api.baseUrl + '/admin/roles';
    $http.get(url)
      .then(function(response) {
        deferred.resolve({
          data: response.data
        });
      }, function(error) {
        deferred.reject({
          error: error
        });
      });
    return deferred.promise;
  };

  function getUserRoles(userId) {
    var deferred = $q.defer();
    var url = ConfigService.api.baseUrl + '/admin/roles/user/' + userId;
    $http.get(url)
      .then(function(response) {
        deferred.resolve({
          data: response.data
        });
      }, function(error) {
        deferred.reject({
          error: error
        });
      });
    return deferred.promise;
  };

  function getAssignableUserRoles(userId) {
    var deferred = $q.defer();
    var url = ConfigService.api.baseUrl + '/admin/roles/user/' + userId + '/available';
    $http.get(url)
      .then(function(response) {
        deferred.resolve({
          data: response.data
        });
      }, function(error) {
        deferred.reject({
          error: error
        });
      });
    return deferred.promise;
  };

  function assignRealmRole(userId, roles) {
    var deferred = $q.defer();
    var url = ConfigService.api.baseUrl + '/admin/roles/user/' + userId;
    $http.post(url, roles)
      .then(function(response) {
        deferred.resolve({
          data: response.data
        });
      }, function(error) {
        deferred.reject({
          error: error
        });
      });
    return deferred.promise;
  };

  function removeRealmRole(userId, roles) {
    var deferred = $q.defer();
    var url = ConfigService.api.baseUrl + '/admin/roles/user/' + userId;

    var req = {
      method: 'DELETE',
      url: url,
      data: roles,
      headers: {'Content-Type': 'application/json;charset=utf-8'}
    };

    $http(req)
      .then(function(response) {
        deferred.resolve({
          data: response.data
        });
      }, function(error) {
        deferred.reject({
          error: error
        });
      });
    return deferred.promise;
  };

  return {
    getRealmRoles: getRealmRoles,
    getUserRoles: getUserRoles,
    getAssignableUserRoles: getAssignableUserRoles,

    assignRealmRole: assignRealmRole,
    removeRealmRole: removeRealmRole
  };

});

'use strict';

angular.module('steve2')

.directive('itemCheck', function() {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      validation: '='
    },
    templateUrl: 'app/adminuserdetail/itemcheck.directive.tpl.html'
  };
})

.controller('UserDetailController', function (Auth, $state, toaster,
    UsersService, $stateParams, $scope, RolesService, $translate) {
  //Check for authenticated AND role admin
  if (!Auth.user.authenticated()) {
    $state.go('landing');
  } else {
    if (Auth.user.roles().indexOf('steve2-admin') === -1) {
      $state.go('index.dashboard');
    }
  }

  var vm = this;

  vm.action = $stateParams.action;
  vm.userId = $stateParams.userId || null;

  vm.roles = [];
  vm.userRoles = [];

  vm.getRoles = function(userId) {
    RolesService.getUserRoles(userId)
      .then(function(response) {
        vm.userRoles = response.data || [];
      });

    RolesService.getAssignableUserRoles(userId)
      .then(function(response) {
        vm.roles = response.data || [];
      });
  }

  vm.loadUser = function(userId) {
    if (userId !== null) {
      vm.isLoading = true;
      UsersService.getUser(userId)
        .then(function(response) {
          vm.userDetail = response.userDetail;
          vm.isLoading = false;

          vm.getRoles(userId);
        }, function(/* error */) {
          vm.isLoading = false;
        });

    } else {
      vm.userDetail = {};
    }
  }
  vm.loadUser(vm.userId);

  vm.saveUserDetails = function() {

    if (typeof vm.userDetail.id === 'undefined') {
      if (typeof vm.userDetail.email === 'undefined') {
        //show some error and return
        vm.emailRequired = $translate.instant('users.detail.emailrequired');
        return;
      }
      if (vm.resetBtnDisabled) {
        toaster.pop('error', 'Error', $translate.instant('users.detail.temppassrequired'));
        return;
      }
      vm.userDetail.username = vm.userDetail.email;

      UsersService.createUser(vm.userDetail, vm.password.new)
        .then(function(response) {
          var created = response.data || {};
          var title = $translate.instant('users.detail.createsuccess');
          var body = created.email || vm.userDetail.email || '';
          var profileExisting =
            created.steveProfileExisting === true ||
            created.steveProfileCreated === false;
          if (profileExisting) {
            body = created.warning ||
              $translate.instant('users.detail.createsuccessprofileexisting');
          }
          toaster.pop('success', title, body);
          $state.go('admin.users');
        }, function(errorRes) {
          var status = errorRes.error && errorRes.error.status;
          var apiMessage =
            errorRes.error &&
            errorRes.error.data &&
            (errorRes.error.data.message || errorRes.error.data.error);
          if (status === 409) {
            toaster.pop('error', 'Error', $translate.instant('users.detail.createerrorduplicated'));
          } else {
            toaster.pop(
              'error',
              'Error',
              apiMessage || $translate.instant('users.detail.createerror')
            );
          }
        });

    } else {

      UsersService.updateUser(vm.userDetail)
        .then(function(/* response */) {
          toaster.pop('success', 'Completed', $translate.instant('users.detail.updatesuccess'));
          $state.go('admin.users');
        }, function(/* error */) {
          toaster.pop('error', 'Error', $translate.instant('users.detail.updatesuccess'));
        });

    }
  };


  /* Password validation */
  vm.password = {
    new: '',
    confirm: ''
  };

  var setInitialRequirements = function() {
    vm.resetBtnDisabled = true;
    vm.passEmpty = false;
    vm.passLower = false;
    vm.passUpper = false;
    vm.passNumber = false;
    vm.passLength = false;
    vm.passConfirm = false;
  };

  setInitialRequirements();

  $scope.$watchGroup(['udet.password.new', 'udet.password.confirm'], function(newValues) {
    if ((typeof newValues[0] === 'undefined') || (newValues[0] === '')) {
      vm.passEmpty = false;
      vm.passLower = false;
      vm.passUpper = false;
      vm.passNumber = false;
    } else {
      vm.passEmpty = true;
      if (typeof newValues[0] !== 'undefined')  {
        vm.passConfirm = (newValues[0] === newValues[1]);
        vm.passLower = (newValues[0].match(/[a-z]/));
        vm.passUpper = (newValues[0].match(/[A-Z]/));
        vm.passNumber = (newValues[0].match(/\d/));
        vm.passLength = (newValues[0].length >= 8);
      }
    }

    vm.resetBtnDisabled = !(vm.passConfirm
      && vm.passLower
      && vm.passUpper
      && vm.passLength
      && vm.passEmpty
    );
  });

  vm.resetPassword = function() {
    if (!vm.resetBtnDisabled) {
      vm.credRep = {
        type: 'password',
        value: vm.password.new
      };

      if (typeof vm.userDetail.id !== 'undefined') {

        UsersService.resetPassword(vm.userDetail.id, vm.credRep)
          .then(function(/* response */) {
            vm.password = {
              new: '',
              confirm: '',
              temporary: true
            };
            setInitialRequirements();
            //vm.credentials.$setPristine();
            toaster.pop('success', 'Completed', $translate.instant('users.detail.resetsuccess'));
          }, function(/* error */) {
            toaster.pop('error', 'Error', $translate.instant('users.detail.reseterror'));
          });
      } else {
        toaster.pop('error', 'Error', $translate.instant('users.detail.reseterror'));
      }

    } else {
      console.log('Form invalid'); // eslint-disable-line
    }

  };

  /* ROLES */
  vm.assignRole = function() {
    //console.log('RoleID: ' + JSON.stringify($scope.assignableRoles));
    RolesService.assignRealmRole(vm.userId, vm.assignableRoles || [])
      .then(function(/* response */) {
        //Update the UI
        vm.getRoles(vm.userId);
      }, function(/* error */) {
        toaster.pop('success', 'Error', $translate.instant('users.detail.updatesuccess'));
      });
  };

  vm.removeRole = function() {
    //console.log('RoleID: ' + JSON.stringify($scope.assignedRoles));
    RolesService.removeRealmRole(vm.userId, vm.assignedRoles || [])
      .then(function(/* response */) {
        // Update the UI
        vm.getRoles(vm.userId);
      }, function(/* error */) {
        toaster.pop('success', 'Error', $translate.instant('users.detail.updatesuccess'));
      });
  };

  /* User Logs Audit */
  vm.getRequests = function() {
    UsersService.getRequests(vm.userDetail.email)
      .then(function(response) {
        vm.auditRequests = response.data;
      });
  }

  vm.requestLogs = function() {
    if (vm.requestLogsForm.$valid) {
      vm.requestSuccessful = false;
      UsersService.submitRequest({
        userEmail: vm.userDetail.email,
        requester: Auth.user.get().email,
        startDate: vm.datePicker.date.startDate,
        endDate: vm.datePicker.date.endDate
      }).then(function() {
        vm.getRequests();
        vm.requestSuccessful = true;
        vm.datePicker.date = {};
      }, function() {
        // console.error('Error', error);
      });
    }
  }

  var mont = moment; //eslint-disable-line

  vm.datePicker = {
      date: {
        startDate: null,
        endDate: null
      },
      options: {
        applyClass: 'btn-success',
        timePicker: false,
        alwaysShowCalendars: true,
        minDate: mont([2017, 10, 20]),
        maxDate: mont(),
        locale: {
          format: "MMM DD, YYYY"
        },
        ranges: {
          'Last 7 days': [mont().subtract(6, 'days').startOf('day'), mont()],
          'Last 30 days': [mont().subtract(29, 'days').startOf('day'), mont()]
        },
        eventHandlers: {
          'cancel.daterangepicker': function() {
            vm.datePicker.date.startDate = null;
            vm.datePicker.date.endDate = null;
          }
        },
        font: 'fa'
      }
    };

});

'use strict';

angular.module('steve2')

.factory('UsersService', function($q, $http, ConfigService, Auth) {

  // generateId :: Integer -> String
  function generateId (len) {
    return Math.random().toString(36).substr(2, len);
  }

  function getRealm() {
    return Auth.realm.getName();
  }

  function adminUsersUrl(suffix) {
    return ConfigService.api.baseUrl + '/admin/users' + (suffix || '');
  }

  function trimOrUndef(val) {
    if (val == null) {
      return undefined;
    }
    var s = String(val).trim();
    return s || undefined;
  }

  function getPage(start, number, tableParams) {
    var deferred = $q.defer();

    var params = tableParams.search.predicateObject || {};
    params.cache = generateId(8);
    params.realm = getRealm();
    $http({
      url: adminUsersUrl(),
      params: params
    }).then(function(response) {
      deferred.resolve({
        data: response.data.slice(start, start + number),
        numberOfPages: Math.ceil(response.data.length / number),
        totalItemCount: response.data.length
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  }

  function getUser(userId) {
    var deferred = $q.defer();
    var params = {
      cache: generateId(8),
      realm: getRealm()
    };
    $http.get(adminUsersUrl('/' + userId), {
      params: params
    })
      .then(function(response) {
        deferred.resolve({
          userDetail: response.data
        });
      }, function(error) {
        deferred.reject({
          error: error
        });
      });

    return deferred.promise;
  }

  function displayName(userDetail) {
    var parts = [];
    if (userDetail.firstName) {
      parts.push(userDetail.firstName);
    }
    if (userDetail.lastName) {
      parts.push(userDetail.lastName);
    }
    var name = parts.join(' ').trim();
    return name || userDetail.name || userDetail.email || '';
  }

  function createUser(userDetail, temporaryPassword) {
    var deferred = $q.defer();

    var email = trimOrUndef(userDetail.email);
    var username = trimOrUndef(userDetail.username) || email;
    var firstName = trimOrUndef(userDetail.firstName);
    var lastName = trimOrUndef(userDetail.lastName);
    var name = displayName(userDetail);

    var payload = {
      username: username,
      email: email,
      temporaryPassword: temporaryPassword
    };
    if (firstName) {
      payload.firstName = firstName;
    }
    if (lastName) {
      payload.lastName = lastName;
    }
    if (name) {
      payload.name = name;
    }

    $http.post(adminUsersUrl(), payload, {
      params: { realm: getRealm() }
    })
      .then(function(response) {
        var created = response.data;
        var enabled = userDetail.enabled;
        if (typeof enabled === 'boolean' && enabled === false && created && created.id) {
          return updateUser({ id: created.id, enabled: false })
            .then(function() {
              deferred.resolve({ data: created });
            }, function(error) {
              deferred.reject({ error: error });
            });
        }
        deferred.resolve({ data: created });
      }, function(error) {
        deferred.reject({ error: error });
      });

    return deferred.promise;
  }

  function updateUser(userDetail) {
    var deferred = $q.defer();

    var body = {};
    if (typeof userDetail.enabled === 'boolean') {
      body.enabled = userDetail.enabled;
    }
    if (userDetail.email) {
      body.email = String(userDetail.email).trim();
    }
    if (userDetail.firstName != null) {
      body.firstName = String(userDetail.firstName).trim();
    }
    if (userDetail.lastName != null) {
      body.lastName = String(userDetail.lastName).trim();
    }
    var name = displayName(userDetail);
    if (name) {
      body.name = name;
    }

    $http.put(adminUsersUrl('/' + userDetail.id), body, {
      params: { realm: getRealm() }
    })
      .then(function(response) {
        deferred.resolve({
          data: response.data
        });
      }, function(error) {
        deferred.reject({
          error: error
        });
      });

    return deferred.promise;
  }

  function deleteUser(userId) {
    var deferred = $q.defer();

    $http.delete(adminUsersUrl('/' + userId), {
      params: { realm: getRealm() }
    })
      .then(function(response) {
        deferred.resolve({
          data: response.data
        });
      }, function(error) {
        deferred.reject({
          error: error
        });
      });

    return deferred.promise;
  }

  function resetPassword(userId, credRep) {
    var deferred = $q.defer();

    var body = {
      value: credRep.value,
      temporary: credRep.temporary !== false
    };

    $http.put(adminUsersUrl('/' + userId + '/reset-password'), body, {
      params: { realm: getRealm() }
    })
      .then(function(response) {
        deferred.resolve({
          data: response
        });
      }, function(error) {
        deferred.reject({
          error: error
        });
      });

    return deferred.promise;
  }

  function getRequests(userEmail) {
    return $http({
      method: 'get',
      url: ConfigService.api.baseUrl + '/logs/' + userEmail
    });
  }

  function submitRequest(request) {
    return $http({
      method: 'post',
      url: ConfigService.api.baseUrl + '/logs',
      data: request
    });
  }

  return {
    getPage: getPage,
    getUser: getUser,
    createUser: createUser,
    updateUser: updateUser,
    deleteUser: deleteUser,
    resetPassword: resetPassword,
    getRequests: getRequests,
    submitRequest: submitRequest
  }

});

'use strict';

angular.module('steve2')

.factory('UsersReportService', function($q, $http, ConfigService) {

  function getInactiveUsers(realm) {
    var deferred = $q.defer();
    var params = {};

    if (typeof realm !== 'undefined') {
      params.realm = realm;
    } else {
      params.allRealms = 'true';
    }

    $http({
      method: 'get',
      url: ConfigService.api.baseUrl + '/status/users/inactive',
      params: params
    })
    .then(function(response) {
      deferred.resolve({
        users: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  };

  return {
    getInactiveUsers: getInactiveUsers
  };

})

;

'use strict';

angular.module('steve2')

.controller('UserReportController', function (Auth, $state, $http, toaster, UsersReportService, $translate) {
  //Check for authenticated AND role admin
  if (!Auth.user.authenticated()) {
    $state.go('landing');
  } else {
    if (Auth.user.roles().indexOf('steve2-admin') === -1) {
      $state.go('index.dashboard');
    }
  }

  var vm = this;

  //TODO: take this function to keycloak-angular module
  vm.hasSupervisorRole = function (clientName, roleName) {
    var clientRoles = Auth.user.clientRoles(clientName);
    if (typeof clientRoles !== 'undefined') {
      return (Auth.user.clientRoles(clientName).indexOf(roleName) !== -1);
    } else {
      return false;
    }
  };

  vm.isSupervisor = vm.hasSupervisorRole('steve-client', 'supervisor');

  vm.loadInactiveUsers = function(realm) {
    vm.loading = true;
    vm.errors = '';
    UsersReportService.getInactiveUsers(realm)
      .then(function(response) {
        vm.inactiveUsers = response.users;
        vm.loading = false;
      }, function(error) {
        vm.loading = false;
        vm.errors = $translate.instant('users.report.errorloading');
      });
  };

  vm.inactive = function() {
    if (vm.inactiveType !== 'all') {
      vm.loadInactiveUsers(Auth.realm.getName());
    } else {
      vm.loadInactiveUsers();
    }
  };

  vm.inactiveType = 'jurisdiction';
  vm.inactive();



})

;

'use strict';

angular.module('steve2')

.controller('UsersController', function (Auth, $state, $http, toaster, UsersService, $translate) {
  //Check for authenticated AND role admin
  if (!Auth.user.authenticated()) {
    $state.go('landing');
  } else {
    if (Auth.user.roles().indexOf('steve2-admin') === -1) {
      $state.go('index.dashboard');
    }
  }

  var vm = this;

  vm.loggedInUserEmail = Auth.user.get().email;

  vm.safeUsers = [];
  vm._tableState;

  vm.callServer = function(tableState) {
    vm._tableState = tableState;
    vm.isLoading = true;
    vm.errors = null;

    var start = tableState.pagination.start || 0;
    var number = tableState.pagination.number || 20;

    UsersService.getPage(start, number, tableState)
      .then(function(response) {
        tableState.pagination.numberOfPages = response.numberOfPages;
        tableState.pagination.totalItemCount = response.totalItemCount;
        vm.users = response.data;
        vm.isLoading = false;
      }, function(error) {
        vm.errors = $translate.instant('users.errorloading');
        vm.isLoading = false;
      });
  };

  vm.refreshChanges = function() {
    vm._tableState.start = 0;
    vm.callServer(vm._tableState);
  };

  vm.deleteUser = function(userId) {

    swal({
      title: $translate.instant('users.deletemsgtitle'),
      text: $translate.instant('users.deletemsg'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: $translate.instant('yes'),
      cancelButtonText: $translate.instant('cancel')
    }, function(isConfirm) {
      if (isConfirm) {

        UsersService.deleteUser(userId)
          .then(function(response) {
            toaster.pop('success', 'Completed', $translate.instant('users.deletesuccess'));
            $state.reload();
          }, function(error) {
            toaster.pop('error', 'Error', $translate.instant('users.deleteerror'));
          });

      }
    });
  } //Delete user

  vm.clearSearch = function() {
    vm.searchUser = '';
    vm._tableState.search.predicateObject = {};
    vm.callServer(vm._tableState);
  }



});

"use strict";

angular
  .module("steve2")

  .controller(
    "ProfileController",
    function (
      Auth,
      $state,
      AddressBookService,
      toaster,
      $translate,
      $rootScope,
      $timeout
    ) {
      var vm = this;

      vm.countries = [
        { code: "US", name: "United States" },
        { code: "AS", name: "American Samoa" },
        { code: "PR", name: "Puerto Rico" },
        { code: "VI", name: "Virgin Islands" },
        { code: "GU", name: "Guam" },
        { code: "MP", name: "Northern Mariana Islands" },
      ];

      vm.states = [
        { code: "AL", name: "Alabama" },
        { code: "AK", name: "Alaska" },
        { code: "AZ", name: "Arizona" },
        { code: "AR", name: "Arkansas" },
        { code: "CA", name: "California" },
        { code: "CO", name: "Colorado" },
        { code: "CT", name: "Connecticut" },
        { code: "DE", name: "Delaware" },
        { code: "DC", name: "District Of Columbia" },
        { code: "FL", name: "Florida" },
        { code: "GA", name: "Georgia" },
        { code: "HI", name: "Hawaii" },
        { code: "ID", name: "Idaho" },
        { code: "IL", name: "Illinois" },
        { code: "IN", name: "Indiana" },
        { code: "IA", name: "Iowa" },
        { code: "KS", name: "Kansas" },
        { code: "KY", name: "Kentucky" },
        { code: "LA", name: "Louisiana" },
        { code: "ME", name: "Maine" },
        { code: "MD", name: "Maryland" },
        { code: "MA", name: "Massachusetts" },
        { code: "MI", name: "Michigan" },
        { code: "MN", name: "Minnesota" },
        { code: "MS", name: "Mississippi" },
        { code: "MO", name: "Missouri" },
        { code: "MT", name: "Montana" },
        { code: "NE", name: "Nebraska" },
        { code: "NV", name: "Nevada" },
        { code: "NH", name: "New Hampshire" },
        { code: "NJ", name: "New Jersey" },
        { code: "NM", name: "New Mexico" },
        { code: "NY", name: "New York" },
        { code: "NC", name: "North Carolina" },
        { code: "ND", name: "North Dakota" },
        { code: "OH", name: "Ohio" },
        { code: "OK", name: "Oklahoma" },
        { code: "OR", name: "Oregon" },
        { code: "PA", name: "Pennsylvania" },
        { code: "RI", name: "Rhode Island" },
        { code: "SC", name: "South Carolina" },
        { code: "SD", name: "South Dakota" },
        { code: "TN", name: "Tennessee" },
        { code: "TX", name: "Texas" },
        { code: "UT", name: "Utah" },
        { code: "VT", name: "Vermont" },
        { code: "VA", name: "Virginia" },
        { code: "WA", name: "Washington" },
        { code: "WV", name: "West Virginia" },
        { code: "WI", name: "Wisconsin" },
        { code: "WY", name: "Wyoming" },
      ];

      vm.loadProfile = function () {
        vm.loadingProfile = true;
        vm.loadingProfileError = false;
        AddressBookService.getContactByEmail(Auth.user.get().email)
          .then(
            function (response) {
              vm.user = response.contact;

              if (vm.user.address === null) {
                vm.user.address = {
                  street: "",
                  city: "",
                  state: "",
                  zipcode: "",
                  country: "United States",
                };
              }

              vm.phoneNumberDisplay =
                vm.user.phoneNumber !== null
                  ? angular.copy(
                      vm.user.phoneNumber.replace(new RegExp("^\\+1+"), "")
                    )
                  : null;
              vm.loadingProfile = false;
            },
            function () {
              // console.error('Error fetching contact by email', error);
              vm.loadingProfile = false;
              vm.loadingProfileError = true;
            }
          )
          .finally(function () {
            vm.loadingProfile = false;
          });
      };

      vm.changeCountry = function (country) {
        if (vm.user.address === null) vm.user.address = {};
        vm.user.address.country = country.name;
      };

      if (!Auth.user.authenticated()) {
        $state.go("landing");
      } else {
        vm.loadProfile();
      }

      vm.saveProfile = function () {
        // country
        if (vm.user.address.country !== "United States")
          delete vm.user.address.state;

        vm.user.phoneNumber = vm.phoneNumberDisplay
          ? "+1" + vm.phoneNumberDisplay
          : null;

        if (typeof vm.user.address.country !== "undefined") {
          if (vm.user.address.country !== "United States") {
            delete vm.user.address.state;
          }
        }

        if (vm.user.phoneNumber === null) {
          vm.user.twoFactorDeliveryMethod = "email";
        }

        delete vm.user.allowTwoFactorRemember;

        AddressBookService.saveContact(vm.user).then(
          function () {
            toaster.pop(
              "success",
              "Success",
              $translate.instant("profile.updatesuccess")
            );
            //TODO: broadcast profile creation update
            $rootScope.$broadcast("profile-saved");
            $timeout(function () {
              vm.loadProfile();
            }, 100);
          },
          function () {
            // console.log(error);
          }
        );
      };
    }
  );

'use strict';

angular.module('steve2')

.factory('AddressBookService', function($q, $http, Auth, ConfigService) {

  function getContacts() {
    var deferred = $q.defer();

    var realm = Auth.get().realm;

    $http({
      method: 'get',
      url: ConfigService.api.baseUrl + '/userProfiles/',
      params: {
        realm: realm
      }
    }).then(function(response) {
      deferred.resolve({
        contacts: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(ex) {
      deferred.reject({
        ex: ex
      });
    });

    return deferred.promise;
  }

  function getAllContacts(query) {
    var deferred = $q.defer();

    $http({
      method: 'get',
      url: ConfigService.api.baseUrl + '/userProfiles/',
      params: query
    }).then(function(response) {
      deferred.resolve({
        contacts: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(ex) {
      deferred.reject({
        ex: ex
      });
    });

    return deferred.promise;
  }

  function getContactByEmail(email) {
    var deferred = $q.defer();

    // Query steve users by email. The realm param path uses Keycloak USER_ENTITY.REALM_ID
    // which often does not match the token realm string, so the contact list can be empty.
    $http({
      method: 'get',
      url: ConfigService.api.baseUrl + '/userProfiles/',
      params: {
        email: email
      }
    }).then(function(response) {

      var contact = null;
      var rows = response.data;
      if (!angular.isArray(rows)) {
        rows = rows && rows.models ? rows.models : [];
      }
      angular.forEach(rows, function(element) {
        if (element.email === email) {
          contact = element;
        }
      });

      deferred.resolve({
        contact: contact
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(ex) {
      deferred.reject({
        ex: ex
      });
    });

    return deferred.promise;
  }

  function addContact(contact) {
    var deferred = $q.defer();

    $http({
      method: 'post',
      url: ConfigService.api.baseUrl + '/userProfiles/',
      data: contact
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  }

  function updateContact(contact) {
    var deferred = $q.defer();

    $http({
      method: 'put',
      url: ConfigService.api.baseUrl + '/userProfiles/' + contact.id,
      data: contact
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  }

  function saveContact(contact) {
    if (typeof contact.id !== 'undefined') {
      return updateContact(contact);
    } else {
      return addContact(contact);
    }
  }

  // function deleteContact(contactId) {
  //   var deferred = $q.defer();
  //
  //   $http({
  //     method: 'delete',
  //     url: ConfigService.aims.api + '/users/' + contactId
  //   }).then(function(response) {
  //     deferred.resolve({
  //       data: response.data
  //     });
  //   }, function(error) {
  //     deferred.reject({
  //       error: error
  //     });
  //   });
  //
  //   return deferred.promise;
  // }

  /* Primary Contacts */
  function getPrimaryContact() {
    var deferred = $q.defer();

    var realm = Auth.get().realm;

    $http({
      method: 'get',
      url: ConfigService.api.baseUrl + '/jurisdictionContacts/' + realm
    }).then(function(response) {
      deferred.resolve({
        primary: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(ex) {
      deferred.reject({
        ex: ex
      });
    });

    return deferred.promise;
  }

  function getAllPrimaryIds() {
    var deferred = $q.defer();

    $http({
      method: 'get',
      url: ConfigService.api.baseUrl + '/jurisdictionContacts'
    }).then(function(response) {
      deferred.resolve({
        primary: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    }).catch(function(ex) {
      deferred.reject({
        ex: ex
      });
    });

    return deferred.promise;
  }

  function getAllPrimaryContacts() {
    var deferred = $q.defer();

    getAllPrimaryIds()
      .then(function(response) {
        var allIds = [];
        var tempDataset = {};
        response.primary.forEach(function(element) {
          allIds.push(element.user);
          tempDataset[element.user] = element.realm;
        });

        getAllContacts({
          ids: allIds
        }).then(function(response) {
          // Add realm to each primary contact
          response.contacts.forEach(function(element, index) {
            response.contacts[index]['realm'] = tempDataset[element.id] || '';
          });

          deferred.resolve({
            contacts: response.contacts
          });
        }, function(error) {
          deferred.reject({
            error: error
          });
        });

      }, function(error) {
        deferred.reject({
          error: error
        });
      });

    return deferred.promise;
  }

  function updatePrimaryContact(userId) {
    var deferred = $q.defer();

    var realm = Auth.get().realm;

    $http({
      method: 'put',
      url: ConfigService.api.baseUrl + '/jurisdictionContacts/' + realm,
      data: {
        realm: realm,
        user: userId
      }
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  }

  function createPrimaryContact(userId) {
    var deferred = $q.defer();

    $http({
      method: 'post',
      url: ConfigService.api.baseUrl + '/jurisdictionContacts',
      data: {
        realm: Auth.get().realm,
        user: userId
      }
    }).then(function(response) {
      deferred.resolve({
        data: response.data
      });
    }, function(error) {
      deferred.reject({
        error: error
      });
    });

    return deferred.promise;
  }

  return {
    getContacts: getContacts,
    addContact: addContact,
    getContactByEmail: getContactByEmail,
    updateContact: updateContact,
    saveContact: saveContact,
    // deleteContact: deleteContact,
    getPrimaryContact: getPrimaryContact,
    getAllPrimaryContacts: getAllPrimaryContacts,
    createPrimaryContact: createPrimaryContact,
    updatePrimaryContact: updatePrimaryContact
  }

})

;

'use strict';

angular.module('steve2')

.controller('AddressBookController',
  function (Auth, $state, AddressBookService, $uibModal) {

    var vm = this;

    vm.loading = false;
    vm.primary = null;

    vm.loadPrimary = function() {
      AddressBookService.getPrimaryContact()
      .then(function(response) {
        vm.primary = response.primary;
      }, function() {
        // console.log(error);
        vm.primary = null;
      });
    };

    vm.loadAllPrimaryContacts = function() {
      vm.loading = true;
      vm.errors = false;
      AddressBookService.getAllPrimaryContacts()
      .then(function(response) {
        vm.contacts = response.contacts;
        vm.loading = false;
      }, function() {
        // console.error('ERROR ALL', error);
        vm.loading = false;
        vm.errors = true;
      });
    };

    vm.loadContacts = function() {
      vm.loading = true;
      vm.errors = false;
      AddressBookService.getContacts()
      .then(function(response) {
        vm.contacts = response.contacts;
        vm.loadPrimary();
        vm.loading = false;
      }, function() {
        vm.loading = false;
        vm.errors = true;
      });
    };

    vm.load = function(_place) {
      if (_place) {
        vm.view = _place;
      }

      if (vm.view === 'thisjur') {
        vm.loadContacts();
      } else {
        vm.loadAllPrimaryContacts();
      }
    }

    if (!Auth.user.authenticated()) {
      $state.go('landing');
    } else {
      vm.isAdmin = (Auth.user.realmRoles().indexOf('steve2-admin') > -1);
      vm.load('thisjur');
    }

    vm.setAsPrimary = function(userId) {
      if (vm.primary !== null) {
        //update
        AddressBookService.updatePrimaryContact(userId)
        .then(function() {
          vm.loadPrimary();
        }, function() {
          // console.error('ERROR UPDATING', error);
        });
      } else {
        //create
        AddressBookService.createPrimaryContact(userId)
        .then(function() {
          vm.loadPrimary();
        }, function() {
          // console.error('ERROR CREATING', error);
        });
      }
    };

    vm.selectContact = function(contact) {
      $uibModal.open({
        animation: false,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'app/components/common/contactDetail.tpl.html',
        controller: 'ContactDetailController',
        controllerAs: '$ctrl',
        resolve: {
          contact: function () {
            return contact;
          }
        }
      });
    };

  })

  .controller('ContactDetailController', function($uibModalInstance, contact) {
    var vm = this;
    vm.contact = contact;

    vm.ok = function() {
      $uibModalInstance.close();
    };
  })

;

/**
 * INSPINIA - Responsive Admin Theme
 * 2.6.2
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeigh = angular.element('nav.navbar-default').height();
    var wrapperHeigh = angular.element('#page-wrapper').height();

    if(navbarHeigh > wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", navbarHeigh + "px");
    }

    if(navbarHeigh < wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeigh > wrapperHeigh) {
        angular.element('#page-wrapper').css("min-height", navbarHeigh  + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

(function () {
  'use strict';

  angular.element(document).ready(function () {
    window.setupLogin(null,
      function (keycloak) {
        angular.bootstrap(document, ['steve2']);
      });
  });

  angular
    .module('steve2')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $state, Auth, TACService) {
    $rootScope.$state = $state;

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {

      // if the user is authenticated AND
      // not going to Terms and Conditions page AND
      // the user hasn't accepted the TAC yet THEN
      // Redirect to TAC page
      if (Auth.user.authenticated()) {
        if (toState.name !== 'tac') {
          if (!TACService.hasBeenAccepted()) {
            event.preventDefault();
            $state.go('tac');
          }
        }
      }

    });

    //$log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('steve2')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider

      .state('landing', {
        url: "/landing",
        templateUrl: "app/landing/landing.html",
        controller: 'LandingController as landing',
        data: { specialClass: 'landing-page' },
        resolve: {
          translateReady: ['$translate', function($translate) {
            return $translate.onReady();
          }]
        }
      })
      .state('tac', {
        url: "/tac",
        templateUrl: "app/tac/tac.tpl.html",
        controller: 'TacController as tac',
        data: { specialClass: 'tac-page' },
        resolve: {
          translateReady: ['$translate', function($translate) {
            return $translate.onReady();
          }]
        }
      })

      .state( 'login', {
        url: '/login',
        controller: 'LoginController as login',
        templateUrl: 'app/login/login.tpl.html',
        data:{ pageTitle: 'Login', specialClass: 'login-page' },
        resolve: {
          translateReady: ['$translate', function($translate) {
            return $translate.onReady();
          }]
        }
      })

      .state('index', {
        abstract: true,
        url: "/index",
        templateUrl: "app/components/common/content.html",
        resolve: {
          translateReady: ['$translate', function($translate) {
            return $translate.onReady();
          }]
        }
      })
      .state('index.dashboard', {
        url: "/dashboard",
        templateUrl: "app/main/main.html",
        controller: 'MainController as main',
        data: { pageTitle: 'Dashboard' }
      })
      .state('index.metrics', {
        url: "/metrics",
        templateUrl: "app/main/metrics.tpl.html",
        controller: 'MetricsController as metrics',
        data: { pageTitle: 'Dashboard Metrics' }
      })

      .state('index.settings', {
        url: "/settings",
        templateUrl: "app/settings/settings.tpl.html",
        controller: 'SettingsController as settings',
        data: { pageTitle: 'Settings' }
      })

      .state('index.mailbox', {
        url: "/mailbox",
        params: {
          place: 'inbox'
        },
        templateUrl: "app/mailbox/mailbox.tpl.html",
        controller: 'MailboxController as mail',
        data: { pageTitle: 'Mailboxes' }
      })
      .state('index.sendfile', {
        url: "/sendfile",
        templateUrl: "app/mailbox/sendfile2.tpl.html",
        controller: 'Send2Controller as send2',
        data: { pageTitle: 'Send a File' }
      })

      .state('index.addressbook', {
        url: "/addressbook",
        templateUrl: "app/addressbook/addressbook.tpl.html",
        controller: 'AddressBookController as abook',
        data: { pageTitle: 'Address Book' }
      })
      .state('index.profile', {
        url: "/profile",
        templateUrl: "app/addressbook/profile.tpl.html",
        controller: 'ProfileController as profile',
        data: { pageTitle: 'Profile' }
      })

      .state('index.support', {
        url: "/support",
        templateUrl: "app/support_area/support_area.tpl.html",
        controller: 'SupportAreaController as sup',
        data: { pageTitle: 'Support' }
      })
      .state('index.supportdetail', {
        url: "/support/:supportId",
        templateUrl: "app/support_area/support_area.detail.tpl.html",
        controller: 'SupportDetailController as sd',
        data: { pageTitle: 'Support Details' }
      })

      .state('index.resources', {
        url: "/resources",
        templateUrl: "app/resources/resources.tpl.html",
        controller: 'ResourcesController as res',
        data: { pageTitle: 'Resources' }
      })

      .state('index.notifications', {
        url: "/notifications",
        templateUrl: "app/notifications/notifications.tpl.html",
        controller: 'NotificationsController as notification',
        data: { pageTitle: 'Notifications' }
      })

      .state('admin', {
        abstract: true,
        url: "/admin",
        templateUrl: "app/components/common/content.html",
        resolve: {
          translateReady: ['$translate', function($translate) {
            return $translate.onReady();
          }]
        }
      })

      .state('admin.clients', {
        url: "/clients",
        templateUrl: "app/clients/clients.tpl.html",
        controller: 'ClientsController as cli',
        data: { pageTitle: 'Clients' }
      })
      .state('admin.clientdetail', {
        url: "/client/detail/:clientId",
        templateUrl: "app/clients/client.detail.tpl.html",
        controller: 'ClientDetailController as detail',
        data: { pageTitle: 'Client Detail' }
      })

      .state('admin.users', {
        url: "/users",
        templateUrl: "app/adminuser/users.tpl.html",
        controller: 'UsersController as usr',
        data: { pageTitle: 'Users Management' }
      })
      .state('admin.userdetail', {
        url: "/userdetail",
        params: {
          action: null,
          userId: null
        },
        templateUrl: "app/adminuserdetail/detail.user.tpl.html",
        controller: 'UserDetailController as udet',
        data: { pageTitle: 'User Detail' }
      })
      .state('admin.userreport', {
        url: "/userreport",
        params: {
          action: null,
          userId: null
        },
        templateUrl: "app/adminuser/users.report.tpl.html",
        controller: 'UserReportController as rep',
        data: { pageTitle: 'Inactive User Report' }
      })

      .state('admin.editlistout', {
        url: "/editlistout",
        params: {
          id: null,
          fileType: null
        },
        templateUrl: "app/outbound/editOutbound.tpl.html",
        controller: 'EditOutController as eol',
        data: { pageTitle: 'Editing List' }
      })

      .state('admin.editlistin', {
        url: "/editlistin",
        params: {
          id: null,
          fileType: null
        },
        templateUrl: "app/inbound/editInbound.tpl.html",
        controller: 'EditInController as eil',
        data: { pageTitle: 'Editing List' }
      })

      .state('admin.inbound', {
        url: '/inbound?fileType',
        params: {
          fileType: null
        },
        templateUrl: "app/inbound/inbound.tpl.html",
        controller: 'InboundController as ib',
        data: { pageTitle: 'Mailboxes Configuration' }
      })

      .state('admin.outbound', {
        url: '/outbound?fileType',
        params: {
          fileType: null
        },
        templateUrl: "app/outbound/outbound.tpl.html",
        controller: 'OutboundController as ob',
        data: { pageTitle: 'Filtering and Routing' }
      })


      .state('index.minor', {
        url: "/minor",
        templateUrl: "app/minor/minor.html",
        data: { pageTitle: 'Example view' }
      });

    $urlRouterProvider.otherwise('/landing');
  }

})();

'use strict';

/**
 * INSPINIA - Responsive Admin Theme
 *
 * Main directives.js file
 * Define directives for used plugin
 *
 *
 * Functions (directives)
 *  - sideNavigation
 *  - iboxTools
 *  - minimalizaSidebar
 *  - vectorMap
 *  - sparkline
 *  - icheck
 *  - ionRangeSlider
 *  - dropZone
 *  - responsiveVideo
 *  - chatSlimScroll
 *  - customValid
 *  - fullScroll
 *  - closeOffCanvas
 *  - clockPicker
 *  - landingScrollspy
 *  - fitHeight
 *  - iboxToolsFullScreen
 *  - slimScroll
 *  - truncate
 *  - touchSpin
 *  - markdownEditor
 *  - resizeable
 *  - bootstrapTagsinput
 *
 */


/**
 * pageTitle - Directive for set Page title - mata title
 */
function pageTitle($rootScope, $timeout) {
    return {
        link: function(scope, element) {
            var listener = function(event, toState, toParams, fromState) {
                // Default title - load on Dashboard 1
                var title = 'STEVE';
                // Create your own title pattern
                if (toState.data && toState.data.pageTitle) title = toState.data.pageTitle + ' | STEVE';
                $timeout(function() {
                    element.text(title);
                });
            };
            $rootScope.$on('$stateChangeStart', listener);
        }
    }
};

/**
 * sideNavigation - Directive for run metsiMenu on sidebar navigation
 */
function sideNavigation($timeout) {
    return {
        restrict: 'A',
        link: function(scope, element) {
            // Call the metsiMenu plugin and plug it to sidebar navigation
            $timeout(function(){
                element.metisMenu();

            });

            // Enable initial fixed sidebar
            //var sidebar = element.parent();
            //sidebar.slimScroll({
            //    height: '100%',
            //    railOpacity: 0.9,
            //});
        }
    };
};

/**
 * responsibleVideo - Directive for responsive video
 */
function responsiveVideo() {
    return {
        restrict: 'A',
        link:  function(scope, element) {
            var figure = element;
            var video = element.children();
            video
                .attr('data-aspectRatio', video.height() / video.width())
                .removeAttr('height')
                .removeAttr('width')

            //We can use $watch on $window.innerWidth also.
            $(window).resize(function() {
                var newWidth = figure.width();
                video
                    .width(newWidth)
                    .height(newWidth * video.attr('data-aspectRatio'));
            }).resize();
        }
    }
}

/**
 * iboxTools - Directive for iBox tools elements in right corner of ibox
 */
function iboxTools($timeout) {
    return {
        restrict: 'A',
        scope: true,
        templateUrl: 'app/components/common/ibox_tools.html',
        controller: function ($scope, $element) {
            // Function for collapse ibox
            $scope.showhide = function () {
                var ibox = $element.closest('div.ibox');
                var icon = $element.find('i:first');
                var content = ibox.find('div.ibox-content');
                content.slideToggle(200);
                // Toggle icon from up to down
                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                ibox.toggleClass('').toggleClass('border-bottom');
                $timeout(function () {
                    ibox.resize();
                    ibox.find('[id^=map-]').resize();
                }, 50);
            };
                // Function for close ibox
                $scope.closebox = function () {
                    var ibox = $element.closest('div.ibox');
                    ibox.remove();
                }
        }
    };
}

/**
 * iboxTools with full screen - Directive for iBox tools elements in right corner of ibox with full screen option
 */
function iboxToolsFullScreen($timeout) {
    return {
        restrict: 'A',
        scope: true,
        templateUrl: 'views/common/ibox_tools_full_screen.html',
        controller: function ($scope, $element) {
            // Function for collapse ibox
            $scope.showhide = function () {
                var ibox = $element.closest('div.ibox');
                var icon = $element.find('i:first');
                var content = ibox.find('div.ibox-content');
                content.slideToggle(200);
                // Toggle icon from up to down
                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                ibox.toggleClass('').toggleClass('border-bottom');
                $timeout(function () {
                    ibox.resize();
                    ibox.find('[id^=map-]').resize();
                }, 50);
            };
            // Function for close ibox
            $scope.closebox = function () {
                var ibox = $element.closest('div.ibox');
                ibox.remove();
            };
            // Function for full screen
            $scope.fullscreen = function () {
                var ibox = $element.closest('div.ibox');
                var button = $element.find('i.fa-expand');
                $('body').toggleClass('fullscreen-ibox-mode');
                button.toggleClass('fa-expand').toggleClass('fa-compress');
                ibox.toggleClass('fullscreen');
                setTimeout(function() {
                    $(window).trigger('resize');
                }, 100);
            }
        }
    };
}

/**
 * minimalizaSidebar - Directive for minimalize sidebar
*/
function minimalizaSidebar($timeout) {
    return {
        restrict: 'A',
        template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()" aria-label="Minimalize menu"><i class="fa fa-bars"></i></a>',
        controller: function ($scope, $element) {
            $scope.minimalize = function () {
                $("body").toggleClass("mini-navbar");
                if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
                    // Hide menu in order to smoothly turn on when maximize menu
                    $('#side-menu').hide();
                    // For smoothly turn on menu
                    setTimeout(
                        function () {
                            $('#side-menu').fadeIn(400);
                        }, 200);
                } else if ($('body').hasClass('fixed-sidebar')){
                    $('#side-menu').hide();
                    setTimeout(
                        function () {
                            $('#side-menu').fadeIn(400);
                        }, 100);
                } else {
                    // Remove all inline style from jquery fadeIn function to reset menu state
                    $('#side-menu').removeAttr('style');
                }
            }
        }
    };
};


function closeOffCanvas() {
    return {
        restrict: 'A',
        template: '<a class="close-canvas-menu" ng-click="closeOffCanvas()"><i class="fa fa-times"></i></a>',
        controller: function ($scope, $element) {
            $scope.closeOffCanvas = function () {
                $("body").toggleClass("mini-navbar");
            }
        }
    };
}

/**
 * vectorMap - Directive for Vector map plugin
 */
function vectorMap() {
    return {
        restrict: 'A',
        scope: {
            myMapData: '='
        },
        link: function (scope, element) {
            element.vectorMap({
                map: 'world_mill_en',
                backgroundColor: "transparent",
                regionStyle: {
                    initial: {
                        fill: '#e4e4e4',
                        "fill-opacity": 0.9,
                        stroke: 'none',
                        "stroke-width": 0,
                        "stroke-opacity": 0
                    }
                },
                series: {
                    regions: [
                        {
                            values: scope.myMapData,
                            scale: ["#1ab394", "#22d6b1"],
                            normalizeFunction: 'polynomial'
                        }
                    ]
                }
            });
            var destroyMap = function(){
                element.remove();
            };
            scope.$on('$destroy', function() {
                destroyMap();
            });
        }
    }
}


/**
 * sparkline - Directive for Sparkline chart
 */
function sparkline() {
    return {
        restrict: 'A',
        scope: {
            sparkData: '=',
            sparkOptions: '=',
        },
        link: function (scope, element, attrs) {
            scope.$watch(scope.sparkData, function () {
                render();
            });
            scope.$watch(scope.sparkOptions, function(){
                render();
            });
            var render = function () {
                $(element).sparkline(scope.sparkData, scope.sparkOptions);
            };
        }
    }
};

/**
 * icheck - Directive for custom checkbox icheck
 */
function icheck($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, $attrs, ngModel) {
            return $timeout(function() {
                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function(newValue){
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_square-green',
                    radioClass: 'iradio_square-green'

                }).on('ifChanged', function(event) {
                        if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                            $scope.$apply(function() {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                        if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            return $scope.$apply(function() {
                                return ngModel.$setViewValue(value);
                            });
                        }
                    });
            });
        }
    };
}

/**
 * ionRangeSlider - Directive for Ion Range Slider
 */
function ionRangeSlider() {
    return {
        restrict: 'A',
        scope: {
            rangeOptions: '='
        },
        link: function (scope, elem, attrs) {
            elem.ionRangeSlider(scope.rangeOptions);
        }
    }
}

/**
 * dropZone - Directive for Drag and drop zone file upload plugin
 */
function dropZone() {
    return {
        restrict: 'C',
        link: function(scope, element, attrs) {

            var config = {
                url: 'http://localhost:8080/upload',
                maxFilesize: 100,
                paramName: "uploadfile",
                maxThumbnailFilesize: 10,
                parallelUploads: 1,
                autoProcessQueue: false
            };

            var eventHandlers = {
                'addedfile': function(file) {
                    scope.file = file;
                    if (this.files[1]!=null) {
                        this.removeFile(this.files[0]);
                    }
                    scope.$apply(function() {
                        scope.fileAdded = true;
                    });
                },

                'success': function (file, response) {
                }

            };

            dropzone = new Dropzone(element[0], config);

            angular.forEach(eventHandlers, function(handler, event) {
                dropzone.on(event, handler);
            });

            scope.processDropzone = function() {
                dropzone.processQueue();
            };

            scope.resetDropzone = function() {
                dropzone.removeAllFiles();
            }
        }
    }
}

/**
 * chatSlimScroll - Directive for slim scroll for small chat
 */
function chatSlimScroll($timeout) {
    return {
        restrict: 'A',
        link: function(scope, element) {
            $timeout(function(){
                element.slimscroll({
                    height: '234px',
                    railOpacity: 0.4
                });

            });
        }
    };
}

/**
 * customValid - Directive for custom validation example
 */
function customValid(){
    return {
        require: 'ngModel',
        link: function(scope, ele, attrs, c) {
            scope.$watch(attrs.ngModel, function() {

                // You can call a $http method here
                // Or create custom validation

                var validText = "STEVE";

                if(scope.extras == validText) {
                    c.$setValidity('cvalid', true);
                } else {
                    c.$setValidity('cvalid', false);
                }

            });
        }
    }
}


/**
 * fullScroll - Directive for slimScroll with 100%
 */
function fullScroll($timeout){
    return {
        restrict: 'A',
        link: function(scope, element) {
            $timeout(function(){
                element.slimscroll({
                    height: '100%',
                    railOpacity: 0.9
                });

            });
        }
    };
}

/**
 * slimScroll - Directive for slimScroll with custom height
 */
function slimScroll($timeout){
    return {
        restrict: 'A',
        scope: {
            boxHeight: '@'
        },
        link: function(scope, element) {
            $timeout(function(){
                element.slimscroll({
                    height: scope.boxHeight,
                    railOpacity: 0.9
                });

            });
        }
    };
}

/**
 * clockPicker - Directive for clock picker plugin
 */
function clockPicker() {
    return {
        restrict: 'A',
        link: function(scope, element) {
                element.clockpicker();
        }
    };
};


/**
 * landingScrollspy - Directive for scrollspy in landing page
 */
function landingScrollspy(){
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      element.scrollspy({
        target: '.navbar-fixed-top',
        offset: 80
      });
    }
  }
}

/**
 * fitHeight - Directive for set height fit to window height
 */
function fitHeight(){
    return {
        restrict: 'A',
        link: function(scope, element) {
            element.css("height", $(window).height() + "px");
            element.css("min-height", $(window).height() + "px");
        }
    };
}

/**
 * truncate - Directive for truncate string
 */
function truncate($timeout){
    return {
        restrict: 'A',
        scope: {
            truncateOptions: '='
        },
        link: function(scope, element) {
            $timeout(function(){
                element.dotdotdot(scope.truncateOptions);

            });
        }
    };
}


/**
 * touchSpin - Directive for Bootstrap TouchSpin
 */
function touchSpin() {
    return {
        restrict: 'A',
        scope: {
            spinOptions: '='
        },
        link: function (scope, element, attrs) {
            scope.$watch(scope.spinOptions, function(){
                render();
            });
            var render = function () {
                $(element).TouchSpin(scope.spinOptions);
            };
        }
    }
};

/**
 * markdownEditor - Directive for Bootstrap Markdown
 */
function markdownEditor() {
    return {
        restrict: "A",
        require:  'ngModel',
        link:     function (scope, element, attrs, ngModel) {
            $(element).markdown({
                savable:false,
                onChange: function(e){
                    ngModel.$setViewValue(e.getContent());
                }
            });
        }
    }
};


/**
 *
 * Pass all functions into module
 */
angular
    .module('steve2')
    .directive('pageTitle', pageTitle)
    .directive('sideNavigation', sideNavigation)
    .directive('iboxTools', iboxTools)
    .directive('minimalizaSidebar', minimalizaSidebar)
    .directive('vectorMap', vectorMap)
    .directive('sparkline', sparkline)
    .directive('icheck', icheck)
    .directive('ionRangeSlider', ionRangeSlider)
    .directive('dropZone', dropZone)
    .directive('responsiveVideo', responsiveVideo)
    .directive('chatSlimScroll', chatSlimScroll)
    .directive('customValid', customValid)
    .directive('fullScroll', fullScroll)
    .directive('closeOffCanvas', closeOffCanvas)
    .directive('clockPicker', clockPicker)
    .directive('landingScrollspy', landingScrollspy)
    .directive('fitHeight', fitHeight)
    .directive('iboxToolsFullScreen', iboxToolsFullScreen)
    .directive('slimScroll', slimScroll)
    .directive('truncate', truncate)
    .directive('touchSpin', touchSpin)
    .directive('markdownEditor', markdownEditor);

angular.module("steve2").run(["$templateCache", function($templateCache) {$templateCache.put("app/addressbook/addressbook.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{\'addressbook.title\' | translate}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'landing.steve\' | translate}}</a></li><li class=\"active\"><strong>{{\'addressbook.title\' | translate}}</strong></li></ol></div></div><div class=\"wrapper wrapper-content\"><div class=\"row\"><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"file-manager\"><h5>{{\'addressbook.contacts\' | translate}}</h5><ul class=\"folder-list m-b-md\" style=\"padding: 0\"><li><a ng-click=\"abook.load(\'thisjur\')\">{{\'addressbook.thisjur\' | translate}}</a></li><li><a ng-click=\"abook.load(\'allprimary\')\">{{\'addressbook.allprimary\' | translate}} <span class=\"fa fa-star fa-lg text-warning\" aria-hidden=\"true\" style=\"margin-left: 6px;\"></span></a></li></ul><button class=\"btn btn-default btn-sm\" ng-click=\"abook.load()\"><i class=\"fa fa-refresh\" aria-hidden=\"true\"></i> {{\'addressbook.refresh\' | translate}}</button><div class=\"clearfix\"></div></div></div></div></div><div class=\"col-lg-9\"><div class=\"row\"><div class=\"col-lg-12\"><h2 class=\"m-b-md m-t-sm\">{{abook.view === \'thisjur\' ? (\'addressbook.thisjur\' | translate) : (\'addressbook.allprimary\' | translate)}}</h2></div></div><div class=\"row m-b-md\"><div class=\"col-xs-3 col-sm-2\" ng-init=\"abook.viewType = \'list\'\"><button class=\"btn btn-link\" uib-tooltip=\"{{\'addressbook.listview\' | translate}}\" aria-label=\"{{\'addressbook.listview\' | translate}}\" ng-click=\"abook.viewType = \'list\'\"><i class=\"fa fa-list\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-link\" uib-tooltip=\"{{\'addressbook.cardview\' | translate}}\" aria-label=\"{{\'addressbook.cardview\' | translate}}\" ng-click=\"abook.viewType = \'card\'\"><i class=\"fa fa-th\" aria-hidden=\"true\"></i></button></div><div class=\"col-xs-9 col-sm-10\"><search-box model=\"abook.search\" placeholder=\"{{\'addressbook.searchph\' | translate}}\" aria=\"{{\'addressbook.searchph\' | translate}}\" size=\"normal\"></search-box></div></div><div class=\"row row-abook\" ng-if=\"!abook.loading && !abook.errors && abook.contacts.length > 0 && abook.viewType === \'card\'\"><div class=\"panel panel-abook panel-default\" ng-repeat=\"contact in abook.contacts | filter:abook.search | orderBy:\'name\' | orderBy:\'email\'\"><contact-box contact=\"contact\" parent=\"abook\" on-contact-selected=\"abook.selectContact\"></contact-box></div></div><div class=\"row m-b-md\" ng-if=\"!abook.loading && !abook.errors && abook.contacts.length > 0 && abook.viewType === \'list\'\"><div class=\"col-lg-12\" ng-repeat=\"contact in abook.contacts | filter:abook.search | orderBy:\'email\' | orderBy:\'name\'\"><contact-row contact=\"contact\" parent=\"abook\" on-contact-selected=\"abook.selectContact\"></contact-row></div></div><div class=\"col-lg-12 text-center\" ng-if=\"(abook.contacts | filter:abook.search).length === 0 && abook.search && !abook.loading && !abook.errors\"><i class=\"fa fa-users fa-5x text-ultramuted m-t-lg m-b-md\" aria-hidden=\"true\" style=\"\"></i><br><span class=\"text-muted\">{{\'addressbook.nocontsearch\' | translate}}</span></div><div class=\"row\" ng-if=\"abook.contacts.length === 0 && !abook.loading && !abook.errors\"><div class=\"col-lg-12 text-center\"><i class=\"fa fa-users fa-5x text-ultramuted m-t-lg m-b-md\" aria-hidden=\"true\" style=\"\"></i><br>{{\'addressbook.nocontacts\' | translate}}</div></div><div class=\"row\" ng-if=\"abook.loading\"><div class=\"col-lg-12 text-center\"><h3><i class=\"fa fa-refresh fa-spin\"></i> {{\'addressbook.loading\' | translate}}</h3></div></div><div class=\"row\" ng-if=\"abook.errors\"><div class=\"col-lg-12 text-center\"><h5 class=\"text-danger\">{{\'addressbook.errorloading\' | translate}}</h5><button class=\"btn btn-danger\" ng-click=\"abook.load()\"><i class=\"fa fa-refresh fa-fw\"></i> {{\'addressbook.refresh\' | translate}}</button></div></div></div></div></div>");
$templateCache.put("app/addressbook/profile.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{\'profile.title\' | translate}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'landing.steve\' | translate}}</a></li><li class=\"active\"><strong>{{\'profile.title\' | translate}}</strong></li></ol></div></div><div class=\"wrapper wrapper-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" ng-class=\"{\'sk-loading\': profile.loadingProfile && !profile.loadingProfileError}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><div class=\"alert alert-danger\" ng-if=\"!profile.loadingProfile && profile.loadingProfileError\">{{ \'profile.loadingerror\' | translate }}</div><div class=\"row\"><div class=\"col-md-4\"><h3>{{\'profile.main\' | translate}}</h3>{{\'profile.mainsubtitle\' | translate}}<uib-alert type=\"warning\" class=\"m-t-lg\" ng-if=\"profile.prefilled\">{{\'profile.prefilled\' | translate}}</uib-alert></div><div class=\"col-md-8\"><form role=\"form\"><div class=\"form-group\"><label for=\"profilefor\">{{\'profile.for\' | translate}}</label> <input type=\"hidden\" ng-model=\"profile.user.email\"><p class=\"static-control\" id=\"profilefor\">{{profile.user.email}}</p></div><div class=\"form-group\"><label for=\"name\">{{\'profile.name\' | translate}}</label> <input type=\"text\" class=\"form-control\" id=\"name\" ng-model=\"profile.user.name\"></div><div class=\"form-group\"><label for=\"phone\">{{\'profile.phone\' | translate}}</label><br><div class=\"input-group m-b\"><div class=\"input-group-btn\" uib-dropdown=\"\"><button class=\"btn btn-white\" uib-dropdown-toggle=\"\" type=\"button\"><span ng-if=\"profile.user.address.country\">{{profile.user.address.country}} (+1)</span> <span ng-if=\"!profile.user.address.country\">{{\'profile.selectcountry\' | translate}}</span> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li ng-repeat=\"country in profile.countries\"><a ng-click=\"profile.changeCountry(country)\">{{country.name}} (+1)</a></li></ul></div><input type=\"tel\" class=\"form-control\" id=\"phone\" ng-model=\"profile.phoneNumberDisplay\" ui-mask=\"(999) 999-9999\"></div></div><div class=\"hr-line-dashed m-t-lg\"></div><div class=\"form-group\"><label>{{\'profile.mailtitle\' | translate}}</label></div><div class=\"form-group\"><label for=\"address\">{{\'profile.address\' | translate}}</label> <input type=\"text\" class=\"form-control\" id=\"address\" ng-model=\"profile.user.address.street\"></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"city\">{{\'profile.city\' | translate}}</label> <input type=\"text\" class=\"form-control\" id=\"city\" ng-model=\"profile.user.address.city\"></div></div><div class=\"col-md-3\" ng-if=\"profile.user.address.country === \'United States\'\"><div class=\"form-group\"><label for=\"state\">{{\'profile.state\' | translate}}</label><select class=\"form-control\" ng-model=\"profile.user.address.state\" id=\"state\" ng-options=\"item.name as item.name for item in profile.states\"><option value=\"\"></option></select></div></div><div class=\"col-md-2\"><div class=\"form-group\"><label for=\"zipcode\">{{\'profile.zipcode\' | translate}}</label> <input type=\"text\" class=\"form-control\" mask=\"99999\" id=\"zipcode\" ng-model=\"profile.user.address.zip\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"country\">{{\'profile.country\' | translate}}</label><select class=\"form-control\" ng-model=\"profile.user.address.country\" id=\"country\" ng-options=\"item.name as item.name for item in profile.countries\"><option value=\"\"></option></select></div></div></div></div><div><button class=\"btn btn-primary m-t-n-xs\" ng-click=\"profile.saveProfile()\">{{\'profile.update\' | translate}}</button> <span ng-if=\"profile.user.updated_at\" style=\"margin-left: 8px;\"><em>{{\'profile.updated\' | translate}} {{profile.user.updated_at | relatify}}</em></span> <a class=\"btn btn-default pull-right m-t-n-xs\" ui-sref=\"index.dashboard\">{{\'profile.cancel\' | translate}}</a></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/adminuser/users.report.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>Inactive User Report</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'landing.steve\' | translate}}</a></li><li>{{\'users.administration\' | translate}}</li><li class=\"active\"><a ui-sref=\"admin.users\">{{\'users.title\' | translate}}</a></li><li class=\"active\"><strong>Inactive User Report</strong></li></ol></div></div><div class=\"row wrapper border-bottom gray-bg\"><div class=\"col-lg-9\"><div style=\"padding: 10px 10px 10px 0px;\"><a href=\"\" ui-sref=\"admin.users\" class=\"btn btn-link\"><i class=\"fa fa-arrow-left fa-fw\"></i> {{\'back\' | translate}} {{\'users.title\' | translate}}</a></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{\'users.report.inactivetitle\' | translate}}</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-9 m-b-xs\"><div class=\"btn-group\"><label class=\"btn btn-default\" ng-model=\"rep.inactiveType\" uib-btn-radio=\"\'jurisdiction\'\" ng-change=\"rep.inactive()\">{{\'users.report.myjur\' | translate}}</label> <label class=\"btn btn-default\" ng-model=\"rep.inactiveType\" uib-btn-radio=\"\'all\'\" ng-change=\"rep.inactive()\" ng-if=\"rep.isSupervisor\">{{\'users.report.all\' | translate}}</label></div></div><div class=\"col-md-3\"><search-box model=\"rep.search\" placeholder=\"{{\'users.report.search\' | translate}}...\" aria=\"{{\'users.report.search\' | translate}}\"></search-box></div></div><div class=\"table-responsive\" ng-if=\"rep.inactiveUsers.length > 0\"><table class=\"table table-striped\"><thead><tr><th>{{\'users.report.user\' | translate}}</th><th>{{\'users.report.realm\' | translate}}</th><th>{{\'users.report.lastseen\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"u in rep.inactiveUsers | filter:rep.search\"><td>{{u.userId}}</td><td>{{u.realm}}</td><td><span uib-tooltip=\"{{u.lastSeen | date:\'medium\'}}\" tooltip-placement=\"left\"><i class=\"fa fa-clock-o\"></i> {{u.lastSeen | relatify}}</span></td></tr></tbody></table></div><div class=\"table-responsive m-t-lg text-center\" ng-if=\"rep.inactiveUsers.length === 0\"><h3>{{\'users.report.noinactive\' | translate}}</h3></div></div></div></div></div></div>");
$templateCache.put("app/adminuser/users.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{\'users.title\' | translate}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'landing.steve\' | translate}}</a></li><li>{{\'users.administration\' | translate}}</li><li class=\"active\"><strong>{{\'users.title\' | translate}}</strong></li></ol></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content\"><div class=\"ibox\"><div class=\"ibox-content ibox-heading\" style=\"padding: 15px;\"><div class=\"row\"><div class=\"col-sm-10 col-md-6\"><a href=\"\" ui-sref=\"admin.userdetail({action:\'new\'})\" class=\"btn btn-primary\"><i class=\"fa fa-user-plus fa-fw fa-lg\"></i> {{\'users.create\' | translate}}</a> <a href=\"\" ui-sref=\"admin.userreport\" class=\"btn btn-default\">{{\'users.viewinactive\' | translate}}</a></div><div class=\"col-sm-2 text-right pull-right\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"usr.refreshChanges()\"><i class=\"fa fa-refresh fa-fw fa-lg\"></i> {{\'users.reload\' | translate}}</button></div></div></div><div class=\"ibox-content\"><table st-table=\"usr.users\" class=\"table table-striped table-hover\" st-pipe=\"usr.callServer\" st-safe-src=\"usr.safeUsers\" ng-show=\"!usr.errors && !usr.isLoading\"><thead><tr><th colspan=\"3\"><div class=\"input-group\" style=\"width: 100%\"><input type=\"search\" class=\"form-control input-sm\" st-search=\"search\" name=\"search\" placeholder=\"Search users\" ng-model=\"usr.searchUser\" aria-label=\"Enter user name\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-if=\"!usr.searchUser\" aria-label=\"Search users\"><i class=\"fa fa-search\"></i></button> <button type=\"button\" class=\"btn btn-sm btn-primary\" ng-if=\"usr.searchUser\" ng-click=\"usr.clearSearch()\" aria-label=\"Clear search\"><i class=\"fa fa-times\"></i></button></div></div></th><th></th><th></th></tr><tr><th>{{\'users.firstname\' | translate}}</th><th>{{\'users.lastname\' | translate}}</th><th>{{\'users.email\' | translate}}</th><th class=\"enabled\">{{\'users.enabled\' | translate}}</th><th colspan=\"2\">{{\'users.actions\' | translate}}</th></tr></thead><tbody ng-show=\"usr.users.length > 0\"><tr ng-repeat=\"row in usr.users\"><td>{{row.firstName}}</td><td>{{row.lastName | uppercase}}</td><td>{{row.email}}</td><td class=\"enabled\">{{row.enabled ? (\'yes\' | translate) : (\'no\' | translate)}}</td><td width=\"20px\"><a class=\"btn btn-default btn-xs\" ui-sref=\"admin.userdetail({userId: row.id})\"><i class=\"fa fa-pencil\"></i> {{\'users.edit\' | translate}}</a></td><td width=\"30px\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"usr.deleteUser(row.id);\" ng-hide=\"usr.loggedInUserEmail == row.email\"><i class=\"fa fa-times\"></i> {{\'users.delete\' | translate}}</button></td></tr></tbody><tbody ng-show=\"usr.users.length === 0\"><tr><td colspan=\"6\" class=\"text-center\">{{\'users.nomatch\' | translate}}</td></tr></tbody><tfoot><tr><td class=\"text-center\" st-pagination=\"\" st-items-by-page=\"20\" colspan=\"6\"></td></tr></tfoot></table><div class=\"row m-t-md\" ng-show=\"usr.errors\"><div class=\"text-center\"><h5 class=\"text-danger\">{{usr.errors}}</h5><button class=\"btn btn-danger\" ng-click=\"usr.refreshChanges()\"><i class=\"fa fa-refresh fa-fw\"></i> {{\'users.refresh\' | translate}}</button></div></div><div ng-show=\"usr.isLoading\" class=\"text-center\"><h1><i class=\"fa fa-refresh fa-spin fa-2x fa-fw\"></i></h1></div></div></div></div></div></div>");
$templateCache.put("app/bulletin/bulletin.tpl.html","<div class=\"bulletin-modal\"><div class=\"modal-header\"><h3 class=\"modal-title\" id=\"modal-title\">Important update on the STEVE system transition!</h3></div><div class=\"modal-body\" id=\"modal-body\"></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\">OK</button></div></div>");
$templateCache.put("app/adminuserdetail/detail.user.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{\'users.detail.title\' | translate}} <small ng-show=\"!udet.isLoading\">{{udet.userDetail.email}}</small> <small ng-hide=\"!udet.isLoading\"><i class=\"fa fa-refresh fa-spin fa-fw\"></i> Loading user\'s details</small></h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'landing.steve\' | translate}}</a></li><li>{{\'users.administration\' | translate}}</li><li class=\"active\"><a ui-sref=\"admin.users\">{{\'users.title\' | translate}}</a></li><li class=\"active\"><strong>{{\'users.detail.title\' | translate}}</strong></li></ol></div></div><div class=\"row wrapper wrapper-content\"><div class=\"col-lg-12\"><div class=\"tabs-container\"><uib-tabset><uib-tab heading=\"{{\'users.detail.details\' | translate}}\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-9\"><form name=\"newUser\" class=\"form-horizontal m-t-md\" novalidate=\"\"><div class=\"form-group\" ng-show=\"udet.userDetail.id\"><label for=\"userId\" class=\"col-sm-2 control-label\">ID</label><div class=\"col-sm-10\"><p id=\"userId\" class=\"form-control-static\">{{udet.userDetail.id}}</p></div></div><div class=\"form-group\"><label for=\"firstName\" class=\"col-sm-2 control-label\">{{\'users.detail.firstname\' | translate}}</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"firstName\" placeholder=\"{{\'users.detail.firstname\' | translate}}\" ng-model=\"udet.userDetail.firstName\"></div></div><div class=\"form-group\"><label for=\"lastName\" class=\"col-sm-2 control-label\">{{\'users.detail.lastname\' | translate}}</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"lastName\" placeholder=\"{{\'users.detail.lastname\' | translate}}\" ng-model=\"udet.userDetail.lastName\"></div></div><div class=\"form-group\"><label for=\"email\" class=\"col-sm-2 control-label\">{{\'users.detail.email\' | translate}} <span class=\"text-danger\">*</span></label><div class=\"col-sm-10\"><input type=\"email\" class=\"form-control\" id=\"email\" ng-hide=\"udet.userDetail.id\" placeholder=\"{{\'users.detail.email\' | translate}}\" ng-model=\"udet.userDetail.email\" required=\"\"><p id=\"username\" class=\"form-control-static\" ng-show=\"udet.userDetail.id\">{{udet.userDetail.email}}</p><span class=\"help-block m-b-none text-danger\" ng-show=\"udet.emailRequired\" ng-hide=\"udet.userDetail.email\">{{udet.emailRequired}}</span></div></div><div class=\"form-group\"><label for=\"userEnabled\" class=\"col-sm-2 control-label\">{{\'users.detail.enabled\' | translate}}</label><div class=\"col-sm-10\"><toggle-switch knob-label=\"-\" id=\"userEnabled\" on-label=\"{{\'yes\' | translate}}\" off-label=\"{{\'no\' | translate}}\" ng-model=\"udet.userDetail.enabled\" aria-checked=\"{{udet.userDetail.enabled}}\"></toggle-switch></div></div><div ng-hide=\"udet.userDetail.id\"><div class=\"form-group\"><label for=\"createPwd\" class=\"col-sm-2 control-label\">{{\'users.detail.temppass\' | translate}} <span class=\"text-danger\">*</span></label><div class=\"col-sm-10\"><input type=\"password\" class=\"form-control\" id=\"createPwd\" name=\"createPwd\" ng-model=\"udet.password.new\" required=\"\"> <span class=\"help-block m-b-none text-muted\">{{\'users.detail.temppasshelp\' | translate}}</span></div></div><div class=\"form-group\"><label for=\"createPassConfirm\" class=\"col-sm-2 control-label\">{{\'users.detail.confpass\' | translate}} <span class=\"text-danger\">*</span></label><div class=\"col-sm-10\"><input type=\"password\" class=\"form-control\" id=\"createPassConfirm\" name=\"createPassConfirm\" ng-model=\"udet.password.confirm\" match-password=\"createPwd\"></div></div></div><div class=\"form-group m-t-lg\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!udet.userDetail.id && udet.resetBtnDisabled\" ng-click=\"udet.saveUserDetails()\">{{\'save\' | translate}}</button> <button type=\"button\" ui-sref=\"admin.users\" class=\"btn btn-default\">{{\'cancel\' | translate}}</button></div></div></form></div><div class=\"col-md-3\" ng-hide=\"udet.userDetail.id\"><div class=\"panel panel-default text-left center-block margin-top-20 text-muted\"><div class=\"panel-heading\"><span class=\"text-muted\"><strong>{{\'users.detail.passreq\' | translate}}</strong></span></div><div class=\"panel-body\"><ul style=\"list-style-type: none; padding-left:10px;\"><item-check validation=\"udet.passEmpty\">{{\'users.detail.empty\' | translate}}</item-check><item-check validation=\"udet.passLower\">{{\'users.detail.lower\' | translate}}</item-check><item-check validation=\"udet.passUpper\">{{\'users.detail.upper\' | translate}}</item-check><item-check validation=\"udet.passNumber\">{{\'users.detail.number\' | translate}}</item-check><item-check validation=\"udet.passLength\">{{\'users.detail.len8\' | translate}}</item-check><item-check validation=\"udet.passConfirm\">{{\'users.detail.confmatch\' | translate}}</item-check><li><hr></li><li>{{\'users.detail.nouname\' | translate}}</li><li>{{\'users.detail.last3\' | translate}}</li></ul></div></div></div></div></div></uib-tab><uib-tab heading=\"{{\'users.detail.passtab\' | translate}}\" ng-show=\"udet.userDetail.id\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-8\"><form name=\"credentials\" class=\"form-horizontal m-t-md\" novalidate=\"\"><div class=\"form-group\"><label for=\"newPwd\" class=\"col-sm-3 control-label\">{{\'users.detail.newpass\' | translate}}</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"newPwd\" name=\"newPwd\" ng-model=\"udet.password.new\" required=\"\"></div></div><div class=\"form-group\"><label for=\"passConfirm\" class=\"col-sm-3 control-label\">{{\'users.detail.confpass\' | translate}}</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"passConfirm\" name=\"passConfirm\" ng-model=\"udet.password.confirm\" match-password=\"newPwd\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-9\"><button type=\"buttom\" class=\"btn btn-primary\" ng-disabled=\"udet.resetBtnDisabled\" ng-click=\"udet.resetPassword()\">{{\'users.detail.resetpass\' | translate}}</button></div></div></form></div><div class=\"col-md-4\"><div class=\"panel panel-default text-left center-block margin-top-20 text-muted\"><div class=\"panel-heading\"><span class=\"text-muted\"><strong>{{\'users.detail.passreq\' | translate}}</strong></span></div><div class=\"panel-body\"><ul style=\"list-style-type: none; padding-left:10px;\"><item-check validation=\"udet.passEmpty\">{{\'users.detail.empty\' | translate}}</item-check><item-check validation=\"udet.passLower\">{{\'users.detail.lower\' | translate}}</item-check><item-check validation=\"udet.passUpper\">{{\'users.detail.upper\' | translate}}</item-check><item-check validation=\"udet.passNumber\">{{\'users.detail.number\' | translate}}</item-check><item-check validation=\"udet.passLength\">{{\'users.detail.len8\' | translate}}</item-check><item-check validation=\"udet.passConfirm\">{{\'users.detail.confmatch\' | translate}}</item-check><li><hr></li><li>{{\'users.detail.nouname\' | translate}}</li><li>{{\'users.detail.last3\' | translate}}</li></ul></div></div></div></div></div></uib-tab><uib-tab heading=\"{{\'users.detail.permtab\' | translate}}\" ng-show=\"udet.userDetail.id\"><div class=\"panel-body\"><div class=\"row m-t-md\"><div class=\"col-xs-6 col-md-5\"><div class=\"form-group\"><label for=\"roles\">{{\'users.detail.permavail\' | translate}}</label><select multiple=\"\" ng-model=\"udet.assignableRoles\" class=\"form-control\" ng-options=\"role as role.name for role in udet.roles\" size=\"10\" aria-label=\"{{\'users.detail.permavail\' | translate}}\"></select><button type=\"buttom\" class=\"btn btn-primary pull-right m-t-sm\" ng-click=\"udet.assignRole()\" ng-disabled=\"udet.roles.length == 0\">{{\'users.detail.assign\' | translate}} <i class=\"fa fa-chevron-right\"></i></button></div></div><div class=\"col-xs-6 col-md-5\"><div class=\"form-group\"><label for=\"roles\">{{\'users.detail.permassig\' | translate}}</label><select multiple=\"\" ng-model=\"udet.assignedRoles\" class=\"form-control\" ng-options=\"role as role.name for role in udet.userRoles\" size=\"10\" aria-label=\"{{\'users.detail.permassig\' | translate}}\"><option value=\"\" disabled=\"\">steve2-user *</option></select><button type=\"buttom\" class=\"btn btn-primary m-t-sm\" ng-click=\"udet.removeRole()\" ng-disabled=\"udet.userRoles.length == 0\"><i class=\"fa fa-chevron-left\"></i> {{\'users.detail.unassign\' | translate}}</button></div></div></div><div class=\"row margin-top-20\"><div class=\"col-lg-12\"><p class=\"well\">{{\'users.detail.permmessage\' | translate}}</p><div class=\"form-group\"><button type=\"button\" ui-sref=\"admin.users\" class=\"btn btn-success\">{{\'done\' | translate}}</button></div></div></div></div></uib-tab><uib-tab heading=\"{{\'users.detail.audit\' | translate}}\" select=\"udet.getRequests()\" ng-show=\"udet.userDetail.id\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-lg-6\"><span>{{\'users.detail.requestlogsfor\' | translate}}</span><h3>{{ udet.userDetail.email }}</h3><form name=\"udet.requestLogsForm\"><div class=\"form-group m-t-xl\" id=\"datePicker\"><label class=\"control-label\" for=\"filetype\">Date range</label><div class=\"input-group\"><input date-range-picker=\"\" class=\"form-control date-picker\" type=\"text\" aria-label=\"Date range\" ng-model=\"udet.datePicker.date\" options=\"udet.datePicker.options\" clearable=\"true\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i></span></div></div><div class=\"alert alert-success m-t-lg\" ng-if=\"udet.requestSuccessful\"><h3>{{\'users.detail.requestsuccesstitle\' | translate}}</h3>{{\'users.detail.requestsuccesstext\' | translate}}<div class=\"text-right m-t-md\"><a class=\"btn btn-default btn-sm\" ui-sref=\"index.mailbox\">{{\'users.detail.gotoinbox\' | translate}}</a></div></div><button type=\"submit\" class=\"btn btn-primary btn-lg m-t-sm\" ng-click=\"udet.requestLogs()\">{{\'users.detail.requestlogs\' | translate}}</button></form></div><div class=\"col-lg-6 m-t-lg\"><div class=\"m-t-xl\" ng-if=\"udet.auditRequests.length > 0\"><table class=\"table\"><thead><tr><th>{{\'users.detail.requestedby\' | translate}}</th><th>Range</th><th class=\"text-right\">{{\'users.detail.requestdate\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"row in udet.auditRequests | orderBy:\'created_at\'\"><td>{{ row.requester }}</td><td>{{ row.startDate | date:\'MM/dd/yyyy\' }} - {{ row.endDate | date:\'MM/dd/yyyy\' }}</td><td class=\"text-right\">{{ row.created_at | date:\'MMM d, yyyy h:mm:ss a\'}}</td></tr></tbody></table></div></div></div></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("app/adminuserdetail/itemcheck.directive.tpl.html","<li ng-if=\"!validation\" class=\"text-danger\"><i class=\"fa fa-times fa-fw\"></i> <span ng-transclude=\"\"></span></li><li ng-if=\"validation\" class=\"text-success\"><i class=\"fa fa-check fa-fw\"></i> <span ng-transclude=\"\"></span></li>");
$templateCache.put("app/clients/client.detail.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{\'clients.detail.title\' | translate}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'landing.steve\' | translate}}</a></li><li>{{\'users.administration\' | translate}}</li><li><a ui-sref=\"admin.clients\">{{\'clients.title\' | translate}}</a></li><li class=\"active\"><strong>{{\'clients.detail.title\' | translate}}</strong></li></ol></div></div><div class=\"row wrapper border-bottom gray-bg\"><div class=\"col-lg-9\"><div style=\"padding: 10px 10px 10px 0px;\"><a href=\"\" ui-sref=\"admin.clients\" class=\"btn btn-link\"><i class=\"fa fa-arrow-left fa-fw\"></i> {{\'back\' | translate}} {{\'clients.title\' | translate}}</a></div></div></div><div class=\"wrapper wrapper-content\"><div class=\"row\" ng-if=\"detail.clientInfo && !detail.canEdit\"><div class=\"col-lg-12\"><div class=\"alert alert-info\">{{\'clients.detail.readonly\' | translate}}</div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox product-detail\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-6\"><h2 class=\"font-bold m-b-xs\">{{detail.clientInfo.clientName}}</h2><small>{{detail.clientInfo.clientId}}</small><p ng-if=\"detail.clientInfo.userId\" class=\"m-t-xs\"><strong>{{\'clients.owner\' | translate}}</strong> {{detail.clientInfo.userId}}</p></div><div class=\"col-lg-6 pull-right text-right\"><div><h1 class=\"product-main-price\">{{detail.clientInfo.status}}</h1><h4>{{detail.clientInfo.statusMsg}}</h4></div></div></div><div class=\"row m-t-sm\"><div class=\"col-lg-6\"><div><p>{{\'clients.detail.installed\' | translate}} <strong>{{detail.clientInfo.installed}}</strong><br>{{\'clients.detail.veravail\' | translate}} <strong>{{detail.clientInfo.available}}</strong></p></div><client-download installer=\"detail.installer\"></client-download></div><div class=\"col-lg-6 text-right\"><div><p>{{\'clients.detail.lastcontact\' | translate}} {{detail.clientInfo.lastContacted | momentify}}</p></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"tabs-container\"><uib-tabset><uib-tab active=\"true\"><uib-tab-heading><i class=\"fa fa-arrow-circle-down\"></i>{{\'clients.detail.mailtitle\' | translate}}</uib-tab-heading><div class=\"panel-body\"><div class=\"m-b-md\"><button class=\"btn btn-primary\" ng-click=\"detail.newInboundRule()\" ng-if=\"detail.canEdit && !detail.createNewIn\">{{\'clients.detail.mailnew\' | translate}}</button></div><div class=\"panel panel-default\" ng-if=\"detail.canEdit && detail.createNewIn\"><div class=\"panel-heading\"><strong>{{\'clients.detail.ruleconfig\' | translate}}</strong></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-lg-4\"><div class=\"form-group\"><label for=\"folder\"><h3>{{\'clients.detail.deliverfolder\' | translate}}</h3></label> <input type=\"text\" class=\"form-control\" id=\"folder\" placeholder=\"{{\'clients.detail.foldername\' | translate}}\" allow-pattern=\"(\\d|[a-z])\" ng-model=\"detail.newFolderName\"></div></div><div class=\"col-lg-8\"><div class=\"well m-t-md\">{{\'clients.detail.foldermsg\' | translate}}</div></div></div><div class=\"row\"><div class=\"col-lg-12\"><h3>{{\'clients.detail.mailcoming\' | translate}}</h3></div><div class=\"col-lg-6\"><select aria-label=\"{{\'clients.detail.selectft\' | translate}}\" class=\"form-control\" ng-options=\"ft for ft in detail.filetypes | orderBy:\'toString()\'\" ng-model=\"detail.selectedFileType\"><option style=\"display:none\" value=\"\">{{\'clients.detail.selectft\' | translate}}</option></select><select multiple=\"\" aria-label=\"{{\'clients.detail.selectmailadd\' | translate}}\" class=\"form-control\" ng-model=\"detail.selectedMailboxes\" size=\"15\" ng-options=\"am as am.listName for am in detail.availableMailboxes | filter:{fileType:detail.selectedFileType}:true | orderBy:\'listName\'\"></select></div><div class=\"col-lg-1 text-center\"><p><button class=\"btn btn-primary\" ng-click=\"detail.addMailboxes()\" aria-label=\"{{\'clients.detail.addmb\' | translate}}\"><i class=\"fa fa-chevron-right\"></i></button></p><p><button class=\"btn btn-primary\" ng-click=\"detail.removeMailboxes()\" aria-label=\"{{\'clients.detail.remmb\' | translate}}\"><i class=\"fa fa-chevron-left\"></i></button></p></div><div class=\"col-lg-5\"><h3>Selected Mailboxes</h3><select multiple=\"\" aria-label=\"{{\'clients.detail.selectmailrm\' | translate}}\" class=\"form-control\" ng-model=\"detail.selectedAssMailboxes\" size=\"15\" ng-options=\"assm as assm.displayName + \' - \' + assm.fileType for assm in detail.associatedMailboxes | orderBy:\'listName\'\"></select></div></div></div><div class=\"panel-footer text-right\"><button class=\"btn btn-primary\" ng-click=\"detail.saveInRule()\">{{\'save\' | translate}}</button> <button class=\"btn btn-default\" ng-click=\"detail.createNewIn = false\">{{\'cancel\' | translate}}</button></div></div><div class=\"row\"><div class=\"col-lg-12\"><h3>{{\'clients.detail.rulesconfig\' | translate}}</h3><div class=\"project-list m-t-md\"><table class=\"table table-striped\" ng-if=\"detail.clientConfig.inrules.length > 0\"><tbody><tr ng-repeat=\"inrule in detail.clientConfig.inrules\"><td class=\"project-title text-center\" style=\"padding: 20px;\"><h3><i class=\"fa fa-folder\"></i> {{inrule.folder}}</h3></td><td style=\"padding: 10px;\"><h3>{{\'clients.detail.mailboxes\' | translate}} ({{inrule.address.length}})</h3><div class=\"panel panel-default\" style=\"margin-bottom: 0px;\"><div class=\"panel-body\" style=\"padding:10px;\"><div style=\"max-height: 100px; overflow: auto;\"><span ng-repeat=\"mailbox in inrule.address | orderBy:displayName\">{{mailbox.displayName}} - {{mailbox.fileType}}<br></span></div></div></div></td><td class=\"project-actions\" style=\"padding: 20px;\" width=\"200px\"><span ng-if=\"detail.canEdit\"><button class=\"btn btn-default btn-sm\" ng-click=\"detail.editInboundRule($index)\"><i class=\"fa fa-pencil fa-fw\"></i> {{\'clients.detail.edit\' | translate}}</button> <button class=\"btn btn-default btn-sm\" ng-click=\"detail.deleteRule(\'inbound\', $index)\"><i class=\"fa fa-trash fa-fw\"></i> {{\'clients.detail.delete\' | translate}}</button></span></td></tr></tbody></table><span ng-if=\"detail.clientConfig.inrules.length === 0\">{{\'clients.detail.norules\' | translate}}</span></div></div></div></div></uib-tab><uib-tab><uib-tab-heading><i class=\"fa fa-arrow-circle-up\"></i>{{\'clients.detail.outtitle\' | translate}}</uib-tab-heading><div class=\"panel-body\"><div class=\"m-b-md\"><button class=\"btn btn-primary\" ng-click=\"detail.newOutboundRule()\" ng-if=\"detail.canEdit && !detail.createNewOut\">{{\'clients.detail.outnew\' | translate}}</button></div><div class=\"panel panel-default\" ng-if=\"detail.canEdit && detail.createNewOut\"><div class=\"panel-heading\"><strong>{{\'clients.detail.ruleconfig\' | translate}}</strong></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-lg-4\"><div class=\"form-group\"><label for=\"folder\"><h3>{{\'clients.detail.filesin\' | translate}}</h3></label> <input type=\"text\" aria-label=\"Folder\" class=\"form-control\" id=\"folderOut\" placeholder=\"{{\'clients.detail.foldername\' | translate}}\" allow-pattern=\"(\\d|[a-z])\" ng-model=\"detail.newOutFolderName\"></div></div><div class=\"col-lg-8\"><div class=\"well m-t-md\">{{\'clients.detail.foldermsg\' | translate}}</div></div></div><div class=\"row\"><div class=\"col-lg-12\"><h3>{{\'clients.detail.sendto\' | translate}}</h3></div><div class=\"col-lg-6\"><select aria-label=\"Select file type\" class=\"form-control\" ng-options=\"ft for ft in detail.filetypes | orderBy:\'toString()\'\" ng-model=\"detail.selectedOutFileType\"><option style=\"display:none\" value=\"\">{{\'clients.detail.selectft\' | translate}}</option></select><select multiple=\"\" aria-label=\"{{\'clients.detail.selectoutadd\' | translate}}\" class=\"form-control\" ng-model=\"detail.selectedOutbound\" size=\"15\" ng-options=\"ao as ao.listName for ao in detail.availableOutbound | filter:{fileType:detail.selectedOutFileType}:true | orderBy:\'listName\'\"></select></div><div class=\"col-lg-1 text-center\"><p><button class=\"btn btn-primary\" ng-click=\"detail.addOutbound()\" aria-label=\"{{\'clients.detail.addout\' | translate}}\"><i class=\"fa fa-chevron-right\"></i></button></p><p><button class=\"btn btn-primary\" ng-click=\"detail.removeOutbound()\" aria-label=\"{{\'clients.detail.rmout\' | translate}}\"><i class=\"fa fa-chevron-left\"></i></button></p></div><div class=\"col-lg-5\"><h3>{{\'clients.detail.outselected\' | translate}}</h3><select multiple=\"\" aria-label=\"{{\'clients.detail.selectoutrm\' | translate}}\" class=\"form-control\" ng-model=\"detail.selectedAssOutbound\" size=\"15\" ng-options=\"asso as asso.displayName + \' - \' + asso.fileType for asso in detail.associatedOutbound | orderBy:\'listName\'\"></select></div></div></div><div class=\"panel-footer text-right\"><button class=\"btn btn-primary\" ng-click=\"detail.saveOutRule()\">{{\'save\' | translate}}</button> <button class=\"btn btn-default\" ng-click=\"detail.createNewOut = false\">{{\'cancel\' | translate}}</button></div></div><div class=\"row\"><div class=\"col-lg-12\"><h3>{{\'clients.detail.rulesconfig\' | translate}}</h3><div class=\"project-list m-t-md\"><table class=\"table table-striped\" ng-if=\"detail.clientConfig.outrules.length > 0\"><tbody><tr ng-repeat=\"outrule in detail.clientConfig.outrules\"><td class=\"project-title text-center\" style=\"padding: 20px;\"><h3><i class=\"fa fa-folder\"></i> {{outrule.folder}}</h3></td><td style=\"padding: 10px;\"><h3>{{\'clients.detail.out\' | translate}} ({{outrule.address.length}})</h3><div class=\"panel panel-default\" style=\"margin-bottom: 0px;\"><div class=\"panel-body\" style=\"padding:10px;\"><div style=\"max-height: 100px; overflow: auto;\"><span ng-repeat=\"fnr in outrule.address | orderBy:displayName\">{{fnr.displayName}} - {{fnr.fileType}}<br></span></div></div></div></td><td class=\"project-actions\" style=\"padding: 20px;\" width=\"200px\"><span ng-if=\"detail.canEdit\"><button class=\"btn btn-default btn-sm\" ng-click=\"detail.editOutboundRule($index)\"><i class=\"fa fa-pencil fa-fw\"></i> {{\'clients.detail.edit\' | translate}}</button> <button class=\"btn btn-default btn-sm\" ng-click=\"detail.deleteRule(\'outbound\', $index)\"><i class=\"fa fa-trash fa-fw\"></i> {{\'clients.detail.delete\' | translate}}</button></span></td></tr></tbody></table><span ng-if=\"detail.clientConfig.outrules.length === 0\">{{\'clients.detail.nooutrules\' | translate}}</span></div></div></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/clients/clients.directive.tpl.html","<div class=\"col-lg-4 col-md-6\"><div class=\"widget-head-color-box navy-bg p-lg text-center\" ng-class=\"{ ONLINE: \'navy-bg\', OFFLINE: \'red-bg\', DISCONNECTED: \'yellow-bg\', CHECKING: \'lazur-bg\'}[clientInfo.status]\"><div class=\"m-b-md\"><h2 class=\"font-bold no-margins\">{{clientInfo.clientName}}</h2><span>{{\'clients.installed\' | translate}} {{clientInfo.installed}}</span><br><span>{{clientInfo.clientId}}</span><br><span ng-if=\"clientInfo.userId\"><small>{{\'clients.owner\' | translate}} {{clientInfo.userId}}</small></span></div><div ng-if=\"clientInfo.status == \'CHECKING\'\"><i class=\"fa fa-refresh fa-spin fa-4x fa-fw\"></i><h2>{{\'clients.checkstat\' | translate}}</h2><span>{{\'clients.checkmsg\' | translate}}</span></div><div ng-if=\"clientInfo.status == \'ONLINE\'\"><i class=\"fa fa-check fa-4x\"></i><h2>{{clientInfo.status}}</h2><span>{{clientInfo.statusMsg}}</span></div><div ng-if=\"clientInfo.status == \'OFFLINE\'\"><i class=\"fa fa-times fa-4x fa-fw\"></i><h2>{{clientInfo.status}}</h2><span>{{clientInfo.statusMsg}}</span></div><div ng-if=\"clientInfo.status == \'DISCONNECTED\'\"><i class=\"fa fa-exclamation fa-4x fa-fw\"></i><h2>{{clientInfo.status}}</h2><span>{{clientInfo.statusMsg}}</span></div></div><div class=\"widget-text-box\"><div class=\"btn-group btn-group-justified\" role=\"group\" aria-label=\"...\"><div class=\"btn-group\" role=\"group\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"checkStatus()\"><i class=\"fa fa-refresh fa-fw\"></i> {{\'clients.checkaction\' | translate}}</button></div><div class=\"btn-group\" role=\"group\"><button type=\"button\" class=\"btn btn-default\" ui-sref=\"admin.clientdetail({clientId: clientInfo.clientId})\"><i class=\"fa fa-cog fa-fw\"></i> {{\'clients.settings\' | translate}}</button></div></div><client-download installer=\"installer\"></client-download><p class=\"text-center m-t-sm\">{{\'clients.veravail\' | translate}} {{clientInfo.available}}</p></div></div>");
$templateCache.put("app/clients/clients.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{\'clients.title\' | translate}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'landing.steve\' | translate}}</a></li><li>{{\'users.administration\' | translate}}</li><li class=\"active\"><strong>{{\'clients.title\' | translate}}</strong></li></ol></div></div><div class=\"row wrapper border-bottom gray-bg\"><div class=\"col-lg-9\"><div style=\"padding: 10px 10px 10px 0px;\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"cli.loadClients()\" aria-label=\"{{\'clients.reload\' | translate}}\"><i class=\"fa fa-refresh fa-fw\"></i> {{\'clients.refreshlist\' | translate}}</button></div></div></div><div class=\"wrapper wrapper-content\"><div ng-hide=\"cli.loading\"><div class=\"row\" ng-show=\"cli.clients.length > 0 && !cli.errors\"><client-status info=\"clientInfo\" callback=\"cli.checkStatus\" class=\"animate-repeat\" installer=\"cli.installer\" ng-repeat=\"clientInfo in cli.clients | filter:searchClient\"></client-status></div><div class=\"row\" ng-show=\"cli.errors\"><div class=\"text-center\"><h5 class=\"text-danger\">{{cli.errors}}</h5><button class=\"btn btn-danger\" ng-click=\"cli.loadClients()\"><i class=\"fa fa-refresh fa-fw\"></i> {{\'clients.refresh\' | translate}}</button></div></div><div class=\"row\" ng-show=\"cli.clients.length == 0 && !cli.errors\"><div class=\"text-center\"><h3>{{\'clients.noclients\' | translate}}</h3></div></div></div><div ng-show=\"cli.loading\" class=\"text-center\"><h1><i class=\"fa fa-refresh fa-spin fa-4x fa-fw\"></i></h1></div></div><script type=\"text/ng-template\" id=\"createRequest.html\"><div class=\"modal-header\"> <h4 class=\"modal-title\">{{\'clients.req.request\' | translate}}</h4> </div> <form name=\"requestClientForm\" id=\"requestClientForm\"> <div class=\"modal-body\" id=\"modal-body\" > <div class=\"form-group\"> <label for=\"client-name\">{{\'clients.req.cliname\' | translate}} <span class=\"text-danger\">*</span></label> <input type=\"text\" class=\"form-control\" ng-model=\"req.clientRequest.clientName\" id=\"client-name\" required autofocus> </div> <div class=\"form-group\"> <label for=\"client-type\">{{\'clients.req.clitype\' | translate}} <span class=\"text-danger\">*</span></label> <select class=\"form-control\" id=\"client-type\" ng-model=\"req.clientRequest.clientType\" required ng-options=\"ct for ct in req.clientTypes | orderBy:\'toString()\'\"> </select> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" type=\"submit\" ng-click=\"req.request()\" ng-disabled=\"req.submitting || !(req.clientRequest.clientName && req.clientRequest.clientType) \"> <span ng-if=\"req.submitting\"><i class=\"fa fa-refresh fa-spin fa-lg fa-fw\"></i> {{\'clients.req.reqdoing\' | translate}}</span> <span ng-if=\"!req.submitting\">{{\'clients.req.reqdo\' | translate}}</span> </button> <button class=\"btn btn-default\" type=\"button\" ng-click=\"req.cancel()\" ng-disabled=\"req.submitting\">{{\'cancel\' | translate}}</button> </div> </form></script>");
$templateCache.put("app/clients/reclist.directive.tpl.html","<span ng-repeat=\"item in addressList\"><code class=\"nowrap\">\n    <i class=\"fa fa-user fa-fw\" ng-if=\"item.type==\'user\'\"></i>\n    <i class=\"fa fa-users fa-fw\" ng-if=\"item.type==\'jurisdiction\'\"></i>\n    <i class=\"fa fa-plus fa-fw\" ng-if=\"item.type==\'unknown\'\"></i>\n    {{item.displayName}}\n  </code>{{$last ? \'\' : \'&nbsp;\'}}</span>");
$templateCache.put("app/inbound/createInbound.tpl.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"cib.close()\" aria-label=\"{{\'close\' | translate}}\"><span aria-hidden=\"true\">&times;</span></button><h3 class=\"modal-title\" id=\"modal-title\">{{\'in.create.title\' | translate}}</h3></div><div class=\"modal-body\" id=\"modal-body\"><div class=\"wizard\"><div class=\"steps clearfix\"><ul><li ng-class=\"{current: cib.activeStep === 0, done: cib.activeStep > 0}\"><a><strong>1</strong> {{\'in.create.step1\' | translate}}</a></li><li ng-class=\"{current: cib.activeStep === 1, done: cib.activeStep > 1}\"><a><strong>2</strong> {{\'in.create.step2\' | translate}}</a></li><li ng-class=\"{current: cib.activeStep === 2}\"><a><strong>3</strong> {{\'in.create.step3\' | translate}}</a></li></ul></div></div><div class=\"wizard\"><div class=\"content\" ng-show=\"cib.activeStep === 0\"><div class=\"row m-sm\"><div class=\"col-lg-6\"><div class=\"form-group\"><label for=\"fileTypes\">{{\'in.create.filetype\' | translate}} <span class=\"text-danger\">*</span></label><select id=\"fileTypes\" name=\"fileTypes\" class=\"form-control\" aria-label=\"{{\'in.create.selectft\' | translate}}\" ng-options=\"ft for ft in cib.fileTypes | orderBy:\'toString()\'\" ng-model=\"cib.fileType\"><option style=\"display:none\" value=\"\">{{\'in.create.selectft\' | translate}}</option></select></div><div class=\"form-group\"><label for=\"listName\">{{\'in.create.name\' | translate}} <span class=\"text-danger\">*</span></label> <input class=\"form-control\" id=\"listName\" ng-model=\"cib.listName\" required=\"\"></div><div class=\"alert alert-danger\" role=\"alert\" ng-if=\"cib.errors.length > 0\"><ul style=\"margin-bottom: 0px;\"><li ng-repeat=\"item in cib.errors\">* {{item}}</li></ul></div></div><div class=\"col-lg-6 m-t-md\"><p translate=\"in.create.ftmsg\"></p><p translate=\"in.create.namemsg\"></p></div></div></div><div class=\"content\" ng-show=\"cib.activeStep === 1\"><div class=\"row m-sm\"><div class=\"col-lg-6\"><div class=\"form-group m-t-md\"><label for=\"listEnabled\" class=\"control-label\" style=\"margin-right: 30px;\">{{\'in.create.enabled\' | translate}}</label><toggle-switch id=\"listEnabled\" on-label=\"{{\'yes\' | translate}}\" off-label=\"{{\'no\' | translate}}\" ng-model=\"cib.enabled\" aria-checked=\"{{cib.enabled}}\"></toggle-switch></div></div><div class=\"col-lg-6 m-t-md\"><p translate=\"in.create.emsg\"></p></div></div></div><div class=\"content\" ng-show=\"cib.activeStep === 2\"><div class=\"row m-sm\"><div class=\"col-lg-6 m-t-md\"><p><strong>{{\'in.create.filetype\' | translate}}</strong> {{cib.fileType}}</p><p><strong>{{\'in.create.name\' | translate}}</strong> {{cib.listName}}</p><p><strong>{{\'in.create.enabled\' | translate}}:</strong> {{cib.enabled | yesNo}}</p></div><div class=\"col-lg-6 m-t-md\"><p translate=\"in.create.confirmmsg\"></p></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default pull-left\" type=\"button\" ng-click=\"cib.previuos()\" ng-if=\"cib.activeStep > 0\"><i class=\"fa fa-chevron-left\"></i> {{\'in.create.previous\' | translate}}</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"cib.next()\" ng-if=\"cib.activeStep < 2\">{{\'in.create.next\' | translate}} <i class=\"fa fa-chevron-right\"></i></button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"cib.createList()\" ng-if=\"cib.activeStep === 2\">{{\'create\' | translate}}</button> <button class=\"btn btn-default\" type=\"button\" ng-click=\"cib.close()\">{{\'cancel\' | translate}}</button></div>");
$templateCache.put("app/inbound/editInbound.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\" ng-cloak=\"\"><div class=\"col-lg-9\"><h2>{{\'in.edit.title\' | translate}} <small style=\"color: #404041\">{{(eil.listInfo && eil.listInfo.listName) | uppercase}}</small></h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'landing.steve\' | translate}}</a></li><li>{{\'users.administration\' | translate}}</li><li><a href=\"\" ng-click=\"eil.goBackToInboundList($event)\">{{\'in.title\' | translate}}</a></li><li class=\"active\"><strong>{{\'in.edit.title\' | translate}}</strong></li></ol></div></div><div class=\"row wrapper border-bottom gray-bg\"><div class=\"col-lg-9\"><div style=\"padding: 10px 10px 10px 0px;\"><a href=\"\" class=\"btn btn-link\" ng-click=\"eil.goBackToInboundList($event)\"><i class=\"fa fa-arrow-left fa-fw\"></i> {{\'back\' | translate}} {{\'in.title\' | translate}}</a></div></div></div><div class=\"wrapper wrapper-content\" ng-cloak=\"\" ng-show=\"eil.loading\"><div class=\"row m-b-lg\"><div class=\"col-lg-12 text-center\"><h2><i class=\"fa fa-refresh fa-spin fa-fw\"></i> {{\'in.edit.loading\' | translate}}</h2></div></div></div><div class=\"wrapper wrapper-content\" ng-cloak=\"\" ng-show=\"eil.loadingError\"><div class=\"row m-b-lg\"><div class=\"col-lg-12 text-center\"><h5 class=\"text-danger\">{{\'in.edit.errorloading\' | translate}}</h5><button class=\"btn btn-danger btn-sm\" ng-click=\"eil.loadInfo()\"><i class=\"fa fa-refresh fa-fw\"></i> {{\'in.edit.refresh\' | translate}}</button></div></div></div><div class=\"wrapper wrapper-content\" ng-cloak=\"\" ng-hide=\"eil.loading || eil.loadingError\"><div class=\"row m-b-lg\"><div class=\"col-lg-8\"><div class=\"widget p-xl\" style=\"padding-left:0px\"><div class=\"profile-image text-center\"><i class=\"fa fa-arrow-circle-down fa-5x text-muted\" ng-if=\"eil.listInfo.enabled !== \'true\'\"></i> <i class=\"fa fa-arrow-circle-down fa-5x text-success\" ng-if=\"eil.listInfo.enabled === \'true\'\"></i><p>&nbsp;</p><p>&nbsp;</p></div><div class=\"profile-info\" style=\"margin-left: 0px;\"><h2>{{eil.listInfo.listName | uppercase}} <i class=\"fa fa-shield text-danger\" uib-tooltip=\"{{\'in.protected\' | translate}}\" ng-if=\"eil.listInfo.protected === \'true\'\"></i></h2><ul class=\"list-unstyled m-t-md\"><li><label>{{\'in.edit.filetype\' | translate}}</label> {{eil.listInfo.fileType}}</li><li><label>{{\'in.edit.fullname\' | translate}}</label> {{eil.listInfo.listFullName}}</li><li><label>{{\'in.edit.routingcode\' | translate}}</label> {{eil.listInfo.routingCode | uppercase}}</li></ul></div></div></div><div class=\"col-lg-2\"><div class=\"widget p-lg text-center\" ng-if=\"eil.listInfo.protected !== \'true\'\"><div class=\"m-b-md\"><h3>{{\'in.edit.enabled\' | translate}}</h3><p class=\"m-t-md\"><toggle-switch knob-label=\"-\" ng-model=\"eil.listInfo.enabler\" aria-checked=\"{{eil.listInfo.enabled}}\" ng-model-options=\"{ getterSetter: true }\" ng-change=\"eil.switchList()\" on-label=\"{{\'yes\' | translate}}\" off-label=\"{{\'no\' | translate}}\"></toggle-switch></p></div></div></div><div class=\"col-lg-2\"><div class=\"widget navy-bg p-lg text-center\"><div class=\"m-b-md\"><i class=\"fa fa-user fa-4x\"></i><h1 class=\"m-xs\">{{eil.listInfo.users.length}}</h1><h3 class=\"no-margins\">{{\'in.edit.members\' | translate}}</h3></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{\'in.edit.inmembers\' | translate}}</h5></div><div class=\"ibox-content\"><div class=\"row m-t-lg\"><div class=\"col-md-6\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{\'in.edit.members\' | translate}} ({{eil.listInfo.users.length}})</h5></div><div class=\"ibox-content\"><div class=\"project-list\"><table class=\"table table-hover\" ng-if=\"eil.listInfo.users.length > 0\"><tbody><tr ng-repeat=\"user in eil.listInfo.users\"><td class=\"project-title\" style=\"padding: 5px;\">{{user.userId | emailify}}</td><td class=\"project-actions\" style=\"padding: 5px;\"><a class=\"btn btn-white btn-xs\" ng-click=\"eil.removeUser(user.userId)\" aria-label=\"{{\'in.edit.rmmember\' | translate}}\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><span ng-if=\"eil.listInfo.users.length === 0\">{{\'in.edit.nomembers\' | translate}}</span></div></div></div></div><div class=\"col-md-6\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{\'in.edit.avusers\' | translate}}</h5></div><div class=\"ibox-content ibox-heading\"><div class=\"row\"><div class=\"col-lg-12\"><search-box model=\"eil.searchUser\" placeholder=\"{{\'in.edit.searchph\' | translate}}\" aria=\"{{\'in.edit.searcharia\' | translate}}\"></search-box></div></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center\" ng-show=\"eil.loadingUsers\"><i class=\"fa fa-refresh fa-spin fa-fw\"></i> {{\'in.edit.loading\' | translate}}</div><div class=\"text-center\" ng-show=\"eil.loadingUsersError\"><h5 class=\"text-danger\">{{\'in.edit.errorloading\' | translate}}</h5><button class=\"btn btn-danger btn-sm\" ng-click=\"eil.loadMembers()\"><i class=\"fa fa-refresh fa-fw\"></i> {{\'in.edit.refresh\' | translate}}</button></div><div class=\"form-group\" ng-hide=\"eil.loadingUsers || eil.loadingUsersError\"><select multiple=\"\" class=\"form-control\" ng-size=\"{{eil.recipients.length}}\" ng-model=\"eil.selectedUsers\" aria-label=\"{{\'in.edit.selectusers\' | translate}}\"><option ng-repeat=\"user in eil.recipients | filter:eil.searchUser:user.displayName\" value=\"{{user.id}}\">{{user.displayName}}</option></select><button type=\"buttom\" class=\"btn btn-primary m-t-sm\" ng-click=\"eil.addUsers()\" ng-disabled=\"!eil.selectedUsers\"><i class=\"glyphicon glyphicon-chevron-left\"></i> {{\'in.edit.addusers\' | translate}}</button></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/inbound/inbound.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{\'in.title\' | translate}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'landing.steve\' | translate}}</a></li><li>{{\'users.administration\' | translate}}</li><li class=\"active\"><strong>{{\'in.title\' | translate}}</strong></li></ol></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content\"><div class=\"ibox\"><div class=\"ibox-content ibox-heading\" style=\"padding: 15px;\"><div class=\"row\"><div class=\"col-md-2\"><button class=\"btn btn-primary\" ng-click=\"ib.createNewIn()\"><i class=\"fa fa-plus\"></i> {{\'in.new\' | translate}}</button></div><div class=\"hidden-md hidden-lg\" style=\"height:12px;\">&nbsp;</div><div class=\"col-md-offset-4 col-md-3\"><select class=\"form-control\" ng-options=\"ft for ft in ib.filetypes | orderBy:\'toString()\'\" ng-model=\"ib.selectedFileType\" ng-change=\"ib.onSelectedFileTypeChange()\" aria-label=\"{{\'in.selectft\' | translate}}\"><option style=\"display:none\" value=\"\">{{\'in.selectft\' | translate}}</option></select></div><div class=\"hidden-md hidden-lg\" style=\"height:12px;\">&nbsp;</div><div class=\"col-md-3\"><search-box model=\"ib.searchList\" placeholder=\"{{\'in.searchph\' | translate}}\" aria=\"{{\'in.searcharia\' | translate}}\"></search-box></div></div></div><div class=\"ibox-content\"><div class=\"project-list\"><table class=\"table table-hover\" ng-show=\"ib.lists.length > 0 && !ib.errors && !ib.isLoading\"><tbody><tr ng-repeat=\"item in ib.lists | filter:{fileType: ib.selectedFileType} | filter:ib.searchList | orderBy:\'listName\'\"><td style=\"padding-left: 20px; padding-right: 0px;\"><i class=\"fa fa-2x fa-circle text-success\" ng-if=\"item.enabled === \'true\'\" uib-tooltip=\"{{\'in.enabled\' | translate}}\"></i> <i class=\"fa fa-2x fa-circle-o text-mutted\" ng-if=\"item.enabled !== \'true\'\" uib-tooltip=\"{{\'in.disabled\' | translate}}\"></i></td><td class=\"project-title\" style=\"padding-left: 0px;\"><a ui-sref=\"admin.editlistin({id:item.id, fileType: ib.selectedFileType || item.fileType})\">{{item.listName | uppercase}}</a> <i class=\"fa fa-shield text-danger\" ng-if=\"item.protected === \'true\'\" uib-tooltip=\"{{\'in.protected\' | translate}}\"></i><br>{{item.listType | capitalize}}</td><td class=\"project-completion\">{{\'in.filetype\' | translate}} {{item.fileType}}</td><td class=\"project-actions\"><a ui-sref=\"admin.editlistin({id:item.id, fileType: ib.selectedFileType || item.fileType})\" class=\"btn btn-white btn-sm\"><i class=\"fa fa-pencil\"></i> {{\'in.editbtn\' | translate}}</a> <a href=\"\" class=\"btn btn-white btn-sm\" ng-click=\"ib.deleteList(item.id)\" ng-if=\"item.protected === \'false\'\"><i class=\"fa fa-times\"></i> {{\'in.delete\' | translate}}</a></td></tr><tr ng-if=\"(ib.lists | filter:{listType: ib.bound} | filter:{fileType: ib.selectedFileType} | filter:ib.searchList).length === 0\"><td class=\"text-center\"><h3 ng-if=\"ib.selectedFileType === null\">{{\'in.ftreq\' | translate}}</h3><h3 ng-if=\"ib.selectedFileType !== null\">{{\'in.noin\' | translate}}</h3></td></tr></tbody></table><div class=\"text-center\" ng-show=\"ib.isLoading\"><h2><i class=\"fa fa-refresh fa-spin fa-fw\"></i> {{\'in.loading\' | translate}}</h2></div><div class=\"text-center\" ng-show=\"ib.errors\"><h5 class=\"text-danger\">{{ib.errors}}</h5><button class=\"btn btn-danger\" ng-click=\"ib.loadLists()\"><i class=\"fa fa-refresh fa-fw\"></i> {{\'in.refresh\' | translate}}</button></div></div></div></div></div></div></div>");
$templateCache.put("app/landing/landing.html","<div class=\"navbar-wrapper\"><nav class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\"><div class=\"navbar-header page-scroll\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#navbar\" aria-expanded=\"false\" aria-controls=\"navbar\"><span class=\"sr-only\">{{\'toggledd\' | translate}}</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand steve\" ui-sref=\"dashboards.dashboard_1\"><img src=\"assets/images/steve.png\" alt=\"{{\'landing.steve\' | translate}}\" height=\"40px\"></a></div><div id=\"navbar\" class=\"navbar-collapse collapse\"><ul class=\"nav navbar-nav navbar-right\"><li class=\"active\"><a class=\"page-scroll\" page-scroll=\"\" href=\"#page-top\">{{\'landing.home\' | translate}}</a></li><li><a class=\"page-scroll\" page-scroll=\"\" href=\"#steve\">{{\'landing.steve\' | translate}}</a></li><li><a class=\"page-scroll\" page-scroll=\"\" href=\"#naphsis\">{{\'landing.naphsis\' | translate}}</a></li><li><a class=\"page-scroll\" page-scroll=\"\" href=\"#contact\">{{\'landing.contact\' | translate}}</a></li><li><a ng-click=\"landing.launchSupport()\">{{\'landing.support\' | translate}}</a></li><li><login-button login-state=\"login\"></login-button></li></ul></div></div></nav></div><div id=\"inSlider\" class=\"carousel slide\"><div class=\"carousel-inner\"><div class=\"item active\"><div class=\"container\"><div class=\"carousel-caption\" style=\"margin-top: 50px;\"><h1>{{\'landing.intro\' | translate}}</h1><h1>{{\'landing.steve\' | translate}}</h1><p>{{\'landing.introtext\' | translate}}</p><p><a class=\"btn btn-lg btn-info page-scroll\" href=\"#steve\" id=\"maincontent\">{{\'landing.learnmore\' | translate}}</a></p></div><div class=\"carousel-image\"><img src=\"assets/images/landing/steve_iconset.png\" alt=\"{{\'landing.steve\' | translate}}\" width=\"50%\"></div></div><div class=\"header-back one\"></div></div></div></div><section id=\"compliance\" class=\"container services\"><div class=\"row\"><div class=\"col-lg-10 col-lg-offset-1 text-center\"><img src=\"assets/images/landing/3logos.png\" class=\"img-responsive center-block\" style=\"margin-bottom: 10px;\" alt=\"{{\'landing.compliance\' | translate}}\"><p class=\"lightgreen\" style=\"font-weight:bold; text-transform: uppercase;\">{{\'landing.contactmore\' | translate}} <a href=\"mailto:support@steve.naphsis.us\">support@steve.naphsis.us</a></p></div></div></section><section id=\"steve\" class=\"gray-section team\"><div class=\"container\" style=\"padding-top: 80px; padding-bottom: 80px;\"><div class=\"row\"><div class=\"col-lg-12\"><h1 class=\"section-header-colored1\">{{\'landing.steveplusuberops\' | translate}}</h1></div></div><div class=\"row\"><div class=\"col-md-6\"><p class=\"text-color\">{{\'landing.naphsistxt\' | translate}}</p></div><div class=\"col-md-6 text-center\"><p class=\"lightgreen\" style=\"font-weight: bold;\"><a download=\"\" href=\"assets/NAPHSIS_Steve2_Overview.pdf\">{{\'landing.downsteveover\' | translate}}</a></p><a class=\"btn btn-info\" download=\"\" href=\"assets/NAPHSIS_Steve2_Overview.pdf\">{{\'landing.download\' | translate | uppercase}}</a> <a href=\"https://acrobat.adobe.com/us/en/acrobat/pdf-reader.html\" style=\"margin-left: 20px;\"><img alt=\"Adobe Acrobat Reader\" src=\"assets/images/landing/Get_Adobe_Acrobat_Reader_DC_web_button_158x39.fw.png\"></a></div></div></div></section><section id=\"naphsis\" class=\"features\"><div class=\"container\" style=\"padding-top: 80px; padding-bottom: 80px;\"><div class=\"row\"><div class=\"col-lg-12\"><h1 class=\"section-header-colored2\">{{\'landing.aboutn\' | translate}}</h1></div></div><div class=\"row\"><div class=\"col-lg-7\"><p class=\"text-color\">NAPHSIS and its members work with a variety of partners to improve the efficiency and security of vital records operations in every state, plus the District of Columbia, New York City, Puerto Rico, Guam, American Samoa, the U.S. Virgin Islands, and the Northern Marianas Islands.</p><p class=\"text-color\">Working with federal partners such as the Centers for Disease Control and Prevention (CDC), the CDC\'s National Center for Health Statistics (NCHS), the Social Security Administration, the Department of State, the Department of Homeland Security, and the Office of Personnel Management, NAPHSIS has developed and operates electronic systems for vital records offices that:</p><ul class=\"text-color\" style=\"font-size: 15px;\"><li>Allow for the secure exchange of vital records and information among jurisdictions,</li><li>Provide data to agencies that use information from birth and death records, and</li><li>Support electronic verification and/or certification of vital event records.</li></ul><p class=\"text-color\">NAPHSIS supports these initiatives to improve the quality, speed, availability, and security of vital records and statistics through training, standards, best practices, and technical assistance.</p><p class=\"text-color\">NAPHSIS also works with its members, its corporate partners, and NCHS to support the development and use of electronic birth and death registration systems. These systems enable health departments to register and administer vital records securely, accurately, and quickly. Chances are, if you order a certified birth or death certificate, it will be issued from one of these systems.</p></div><div class=\"col-lg-5\"><div class=\"hidden-xs hidden-sm hidden-md\" style=\"height: 120px;\"></div><img src=\"assets/images/landing/naphsis_rebrand_logo.png\" alt=\"{{\'landing.naphsis\' | translate}}\" class=\"center-block\" width=\"90%\"></div></div></div></section><section id=\"contact\" class=\"green-section\"><div class=\"container\" style=\"padding-top: 80px; padding-bottom: 80px;\"><div class=\"row\"><div class=\"col-md-6 col-md-offset-3\"><h1 class=\"section-header-white\">{{\'landing.contact\' | translate | uppercase}}</h1><div ng-hide=\"submitted\"><form ng-submit=\"landing.processForm()\"><div class=\"row\"><div class=\"col-md-6\"><input autocomplete=\"off\" ng-model=\"landing.formData.name\" class=\"form-control form-landing-controls\" id=\"yourname\" type=\"text\" placeholder=\"{{\'landing.name\' | translate}}\" title=\"{{\'landing.name\' | translate}}\"></div><div class=\"col-md-6\"><input autocomplete=\"off\" ng-model=\"landing.formData.email\" class=\"form-control form-landing-controls\" id=\"email\" type=\"text\" placeholder=\"{{\'landing.email\' | translate}}\" title=\"{{\'landing.email\' | translate}}\"></div></div><br><textarea autocomplete=\"off\" ng-model=\"landing.formData.message\" class=\"form-control form-landing-controls\" placeholder=\"{{\'landing.message\' | translate}}\" rows=\"5\" title=\"{{\'landing.message\' | translate}}\"></textarea><br><input type=\"submit\" id=\"send\" class=\"btn btn-info pull-right\" value=\"{{\'landing.send\' | translate | uppercase}}\"></form></div><div ng-show=\"landing.submitted\"><a class=\"pointer\" ng-click=\"landing.submitted=false\">Thank you, we will be in touch!</a></div></div></div></div></section><section class=\"features\"><div class=\"container\" style=\"padding-top: 25px; padding-bottom: 25px;\"><div class=\"row text-center lightgreen\"><div class=\"col-lg-4\" style=\"line-height: 40px;\"><a href=\"http://www.NAPHSIS.org\">www.NAPHSIS.org</a></div><div class=\"col-lg-4\" style=\"line-height: 40px;\"><a href=\"http://www.AIMSPlatform.com\">www.AIMSPlatform.com</a></div><div class=\"col-lg-4\"></div></div></div></section><script>\n  $(document).ready(function() {\n    // Page scrolling feature\n    $(\'a.page-scroll\').bind(\'click\', function(event) {\n      var link = $(this);\n      $(\'html, body\').stop().animate({\n        scrollTop: $(link.attr(\'href\')).offset().top - 50\n      }, 500);\n      event.preventDefault();\n      if ($(\'body\').hasClass(\'body-small\')) {\n        $(\'#navbar\').collapse(\'toggle\');\n      }\n    });\n  });\n\n  var cbpAnimatedHeader = (function() {\n    var docElem = document.documentElement,\n      header = document.querySelector(\'.navbar-default\'),\n      didScroll = false,\n      changeHeaderOn = 200;\n\n    function init() {\n      window.addEventListener(\'scroll\', function(event) {\n        if (!didScroll) {\n          didScroll = true;\n          setTimeout(scrollPage, 250);\n        }\n      }, false);\n    }\n\n    function scrollPage() {\n      var sy = scrollY();\n      if (sy >= changeHeaderOn) {\n        $(header).addClass(\'navbar-scroll\')\n      } else {\n        $(header).removeClass(\'navbar-scroll\')\n      }\n      didScroll = false;\n    }\n\n    function scrollY() {\n      return window.pageYOffset || docElem.scrollTop;\n    }\n    init();\n\n  })();\n</script>");
$templateCache.put("app/login/login.tpl.html","<div style=\"height:80px;\"></div><login-frontend login-url=\"login.loginUrl\" lookup-url=\"login.lookupUrl\" app-base-url=\"login.appBaseUrl\" back-state=\"landing\" application=\"steve-client\" authenticated-state=\"index.dashboard\"></login-frontend>");
$templateCache.put("app/login-frontend/login-button.tpl.html","<div class=\"signin-aims-btn\" ui-sref=\"{{$ctrl.loginState}}\" aria-label=\"Sign in with AIMS\"></div>");
$templateCache.put("app/login-frontend/login-frontend.tpl.html","<div class=\"login-frontend\"><div class=\"wrapper text-center center-block\"><form class=\"form-signin\"><div class=\"image-container\"><img src=\"https://aimsplatform.com/assets/apps/aims.png\" height=\"120px\"></div><div style=\"margin-bottom: 15px;\" class=\"text-muted\" ng-show=\"loginMessages\">{{loginMessages}}</div><div class=\"slide-container\"><div class=\"slide1\" ng-show=\"slide1\" ng-cloak=\"\"><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\"><i class=\"glyphicon glyphicon-envelope text-primary\"></i></span> <input type=\"text\" class=\"form-control text-primary\" placeholder=\"Email\" aria-describedby=\"basic-addon1\" ng-model-options=\"{ debounce: 0 }\" id=\"email\" name=\"email\" ng-model=\"email\" autofocus=\"\" autocomplete=\"off\"></div></div><div class=\"center-block login-btn\"><button class=\"btn btn-primary btn-block\" type=\"submit\" ng-click=\"lookup()\">Submit</button></div></div><div class=\"slide2\" ng-show=\"slide2\" ng-cloak=\"\"><p>{{email}}</p><div ng-show=\"realms.length === 0\"><p>User credentials not found.</p></div><div class=\"form-group text-left\"><ul class=\"list-group\"><a href=\"\" class=\"list-group-item\" ng-repeat=\"realm in realms\" ng-click=\"login(realm)\" ng-cloak=\"\">{{realm | uppercase}} <span class=\"glyphicon glyphicon-chevron-right pull-right\"></span></a></ul></div></div></div><div class=\"center-block text-muted\" ng-show=\"slide1\"><button type=\"button\" ng-click=\"goHome()\" class=\"btn btn-link btn-sm rounded-corners text-primary\">Cancel</button></div><div class=\"text-center text-muted\" ng-show=\"slide2\"><button type=\"button\" ng-click=\"goMailSlide()\" class=\"btn btn-link btn-sm rounded-corners text-primary\"><i class=\"glyphicon glyphicon-chevron-left\"></i> Back</button></div></form><div class=\"tealstrip\"></div></div></div>");
$templateCache.put("app/login-frontend/logout-button.tpml.html","<span ng-click=\"logout()\"><i class=\"fa fa-sign-out\"></i> Sign out</span>");
$templateCache.put("app/mailbox/details.tpl.html","<div class=\"modal-header\"><div class=\"row\"><div class=\"col-xs-10\"><h3 class=\"modal-title\">{{modal.row.fileName}}</h3></div></div></div><div class=\"modal-body\"><div class=\"container-fluid\"><div class=\"row detail-header\"><div class=\"col-md-5\"><span ng-if=\"modal.row.receiverId\">{{\'mail.sentto\' | translate}} <strong>{{modal.row.receiverId}}</strong></span> <span ng-if=\"modal.row.recipients\">{{\'mail.sentto\' | translate}} <strong>{{modal.row.recipients | recipientList}}</strong></span><br><small>{{modal.row.created_at | momentify}}</small></div><div class=\"col-md-5\">{{\'mail.sender\' | translate}} <strong>{{modal.row.senderId | senderUser}}</strong></div><div class=\"col-md-2 text-right\"><span class=\"label\" ng-class=\"modal.getStatusLabelClass(modal.row)\">{{modal.row.status}}</span></div></div><div class=\"row m-t-md\" ng-if=\"!modal.row.errorMessage\" style=\"min-height: 100px;\"><div ng-if=\"modal.folder === \'sent\'\"><h3>{{\'mail.mds\' | translate}}</h3><div class=\"well well-sm\" ng-if=\"modal.deliveryStatus | contains:\'jurisdiction.toUpperCase() === \\\'NCHS\\\'\'\"><span ng-repeat=\"item in modal.deliveryStatus | pick:\'jurisdiction.toUpperCase() === \\\'NCHS\\\'\'\"><strong>{{item.jurisdiction}}</strong>: <strong>{{item.status | uppercase}}</strong> <span ng-if=\"item.recordCount != null\">·<ng-pluralize count=\"item.recordCount\" when=\"{\'0\': (\'mail.precordno\' | translate), \'one\': (\'mail.precord1\' | translate), \'other\': \'{} \' + (\'mail.precordmany\' | translate)}\"></ng-pluralize></span></span></div><div style=\"max-height:500px; overflow:auto;\" ng-if=\"modal.deliveryStatus.length > 0\"><table class=\"table table-striped\"><thead><tr><th>{{\'mail.jurisdiction\' | translate}}</th><th>{{\'mail.status\' | translate}}</th><th class=\"text-right\">{{\'mail.records\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"item in modal.deliveryStatus | omit:\'jurisdiction.toUpperCase() === \\\'NCHS\\\'\'\"><td>{{item.jurisdiction}}</td><td>{{item.status | uppercase}}</td><td class=\"text-right\"><span ng-if=\"item.recordCount != null\">{{item.recordCount}}</span> <span ng-if=\"item.recordCount == null\">—</span></td></tr></tbody></table></div><div ng-if=\"modal.deliveryStatus.length === 0\">{{\'mail.nomds\' | translate}}</div></div></div><div class=\"row m-t-md\" ng-if=\"modal.row.errorMessage\" style=\"min-height: 200px;\"><div class=\"col-xs-12\"><h3 class=\"text-danger\">{{\'mail.errormsg\' | translate}}</h3><div ng-bind-html=\"modal.row.errorMessage\" class=\"\" style=\"max-height: 300px; overflow: auto;\"></div></div></div><div class=\"row m-t-md\" ng-if=\"modal.row.warnings\" style=\"min-height: 200px;\"><div class=\"col-xs-12\"><h3 class=\"text-danger\">{{\'mail.warningmsg\' | translate}}</h3><div ng-bind-html=\"modal.row.warnings\" class=\"\" style=\"max-height: 300px; overflow: auto;\"></div></div></div></div></div><div class=\"modal-footer\"><button ng-if=\"!modal.row.notDownloadable\" type=\"button\" class=\"btn btn-success pull-left\" ng-click=\"modal.downloadFile(modal.row)\"><i class=\"fa fa-download\"></i> {{\'mail.download\' | translate}} <span ng-if=\"row.size\">({{modal.row.size | bytes}})</span></button><div ng-if=\"!modal.row.notDownloadable\" class=\"valign-text-modal-footer pull-left\" style=\"margin-left: 10px;\"><em><i class=\"fa fa-shield\"></i> {{\'mail.filesecured\' | translate}}</em></div><button class=\"btn btn-default\" type=\"button\" ng-click=\"modal.close()\">{{\'close\' | translate}}</button></div>");
$templateCache.put("app/mailbox/mailbox.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{\'mail.title\' | translate}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'landing.steve\' | translate}}</a></li><li class=\"active\"><strong>{{\'mail.title\' | translate}}</strong></li></ol></div></div><div class=\"wrapper wrapper-content\"><div class=\"row\"><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content mailbox-content\"><div class=\"file-manager\"><a class=\"btn btn-block btn-primary compose-mail\" ui-sref=\"index.sendfile\">{{\'mail.send\' | translate}}</a><div class=\"space-25\"></div><ul class=\"folder-list m-b-md\" style=\"padding: 0\"><li ng-repeat=\"list in mail.lists | orderBy:\'listName\'\" ng-if=\"list.id\"><a href=\"\" ng-click=\"mail.setList(list)\"><i class=\"fa fa-arrow-circle-up text-danger\" ng-if=\"list.listType === \'outbound\'\"></i> <i class=\"fa fa-arrow-circle-down text-danger\" ng-if=\"list.listType === \'inbound\'\"></i> {{list.listName | uppercase}} ({{list.fileType}})</a></li><li class=\"m-t-sm\"><a href=\"\" ng-click=\"mail.setFolder(\'inbox\')\"><i class=\"fa fa-inbox\"></i> {{\'mail.tome\' | translate}}</a></li><li><a href=\"\" ng-click=\"mail.setFolder(\'sent\')\"><i class=\"fa fa-paper-plane\"></i> {{\'mail.sent\' | translate}}</a></li></ul><div class=\"clearfix\"></div></div></div></div></div><div class=\"col-lg-9\"><div class=\"mail-box-header\"><form class=\"pull-right mail-search\"><div class=\"input-group\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"mail.searchFilename\" ng-model-options=\"{ debounce: 700 }\" placeholder=\"{{\'mail.search\' | translate}}...\" ng-change=\"mail.searchByFilename()\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-if=\"!mail.searchFilename\"><i class=\"fa fa-search\" aria-hidden=\"true\" aria-label=\"{{\'mail.search\' | translate}}\"></i></button> <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-if=\"mail.searchFilename\" ng-click=\"mail.clearSearch()\" aria-label=\"{{\'cancel\' | translate}}\"><i class=\"fa fa-times fa-lg\" style=\"font-weight: lighter;\"></i></button></div></div></form><h2>{{mail.placeName | capitalize}} <span ng-if=\"mail.placeFileType\">({{mail.placeFileType}})</span></h2><div class=\"mail-tools m-t-md\" ng-if=\"mail.folder !== \'sent\'\"><button ng-if-start=\"mail.selectedBulkRows.length === 0\" class=\"btn btn-white btn-sm\" ng-click=\"mail.checkForNew()\"><i class=\"fa fa-refresh fa-fw\" ng-class=\"{\'fa-spin fa-lg\': mail.loading}\"></i> {{\'mail.checkfornew\' | translate}}</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-model=\"mail.read\" uib-btn-checkbox=\"\" ng-change=\"mail.filterUnread()\">{{ mail.read ? (\'notification.showall\' | translate) : (\'notification.showunread\' | translate) }}</button> <button type=\"button\" ng-if=\"mail.folder !== \'inbox\'\" class=\"btn btn-white btn-sm\" ng-click=\"mail.downloadUnread()\"><i class=\"fa fa-download fa-fw\" aria-hidden=\"true\"></i> {{\'mail.downloadunread.button\' | translate}}</button> <button type=\"button\" ng-if=\"mail.folder !== \'inbox\'\" class=\"btn btn-danger btn-sm\" ng-click=\"mail.deleteRead()\"><i class=\"fa fa-trash fa-fw\" aria-hidden=\"true\"></i> {{\'mail.deleteread.button\' | translate}}</button><h3 ng-if-end=\"\" class=\"pull-right\" ng-if=\"!mail.loading || !mail.refreshView\">{{\'mail.summary\' | translate:{unread:mail.unreadCount, total:mail.totalCount} }}</h3><div ng-if=\"mail.selectedBulkRows.length > 0\"><button ng-if=\"mail.folder !== \'inbox\'\" class=\"btn btn-success btn-sm\" ng-click=\"mail.downloadMultiple()\" title=\"{{\'mail.downloadmultiple.button\' | translate}}\"><i class=\"fa fa-files-o fa-fw\"></i> {{\'mail.downloadmultiple.button\' | translate}}</button> <button class=\"btn btn-danger btn-sm\" ng-click=\"mail.deleteSelected()\" title=\"{{\'mail.deletefiles\' | translate}}\"><i class=\"fa fa-trash fa-fw\"></i> {{\'mail.deletefiles\' | translate}}</button> <button class=\"btn btn-white btn-sm\" ng-click=\"mail.clearSelection()\" title=\"{{\'mail.deletefiles\' | translate}}\">{{\'mail.clearselected\' | translate}}</button> <span class=\"span-title-h3\" style=\"margin-left: 30px;\"><ng-pluralize count=\"mail.selectedBulkRows.length\" when=\"{\'0\': (\'mail.pselectedno\' | translate), \'one\': (\'mail.pselected1\' | translate), \'other\': \'{} \' + (\'mail.pselectedmany\' | translate)}\"></ng-pluralize></span></div></div><div class=\"mail-tools m-t-md\" ng-if=\"mail.folder === \'sent\'\"><button class=\"btn btn-white btn-sm\" ng-click=\"mail.load()\" uib-tooltip=\"{{\'mail.checkfornew\' | translate}}\" title=\"{{\'mail.checkfornew\' | translate}}\"><i class=\"fa fa-refresh\"></i> {{\'mail.checkfornew\' | translate}}</button><h3 class=\"pull-right\"><ng-pluralize count=\"mail.totalCount\" when=\"{\'0\': (\'mail.ptotalno\' | translate), \'one\': (\'mail.ptotal1\' | translate), \'other\': \'{} \' + (\'mail.ptotalmany\' | translate)}\"></ng-pluralize></h3></div></div><div class=\"mail-box\"><table class=\"table table-hover table-mail\" ng-if=\"mail.mailCollection.length > 0 && !vm.errors && !vm.loading\"><tbody><tr ng-repeat=\"row in mail.mailCollection | orderBy:\'-created_at\'\" ng-class=\"{read: row.status !== \'unread\', unread: row.status === \'unread\'}\"><td class=\"check-mail\"><input type=\"checkbox\" id=\"mail-check\" ng-model=\"row.checked\" ng-change=\"mail.entrySelected(row)\" ng-if=\"mail.folder !== \'sent\'\" style=\"margin:0px;\"></td><td class=\"mail-ontact\" ng-click=\"mail.selectItem(row)\">{{row.senderId | senderUser}}</td><td class=\"mail-subject\" ng-click=\"mail.selectItem(row)\">{{row.fileName}}</td><td class=\"text-right\" ng-click=\"mail.selectItem(row)\"><span class=\"label\" ng-class=\"mail.folder === \'sent\' ? mail.getStatusLabelClass(row) : \'label-info\'\">{{row.status}}</span></td><td><ng-pluralize count=\"row.recordCount\" when=\"{\'0\': (\'mail.precordno\' | translate), \'one\': (\'mail.precord1\' | translate), \'other\': \'{} \' + (\'mail.precordmany\' | translate)}\"></ng-pluralize></td><td class=\"text-right mail-date\">{{row.created_at | momentify}}</td><td class=\"text-right\"><a ng-if=\"!row.notDownloadable\" href=\"\" ng-click=\"mail.downloadFile(row)\" style=\"padding: 0 12px 0 0;\"><i class=\"fa fa-download\" tooltip-placement=\"left\" aria-label=\"{{\'mail.downfiles\' | translate}}\" uib-tooltip=\"{{\'mail.download\' | translate}} {{row.fileName}}\"></i></a></td></tr></tbody><tfoot ng-if=\"mail.mailCollection.length > 0\"><tr><td colspan=\"2\"><p style=\"margin: 24px 0 24px 15px;\"><em><i class=\"fa fa-clock-o fa-lg\" aria-hidden=\"true\" uib-tooltip=\"{{mail.lastUpdate | momentify}}\" tooltip-placement=\"right\"></i> {{\'mail.updated\' | translate}} {{mail.lastUpdate | relatify}}</em></p></td><td class=\"text-center\" colspan=\"3\"><ul uib-pagination=\"\" total-items=\"mail.totalCount\" ng-model=\"mail.currentPage\" max-size=\"5\" items-per-page=\"mail.pageSize\" boundary-links=\"true\" force-ellipses=\"true\"></ul></td><td class=\"text-right\" colspan=\"2\"><select ng-model=\"mail.pageSize\" class=\"form-control input-sm\" style=\"margin: 20px 0;\"><option value=\"10\">10 items per page</option><option value=\"20\">20 items per page</option><option value=\"50\">50 items per page</option><option value=\"100\">100 items per page</option></select></td></tr></tfoot></table><div ng-if=\"mail.mailCollection.length === 0 && !mail.loading && !mail.errors\" style=\"padding: 50px;\"><div class=\"text-center m-t-md m-b-lg\"><i class=\"fa fa-file fa-5x text-ultramuted m-b-sm\" aria-hidden=\"true\" style=\"\"></i><br>There are currently no files to display.</div></div><div class=\"row\" style=\"padding: 20px;\" ng-if=\"mail.errors && !mail.loading\"><div class=\"text-center\"><span>{{mail.errors}}</span><br><button class=\"btn btn-danger btn-sm m-t-sm\" ng-click=\"mail.load()\"><i class=\"fa fa-refresh fa-fw\"></i> {{\'mail.refresh\' | translate}}</button></div></div><div ng-if=\"mail.loading && mail.refreshView\" class=\"text-center\" style=\"padding: 50px;\"><i class=\"fa fa-refresh fa-spin fa-4x fa-fw\"></i></div></div></div></div></div>");
$templateCache.put("app/mailbox/sendfile2-all-details.tpl.html","<div class=\"modal-header\"><h3 class=\"modal-title\">{{\'send.allDetailsTitle\' | translate}}</h3></div><div class=\"modal-body\"><p class=\"text-muted\" ng-if=\"allModal.fileType\">{{\'send.allDetailsFileType\' | translate:{ fileType: allModal.fileType } }}</p><p ng-if=\"allModal.destinations.length === 0\">{{\'send.allDetailsEmpty\' | translate}}</p><ul class=\"list-unstyled m-t-sm\" ng-if=\"allModal.destinations.length > 0\"><li ng-repeat=\"d in allModal.destinations | orderBy:\'listName\'\">{{d.listName | uppercase}} <span class=\"text-muted\">({{d.fileType}})</span></li></ul><p class=\"text-muted small m-t-md m-b-none\">{{\'send.allDetailsAdminNote\' | translate}}</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"allModal.close()\">{{\'close\' | translate}}</button></div>");
$templateCache.put("app/mailbox/sendfile2.tpl.html","<div class=\"wrapper wrapper-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"mail-box-header\"><div class=\"pull-right tooltip-demo\"><button ng-click=\"send2.discardMessage()\" class=\"btn btn-white btn-sm\" title=\"{{\'send.discardaria\' | translate}}\" ng-disabled=\"send.disableWhileSending\"><i class=\"fa fa-times\"></i> {{\'send.discard\' | translate}}</button></div><h2>{{\'send.sendtitle\' | translate}}</h2></div><div class=\"mail-box\"><div class=\"mail-body\"><div class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\" for=\"filetypes\">{{\'send.filetypes\' | translate}}</label><div class=\"col-sm-10\"><select class=\"form-control\" name=\"filetypes\" id=\"filetypes\" ng-model=\"send2.message.filetype\" ng-options=\"ft for ft in send2.fileTypes | orderBy:\'toString()\'\" aria-label=\"{{\'send.filetypes\' | translate}}\"></select></div></div><div class=\"form-group\" ng-if=\"send2.message.filetype && send2.message.filetype !== \'Other\'\"><label class=\"col-xs-2 control-label\">{{\'send.sendto\' | translate}}</label><div class=\"col-xs-10\"><label class=\"btn btn-default\" ng-model=\"send2.destType\" uib-btn-radio=\"\'All\'\" ng-if=\"send2.all.length > 0\">{{\'send.all\' | translate}}</label> <span uib-tooltip=\"{{\'send.allNoDestinationsTooltip\' | translate}}\" tooltip-placement=\"top\" ng-if=\"send2.all.length === 0\"><span class=\"btn btn-default disabled\" tabindex=\"-1\">{{\'send.all\' | translate}}</span></span> <label class=\"btn btn-default\" ng-model=\"send2.destType\" uib-btn-radio=\"\'NCHS\'\" ng-if=\"send2.nchsOnly.length > 0\">{{\'send.nchs\' | translate}}</label> <label class=\"btn btn-default\" ng-model=\"send2.destType\" uib-btn-radio=\"\'Jurisdictions\'\">{{\'send.jur\' | translate}}</label> <label class=\"btn btn-default\" ng-model=\"send2.destType\" uib-btn-radio=\"\'Custom\'\">{{\'send.custom\' | translate}}</label></div></div><div class=\"form-group m-b-lg\" ng-if=\"send2.destType\"><label class=\"col-xs-2 control-label\" ng-if=\"send2.destType !== \'Custom\'\">{{\'send.recipient\' | translate}}</label> <label class=\"col-xs-2 control-label\" ng-if=\"send2.destType === \'Custom\'\">{{\'send.customrecipient\' | translate}}</label><div class=\"col-xs-10\" ng-if=\"send2.destType===\'All\'\"><p class=\"form-control-static\"><a href=\"\" class=\"send-all-details-link\" ng-click=\"send2.showAllDestinationsModal(); $event.preventDefault();\" role=\"button\">{{\'send.alltext\' | translate}}</a></p></div><div class=\"col-xs-10\" ng-if=\"send2.destType===\'NCHS\'\"><p class=\"form-control-static\">{{\'send.nchstext\' | translate}}</p></div><div class=\"col-xs-10\" ng-if=\"send2.destType===\'Jurisdictions\'\"><p class=\"form-control-static\">{{\'send.jurtext\' | translate}}</p></div><div class=\"col-xs-10\" ng-if=\"send2.destType===\'Custom\'\"><ui-select multiple=\"\" ng-model=\"send2.message.selectedRecipients\" theme=\"bootstrap\" close-on-select=\"false\"><ui-select-match placeholder=\"{{\'send.selectr\' | translate}}\" ng-class=\"{\'add-recipient-match\': $item.listName === \'Add recipient...\'}\">{{$item.listName}}<span ng-if=\"$item.listName !== \'Add recipient...\'\" class=\"remove-recipient-x\" ng-click=\"send2.recipientRemove(); send2.removeFromSelectedRecipients($item.listName)\"></span></ui-select-match><ui-select-choices repeat=\"recip in send2.to | filter:{listName: $select.search} | orderBy:\'listName\'\" ng-click=\"send2.recipientAdd()\"><div class=\"select-item\" ng-bind-html=\"recip.listName | highlight: $select.search\"></div><span ng-bind-html=\"recip.fileType | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div></div><div class=\"mail-text h-200\" style=\"padding: 40px;\"><div class=\"row\" ng-if=\"send2.files.length === 0 || !send2.files\"><div class=\"col-lg-12\"><div ngf-drop=\"\" ngf-select=\"\" ng-model=\"send2.files\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\">{{\'send.drop\' | translate}}</div><div ngf-no-file-drop=\"\">{{\'send.nodrop\' | translate}}</div></div></div><div class=\"row\" ng-if=\"send2.files.length > 0\"><div class=\"col-lg-12\"><div ngf-drop=\"\" ng-attr-ngf-select=\"{{!send2.fileSizeLimitReached ? \'true\' : \'false\'}}\" ngf-change=\"!send2.fileSizeLimitReached && send2.addFiles($files)\" ng-class=\"{\'add-more-send-files\': true, \'file-size-limit-reached\': send2.fileSizeLimitReached}\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\">{{!send2.fileSizeLimitReached ? (\'send.drop\' | translate) : \"File size limit has been reached! You will not be able to add additional files or send until the total file size selected is reduced.\"}}<br>Total File Size: {{send2.fileSizeString}}</div><div ngf-no-file-drop=\"\">{{\'send.nodrop\' | translate}}</div></div></div><div ng-class=\"send2.listFileExists ? \'file-exists-prompt\' : \'file-exists-prompt-hidden\'\"><div class=\"file-exists\"><span class=\"file-icon\">!<i class=\"fa fa-folder-open-o\"></i></span><h2>File has already been added!</h2><p>No new files were added to the send list! <strong>{{send2.existingFile}}</strong> filename has already been added to the send list. Make sure not to include filenames that are already included within the list when attaching new files to send.</p><span ng-click=\"send2.listFileExists = false\" class=\"file-exists-exit-btn\">X</span></div></div><div class=\"row\" ng-if=\"send2.files.length > 0\" ng-repeat=\"file in send2.files\"><div class=\"col-lg-12\"><div class=\"file-selected\"><i class=\"fa fa-file icon-big\"></i> <strong>\"{{file.name}}\"</strong>&nbsp;({{file.size | bytes}}) <button class=\"btn btn-link\" ng-click=\"send2.removeFile(file)\" ng-if=\"!send2.disableWhileSending\" aria-label=\"{{\'send.rmfile\' | translate}}\"><i class=\"fa fa-trash\"></i></button></div><div class=\"progress\" ng-if=\"file.progressPercentage > 0\"><div class=\"progress-bar progress-bar-striped active\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: file.progressPercentage + \'%\'}\">{{file.progressPercentage}}%</div></div></div></div><div class=\"row\" ng-if=\"send2.showProgress\"><div class=\"col-lg-12\"><h2>{{\'send.wait\' | translate}}</h2><uib-progressbar class=\"progress-striped active\" value=\"send2.progressPercentage\">{{send2.progressMessage}}</uib-progressbar></div></div></div></div><div class=\"row\" ng-if=\"send2.errors\"><div class=\"col-lg-12 text-danger text-center\">{{send2.errors}}</div></div></div><div class=\"mail-body text-right tooltip-demo\"><button class=\"btn btn-primary\" title=\"{{\'send.send\' | translate}}\" ng-click=\"send2.doSendFile()\" ng-disabled=\"send2.disableWhileSending || !send2.message.filetype || send2.modRecip.length === 0 || send2.disableNoFile\"><i class=\"fa fa-send\"></i> {{\'send.send\' | translate}}</button> <button ng-click=\"send2.discardMessage()\" class=\"btn btn-white\" title=\"{{\'send.discardaria\' | translate}}\" ng-disabled=\"send.disableWhileSending\"><i class=\"fa fa-times\"></i> {{\'send.discard\' | translate}}</button></div><div class=\"clearfix\"></div></div></div><div ng-class=\"send2.recipientAdded ? \'recipient-prompt\' : \'recipient-prompt-hidden\'\"><div class=\"added-recipient-prompt\"><h1>Added recipient</h1></div></div><div ng-class=\"send2.recipientRemoved ? \'recipient-prompt\' : \'recipient-prompt-hidden\'\"><div class=\"removed-recipient-prompt\"><h1>Removed recipient</h1></div></div>");
$templateCache.put("app/main/main.html","<div class=\"row border-bottom white-bg dashboard-header\"><div class=\"col-sm-6\"><h1>{{\'main.welcome\' | translate:{name:((app.profile && app.profile.name) || app.userInfo.name)} }}</h1></div></div><div class=\"wrapper wrapper-content\"><div class=\"row m-b-md\" ng-if=\"!main.dismissed\"><div class=\"col-lg-12 m-b-md\"><div class=\"ibox-content\" style=\"background-color: white\"><h2>{{ main.tacTitle }}</h2><p style=\"font-size: 14px\">{{ main.tacText }}</p><div class=\"text-right\"><button class=\"btn btn-default\" style=\"background-color: #2e527a; color: white\" ng-click=\"main.dismiss()\">Accept and Dismiss</button> <button class=\"btn btn-danger\" ng-click=\"main.disagree()\">Disagree</button></div></div></div></div><div class=\"row m-b-md\" ng-if=\"main.noProfileAvailable\"><div class=\"col-lg-12\"><no-profile></no-profile></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\" ng-cloak=\"\"><div ng-class=\"{ \'ibox-content\': true, \'sk-loading\': main.loadingMap && !main.loadingMapError}\"><div class=\"sk-spinner sk-spinner-double-bounce\"><div class=\"sk-double-bounce1\"></div><div class=\"sk-double-bounce2\"></div></div><h2 id=\"maincontent\" ng-translate=\"main.maptitle\"></h2><h3>{{\'main.mapsubtitle\' | translate}}</h3><div class=\"row\" ng-if=\"!main.loadingMapError\"><div class=\"col-lg-9\"><div class=\"svg-map\"><div svg-map=\"\"></div></div></div><div class=\"col-lg-3 p-l-xl\"><div class=\"status-btn\" uib-tooltip=\"{{\'main.good\' | translate}}\" ng-click=\"main.showList(\'good\')\"><div class=\"status-head stat-good\">{{main.good.length}}</div><div class=\"status-body\"><div class=\"help\">File(s) sent within last</div>3 days</div></div><div class=\"status-btn\" uib-tooltip=\"{{\'main.warn\' | translate}}\" ng-click=\"main.showList(\'warn\')\"><div class=\"status-head stat-warn\">{{main.warn.length}}</div><div class=\"status-body\"><div class=\"help\">File(s) sent between</div>3-7 days ago</div></div><div class=\"status-btn\" uib-tooltip=\"{{\'main.inactive\' | translate}}\" ng-click=\"main.showList(\'severe\')\"><div class=\"status-head stat-error\">{{main.severe.length}}</div><div class=\"status-body\"><div class=\"help\">File(s) sent over</div>7 days ago</div></div><div style=\"clear: both\"></div></div><div class=\"col-lg-3\" ng-show=\"main.selectedRInfo\"><div class=\"state-info-box\" ng-if=\"main.selectedRInfo.infoType === \'statusList\'\"><h2>{{main.selectedRInfo.name}}</h2><h3>{{\'main.jurisdictions\' | translate}}</h3><div class=\"panel panel-default\" style=\"margin-bottom: 0px\" ng-if=\"main.selectedRInfo.fullList.length > 0\"><div class=\"panel-body\" style=\"padding: 10px\"><div style=\"max-height: 400px; overflow: auto\"><span ng-repeat=\"j in main.selectedRInfo.fullList | orderBy:\'name\'\">{{j.name}}<br></span></div></div></div><div ng-if=\"main.selectedRInfo.fullList.length === 0\">{{\'main.nojur\' | translate:{status: main.selectedRInfo.name} }}</div></div><div class=\"state-info-box\" ng-if=\"main.selectedRInfo.infoType === \'info\'\"><div class=\"state-card\"><div class=\"state-image\" style=\"background-image: url(\'../assets/images/states/{{main.selectedRInfo.regionImage}}\'), url(\'../assets/images/states/landscape.png\');\"></div><div class=\"state-header stat-onboarding\" ng-class=\"{severe: \'stat-error\', warn: \'stat-warn\', good: \'stat-good\'}[main.selectedRInfo.status]\">{{main.selectedRInfo.name}}</div><div class=\"state-body\"><span class=\"state-normal\">{{\'main.status\' | translate}} {{(main.selectedRInfo.status | uppercase) || (\'main.noinfo\' | translate)}}</span> <span class=\"state-small m-b-md\" ng-hide=\"!main.selectedRInfo.lastSeen\">{{\'main.lastactive\' | translate}} {{main.selectedRInfo.lastSeen | relatify}}</span><contact-card contact=\"main.selectedRInfo.primaryContact\" ng-if=\"main.selectedRInfo.primaryContact\"></contact-card></div><div class=\"state-actions\" ng-if=\"main.userRealmCode === main.selectedRegionId\"><a class=\"state-btn\" ui-sref=\"index.mailbox\">Mailboxes</a> <a class=\"state-btn pull-right\" ui-sref=\"index.addressbook\">address book</a></div></div></div></div></div><div class=\"row\" ng-if=\"!main.loadingMap && main.loadingMapError\"><div class=\"col-lg-12\"><h5 class=\"text-danger\">There\'s been an error loading the map. Please, try again or contact the Support Team</h5><button class=\"btn btn-danger\" ng-click=\"main.loadJurisdistionStatus()\"><i class=\"fa fa-refresh fa-fw\"></i> {{\'supa.refresh\' | translate}}</button></div></div></div></div></div></div></div>");
$templateCache.put("app/main/metrics.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-12\"><h2>Metrics</h2><button class=\"btn btn-default btn-sm pull-right\" ng-click=\"metrics.loadDataWidgets()\"><i class=\"fa fa-refresh fa-fw\" ng-class=\"{\'fa-spin\': metrics.widgetsRefresh}\"></i> Refresh</button><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'landing.steve\' | translate}}</a></li><li class=\"active\"><strong>Metrics</strong></li></ol></div></div><div class=\"wrapper wrapper-content\"><div class=\"row m-b-sm\"><div ng-repeat=\"widget in metrics.widgets | where:{type:\'status\'} | orderBy:[\'weight\', \'title\']\"><dash-widget status=\"widget\"></dash-widget></div></div><div class=\"row m-b-md\"><div ng-repeat=\"widget in metrics.widgets | where:{type:\'gauge\'} | orderBy:[\'weight\', \'title\']\"><dash-widget status=\"widget\"></dash-widget></div></div><div class=\"row m-b-md\"><div ng-repeat=\"widget in metrics.widgets | pick:\'type === \\\'graph\\\' || type === \\\'table\\\'\' | orderBy:[\'weight\', \'title\']\"><dash-widget status=\"widget\"></dash-widget></div></div></div>");
$templateCache.put("app/notifications/notifications.detail.tpl.html","<div class=\"notification-modal\"><div class=\"modal-header\" ng-class=\"{error: \'bg-danger\', info: \'bg-info\', warning: \'bg-warning\'}[modal.row.type]\" style=\"border-radius: 4px 4px 0px 0px;\"><button type=\"button\" class=\"close\" ng-click=\"modal.close()\" aria-label=\"{{\'close\' | translate}}\"><span aria-hidden=\"true\">&times;</span></button><h3 class=\"modal-title\" id=\"modal-title\">{{modal.row.title}}</h3></div><div class=\"modal-body\" style=\"min-height: 200px;\"><div class=\"container-fluid\"><div class=\"row\"><p>{{modal.row.created_at | momentify}}</p><p>{{modal.row.content}}</p></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"modal.close()\">{{\'close\' | translate}}</button></div></div>");
$templateCache.put("app/notifications/notifications.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\" ng-cloak=\"\"><div class=\"col-lg-9\"><h2>{{\'notification.title\' | translate}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'landing.steve\' | translate}}</a></li><li class=\"active\"><strong>{{\'notification.title\' | translate}}</strong></li></ol></div></div><div class=\"wrapper wrapper-content\" ng-cloak=\"\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content ibox-heading\"><div class=\"row\"><div class=\"col-md-2\"><button type=\"button\" class=\"btn btn-primary\" ng-model=\"notification.read\" uib-btn-checkbox=\"\" btn-checkbox-true=\"0\" btn-checkbox-false=\"undefined\">{{notification.read === 0 ? (\'notification.showall\' | translate) : (\'notification.showunread\' | translate)}}</button> <button class=\"btn btn-default\" ng-click=\"notification.loadNotifications()\"><i class=\"fa fa-refresh fa-spin\" ng-if=\"notification.loading\"></i> {{\'notification.reload\' | translate}}</button></div><div class=\"hidden-md hidden-lg\" style=\"height:12px;\">&nbsp;</div><div class=\"col-md-3 pull-right text-right\"><search-box model=\"notification.search\" placeholder=\"{{\'notification.searchph\' | translate}}...\" aria=\"{{\'notification.searchph\' | translate}}\" size=\"normal\"></search-box></div></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><table class=\"table table-hover issue-tracker\"><tbody><tr ng-repeat=\"notif in notification.notifications | orderBy:\'-created_at\' | filter:notification.search | filter:{read: notification.read}:true\" ng-click=\"notification.selectItem(notif)\"><td class=\"text-center\" width=\"10%\"><span class=\"label\" ng-class=\"{error: \'label-danger\', info: \'label-info\', warning: \'label-warning\'}[notif.type]\">{{notif.type | uppercase}}</span></td><td class=\"issue-info\"><a href=\"\">{{notif.title}}</a><br><span>{{notif.content}}</span></td><td class=\"text-right\">{{notif.created_at | momentify}}</td><td class=\"text-center text-navy\" width=\"50px\"><i class=\"fa fa-circle fa-lg\" aria-hidden=\"true\" ng-if=\"notif.read === 0\" uib-tooltip=\"{{\'notification.unread\' | translate}}\"></i> <i class=\"fa fa-circle-o fa-lg\" aria-hidden=\"true\" ng-if=\"notif.read !== 0\" uib-tooltip=\"{{\'notification.read\' | translate}}\"></i></td></tr></tbody></table></div><div ng-if=\"(notification.notifications | orderBy:\'-created_at\' | filter:notification.search | filter:{read: notification.read}:true).length === 0\"><div class=\"text-center\"><i class=\"fa fa-bell fa-5x text-ultramuted m-t-lg m-b-md\" aria-hidden=\"true\" style=\"\"></i><br>{{\'notification.nonotifications\' | translate}}</div></div><div ng-if=\"notification.loading && notification.refreshView\"><div class=\"text-center\"><h2><i class=\"fa fa-refresh fa-spin\"></i> {{\'notification.loading\' | translate}}</h2></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/outbound/createOutbound.tpl.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"cob.close()\" aria-label=\"{{\'close\' | translate}}\"><span aria-hidden=\"true\">&times;</span></button><h3 class=\"modal-title\" id=\"modal-title\">{{\'out.create.title\' | translate}}</h3></div><div class=\"modal-body\" id=\"modal-body\"><div class=\"wizard\"><div class=\"steps clearfix\"><ul><li ng-class=\"{current: cob.activeStep === 0, done: cob.activeStep > 0}\"><a><strong>1</strong> {{\'out.create.step1\' | translate}}</a></li><li ng-class=\"{current: cob.activeStep === 1, done: cob.activeStep > 1}\"><a><strong>2</strong> {{\'out.create.step2\' | translate}}</a></li><li ng-class=\"{current: cob.activeStep === 2}\"><a><strong>3</strong> {{\'out.create.step3\' | translate}}</a></li></ul></div></div><div class=\"wizard\"><div class=\"content\" ng-show=\"cob.activeStep === 0\"><div class=\"row m-sm\"><div class=\"col-lg-6\"><div class=\"form-group\"><label for=\"fileTypes\">{{\'out.create.filetype\' | translate}} <span class=\"text-danger\">*</span></label><select class=\"form-control\" ng-options=\"ft for ft in cob.fileTypes | orderBy:\'toString()\'\" ng-model=\"cob.fileType\"><option style=\"display:none\" value=\"\">{{\'out.create.selectft\' | translate}}</option></select></div><div class=\"form-group\"><label for=\"listName\">{{\'out.create.name\' | translate}} <span class=\"text-danger\">*</span></label> <input class=\"form-control\" id=\"listName\" ng-model=\"cob.listName\" required=\"\"></div><div class=\"alert alert-danger\" role=\"alert\" ng-if=\"cob.errors.length > 0\"><ul style=\"margin-bottom: 0px;\"><li ng-repeat=\"item in cob.errors\">* {{item}}</li></ul></div></div><div class=\"col-lg-6 m-t-md\"><p translate=\"out.create.ftmsg\"></p><p translate=\"out.create.rulemsg\"></p></div></div></div><div class=\"content\" ng-show=\"cob.activeStep === 1\"><div class=\"row m-sm\"><div class=\"col-lg-6\"><div class=\"form-group m-t-lg\"><label for=\"autoRouting\" class=\"control-label\" style=\"margin-right: 20px;\">{{\'out.create.autor\' | translate}}</label><toggle-switch id=\"autoRouting\" on-label=\"{{\'yes\' | translate}}\" off-label=\"{{\'no\' | translate}}\" ng-model=\"cob.autoRouting\" aria-checked=\"{{cob.autoRouting}}\"></toggle-switch></div></div><div class=\"col-lg-6 m-t-md\"><p translate=\"out.create.automsg\"></p></div></div></div><div class=\"content\" ng-show=\"cob.activeStep === 2\"><div class=\"row m-sm\"><div class=\"col-lg-6 m-t-md\"><p><strong>{{\'out.create.filetype\' | translate}}</strong> {{cob.fileType}}</p><p><strong>{{\'out.create.name\' | translate}}</strong> {{cob.listName}}</p><p><strong>{{\'out.create.autor\' | translate}}</strong> {{cob.autoRouting | yesNo}}</p></div><div class=\"col-lg-6 m-t-md\"><p translate=\"out.create.confirmmsg\"></p></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default pull-left\" type=\"button\" ng-click=\"cob.previuos()\" ng-if=\"cob.activeStep > 0\"><i class=\"fa fa-chevron-left\"></i> {{\'out.create.previous\' | translate}}</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"cob.next()\" ng-if=\"cob.activeStep < 2\">{{\'out.create.next\' | translate}} <i class=\"fa fa-chevron-right\"></i></button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"cob.createList()\" ng-if=\"cob.activeStep === 2\">{{\'create\' | translate}}</button> <button class=\"btn btn-default\" type=\"button\" ng-click=\"cob.close()\">{{\'cancel\' | translate}}</button></div>");
$templateCache.put("app/outbound/editOutbound.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\" ng-cloak=\"\"><div class=\"col-lg-9\"><h2>{{\'out.edit.title\' | translate}} <small style=\"color: #404041\">{{(eol.listInfo && eol.listInfo.listName) | uppercase}}</small></h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'landing.steve\' | translate}}</a></li><li>{{\'users.administration\' | translate}}</li><li><a href=\"\" ng-click=\"eol.goBackToOutboundList($event)\">{{\'out.title\' | translate}}</a></li><li class=\"active\"><strong>{{\'out.edit.title\' | translate}}</strong></li></ol></div></div><div class=\"row wrapper border-bottom gray-bg\"><div class=\"col-lg-9\"><div style=\"padding: 10px 10px 10px 0px;\"><a href=\"\" class=\"btn btn-link\" ng-click=\"eol.goBackToOutboundList($event)\"><i class=\"fa fa-arrow-left fa-fw\"></i> {{\'back\' | translate}} {{\'out.title\' | translate}}</a></div></div></div><div class=\"wrapper wrapper-content\" ng-cloak=\"\" ng-show=\"eol.loading\"><div class=\"row m-b-lg\"><div class=\"col-lg-12 text-center\"><h2><i class=\"fa fa-refresh fa-spin fa-fw\"></i> {{\'out.edit.loading\' | translate}}</h2></div></div></div><div class=\"wrapper wrapper-content\" ng-cloak=\"\" ng-show=\"eol.loadingError\"><div class=\"row m-b-lg\"><div class=\"col-lg-12 text-center\"><h5 class=\"text-danger\">{{\'out.edit.errorloding\' | translate}}</h5><button class=\"btn btn-danger btn-sm\" ng-click=\"eol.loadInfo()\"><i class=\"fa fa-refresh fa-fw\"></i> {{\'out.edit.refresh\' | translate}}</button></div></div></div><div class=\"wrapper wrapper-content\" ng-cloak=\"\" ng-hide=\"eol.loading || eol.loadingError\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"widget p-xl\" style=\"padding-left:0px;\"><div class=\"profile-image text-center\"><i class=\"fa fa-arrow-circle-down fa-5x text-muted\" ng-if=\"eol.listInfo.enabled !== \'true\'\"></i> <i class=\"fa fa-arrow-circle-down fa-5x text-success\" ng-if=\"eol.listInfo.enabled === \'true\'\"></i><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p></div><div class=\"profile-info\" style=\"margin-left: 0px;\"><h2>{{eol.listInfo.listName | uppercase}} <i class=\"fa fa-shield text-danger\" uib-tooltip=\"{{\'out.edit.protected\' | translate}}\" ng-if=\"eol.listInfo.protected === \'true\'\"></i></h2><ul class=\"list-unstyled m-t-md\"><li><label>{{\'out.edit.filetype\' | translate}}</label> {{eol.listInfo.fileType}}</li><li><label>{{\'out.edit.fullname\' | translate}}</label> {{eol.listInfo.listFullName}}</li><li><label>{{\'out.edit.autor\' | translate}}</label> <span class=\"label\" ng-class=\"{ true: \'label-success\', false: \'label-default\'}[eol.listInfo.autoRouting]\">{{eol.listInfo.autoRouting === \'true\'? (\'out.enabled\' | translate | uppercase):(\'out.disabled\' | translate | uppercase)}} <span></span></span></li></ul></div></div></div><div class=\"col-lg-2 pull-right\"><div class=\"widget navy-bg p-lg text-center\"><div class=\"m-b-md\"><i class=\"fa fa-envelope fa-4x\"></i><h1 class=\"m-xs\">{{eol.alist.length}}</h1><h3 class=\"no-margins\">{{\'out.edit.routesconfig\' | translate}}</h3></div></div></div><div class=\"col-lg-2 pull-right\" ng-if=\"eol.viewFilters\"><div class=\"widget navy-bg p-lg text-center\"><div class=\"m-b-md\"><i class=\"fa fa-check-square-o fa-4x\"></i><h1 class=\"m-xs\">{{eol.listInfo.filter.length}}</h1><h3 class=\"no-margins\">{{\'out.edit.filtersconfig\' | translate}}</h3></div></div></div><div class=\"col-xs-4 col-md-2 pull-right\"><div class=\"widget p-lg text-center\" ng-if=\"eol.filtersEnabled\"><div class=\"m-b-md\"><h3>{{\'out.edit.ruleenabled\' | translate}}</h3><p class=\"m-t-md\"><toggle-switch knob-label=\"-\" ng-model=\"eol.listInfo.enabler\" ng-model-options=\"{ getterSetter: true }\" ng-disabled=\"(eol.listInfo.filter.length === 0 && eol.listInfo.fileType !== \'Other\') || eol.alist.length === 0\" ng-change=\"eol.switchList()\" aria-checked=\"{{eol.listInfo.enabled}}\" on-label=\"{{\'yes\' | translate}}\" off-label=\"{{\'no\' | translate}}\"></toggle-switch></p><p><span ng-if=\"eol.listInfo.filter.length === 0 && eol.listInfo.fileType !== \'Other\'\" class=\"text-danger\"><i class=\"fa fa-times-circle\"></i> {{\'out.edit.filterconfigno\' | translate}}</span> <span ng-if=\"eol.listInfo.filter.length > 0 && eol.listInfo.fileType !== \'Other\'\" class=\"text-primary\"><i class=\"fa fa-check-circle\"></i> {{\'out.edit.filterconfigyes\' | translate}}</span><br><span ng-if=\"eol.alist.length === 0\" class=\"text-danger\"><i class=\"fa fa-times-circle\"></i> {{\'out.edit.inconfigno\' | translate}}</span> <span ng-if=\"eol.alist.length > 0\" class=\"text-primary\"><i class=\"fa fa-check-circle\"></i> {{\'out.edit.inconfigyes\' | translate}}</span></p></div></div><div class=\"widget p-lg text-center\" ng-if=\"eol.filtersEnabled && eol.listInfo.listName !== \'NCHS\'\"><div class=\"m-b-md\"><h3>{{\'out.edit.includeInAll\' | translate}}</h3><p class=\"m-t-md\"><toggle-switch knob-label=\"-\" ng-model=\"eol.listInfo.includeInAller\" ng-model-options=\"{ getterSetter: true }\" ng-change=\"eol.switchIncludeInAll()\" aria-checked=\"{{eol.listInfo.includeInAll}}\" on-label=\"{{\'yes\' | translate}}\" off-label=\"{{\'no\' | translate}}\"></toggle-switch></p></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"tabs-container\"><uib-tabset><uib-tab heading=\"{{\'out.edit.filters\' | translate}}\" ng-if=\"eol.viewFilters\" active=\"true\"><div class=\"panel-body\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" ng-if=\"!eol.filters && !eol.loadingFilters\" style=\"border: none;\"><div class=\"row\"><div class=\"col-lg-12 text-center\"><h3 class=\"text-danger\">{{\'out.edit.errorloading\' | translate}}</h3><button class=\"btn btn-danger\" ng-click=\"eol.loadFilters(eol.listInfo.fileType)\">Refresh</button></div></div></div><div class=\"ibox-content\" ng-if=\"eol.loadingFilters\" style=\"border: none;\"><div class=\"row\"><div class=\"col-lg-12 text-center\"><h2><i class=\"fa fa-refresh fa-spin fa-fw\"></i> {{\'out.edit.loading\' | translate}}</h2></div></div></div><div class=\"ibox-content\" ng-if=\"eol.filters && !eol.loadingFilters\" style=\"border: none;\"><div class=\"row\"><div class=\"col-lg-12 text-right\"><a href=\"\" class=\"btn btn-primary\" ng-click=\"eol.saveFilters()\" ng-if=\"eol.filtersEnabled\" ng-disabled=\"!eol.filtersModified\">{{\'out.edit.save\' | translate}}</a> <button class=\"btn btn-default\" ng-click=\"eol.exportFilters()\" ng-if=\"eol.filtersEnabled\" ng-disabled=\"eol.filtersModified\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Export filters</button> <label class=\"btn-upload btn btn-default\"><i class=\"fa fa-upload\" aria-hidden=\"true\"></i> Import filters <input type=\"file\" id=\"file2Upload\" onchange=\"angular.element(\'#file2Upload\').scope().eol.onFileChange(this)\"></label> <a href=\"\" class=\"btn btn-default\" ng-click=\"eol.goBackToOutboundList($event)\">{{\'cancel\' | translate}}</a></div></div><div class=\"tabs-container\"><uib-tabset><uib-tab heading=\"{{filter[\'@name\']}} ({{(filter.fields | filter:{\'@enabled\':true}).length}})\" ng-repeat=\"filter in eol.filters\"><div class=\"container-fluid\"><div class=\"row ibox-heading\" style=\"padding: 20px 0px;\"><div class=\"col-md-3\"><span style=\"font-size: 2em;\"><ng-pluralize count=\"(filter.fields | filter:{\'@enabled\':true}).length\" when=\"{\'0\': (\'out.edit.pnofilters\' | translate), \'one\': (\'out.edit.p1filter\' | translate), \'other\': \'{} \' + (\'out.edit.pmanyfilters\' | translate)}\"></ng-pluralize></span> <small class=\"text-danger\" ng-show=\"eol.filtersModified\">{{\'out.edit.unsaved\' | translate}}</small></div><div class=\"col-md-2\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"eol.checkAllToggle\" ng-disabled=\"!eol.filtersEnabled\" ng-change=\"eol.selectAll(filter)\"> {{\'out.edit.selectall\' | translate}}</label></div></div><div class=\"col-md-2 text-right\"><span style=\"line-height: 36px;\">{{\'out.edit.showing\' | translate:{some: (filter.fields | filter:eol.searchFilter).length, all: filter.fields.length} }}</span></div><div class=\"col-md-5\"><search-box model=\"eol.searchFilter\" placeholder=\"{{\'out.edit.searchph\' | translate}}\" aria=\"{{\'out.edit.searcharia\' | translate}}\"></search-box></div></div><div class=\"row m-t-sm\"><div class=\"col-lg-12 multi-column\"><div class=\"checkbox\" ng-repeat=\"item in filter.fields | filter:eol.searchFilter\" style=\"margin-top: 0px;\"><label><input type=\"checkbox\" ng-model=\"item[\'@enabled\']\" ng-checked=\"item[\'@enabled\']\" ng-disabled=\"eol.isFilterCheckboxDisabled(item)\" title=\"{{eol.isFilterCheckboxDisabled(item) && eol.isSsnFilterField(item) ? (\'out.edit.ssnRestricted\' | translate) : \'\'}}\"> {{item[\'@name\']}} <span class=\"text-muted\" ng-if=\"eol.isFilterCheckboxDisabled(item) && eol.isSsnFilterField(item)\">({{\'out.edit.ssnRestricted\' | translate}})</span> <span class=\"text-danger\" ng-if=\"item[\'@enabled\'] !== eol.filtersMaster[$parent.$index].fields[$index][\'@enabled\']\">*</span></label></div></div></div></div></uib-tab></uib-tabset></div><div class=\"row\"><div class=\"col-lg-12 text-right\"><hr><a href=\"\" class=\"btn btn-primary\" ng-click=\"eol.saveFilters()\" ng-if=\"eol.filtersEnabled\" ng-disabled=\"!eol.filtersModified\">{{\'out.edit.save\' | translate}}</a> <a href=\"\" class=\"btn btn-default\" ng-click=\"eol.goBackToOutboundList($event)\">{{\'cancel\' | translate}}</a></div></div></div></div></div></uib-tab><uib-tab heading=\"Routes\"><div class=\"panel-body\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"border: none;\"><div class=\"row m-t-sm\"><div class=\"col-md-6\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{\'out.edit.destinations\' | translate}}</h5></div><div class=\"ibox-content\"><div class=\"project-list\" style=\"max-height: 500px; overflow: auto;\"><table class=\"table table-hover\" ng-if=\"eol.alist.length > 0\"><tbody><tr ng-repeat=\"al in eol.alist | orderBy:\'realm\' | orderBy:\'listName\'\"><td class=\"project-title\" style=\"padding: 5px;\"><span ng-if=\"al.routingCode\">({{al.routingCode}})</span> {{al.listName | uppercase}}</td><td class=\"project-actions\" style=\"padding: 5px;\" ng-if=\"eol.listInfo.protected !== \'true\'\"><a class=\"btn btn-white btn-xs\" ng-click=\"eol.removeInbound(al.id)\" aria-label=\"{{\'out.edit.rmdest\' | translate}}\"><i class=\"fa fa-times\"></i></a></td></tr></tbody></table><span ng-if=\"eol.alist.length === 0\">{{\'out.edit.nomb\' | translate}}</span></div></div></div></div><div class=\"col-md-6\"><div class=\"ibox float-e-margins\" ng-if=\"eol.listInfo.protected === \'true\'\"><div class=\"ibox-title\"><h5><i class=\"fa fa-shield text-danger\" uib-tooltip=\"{{\'out.edit.protected\' | translate}}\"></i> {{\'out.edit.protectedmsg\' | translate}}</h5></div><div class=\"ibox-content\">{{\'out.edit.readonly\' | translate}}</div></div><div class=\"ibox float-e-margins\" ng-if=\"eol.listInfo.protected !== \'true\'\"><div class=\"ibox-title\"><h5>{{\'out.edit.mbavail\' | translate}}</h5></div><div class=\"ibox-content ibox-heading\"><div class=\"row\"><div class=\"col-lg-4\"><select class=\"form-control\" ng-options=\"rc for rc in eol.routingCodes | orderBy:\'toString()\'\" ng-model=\"eol.selectedRoutingCode\" ng-change=\"eol.loadAvailableDestinations()\" aria-label=\"{{\'out.edit.selectrc\' | translate}}\"><option style=\"display:none\" value=\"\">{{\'out.edit.selectrc\' | translate}}</option></select></div><div class=\"col-lg-8\"><search-box model=\"eol.searchInbound\" placeholder=\"{{\'out.edit.searchph\' | translate}}\" aria=\"{{\'out.edit.searchariamb\' | translate}}\"></search-box></div></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center\" ng-show=\"eol.loadingRoutes\"><i class=\"fa fa-refresh fa-spin fa-fw\"></i> {{\'out.edit.loading\' | translate}}</div><div class=\"text-center\" ng-show=\"eol.loadingRoutesError\"><h5 class=\"text-danger\">{{\'out.edit.errorloading\' | translate}}</h5><button class=\"btn btn-danger btn-sm\" ng-click=\"eol.loadMembers()\"><i class=\"fa fa-refresh fa-fw\"></i> {{\'out.edit.refresh\' | translate}}</button></div><div class=\"form-group\" ng-hide=\"eol.loadingRoutes || eol.loadingRoutesError\"><select multiple=\"\" class=\"form-control\" ng-size=\"{{eol.availableLists.length}}\" ng-model=\"eol.selectedInbounds\" aria-label=\"{{\'out.edit.selectmb\' | translate}}\"><option ng-repeat=\"il in eol.availableLists | filter:{routingCode:eol.selectedRoutingCode}:true | filter:{listName:eol.searchInbound} | orderBy:\'realm\' | orderBy:\'listName\'\" value=\"{{il.id}}\">{{il.routingCode | routingCode}}{{il.listName}}</option></select><button type=\"buttom\" class=\"btn btn-primary m-t-sm\" ng-click=\"eol.addInbound()\" ng-disabled=\"!eol.selectedInbounds\"><i class=\"glyphicon glyphicon-chevron-left\"></i> {{\'out.edit.addmb\' | translate}}</button></div></div></div></div></div></div></div></div></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/outbound/outbound.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{\'out.title\' | translate}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'landing.steve\' | translate}}</a></li><li>{{\'users.administration\' | translate}}</li><li class=\"active\"><strong>{{\'out.title\' | translate}}</strong></li></ol></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content\"><div class=\"ibox\"><div class=\"ibox-content ibox-heading\" style=\"padding: 15px;\"><div class=\"row\"><div class=\"col-md-2\"><button class=\"btn btn-primary\" ng-click=\"ob.createNewOut()\"><i class=\"fa fa-plus\"></i> {{\'out.new\' | translate}}</button></div><div class=\"hidden-md hidden-lg\" style=\"height:12px;\">&nbsp;</div><div class=\"col-md-offset-4 col-md-3\"><select class=\"form-control\" ng-options=\"ft for ft in ob.filetypes | orderBy:\'toString()\'\" ng-model=\"ob.selectedFileType\" ng-change=\"ob.onSelectedFileTypeChange()\" aria-label=\"{{\'out.selectft\' | translate}}\"><option style=\"display:none\" value=\"\">{{\'out.selectft\' | translate}}</option></select></div><div class=\"hidden-md hidden-lg\" style=\"height:12px;\">&nbsp;</div><div class=\"col-md-3\"><search-box model=\"ob.searchList\" placeholder=\"{{\'out.searchph\' | translate}}\" aria=\"{{\'out.searcharia\' | translate}}\"></search-box></div></div></div><div class=\"ibox-content\"><div class=\"project-list\"><table class=\"table table-hover\" ng-show=\"ob.lists.length > 0 && !ob.errors && !ob.isLoading\"><tbody><tr ng-repeat=\"item in ob.lists | filter:{fileType: ob.selectedFileType} | filter:{listName:ob.searchList} | orderBy:\'listName\'\"><td style=\"padding-left: 20px; padding-right: 0px;\"><i class=\"fa fa-2x fa-circle text-success\" ng-if=\"item.enabled === \'true\'\" uib-tooltip=\"{{\'out.enabled\' | translate}}\"></i> <i class=\"fa fa-2x fa-circle-o text-mutted\" ng-if=\"item.enabled !== \'true\'\" uib-tooltip=\"{{\'out.disabled\' | translate}}\"></i></td><td class=\"project-title\" style=\"padding-left: 0px;\"><a ui-sref=\"admin.editlistout({id:item.id, fileType: ob.selectedFileType || item.fileType})\" ng-if=\"item.listName !== \'NCHS\'\">{{item.listName | uppercase}}</a> <span ng-if=\"item.listName === \'NCHS\'\"><strong>{{item.listName | uppercase}}</strong></span> <i class=\"fa fa-shield text-danger\" ng-if=\"item.protected === \'true\'\" uib-tooltip=\"{{\'out.protected\' | translate}}\"></i><br>{{item.listType | capitalize}}</td><td class=\"project-completion\">{{\'out.filetype\' | translate}} {{item.fileType}}</td><td class=\"project-completion text-center\">{{\'out.autor\' | translate}}<br><span class=\"label\" ng-class=\"{ true: \'label-success\', false: \'label-default\'}[item.autoRouting]\">{{item.autoRouting === \'true\'? (\'out.enabled\' | translate | uppercase):(\'out.disabled\' | translate | uppercase)}} <span></span></span></td><td class=\"project-completion text-center\"><i class=\"fa fa-2x fa-check-circle text-success\" ng-if=\"item.includeInAll === 1\" uib-tooltip=\"{{\'out.includeInAll\' | translate}}\"></i> <i class=\"fa fa-2x fa-minus-circle text-muted\" ng-if=\"item.includeInAll !== 1\" uib-tooltip=\"{{\'out.excludedFromAll\' | translate}}\"></i></td><td class=\"project-actions\"><a ui-sref=\"admin.editlistout({id:item.id, fileType: ob.selectedFileType || item.fileType})\" class=\"btn btn-white btn-sm\" ng-if=\"ob.canEdit(item)\"><i class=\"fa fa-pencil\"></i> {{\'out.editbtn\' | translate}}</a> <a class=\"btn btn-white btn-sm\" ng-if=\"ob.canDelete(item)\" ng-click=\"ob.deleteList(item.id)\"><i class=\"fa fa-times\"></i> {{\'out.delete\' | translate}}</a> &nbsp;</td></tr><tr ng-if=\"(ob.lists | filter:{listType: ob.bound} | filter:{fileType: ob.selectedFileType} | filter:ob.searchList).length === 0\"><td class=\"text-center\"><h3 ng-if=\"ob.selectedFileType === null\">{{\'out.ftreq\' | translate}}</h3><h3 ng-if=\"ob.selectedFileType !== null\">{{\'out.noout\' | translate}}</h3></td></tr></tbody></table><div class=\"text-center\" ng-show=\"ob.isLoading\"><h2><i class=\"fa fa-refresh fa-spin fa-fw\"></i> {{\'out.loading\' | translate}}</h2></div><div class=\"text-center\" ng-show=\"ob.errors\"><h5 class=\"text-danger\">{{ob.errors}}</h5><button class=\"btn btn-danger\" ng-click=\"ob.loadLists()\"><i class=\"fa fa-refresh fa-fw\"></i> {{\'out.refresh\' | translate}}</button></div></div></div></div></div></div></div>");
$templateCache.put("app/resources/resources.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-8\"><h2>{{\'resources.title\' | translate}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'landing.steve\' | translate}}</a></li><li class=\"active\"><strong>{{\'resources.title\' | translate}}</strong></li></ol></div><div class=\"col-xs-4 text-right\"><div class=\"m-t-lg\"><a href=\"https://acrobat.adobe.com/us/en/acrobat/pdf-reader.html\" target=\"_blank\"><img alt=\"Adobe Acrobat Reader\" src=\"assets/images/landing/Get_Adobe_Acrobat_Reader_DC_web_button_158x39.fw.png\"></a></div></div></div><div class=\"wrapper wrapper-content\" ng-cloak=\"\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h2>{{\'resources.qsg\' | translate}}</h2></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\"><resource-item icon=\"file-pdf-o\" title-text=\"resources.qsgsend\" text=\"resources.qsgsenddesc\" down=\"./assets/STEVE_2.0_Message_Sending_Guide.pdf\"></resource-item></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\"><resource-item icon=\"file-pdf-o\" title-text=\"resources.qsgconfig\" text=\"resources.qsgconfigdesc\" down=\"./assets/STEVE2UserCreationandMailboxConfigQuickStart.pdf\"></resource-item></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h2>{{\'resources.docs\' | translate}}</h2></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-12\"><resource-item icon=\"file-pdf-o\" title-text=\"resources.docsadmin\" text=\"resources.docsadmindesc\" down=\"./assets/STEVE_2.0_System_Administration_Guide.pdf\"></resource-item></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-12\"><resource-item icon=\"file-pdf-o\" title-text=\"resources.docsfile\" text=\"resources.docsfiledesc\" down=\"./assets/STEVE2MultipleFileDownload.pdf\"></resource-item></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-12\"><resource-item icon=\"file-pdf-o\" title-text=\"resources.docstrans\" text=\"resources.docstransdesc\" down=\"./assets/STEVE_1.0_2.0_Transition_Plan.pdf\"></resource-item></div></div><div class=\"row\"><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-12\"><resource-item icon=\"file-pdf-o\" title-text=\"resources.docsname\" text=\"resources.docsnamedesc\" down=\"./assets/NCHSFileNamingConvention.pdf\"></resource-item></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-12\"><resource-item icon=\"file-pdf-o\" title-text=\"resources.docsfaq\" text=\"resources.docsfaqdesc\" down=\"./assets/STEVE2FAQ.pdf\"></resource-item></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-12\"><resource-item icon=\"file-excel-o\" title-text=\"resources.filterreport\" text=\"resources.filterreportdesc\" down=\"https://client.steve.naphsis.us/reports/STEVE2_Filter_Configuration.xlsx\"></resource-item></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h2>STEVE Thin Client Documentation</h2></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12\"><resource-item icon=\"file-pdf-o\" title-text=\"Technical Overview\" text=\"A technical overview of thin client architecture, requirements, and design.\" down=\"./assets/docs/thinclient/STEVE2_ThinClient_TechOverview.pdf\"></resource-item></div><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12\"><resource-item icon=\"file-pdf-o\" title-text=\"User Guide\" text=\"A guide to install, update, and operate a thin client.\" down=\"./assets/docs/thinclient/STEVE2_ThinClient_UserGuide.pdf\"></resource-item></div><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12\"><resource-item icon=\"file-pdf-o\" title-text=\"Change Log\" text=\"Information regarding features, patches, fixes, and security updates to the thin client over time.\" down=\"./assets/docs/thinclient/STEVE2_ThinClient_Changelog.pdf\"></resource-item></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h2>{{\'resources.vid\' | translate}}</h2></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><resource-item icon=\"video-camera\" title-text=\"resources.vidintro\" text=\"resources.vidintrodesc\" link=\"https://naphsis.sharepoint.com/:v:/r/sites/steve/Shared%20Documents/General/IJE%20STEVE%20Committee%20Call%20Recording%2010-16-17.mp4?csf=1&web=1\" button=\"Watch\"></resource-item></div><div class=\"col-sm-6 col-xs-12\"><resource-item icon=\"video-camera\" title-text=\"resources.vidtrain2\" text=\"resources.vidtrain2desc\" link=\"https://naphsis.sharepoint.com/sites/steve/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Fsteve%2FShared%20Documents%2FGeneral%2FSTEVE%202_0%20Training%20-%20Mailbox%20Management%20and%20NCHS%20Codes.mp4&parent=%2Fsites%2Fsteve%2FShared%20Documents%2FGeneral\" button=\"Watch\"></resource-item></div></div><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><resource-item icon=\"video-camera\" title-text=\"resources.vidtrain3\" text=\"resources.vidtrain3desc\" link=\"https://naphsis.sharepoint.com/sites/steve/Shared%20Documents/Forms/AllItems.aspx?csf=1&web=1&e=W5loXt&cid=2d75cffc-7231-4b2d-ae06-99ccb3ece595&FolderCTID=0x0120003569F57FDA03494FADEFFC09779A409B&id=%2Fsites%2Fsteve%2FShared%20Documents%2FGeneral%2F1.21.21%20Steve%20User%20Training.mp4&parent=%2Fsites%2Fsteve%2FShared%20Documents%2FGeneral\" button=\"Watch\"></resource-item></div><div class=\"col-sm-6 col-xs-12\"><resource-item icon=\"video-camera\" title-text=\"resources.vidtrain4\" text=\"resources.vidtrain4desc\" link=\"https://naphsis.sharepoint.com/:v:/r/sites/steve/Shared%20Documents/General/2018-02-12%20IJE%20MTG%20STEVE%20Thin%20Client%20Discussion.mp4?csf=1&web=1\" button=\"Watch\"></resource-item></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h2>{{\'resources.arch\' | translate}}</h2><h3>{{\'resources.archsubtitle\' | translate}}</h3></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-3 col-md-4 col-sm-6 col-xs-12\"><resource-item icon=\"file-excel-o\" title-text=\"resources.archfetal\" text=\"resources.archfetaldesc\" down=\"./assets/IJE_08_12_FetalDeath_Programs_0811.xls\"></resource-item></div><div class=\"col-lg-3 col-md-4 col-sm-6 col-xs-12\"><resource-item icon=\"file-excel-o\" title-text=\"resources.archmort\" text=\"resources.archmortdesc\" down=\"./assets/IJE_08_12_Mortality_Programs_0811.xls\"></resource-item></div><div class=\"col-lg-3 col-md-4 col-sm-6 col-xs-12\"><resource-item icon=\"file-excel-o\" title-text=\"resources.archnat\" text=\"resources.archnatdesc\" down=\"./assets/IJE_08_12_Natality_Programs_0811.xls\"></resource-item></div><div class=\"col-lg-3 col-md-4 col-sm-6 col-xs-12\"><resource-item icon=\"file-excel-o\" title-text=\"resources.archije\" text=\"resources.archijedesc\" down=\"./assets/IJE_File_Layouts_Version_2024.xlsx\"></resource-item></div></div></div></div></div></div></div>");
$templateCache.put("app/settings/settings.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2>{{\'settings.title\' | translate}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'landing.steve\' | translate}}</a></li><li class=\"active\"><strong>{{\'settings.title\' | translate}}</strong></li></ol></div></div><div class=\"wrapper wrapper-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-4\"><h3>{{\'settings.n.title\' | translate}}</h3>{{\'settings.n.subtitle\' | translate}}</div><div class=\"col-md-8\" ng-if=\"settings.noProfile\"><no-profile></no-profile></div><div class=\"col-md-8\" ng-if=\"!settings.noProfile\"><div class=\"ibox float-e-margins\" ng-repeat=\"type in settings.nTypes | orderBy:\'displayName\'\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-3\"><h3 style=\"margin-bottom: 0px; margin-top: 0px;\">{{\'settings.n.notification\' | translate:{nType: type.displayName} }}</h3></div><div class=\"col-md-8\"><div class=\"form-group\" style=\"margin-bottom: 0px;\"><div><input type=\"checkbox\" id=\"web\" style=\"margin-right: 10px;\" ng-model=\"settings.notifSettings[type.name].config.sendToWeb\"> <label for=\"web\">{{\'settings.n.web\' | translate}}</label></div><div><input type=\"checkbox\" id=\"email\" style=\"margin-right: 10px;\" ng-model=\"settings.notifSettings[type.name].config.sendToEmail\" ng-disabled=\"!settings.user.email\"> <label for=\"email\" ng-class=\"{\'text-muted\': !settings.user.email}\">{{\'settings.n.email\' | translate}}</label> <span ng-if=\"settings.user.email\"><i class=\"fa fa-envelope fa-fw\" aria-hidden=\"true\"></i>{{settings.user.email}}</span></div><div><input type=\"checkbox\" id=\"sms\" style=\"margin-right: 10px;\" ng-model=\"settings.notifSettings[type.name].config.sendToSMS\" ng-disabled=\"!settings.user.phoneNumber\"> <label for=\"sms\" ng-class=\"{\'text-muted\': !settings.user.phoneNumber}\">{{\'settings.n.sms\' | translate}}</label> <span ng-if=\"settings.user.phoneNumber\"><i class=\"fa fa-phone fa-fw\" aria-hidden=\"true\"></i>{{settings.user.phoneNumber | phoneUS}}</span> <span ng-if=\"!settings.user.phoneNumber\"><a ui-sref=\"index.profile\">(Add phone number)</a></span></div></div></div><div class=\"col-md-1\"><button class=\"btn btn-sm btn-primary pull-right\" ng-click=\"settings.saveConfig(type.name)\">{{\'save\' | translate}}</button></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/support/support.tpl.html","<div class=\"support-modal\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"support.cancel()\" aria-label=\"{{\'close\' | translate}}\"><span aria-hidden=\"true\">&times;</span></button><h3 class=\"modal-title\" id=\"modal-title\"><i class=\"fa fa-life-ring fa-fw\"></i> {{\'sup.title\' | translate}}</h3></div><div class=\"modal-body\" id=\"modal-body\"><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"support-name\" class=\"col-sm-2 control-label\">{{\'sup.name\' | translate}}:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"support-name\" placeholder=\"{{\'sup.name\' | translate}}\" ng-model=\"support.name\" ng-if=\"!support.isAuthenticated\"><p class=\"form-control-static\" ng-if=\"support.isAuthenticated\">{{support.name}}</p></div></div><div class=\"form-group\"><label for=\"support-email\" class=\"col-sm-2 control-label\">{{\'sup.email\' | translate}}:</label><div class=\"col-sm-10\"><input type=\"email\" class=\"form-control\" id=\"support-email\" placeholder=\"{{\'sup.name\' | translate}}\" ng-model=\"support.email\" ng-if=\"!support.isAuthenticated\"><p class=\"form-control-static\" ng-if=\"support.isAuthenticated\">{{support.email}}</p></div></div><div class=\"form-group\"><label for=\"support-request\" class=\"col-sm-2 control-label\">{{\'sup.req\' | translate}}</label><div class=\"col-sm-10\"><textarea class=\"form-control\" id=\"support-request\" rows=\"5\" placeholder=\"{{\'sup.reqph\' | translate}}\" ng-model=\"support.request\"></textarea></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"support.submit()\" ng-disabled=\"support.submitting || !(support.name && support.email && support.request)\">{{support.submitButtonText}}</button> <button class=\"btn btn-default\" type=\"button\" ng-click=\"support.cancel()\">{{\'cancel\' | translate}}</button></div></div>");
$templateCache.put("app/support_area/support_area.detail.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-9\"><h2 ng-show=\"!sd.loading\">{{\'supa.detail.title\' | translate}} {{sd.ticketInfo.key}}</h2><h2 ng-hide=\"!sd.loading\"><i class=\"fa fa-refresh fa-spin fa-fw\"></i> {{\'supa.detail.loading\' | translate}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'landing.steve\' | translate}}</a></li><li class=\"active\"><a ui-sref=\"index.support\">{{\'supa.title\' | translate}}</a></li><li class=\"active\"><strong>{{\'supa.detail.titlebc\' | translate}}</strong></li></ol></div></div><div class=\"row wrapper border-bottom gray-bg\"><div class=\"col-lg-9\"><div style=\"padding: 10px 10px 10px 0px;\"><a href=\"\" ui-sref=\"index.support\" class=\"btn btn-link\"><i class=\"fa fa-arrow-left fa-fw\"></i> {{\'back\' | translate}} {{\'supa.issueslist\' | translate}}</a></div></div></div><div class=\"wrapper wrapper-content\" ng-cloak=\"\"><div class=\"row\" ng-if=\"!sd.loading\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row m-t-sm\"><div class=\"col-lg-12\"><h3>{{sd.ticketInfo.fields.summary}}</h3><div class=\"hr-line-dashed\"></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><dl class=\"dl-horizontal dl-custom\"><dt>{{\'supa.detail.status\' | translate}}</dt><dd><span class=\"label\" ng-class=\"{ \'To Do\': \'label-success\', \'In Progress\': \'label-warning\', \'Done\': \'label-primary\', \'No Category\': \'label-danger\'}[sd.ticketInfo.fields.status.statusCategory.name]\">{{sd.ticketInfo.fields.status.name | uppercase}}</span></dd><dt>{{\'supa.detail.created\' | translate}}</dt><dd>{{sd.ticketInfo.fields.created | date:\'fullDate\'}}</dd><dt>{{\'supa.detail.updated\' | translate}}</dt><dd>{{sd.ticketInfo.fields.updated | relatify}}</dd><dt>{{\'supa.detail.description\' | translate}}</dt><dd><div class=\"well\" style=\"white-space: pre-wrap;\">{{sd.ticketInfo.fields.description}}</div></dd></dl></div></div></div></div></div></div><div class=\"row\" ng-if=\"!sd.loading\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>{{\'supa.detail.comments\' | translate}} ({{sd.ticketInfo.fields.comments.length}})</h5></div><div class=\"ibox-content\"><div class=\"feed-activity-list\"><div class=\"feed-element\" ng-repeat=\"c in sd.ticketInfo.fields.comments\"><span class=\"pull-left\"><img alt=\"image\" class=\"img-circle\" src=\"assets/images/default.png\" ng-if=\"!c.author.avatarUrls[\'32x32\']\"> <img alt=\"image\" class=\"img-circle\" ng-src=\"{{c.author.avatarUrls[\'32x32\']}}\" ng-if=\"c.author.avatarUrls[\'32x32\']\"></span><div class=\"media-body\"><small class=\"pull-right\">{{c.created.jira | relatify}}</small> <strong>{{c.author.displayName}}</strong> {{\'supa.detail.commented\' | translate}}<br><small class=\"text-muted\">{{c.created.jira | momentify}}</small><div class=\"well\" style=\"white-space: pre-wrap;\">{{c.body}}</div></div></div></div><div class=\"feed-element\"><div class=\"media-body\" style=\"margin-left: 48px;\"><textarea class=\"form-control\" rows=\"5\" placeholder=\"{{\'supa.detail.comment\' | translate}}\" ng-model=\"sd.newComment\"></textarea> <button class=\"btn btn-sm btn-primary m-t-sm\" ng-disabled=\"!sd.newComment\" ng-click=\"sd.postComment()\">{{\'supa.detail.postcom\' | translate}}</button></div></div></div></div></div></div><div class=\"row\" ng-if=\"sd.loading\"><div class=\"col-lg-12\"><div class=\"text-center\"><i class=\"fa fa-refresh fa-spin fa-2x fa-fw\"></i></div></div></div></div>");
$templateCache.put("app/support_area/support_area.tpl.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-xs-12\"><h2>{{\'supa.title\' | translate}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.dashboard\">{{\'landing.steve\' | translate}}</a></li><li class=\"active\"><strong>{{\'supa.title\' | translate}}</strong></li></ol></div></div><div class=\"wrapper wrapper-content\" ng-cloak=\"\"><div class=\"row\"><div class=\"col-lg-6\"><div class=\"ibox\"><div class=\"ibox-content\"><h2>STEVE Filter Configuration</h2><p class=\"m-t-md\">A spreadsheet of STEVE filter configurations. This report is updated approximately every 24 hours, it will not reflect changes made in the same day. When downloading the report, please note the date prepared field on Sheet 1 - Version.</p><p class=\"text-right\"><a href=\"https://client.steve.naphsis.us/reports/STEVE2_Filter_Configuration.xlsx\" download=\"\" target=\"_blank\" class=\"btn btn-sm btn-primary\"><i class=\"fa fa-file-excel-o fa-lg\" aria-hidden=\"true\" style=\"margin-right: 10px;\"></i> {{\'landing.download\' | translate}}</a></p></div></div></div><div class=\"col-lg-6\"><div class=\"ibox\"><div class=\"ibox-title\"><a class=\"btn btn-default btn-xs pull-right\" href=\"https://us6.campaign-archive.com/home/?u=88628ec7c2a338cdbdb071721&id=7dc133cc6d\" target=\"_blank\">View all</a><h3>STEVE Bulletins <small>(showing last 10)</small></h3></div><div class=\"ibox-content\"><div style=\"max-height: 200px; overflow: auto;\" id=\"bulletin-container\"><script>\n              var oldDocumentWrite = document.write;\n              document.write = function (node) {\n                $(\"#bulletin-container\").append(node);\n              }\n\n              $.getScript(\"//uberops.us6.list-manage.com/generate-js/?u=88628ec7c2a338cdbdb071721&fid=12925&show=10\", function () {\n                setTimeout(function () {\n                  document.write = oldDocumentWrite\n                }, 100)\n              });\n            </script></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>{{\'supa.issueslist\' | translate}}</h5></div><div class=\"ibox-content ibox-heading\"><div class=\"row\"><div class=\"col-md-2\"><button class=\"btn btn-primary\" ng-click=\"sup.launchSupport()\"><i class=\"fa fa-plus\"></i> {{\'supa.reqsup\' | translate}}</button></div><div class=\"hidden-md hidden-lg\" style=\"height:12px;\">&nbsp;</div><div class=\"col-md-2 pull-right text-right\"><button class=\"btn btn-default\" ng-click=\"sup.loadTickets(sup.searchSupport)\"><i class=\"fa fa-refresh\"></i> {{\'supa.refresh\' | translate}}</button></div><div class=\"hidden-md hidden-lg\" style=\"height:12px;\">&nbsp;</div></div></div><div class=\"ibox-content\"><div class=\"table-reponsive m-t-md\" ng-if=\"!sup.loading && !sup.loadingError && sup.safeCollection.length > 0\"><table class=\"table table-hover issue-tracker\" st-table=\"sup.issuesCollection\" st-safe-src=\"sup.safeCollection\"><tbody><tr ng-repeat=\"issue in sup.issuesCollection\"><td width=\"10px\"><img ng-src=\"{{issue.fields.status.iconUrl}}\" ng-if=\"issue.fields.status.iconUrl | endsWith: \'.png\'\"></td><td width=\"10px\"><span class=\"label\" ng-class=\"{ \'To Do\': \'label-success\', \'In Progress\': \'label-warning\', \'Done\': \'label-primary\', \'No Category\': \'label-danger\'}[issue.fields.status.statusCategory.name]\" uib-tooltip=\"{{issue.fields.status.description}}\" tooltip-placement=\"right\">{{issue.fields.status.name}}</span></td><td class=\"issue-info\"><a href=\"\" ui-sref=\"index.supportdetail({supportId:issue.id})\">{{issue.key}}</a> <small>{{issue.fields.description | characters:300}}</small></td><td>{{issue.fields.created | momentify}}</td><td width=\"10px\"><a href=\"\" class=\"btn btn-sm btn-default\" ui-sref=\"index.supportdetail({supportId:issue.id})\">{{\'supa.view\' | translate}}</a></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"20\" st-displayed-pages=\"7\" st-template=\"app/components/common/pagination.tpl.html\"></div></td></tr></tfoot></table></div><div class=\"m-t-md text-center\" ng-if=\"sup.loading\"><h2><i class=\"fa fa-refresh fa-spin fa-2x fa-fw\"></i></h2></div><div class=\"m-t-md text-center\" ng-if=\"!sup.loading && sup.loadingError\"><h5 class=\"text-danger\">There\'s been an error loading your Support Tickets. Please, try again or contact the Support Team</h5><button class=\"btn btn-danger\" ng-click=\"sup.loadTickets()\"><i class=\"fa fa-refresh fa-fw\"></i> {{\'supa.refresh\' | translate}}</button></div><div class=\"m-t-md text-center\" ng-if=\"!sup.loading && !sup.loadingError && sup.safeCollection.length === 0\">{{\'supa.notickets\' | translate}}</div></div></div></div></div></div>");
$templateCache.put("app/tac/tac.tpl.html","<div class=\"top-title\"><div class=\"container\"><div class=\"row m-t-xl m-b-xl\"><div class=\"col-lg-12\"><h1 class=\"title\">STEVE</h1><h1 class=\"title\">{{ tac.title }}</h1></div></div></div></div><div class=\"terms\"><div class=\"container\"><div class=\"row m-t-xl m-b-xl\"><div class=\"col-lg-12\"><p class=\"lead\">{{ tac.text }}</p></div><div class=\"col-lg-12 m-t-xl text-right\"><button class=\"btn btn-primary btn-lg m-r-md\" ng-click=\"tac.accept()\"><span class=\"m-l-lg m-r-lg\">ACCEPT</span></button> <button class=\"btn btn-default btn-lg\" ng-click=\"tac.decline()\"><span class=\"m-l-lg m-r-lg\">DECLINE</span></button></div></div></div></div>");
$templateCache.put("app/components/common/clientDownload.tpl.html","<div class=\"btn-group btn-block download-btn m-t-sm\" uib-dropdown=\"\"><a class=\"btn btn-primary\" style=\"width: 90%\" ng-href=\"{{$ctrl.installer.url}}/{{$ctrl.installer[$ctrl.type].filename}}\">{{\'clients.downfor\' | translate}} <i class=\"fa {{$ctrl.type | iconClass:\'fa\'}}\" aria-hidden=\"true\"></i> {{$ctrl.installer[$ctrl.type].name}}</a> <button type=\"button\" class=\"btn btn-primary dropdown-toggle\" style=\"width: 10%\" uib-dropdown-toggle=\"\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"caret\"></span> <span class=\"sr-only\">{{\'toggledd\' | translate}}</span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu=\"\"><li ng-if=\"$ctrl.installer[\'win64\']\"><a href=\"\" ng-click=\"$ctrl.changePlatform(\'win64\')\"><i class=\"fa fa-windows\" aria-hidden=\"true\"></i> {{$ctrl.installer[\'win64\'].name}}</a></li><li ng-if=\"$ctrl.installer[\'win32\']\"><a href=\"\" ng-click=\"$ctrl.changePlatform(\'win32\')\"><i class=\"fa fa-windows\" aria-hidden=\"true\"></i> {{$ctrl.installer[\'win32\'].name}}</a></li><li ng-if=\"$ctrl.installer[\'mac\']\"><a href=\"\" ng-click=\"$ctrl.changePlatform(\'mac\')\"><i class=\"fa fa-apple\" aria-hidden=\"true\"></i> {{$ctrl.installer[\'mac\'].name}}</a></li><li ng-if=\"$ctrl.installer[\'linux\']\"><a href=\"\" ng-click=\"$ctrl.changePlatform(\'linux\')\"><i class=\"fa fa-linux\" aria-hidden=\"true\"></i> {{$ctrl.installer[\'linux\'].name}}</a></li></ul></div>");
$templateCache.put("app/components/common/compactWidget.tpl.html","<a ui-sref=\"index.metrics\" class=\"compact-link\"><div class=\"widget bg-{{$ctrl.status.color}} text-center widget-compact\" ng-if=\"$ctrl.status.type === \'status\'\"><div><div class=\"compact-title\">{{ $ctrl.status.title }}</div><div uib-tooltip=\"{{ $ctrl.status.value }}\" tooltip-placement=\"bottom\"><div class=\"compact-view\" ng-if=\"[\'OK\', \'DELAYED\', \'WARNING\', \'ERROR\', \'CRITICAL\'].indexOf($ctrl.status.value) === -1\">{{ $ctrl.status.value.length > 3 ? $ctrl.status.value[0] : $ctrl.status.value }}</div><i class=\"fa fa-thumbs-up fa-3x m-t-xs\" ng-if=\"$ctrl.status.value === \'OK\'\"></i> <i class=\"fa fa-clock-o fa-3x m-t-xs\" ng-if=\"$ctrl.status.value === \'DELAYED\'\"></i> <i class=\"fa fa-exclamation-triangle fa-3x m-t-xs\" ng-if=\"$ctrl.status.value === \'WARNING\'\"></i> <i class=\"fa fa-thumbs-down fa-3x m-t-xs\" ng-if=\"$ctrl.status.value === \'ERROR\'\"></i> <i class=\"fa fa-thumbs-down fa-3x m-t-xs\" ng-if=\"$ctrl.status.value === \'CRITICAL\'\"></i></div></div></div><div class=\"widget bg-default text-center widget-compact\" ng-if=\"$ctrl.status.type === \'gauge\'\"><div><div class=\"compact-title m-b-xs\">{{ $ctrl.status.title }}</div><ng-gauge size=\"70\" type=\"semi\" thick=\"8\" min=\"$ctrl.status.min\" max=\"$ctrl.status.max\" value=\"$ctrl.status.value\" cap=\"round\" append=\"{{$ctrl.status.message}}\" duration=\"800\" foreground-color=\"{{$ctrl.status.color}}\" background-color=\"#EEE\"></ng-gauge></div></div><div class=\"widget bg-{{$ctrl.status.color}} text-center widget-compact\" ng-if=\"$ctrl.status.type === \'table\'\"><div><div class=\"compact-title\">{{ $ctrl.status.title }}</div><div class=\"compact-view\">{{ $ctrl.status.rows }}</div></div></div><div class=\"widget bg-{{$ctrl.status.color}} text-center widget-compact\" ng-if=\"$ctrl.status.type === \'graph\'\"><div><div class=\"compact-title\">{{ $ctrl.status.title }}</div><canvas class=\"chart chart-line\" chart-data=\"$ctrl.status.data\" chart-labels=\"$ctrl.status.labels\" chart-series=\"$ctrl.status.series\" chart-options=\"$ctrl.status.options\" style=\"width: 30px; height: 21px;\"></canvas></div></div></a>");
$templateCache.put("app/components/common/contactBox.tpl.html","<div class=\"contact-card\"><span class=\"fa fa-star-o fa-2x pull-right text-warning\" aria-hidden=\"true\" aria-label=\"{{\'addressbook.setprimaryaria\' | translate}}\" uib-tooltip=\"{{\'addressbook.setprimarytt\' | translate}}\" tooltip-placement=\"left-top\" ng-click=\"$ctrl.parent.setAsPrimary($ctrl.contact.id)\" ng-if=\"$ctrl.contact.id && $ctrl.contact.id !== $ctrl.parent.primary.user && $ctrl.parent.view !== \'allprimary\'\" ng-show=\"$ctrl.parent.isAdmin\"></span> <span class=\"fa fa-star fa-2x pull-right text-warning\" aria-hidden=\"true\" aria-label=\"{{\'addressbook.primarycontact\' | translate}}\" uib-tooltip=\"{{\'addressbook.primarycontact\' | translate}}\" tooltip-placement=\"left-top\" ng-if=\"$ctrl.contact.id === $ctrl.parent.primary.user || $ctrl.parent.view === \'allprimary\'\"></span><h3><a class=\"text-bold text-normal\" ng-click=\"$ctrl.onContactSelected($ctrl.contact)\">{{($ctrl.contact.name || $ctrl.contact.email) | characters:20}}</a></h3><address style=\"margin-bottom: 10px;\">{{$ctrl.contact.address.city | characters:24}}<br>{{$ctrl.contact.address.state | characters:30}}<br></address><p><span ng-if=\"$ctrl.contact.phoneNumber\"><strong><i class=\"fa fa-phone fa-fw\" aria-hidden=\"true\"></i> {{$ctrl.contact.phoneNumber | ltrim: \'\\\\+1\' | phoneUS}}</strong></span><br><span ng-if=\"$ctrl.contact.email\"><strong><i class=\"fa fa-envelope fa-fw\" aria-hidden=\"true\"></i> {{$ctrl.contact.email | characters:25}}</strong></span> <span ng-if=\"!$ctrl.contact.email\">&nbsp;</span></p></div>");
$templateCache.put("app/components/common/contactCard.tpl.html","<div id=\"contact-box\">Primary Contact<h3><strong>{{ $ctrl.contact.name || $ctrl.contact.email }}</strong></h3><span ng-if=\"$ctrl.contact.email\"><i class=\"fa fa-envelope fa-fw\"></i> {{ $ctrl.contact.email }}</span> <span ng-if=\"$ctrl.contact.phoneNumber\"><br><i class=\"fa fa-phone fa-fw\"></i> {{ $ctrl.contact.phoneNumber | phoneUS }}</span></div>");
$templateCache.put("app/components/common/contactDetail.tpl.html","<div class=\"contact-detail\"><div class=\"modal-header\"><h3 class=\"modal-title\" id=\"modal-title\">{{$ctrl.contact.name || $ctrl.contact.email}}</h3></div><div class=\"modal-body main-p\" id=\"modal-body\" style=\"min-height: 200px;\"><p ng-if=\"$ctrl.contact.realm\" class=\"text-uppercase m-t-xs lead\">{{$ctrl.contact.realm}}</p><address style=\"margin-bottom: 10px;\"><span ng-if=\"$ctrl.contact.address.street\">{{$ctrl.contact.address.street}}<br></span> <span ng-if=\"$ctrl.contact.address.city\">{{$ctrl.contact.address.city}}<br></span> <span ng-if=\"$ctrl.contact.address.state || $ctrl.contact.address.zip\">{{$ctrl.contact.address.state}} {{$ctrl.contact.address.zip}}</span></address><p><span ng-if=\"$ctrl.contact.phoneNumber\"><strong><i class=\"fa fa-phone fa-fw\" aria-hidden=\"true\"></i> {{$ctrl.contact.phoneNumber | ltrim: \'\\\\+1\' | phoneUS}}</strong></span><br><span><strong><i class=\"fa fa-envelope fa-fw\" aria-hidden=\"true\"></i> {{$ctrl.contact.email}}</strong></span></p></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\"><span class=\"m-l-md m-r-md\">OK</span></button></div></div>");
$templateCache.put("app/components/common/contactRow.tpl.html","<div class=\"contact-card\"><div class=\"row\"><div class=\"col-xs-1 text-center\"><button class=\"btn btn-link text-warning\" aria-label=\"{{\'addressbook.setprimaryaria\' | translate}}\" uib-tooltip=\"{{\'addressbook.setprimarytt\' | translate}}\" ng-click=\"$ctrl.parent.setAsPrimary($ctrl.contact.id)\" ng-if=\"$ctrl.contact.id && $ctrl.contact.id !== $ctrl.parent.primary.user && $ctrl.parent.view !== \'allprimary\'\" ng-show=\"$ctrl.parent.isAdmin\"><i class=\"fa fa-star-o fa-2x\"></i></button> <span class=\"fa fa-star fa-2x text-warning\" aria-label=\"{{\'addressbook.primarycontact\' | translate}}\" style=\"padding: 6px 12px;\" uib-tooltip=\"{{\'addressbook.primarycontact\' | translate}}\" ng-if=\"$ctrl.contact.id === $ctrl.parent.primary.user || $ctrl.parent.view === \'allprimary\'\"></span></div><div class=\"col-xs-4\"><h3><a class=\"text-bold text-normal\" ng-click=\"$ctrl.onContactSelected($ctrl.contact)\">{{($ctrl.contact.name || $ctrl.contact.email)}}</a></h3><span ng-if=\"$ctrl.contact.email\"><i class=\"fa fa-envelope fa-fw\" aria-hidden=\"true\"></i> {{$ctrl.contact.email}}<br></span> <span ng-if=\"$ctrl.contact.phoneNumber\"><i class=\"fa fa-phone fa-fw\" aria-hidden=\"true\"></i> {{$ctrl.contact.phoneNumber | ltrim: \'\\\\+1\' | phoneUS}}</span></div><div class=\"col-xs-3\"><address class=\"m-t-sm\">{{$ctrl.contact.address.city}}<br>{{$ctrl.contact.address.state}}<br></address></div></div></div>");
$templateCache.put("app/components/common/content.html","<div id=\"wrapper\"><div ng-include=\"\'app/components/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/components/common/footer.html\'\"></div></div></div>");
$templateCache.put("app/components/common/dashWidget.tpl.html","<div><div class=\"col-sm-6 col-md-4 col-lg-3\" ng-if=\"$ctrl.status.type === \'status\'\"><div class=\"widget style1 bg-{{$ctrl.status.color}}\"><div class=\"row\"><div class=\"col-xs-12 text-right\"><span ng-if=\"$ctrl.status.title\">{{ $ctrl.status.title }}</span><h2 class=\"font-bold\" ng-if=\"$ctrl.status.value\">{{ $ctrl.status.value }}</h2><span ng-if=\"$ctrl.status.message\">{{ $ctrl.status.message }}</span></div></div></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\" ng-if=\"$ctrl.status.type === \'gauge\'\"><div class=\"widget style1 bg-default\" style=\"height: 200px; overflow: hidden\"><div class=\"row\"><div class=\"col-xs-12 text-center\"><ng-gauge size=\"200\" type=\"semi\" thick=\"20\" min=\"$ctrl.status.min\" max=\"$ctrl.status.max\" value=\"$ctrl.status.value\" duration=\"800\" cap=\"round\" label=\"{{$ctrl.status.title}}\" append=\"{{$ctrl.status.message}}\" foreground-color=\"{{$ctrl.status.color}}\" background-color=\"#EEE\"></ng-gauge></div></div></div></div><div class=\"col-sm-12 col-md-8 col-lg-6\" ng-if=\"$ctrl.status.type === \'graph\'\"><div class=\"widget bg-default\"><div class=\"p-m\"><h3 class=\"font-bold no-margins\" ng-if=\"$ctrl.status.title\">{{ $ctrl.status.title }}</h3><small ng-if=\"$ctrl.status.message\">{{ $ctrl.status.message }}</small></div><div><canvas class=\"chart chart-line\" chart-data=\"$ctrl.status.data\" chart-labels=\"$ctrl.status.labels\" chart-series=\"$ctrl.status.series\" chart-options=\"$ctrl.status.options\"></canvas></div></div></div><div class=\"col-sm-12 col-md-8 col-lg-6\" ng-if=\"$ctrl.status.type === \'table\'\"><div class=\"widget bg-default\"><div class=\"p-m\"><h3 class=\"font-bold no-margins\" ng-if=\"$ctrl.status.title\">{{ $ctrl.status.title }}</h3><small ng-if=\"$ctrl.status.message\">{{ $ctrl.status.message }}</small></div><div><table class=\"table\"><thead><tr><th ng-repeat=\"header in $ctrl.status.headers\" style=\"white-space:nowrap;\">{{ header }}</th></tr></thead><tbody><tr ng-repeat=\"row in $ctrl.status.rows\"><td ng-repeat=\"col in row\">{{ col }}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"><div class=\"pull-right\" translate=\"footer.copy\"></div><div><span ng-if=\"app.environment.name !== \'prod\'\" translate=\"footer.env\" translate-values=\"{envname:app.environment.displayName}\"></span> <span>{{app.realmName | uppercase}}</span></div></div>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/components/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown=\"\"><a ui-sref=\"index.dashboard\"><img class=\"img-responsive\" src=\"assets/images/steve.png\" style=\"background-color: white;\" alt=\"STEVE\"></a> <a uib-dropdown-toggle=\"\" href=\"\"><span class=\"clear\"><span class=\"block m-t-xs\"><strong class=\"font-bold\">{{(app.profile && app.profile.name) || app.userInfo.name}}</strong></span> <span class=\"text-muted text-xs block\">{{\'nav.options\' | translate}}<b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"m-t-xs\"><li><a ng-href=\"{{app.accountUrl}}\" target=\"_blank\"><i class=\"fa fa-lock fa-fw\" aria-hidden=\"true\"></i> {{\'nav.account\' | translate}}</a></li><li><a ui-sref=\"index.profile\"><i class=\"fa fa-user-circle fa-fw\" aria-hidden=\"true\"></i> {{\'nav.profile\' | translate}}</a></li><li><a ui-sref=\"index.settings\"><i class=\"fa fa-bell fa-fw\" aria-hidden=\"true\"></i> {{\'nav.nsettings\' | translate}}</a></li><li role=\"separator\" class=\"divider\"></li><li style=\"padding: 3px 20px 10px 20px;\"><logout-button></logout-button></li></ul></div><div class=\"logo-element\"><img class=\"img-responsive\" src=\"assets/images/steve.png\" style=\"background-color: white;\" alt=\"{{\'steve\' | translate}}\"></div></li><li ng-class=\"{active: $state.includes(\'index.dashboard\') || $state.includes(\'index.metrics\')}\"><a href=\"\" aria-label=\"{{\'nav.dashboard\' | translate}}\"><i class=\"fa fa-tachometer fa-fw\"></i> <span class=\"nav-label\">{{\'nav.dashboard\' | translate}}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index.dashboard\') || $state.includes(\'index.metrics\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.dashboard\">Map</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.metrics\">Metrics</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"index.mailbox\" aria-label=\"{{\'nav.mailboxes\' | translate}}\"><i class=\"fa fa-envelope fa-fw\"></i> <span class=\"nav-label\">{{\'nav.mailboxes\' | translate}}</span> <span class=\"label label-info pull-right\" ng-if=\"app.mailStatus.unread > 0\">{{app.mailStatus.unread}}</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.addressbook\" aria-label=\"{{\'nav.abook\' | translate}}\"><i class=\"fa fa-address-book fa-fw\" aria-hidden=\"true\"></i> <span class=\"nav-label\">{{\'nav.abook\' | translate}}</span></a></li><li ng-if=\"app.userInfo.isAdmin\" ng-class=\"{active: $state.includes(\'admin\')}\"><a href=\"\" aria-label=\"{{\'nav.admin\' | translate}}\"><i class=\"fa fa-shield fa-fw\"></i> <span class=\"nav-label\">{{\'nav.admin\' | translate}}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'admin\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"admin.users\">{{\'nav.users\' | translate}}</a></li><li ui-sref-active=\"active\"><a ui-sref=\"admin.clients\">{{\'nav.clients\' | translate}}</a></li><li ui-sref-active=\"active\"><a ui-sref=\"admin.inbound\">{{\'nav.inbound\' | translate}}</a></li><li ui-sref-active=\"active\"><a ui-sref=\"admin.outbound\">{{\'nav.outbound\' | translate}}</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"index.support\"><i class=\"fa fa-life-ring fa-fw\"></i> <span class=\"nav-label\">{{\'nav.support\' | translate}}</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.resources\"><i class=\"fa fa-th-large fa-fw\"></i> <span class=\"nav-label\">{{\'nav.resources\' | translate}}</span></a></li><li><div class=\"widgets-container\"><compact-widget ng-repeat=\"cWidget in app.compactWidgets | toArray | orderBy:[\'weight\', \'title\'] | limitTo:4\" status=\"cWidget\"></compact-widget></div></li></ul></div></nav>");
$templateCache.put("app/components/common/noprofile.tpl.html","<div class=\"alert alert-warning\" role=\"alert\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"{{\'close\' | translate}}\"><span aria-hidden=\"true\">×</span></button><h3>{{\'profile.notfound\' | translate}}</h3>{{\'profile.notfoundtxt\' | translate}}<p class=\"m-t-md\"><a class=\"btn btn-primary\" ui-sref=\"index.profile\"><i class=\"fa fa-user-circle fa-fw\" aria-hidden=\"true\"></i> {{\'profile.profile\' | translate}}</a></p></div>");
$templateCache.put("app/components/common/pagination.tpl.html","<div class=\"pagination\" ng-if=\"pages.length >= 2\"><ul class=\"pagination\"><li ng-if=\"numPages > pages.length\"><a ng-click=\"selectPage(1)\" aria-label=\"{{\'pag.first\' | translate}}\"><span aria-hidden=\"true\">1</span></a></li><li ng-if=\"numPages > pages.length\"><a ng-click=\"selectPage(currentPage-1)\" aria-label=\"{{\'pag.previous\' | translate}}\"><span aria-hidden=\"true\">&larr;</span></a></li><li ng-repeat=\"page in pages\" ng-class=\"{active: page==currentPage}\"><a ng-click=\"selectPage(page)\">{{page}}</a></li><li ng-if=\"numPages > pages.length\"><a ng-click=\"selectPage(currentPage+1)\" aria-label=\"{{\'pag.next\' | translate}}\"><span aria-hidden=\"true\">&rarr;</span></a></li><li ng-if=\"numPages > pages.length\"><a href=\"\" ng-click=\"selectPage(numPages)\" aria-label=\"{{\'pag.last\' | translate}}\"><span aria-hidden=\"true\">{{numPages}}</span></a></li></ul></div>");
$templateCache.put("app/components/common/resourceItem.tpl.html","<div class=\"contact-box\" style=\"background-color: transparent; border: none;\"><div class=\"col-xs-3\"><div class=\"text-center\"><span class=\"fa fa-{{$ctrl.icon}} fa-4x text-muted\"></span></div></div><div class=\"col-xs-9\"><h3 title=\"Title\"><strong translate=\"{{ $ctrl.titleText | translate}}\"></strong></h3><p title=\"Description\" translate=\"{{ $ctrl.text | translate}}\"></p><a ng-if=\"$ctrl.down\" href=\"{{ $ctrl.down }}\" download=\"\" title=\"{{ $ctrl.button || \'Download\'}}\" target=\"_blank\" class=\"btn btn-primary btn-sm m-t-sm\">{{ $ctrl.button || \'Download\'}}</a> <a ng-if=\"$ctrl.link\" href=\"{{ $ctrl.link }}\" title=\"{{ $ctrl.button || \'Download\'}}\" target=\"_blank\" class=\"btn btn-primary btn-sm m-t-sm\">{{ $ctrl.button || \'Download\'}}</a></div><div class=\"clearfix\"></div></div>");
$templateCache.put("app/components/common/searchBox.tpl.html","<div class=\"input-group\"><input type=\"search\" placeholder=\"{{$ctrl.placeholder}}\" class=\"form-control input-{{$ctrl.size}}\" ng-model=\"$ctrl.search\" aria-label=\"{{\'search.saria\' | translate}}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-primary btn-{{$ctrl.size}}\" ng-if=\"!$ctrl.search\" aria-label=\"{{$ctrl.aria}}\"><i class=\"fa fa-search fa-lg\" style=\"font-weight: lighter;\"></i></button> <button type=\"button\" class=\"btn btn-primary btn-{{$ctrl.size}}\" ng-if=\"$ctrl.search\" ng-click=\"$ctrl.search = \'\'\" aria-label=\"{{\'search.cleararia\' | translate}}\"><i class=\"fa fa-times fa-lg\" style=\"font-weight: lighter;\"></i></button></span></div>");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span> <span class=\"navbar-brand\" style=\"padding-top: 10px;\"><span>{{\'top.steve20\' | translate}}</span><br><span style=\"font-size: 13px;\">{{\'top.devby\' | translate}}</span></span></div><ul class=\"nav navbar-top-links navbar-right\"><li uib-dropdown=\"\"><a class=\"count-info\" href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-bell fa-lg\"></i> <span class=\"label label-info\" ng-if=\"app.notifications.length > 0\">{{app.notifications.length}}</span></a><ul class=\"dropdown-messages\" uib-dropdown-menu=\"\"><div class=\"scroll-body\" slimscroll=\"{height: 300, size: 3}\" ng-if=\"app.notifications.length > 0\"><li ng-repeat-start=\"notification in app.notifications | orderBy:\'-created_at\'\"><div class=\"dropdown-messages-box\" ng-click=\"app.selectItem(notification)\"><a href=\"\" class=\"pull-left\" ng-class=\"notification.type | typeClass:\'text\'\" style=\"padding: 3px 10px;\"><i class=\"fa fa-lg fa-fw\" ng-class=\"notification.type | iconClass:\'fa\'\"></i></a><div><small class=\"pull-right\">{{ notification.created_at | relatify }}</small> <strong>{{ notification.app | uppercase }}</strong><br>{{ notification.title | characters:30 }}</div></div></li><li class=\"divider\" ng-repeat-end=\"\" ng-if=\"!$last\"></li></div><li ng-if=\"app.notifications.length === 0\"><div class=\"text-center link-block\"><p><i class=\"fa fa-bell fa-4x m-t-lg text-muted\" aria-hidden=\"true\"></i></p><p>All caught up!</p></div></li><li class=\"divider\"></li><li><div class=\"link-block text-center\"><a ui-sref=\"index.notifications\"><strong>{{\'top.viewnotif\' | translate}}</strong> <i class=\"fa fa-angle-right\"></i></a></div></li></ul></li><li uib-dropdown=\"\" style=\"padding-left: 8px;\"><a class=\"count-info\" href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-life-ring fa-lg\" uib-tooltip=\"{{\'top.support\' | translate}}\" tooltip-placement=\"bottom\"></i></a><ul class=\"dropdown-alerts\" uib-dropdown-menu=\"\"><li><button class=\"btn btn-primary btn-block\" ng-click=\"app.launchSupport()\"><i class=\"fa fa-plus\"></i> {{\'top.reqsup\' | translate}}</button></li><li class=\"divider\"></li><li><div class=\"text-center link-block\"><a ui-sref=\"index.support\"><strong>{{\'top.viewsup\' | translate}}</strong> <i class=\"fa fa-angle-right\"></i></a></div></li></ul></li><li uib-dropdown=\"\" style=\"padding-left: 8px;\" ng-if-end=\"\"><a class=\"count-info\" href=\"\" uib-dropdown-toggle=\"\" style=\"padding-top: 10px; padding-bottom: 10px;\"><img alt=\"image\" class=\"img-circle\" src=\"assets/images/profile_noimage.png\" height=\"38px\" width=\"38px\" uib-tooltip=\"{{app.profile.name || app.profile.email}}\" tooltip-popup-delay=\"1500\" tooltip-placement=\"bottom\"></a><ul uib-dropdown-menu=\"\" class=\"m-t-xs\"><li class=\"dropdown-header\" style=\"padding-top: 10px;\">You are signed in as:<br><strong>{{ app.profile.name || app.profile.email }}</strong></li><li class=\"divider\"></li><li><a ng-href=\"{{app.accountUrl}}\" target=\"_blank\"><i class=\"fa fa-lock fa-fw\" aria-hidden=\"true\"></i> {{\'nav.account\' | translate}}</a></li><li><a ui-sref=\"index.profile\"><i class=\"fa fa-user-circle fa-fw\" aria-hidden=\"true\"></i> {{\'nav.profile\' | translate}}</a></li><li><a ui-sref=\"index.settings\"><i class=\"fa fa-bell fa-fw\" aria-hidden=\"true\"></i> {{\'nav.nsettings\' | translate}}</a></li><li class=\"divider\"></li><li><a href=\"\" style=\"padding-left: 0;\"><logout-button></logout-button></a></li></ul></li></ul></nav></div><div class=\"row\" ng-if=\"app.environment.name !== \'prod\' && app.environment.name !== \'localhost\'\"><div class=\"col-lg-12 text-center\" style=\"background-color:#f4e242; padding:10px; color:#5b5b5b;\"><h3 style=\"margin: 5px;\">{{\'top.message\' | translate}}</h3></div></div>");}]);